import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  BigInt: { input: any; output: any; }
  Byte: { input: any; output: any; }
  Currency: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  EmailAddress: { input: any; output: any; }
  GUID: { input: any; output: any; }
  HSL: { input: any; output: any; }
  HSLA: { input: any; output: any; }
  HexColorCode: { input: any; output: any; }
  Hexadecimal: { input: any; output: any; }
  IBAN: { input: any; output: any; }
  IPv4: { input: any; output: any; }
  IPv6: { input: any; output: any; }
  ISBN: { input: any; output: any; }
  JSON: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  Long: { input: any; output: any; }
  MAC: { input: any; output: any; }
  NegativeFloat: { input: any; output: any; }
  NegativeInt: { input: any; output: any; }
  NonNegativeFloat: { input: any; output: any; }
  NonNegativeInt: { input: any; output: any; }
  NonPositiveFloat: { input: any; output: any; }
  NonPositiveInt: { input: any; output: any; }
  ObjectID: { input: any; output: any; }
  PhoneNumber: { input: any; output: any; }
  Port: { input: any; output: any; }
  PositiveFloat: { input: any; output: any; }
  PositiveInt: { input: any; output: any; }
  PostalCode: { input: any; output: any; }
  RGB: { input: any; output: any; }
  RGBA: { input: any; output: any; }
  Time: { input: any; output: any; }
  Timestamp: { input: any; output: any; }
  URL: { input: any; output: any; }
  USCurrency: { input: any; output: any; }
  UnsignedFloat: { input: any; output: any; }
  UnsignedInt: { input: any; output: any; }
  UtcOffset: { input: any; output: any; }
  Void: { input: any; output: any; }
};

export type AddressComponent = {
  __typename?: 'AddressComponent';
  long_name?: Maybe<Scalars['String']['output']>;
  short_name?: Maybe<Scalars['String']['output']>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ApiBookingInput = {
  comments?: InputMaybe<Scalars['String']['input']>;
  contactCity?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contactLanguage: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  flightId?: InputMaybe<Scalars['String']['input']>;
  passengers?: InputMaybe<Array<InputMaybe<ApiPassengerInput>>>;
  regionId: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ApiFlightInput = {
  balloonId: Scalars['String']['input'];
  date: Scalars['String']['input'];
  hour: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  period: Scalars['String']['input'];
};

export type ApiPassengerInput = {
  age?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  child?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentDate?: InputMaybe<Scalars['String']['input']>;
  paymentReference?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  paymentVoucher?: InputMaybe<Scalars['String']['input']>;
  paymentVoucherId?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type ApiVoucherInput = {
  adults?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  children?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contactCity?: InputMaybe<Scalars['String']['input']>;
  contactEmail: Scalars['String']['input'];
  contactLanguage: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['String']['input'];
  expiryDate?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['String']['input']>;
  paymentAmount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  paymentDate?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<Scalars['String']['input']>;
  paymentType?: InputMaybe<Scalars['String']['input']>;
  recipientAddress?: InputMaybe<Scalars['String']['input']>;
  recipientCity?: InputMaybe<Scalars['String']['input']>;
  recipientCountry?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientLanguage?: InputMaybe<Scalars['String']['input']>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhone?: InputMaybe<Scalars['String']['input']>;
  recipientPostalCode?: InputMaybe<Scalars['String']['input']>;
  voucherReference: Scalars['String']['input'];
  voucherType: Scalars['String']['input'];
};

export type AuthMailResult = {
  __typename?: 'AuthMailResult';
  accepted: Scalars['Boolean']['output'];
  throttled: Scalars['Boolean']['output'];
};

export type AutorouterConnection = {
  __typename?: 'AutorouterConnection';
  /** Autorouter account email (display only) */
  account?: Maybe<Scalars['String']['output']>;
  connectedAt?: Maybe<Scalars['DateTime']['output']>;
  status: AutorouterStatus;
};

export enum AutorouterStatus {
  Connected = 'CONNECTED',
  Disconnected = 'DISCONNECTED',
  ReauthRequired = 'REAUTH_REQUIRED'
}

export enum AvailabilityType {
  Date = 'DATE',
  Peri = 'PERI'
}

export type Balloon = {
  __typename?: 'Balloon';
  FlightAppAircraftDetails?: Maybe<FlightAppAircraftDetails>;
  FlightAppKey?: Maybe<Scalars['String']['output']>;
  balloonTemp?: Maybe<Scalars['PositiveInt']['output']>;
  balloonWeight?: Maybe<BalloonWeight>;
  basketManufacturer?: Maybe<Scalars['String']['output']>;
  basketType?: Maybe<Scalars['String']['output']>;
  basketWeight?: Maybe<Scalars['PositiveInt']['output']>;
  burnerManufacturer?: Maybe<Scalars['String']['output']>;
  burnerType?: Maybe<Scalars['String']['output']>;
  burnerWeight?: Maybe<Scalars['PositiveInt']['output']>;
  callSign?: Maybe<Scalars['String']['output']>;
  capacity?: Maybe<Scalars['PositiveInt']['output']>;
  classGroup: Array<Maybe<ClassGroup>>;
  classGroups?: Maybe<Scalars['String']['output']>;
  cylinder: Array<Maybe<Cylinder>>;
  envelopeHours?: Maybe<Scalars['PositiveInt']['output']>;
  envelopeInspectionDate?: Maybe<Scalars['DateTime']['output']>;
  envelopeManufacturer?: Maybe<Scalars['String']['output']>;
  envelopeType?: Maybe<Scalars['String']['output']>;
  envelopeVolume?: Maybe<Scalars['PositiveInt']['output']>;
  envelopeWeight?: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  insuranceCompany?: Maybe<Scalars['String']['output']>;
  insuranceDueDate?: Maybe<Scalars['DateTime']['output']>;
  isCurrent?: Maybe<Scalars['Int']['output']>;
  liftWarningOrangeBelow?: Maybe<Scalars['PositiveInt']['output']>;
  liftWarningRedBelow?: Maybe<Scalars['PositiveInt']['output']>;
  logbook?: Maybe<LogBook>;
  minFuel?: Maybe<Scalars['PositiveInt']['output']>;
  mlm?: Maybe<Scalars['PositiveInt']['output']>;
  mtom?: Maybe<Scalars['PositiveInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** 228 US8: learned preferred crew (vaste ploeg), null with too little history */
  preferredCrew?: Maybe<PreferredCrew>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  thumbUrl?: Maybe<Scalars['String']['output']>;
};

export type BalloonInput = {
  balloonTemp?: InputMaybe<Scalars['PositiveInt']['input']>;
  basketManufacturer?: InputMaybe<Scalars['String']['input']>;
  basketType?: InputMaybe<Scalars['String']['input']>;
  basketWeight?: InputMaybe<Scalars['PositiveInt']['input']>;
  burnerManufacturer?: InputMaybe<Scalars['String']['input']>;
  burnerType?: InputMaybe<Scalars['String']['input']>;
  burnerWeight?: InputMaybe<Scalars['PositiveInt']['input']>;
  callSign?: InputMaybe<Scalars['String']['input']>;
  capacity?: InputMaybe<Scalars['PositiveInt']['input']>;
  classGroups?: InputMaybe<Scalars['String']['input']>;
  envelopeHours?: InputMaybe<Scalars['PositiveInt']['input']>;
  envelopeInspectionDate?: InputMaybe<Scalars['DateTime']['input']>;
  envelopeManufacturer?: InputMaybe<Scalars['String']['input']>;
  envelopeType?: InputMaybe<Scalars['String']['input']>;
  envelopeVolume?: InputMaybe<Scalars['PositiveInt']['input']>;
  envelopeWeight?: InputMaybe<Scalars['PositiveInt']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  insuranceCompany?: InputMaybe<Scalars['String']['input']>;
  insuranceDueDate?: InputMaybe<Scalars['DateTime']['input']>;
  liftWarningOrangeBelow?: InputMaybe<Scalars['PositiveInt']['input']>;
  liftWarningRedBelow?: InputMaybe<Scalars['PositiveInt']['input']>;
  minFuel?: InputMaybe<Scalars['PositiveInt']['input']>;
  mlm?: InputMaybe<Scalars['PositiveInt']['input']>;
  mtom?: InputMaybe<Scalars['PositiveInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  thumbUrl?: InputMaybe<Scalars['String']['input']>;
};

export type BalloonWeight = {
  __typename?: 'BalloonWeight';
  cylindersWeight: Scalars['PositiveInt']['output'];
  totalWeight: Scalars['PositiveInt']['output'];
};

export type Booking = {
  __typename?: 'Booking';
  VATnumber?: Maybe<Scalars['String']['output']>;
  autoConfirmEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  availabilityFridayEvening?: Maybe<Scalars['Boolean']['output']>;
  availabilityFridayMorning?: Maybe<Scalars['Boolean']['output']>;
  availabilityMondayEvening?: Maybe<Scalars['Boolean']['output']>;
  availabilityMondayMorning?: Maybe<Scalars['Boolean']['output']>;
  availabilitySaturdayEvening?: Maybe<Scalars['Boolean']['output']>;
  availabilitySaturdayMorning?: Maybe<Scalars['Boolean']['output']>;
  availabilitySundayEvening?: Maybe<Scalars['Boolean']['output']>;
  availabilitySundayMorning?: Maybe<Scalars['Boolean']['output']>;
  availabilityThursdayEvening?: Maybe<Scalars['Boolean']['output']>;
  availabilityThursdayMorning?: Maybe<Scalars['Boolean']['output']>;
  availabilityTuesdayEvening?: Maybe<Scalars['Boolean']['output']>;
  availabilityTuesdayMorning?: Maybe<Scalars['Boolean']['output']>;
  availabilityType?: Maybe<AvailabilityType>;
  availabilityWednesdayEvening?: Maybe<Scalars['Boolean']['output']>;
  availabilityWednesdayMorning?: Maybe<Scalars['Boolean']['output']>;
  bookingCode?: Maybe<Scalars['String']['output']>;
  bookingDate?: Maybe<Scalars['DateTime']['output']>;
  bookingsMerged?: Maybe<Array<Maybe<Booking>>>;
  checkinNotifiedAt?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use 'city' instead. */
  contactCity?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactLanguage?: Maybe<ContactLanguage>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['PhoneNumber']['output']>;
  daysExpired?: Maybe<Scalars['NonNegativeInt']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  external?: Maybe<Scalars['Boolean']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  flight?: Maybe<Flight>;
  flightId?: Maybe<Scalars['ID']['output']>;
  flightOptions?: Maybe<Array<Maybe<Flight>>>;
  icon?: Maybe<Scalars['String']['output']>;
  iconColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  inviteCount?: Maybe<Scalars['Int']['output']>;
  invoiceName?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['ID']['output']>;
  locationType?: Maybe<LocationType>;
  logs?: Maybe<Array<Maybe<BookingLog>>>;
  logsMerged?: Maybe<Array<Maybe<BookingLog>>>;
  logsRemoved?: Maybe<Scalars['NonNegativeInt']['output']>;
  mailEventLatest?: Maybe<MailEventLatest>;
  mails?: Maybe<Array<Maybe<Email>>>;
  mailsMerged?: Maybe<Array<Maybe<Email>>>;
  mergeCandidates?: Maybe<Array<Maybe<Booking>>>;
  mismatchReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  montyOpen?: Maybe<Scalars['Boolean']['output']>;
  montyTag?: Maybe<MontyTag>;
  number?: Maybe<Scalars['NonNegativeInt']['output']>;
  onlineCheckinAt?: Maybe<Scalars['DateTime']['output']>;
  passengerCounters?: Maybe<PassengerCounters>;
  passengers: Array<Maybe<Passenger>>;
  preferredDate?: Maybe<Scalars['String']['output']>;
  preferredFlights?: Maybe<Array<Maybe<PreferredFlight>>>;
  prepaymentAmount?: Maybe<Scalars['Int']['output']>;
  prepaymentDate?: Maybe<Scalars['DateTime']['output']>;
  ref?: Maybe<Scalars['JSONObject']['output']>;
  region?: Maybe<Region>;
  regionId?: Maybe<Scalars['ID']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  smsLatest?: Maybe<SmsLatest>;
  smsType?: Maybe<SmsConversationType>;
  smsUnread?: Maybe<Scalars['NonNegativeInt']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<BookingStatus>;
  tags?: Maybe<Array<Maybe<BookingTag>>>;
  upUrl?: Maybe<Scalars['String']['output']>;
  upcoming?: Maybe<Scalars['Boolean']['output']>;
  /** Effective validity end of the booking (spec 236): endDate, or null when the booking has unlimited validity (no/invalid endDate, or more than 10 years ahead). Its last valid day is this instant's calendar day in the tenant timezone. */
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export type BookingCounters = {
  __typename?: 'BookingCounters';
  /** Active bookings filter count: active status and not expired (spec 235) */
  active?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Spec 235 v3: status CONF, not expired */
  confirmed?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Expired filter count: active status, validity ended before today (spec 235) */
  expired?: Maybe<Scalars['NonNegativeInt']['output']>;
  historical?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Spec 235 v3: status INVI, not expired */
  invited?: Maybe<Scalars['NonNegativeInt']['output']>;
  statusCounters?: Maybe<Array<Maybe<StatusCounter>>>;
  toConfirm?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Spec 235 v3: status OPEN, not expired */
  toPlan?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** All active-status bookings (= active + expired) */
  upcoming?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type BookingData = {
  __typename?: 'BookingData';
  contactName?: Maybe<Scalars['String']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  iconColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  onlineCheckinAt?: Maybe<Scalars['DateTime']['output']>;
  passengers?: Maybe<Array<Maybe<PassengerData>>>;
  status?: Maybe<Scalars['String']['output']>;
};

/** Booking list status filter (spec 235 v3). standard = all active bookings (active status, not expired). Combine with openAmountOnly for the Open amount chip. */
export enum BookingFilter {
  /** @deprecated Removed in spec 235 (always empty). Treated as standard; will be dropped in the next release. */
  AvailableNext30Days = 'availableNext30Days',
  /** @deprecated Removed in spec 235 (always empty). Treated as standard; will be dropped in the next release. */
  AvailableThisYear = 'availableThisYear',
  /** Status CONF, not expired */
  Confirmed = 'confirmed',
  /** Active-status bookings whose validity ended before today (tenant timezone) */
  Expired = 'expired',
  /** @deprecated Removed in spec 235 (unused). Treated as standard; will be dropped in the next release. */
  FlyingNext30Days = 'flyingNext30Days',
  /** @deprecated Removed in spec 235 (unused). Treated as standard; will be dropped in the next release. */
  FlyingThisYear = 'flyingThisYear',
  /** Completed and cancelled bookings (the former Completed tab) */
  History = 'history',
  /** Status INVI, not expired */
  Invited = 'invited',
  /** @deprecated Spec 235 v3: use standard with openAmountOnly: true (treated as such). */
  OpenAmount = 'openAmount',
  Standard = 'standard',
  /** Status ADDE (requested by the passenger), expired included */
  ToConfirm = 'toConfirm',
  /** Status OPEN (no flight yet), not expired */
  ToPlan = 'toPlan',
  /** @deprecated Spec 235 v3: use toPlan (treated as such). */
  WithoutFlight = 'withoutFlight'
}

/** Spec 235 v3: counts of the booking list filter row for the current status (+ search) */
export type BookingFilterCounts = {
  __typename?: 'BookingFilterCounts';
  /** Bookings of the status (+ search) with an open amount > 0 (ignores openAmountOnly) */
  openAmount: Scalars['NonNegativeInt']['output'];
  /** One entry per enabled booking tag: bookings of the status + openAmountOnly (+ search) with that tag */
  tags: Array<BookingTagCount>;
};

export type BookingInput = {
  VATnumber?: InputMaybe<Scalars['String']['input']>;
  availabilityFridayEvening?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityFridayMorning?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityMondayEvening?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityMondayMorning?: InputMaybe<Scalars['Boolean']['input']>;
  availabilitySaturdayEvening?: InputMaybe<Scalars['Boolean']['input']>;
  availabilitySaturdayMorning?: InputMaybe<Scalars['Boolean']['input']>;
  availabilitySundayEvening?: InputMaybe<Scalars['Boolean']['input']>;
  availabilitySundayMorning?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityThursdayEvening?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityThursdayMorning?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityTuesdayEvening?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityTuesdayMorning?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityType?: InputMaybe<AvailabilityType>;
  availabilityWednesdayEvening?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityWednesdayMorning?: InputMaybe<Scalars['Boolean']['input']>;
  bookingDate?: InputMaybe<Scalars['DateTime']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactLanguage?: InputMaybe<ContactLanguage>;
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['PhoneNumber']['input'];
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  externalSource?: InputMaybe<Scalars['String']['input']>;
  flight?: InputMaybe<Scalars['ID']['input']>;
  invoiceName?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationType?: InputMaybe<LocationType>;
  pax?: InputMaybe<Scalars['Int']['input']>;
  preferredDate?: InputMaybe<Scalars['String']['input']>;
  preferredFlights?: InputMaybe<Array<InputMaybe<PreferredFlightInput>>>;
  prepaymentAmount?: InputMaybe<Scalars['Int']['input']>;
  prepaymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  regionId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  status?: InputMaybe<BookingStatus>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type BookingLog = {
  __typename?: 'BookingLog';
  action?: Maybe<BookingLogAction>;
  booking?: Maybe<Booking>;
  date?: Maybe<Scalars['DateTime']['output']>;
  flight?: Maybe<Flight>;
  id: Scalars['ID']['output'];
  mail?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  user?: Maybe<Scalars['String']['output']>;
};

export enum BookingLogAction {
  Adde = 'ADDE',
  Comp = 'COMP',
  Conf = 'CONF',
  Crea = 'CREA',
  Dele = 'DELE',
  Invi = 'INVI',
  Mail = 'MAIL',
  Remo = 'REMO'
}

export type BookingPassengerEmail = {
  __typename?: 'BookingPassengerEmail';
  bookingId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  language?: Maybe<ContactLanguage>;
};

export type BookingPaymentInput = {
  VATnumber?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  invoiceName?: InputMaybe<Scalars['String']['input']>;
  prepaymentAmount?: InputMaybe<Scalars['Int']['input']>;
  prepaymentDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type BookingPoolCounts = {
  __typename?: 'BookingPoolCounts';
  favourite: Scalars['Int']['output'];
  openAmount: Scalars['Int']['output'];
  tags: Array<BookingPoolTagCount>;
  toConfirm: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  unplanned: Scalars['Int']['output'];
  voucherExpiring: Scalars['Int']['output'];
};

export type BookingPoolTagCount = {
  __typename?: 'BookingPoolTagCount';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  fontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tag?: Maybe<Scalars['String']['output']>;
};

/** Spec 235 FR-012: bookings matching a search in each main booking list set */
export type BookingSearchCounts = {
  __typename?: 'BookingSearchCounts';
  active: Scalars['NonNegativeInt']['output'];
  expired: Scalars['NonNegativeInt']['output'];
  history: Scalars['NonNegativeInt']['output'];
};

export enum BookingStatus {
  Adde = 'ADDE',
  Canc = 'CANC',
  Comp = 'COMP',
  Conf = 'CONF',
  Invi = 'INVI',
  Open = 'OPEN'
}

export type BookingTag = Tag & {
  __typename?: 'BookingTag';
  allowedFlightTags?: Maybe<Array<Maybe<FlightTag>>>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TagType>;
  upcoming?: Maybe<Scalars['PositiveInt']['output']>;
};

/** Spec 235 v3: bookings with one booking tag in the current booking list view */
export type BookingTagCount = {
  __typename?: 'BookingTagCount';
  count: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
};

export type BookingsData = {
  __typename?: 'BookingsData';
  addedCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  count?: Maybe<Scalars['NonNegativeInt']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  list?: Maybe<Array<Maybe<BookingData>>>;
  notConfirmedCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  notConfirmedNames?: Maybe<Scalars['String']['output']>;
};

export type BulkFlightAction = {
  __typename?: 'BulkFlightAction';
  action: BulkFlightActionType;
  cancelReason?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  flights: Array<BulkFlightActionFlight>;
  id: Scalars['ID']['output'];
  skipped: Scalars['NonNegativeInt']['output'];
  tagName?: Maybe<Scalars['String']['output']>;
  unchanged: Scalars['NonNegativeInt']['output'];
  undoExpiresAt: Scalars['DateTime']['output'];
  undoable: Scalars['Boolean']['output'];
  undoneAt?: Maybe<Scalars['DateTime']['output']>;
  undoneBy?: Maybe<Scalars['String']['output']>;
  updated: Scalars['NonNegativeInt']['output'];
  user: Scalars['String']['output'];
  visibility?: Maybe<VisibilityType>;
};

export type BulkFlightActionFlight = {
  __typename?: 'BulkFlightActionFlight';
  /** CANCEL undo: bookings that could not be re-attached */
  bookingsNotRestored?: Maybe<Array<BulkFlightBookingNotRestored>>;
  date?: Maybe<Scalars['DateTime']['output']>;
  flightId: Scalars['ID']['output'];
  locationName?: Maybe<Scalars['String']['output']>;
  /** UPDATED | UNCHANGED | SKIPPED */
  result: Scalars['String']['output'];
  skipReason?: Maybe<BulkFlightSkipReason>;
  /** RESTORED | SKIPPED */
  undoResult?: Maybe<Scalars['String']['output']>;
  undoSkipReason?: Maybe<BulkFlightUndoSkipReason>;
};

export type BulkFlightActionInput = {
  action: BulkFlightActionType;
  /** Required for CANCEL (one of the tenant's cancel reasons) */
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  /** Required for ADD_TAG / REMOVE_TAG (flight tag id) */
  tagId?: InputMaybe<Scalars['ID']['input']>;
  /** Required for SET_VISIBILITY */
  visibility?: InputMaybe<VisibilityType>;
};

export enum BulkFlightActionType {
  AddTag = 'ADD_TAG',
  Cancel = 'CANCEL',
  Delete = 'DELETE',
  RemoveTag = 'REMOVE_TAG',
  SetVisibility = 'SET_VISIBILITY'
}

export type BulkFlightBookingNotRestored = {
  __typename?: 'BulkFlightBookingNotRestored';
  bookingId: Scalars['ID']['output'];
  reason: BulkFlightUndoSkipReason;
};

export type BulkFlightPreview = {
  __typename?: 'BulkFlightPreview';
  /** CANCEL: bookings / passengers that will be detached (from denormalised flight data) */
  bookingsAffected: Scalars['NonNegativeInt']['output'];
  firstDate?: Maybe<Scalars['DateTime']['output']>;
  lastDate?: Maybe<Scalars['DateTime']['output']>;
  passengersAffected: Scalars['NonNegativeInt']['output'];
  skipped: Array<BulkFlightSkipCount>;
  unchanged: Scalars['NonNegativeInt']['output'];
  willUpdate: Scalars['NonNegativeInt']['output'];
};

/** Result of 'select all matching': ids only when total <= 100 */
export type BulkFlightSelection = {
  __typename?: 'BulkFlightSelection';
  /** Spec 235: true when a search + tag selection hit the read cap (2000 search matches) — total is then a lower bound */
  capped?: Maybe<Scalars['Boolean']['output']>;
  /** Empty when total > 100 */
  flightIds: Array<Scalars['ID']['output']>;
  limit: Scalars['PositiveInt']['output'];
  total: Scalars['NonNegativeInt']['output'];
};

export type BulkFlightSkipCount = {
  __typename?: 'BulkFlightSkipCount';
  count: Scalars['PositiveInt']['output'];
  reason: BulkFlightSkipReason;
};

export enum BulkFlightSkipReason {
  /** Unexpected error for this flight; the others were applied */
  Error = 'ERROR',
  /** Delete: flight carries bookings */
  HasBookings = 'HAS_BOOKINGS',
  /** Cancel: flight is today or later and carries bookings - cancel individually so passengers are informed */
  HasBookingsFuture = 'HAS_BOOKINGS_FUTURE',
  /** Flight no longer exists or was deleted */
  NotFound = 'NOT_FOUND',
  /** Delete: only scheduled flights can be deleted */
  NotScheduled = 'NOT_SCHEDULED',
  /** Flight is cancelled or finished (not on the upcoming tab) */
  NotUpcoming = 'NOT_UPCOMING'
}

export enum BulkFlightUndoSkipReason {
  /** Flight was changed after the bulk action */
  ChangedSince = 'CHANGED_SINCE',
  /** Booking deleted meanwhile */
  Deleted = 'DELETED',
  /** Unexpected error for this flight; the others were restored */
  Error = 'ERROR',
  /** Flight no longer exists */
  NotFound = 'NOT_FOUND',
  /** Booking no longer open */
  NotOpen = 'NOT_OPEN',
  /** Booking meanwhile planned on another flight */
  OnOtherFlight = 'ON_OTHER_FLIGHT'
}

export type Calendar = {
  __typename?: 'Calendar';
  events?: Maybe<Array<Maybe<Event>>>;
  flights?: Maybe<Array<Maybe<Flight>>>;
};

export type CalendarDayFlyability = {
  __typename?: 'CalendarDayFlyability';
  assessment?: Maybe<FlyabilityAssessment>;
  period?: Maybe<FlightPeriod>;
};

export type CalendarItem = {
  __typename?: 'CalendarItem';
  color?: Maybe<Scalars['JSONObject']['output']>;
  meta?: Maybe<Scalars['JSONObject']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CalendarWeek = {
  __typename?: 'CalendarWeek';
  /** 228: true once any crew availability record exists in the tenant (cached 1 h, lazy) */
  availabilityActive?: Maybe<Scalars['Boolean']['output']>;
  days?: Maybe<Array<Maybe<CalendarWeekDay>>>;
  defaultLocation?: Maybe<Location>;
  events?: Maybe<Array<Maybe<Event>>>;
  flights?: Maybe<Array<Maybe<Flight>>>;
  openBookings?: Maybe<Array<Maybe<OpenBookingDemand>>>;
  /** 228 US8: learned preferred crew per balloon (lazy, cached 1 h; balloons without one are left out) */
  preferredCrews?: Maybe<Array<Maybe<PreferredCrew>>>;
};

export type CalendarWeekDay = {
  __typename?: 'CalendarWeekDay';
  date?: Maybe<Scalars['String']['output']>;
  flyability?: Maybe<Array<Maybe<CalendarDayFlyability>>>;
  sunrise?: Maybe<Scalars['String']['output']>;
  sunset?: Maybe<Scalars['String']['output']>;
};

export type CallSignPopularity = {
  __typename?: 'CallSignPopularity';
  callSign?: Maybe<Scalars['String']['output']>;
  crewPopularity?: Maybe<Scalars['NonNegativeInt']['output']>;
  pilotPopularity?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type Category = {
  __typename?: 'Category';
  child?: Maybe<Scalars['Boolean']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  passengerId?: Maybe<Scalars['ID']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryInput = {
  child?: InputMaybe<Scalars['Boolean']['input']>;
  default?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
};

export type Chart = {
  __typename?: 'Chart';
  columns?: Maybe<Scalars['JSONObject']['output']>;
  data?: Maybe<Scalars['JSONObject']['output']>;
  options?: Maybe<Scalars['JSONObject']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<ChartType>;
};

export type ChartColor = {
  __typename?: 'ChartColor';
  backgroundColor?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  borderColor?: Maybe<Scalars['String']['output']>;
};

export enum ChartType {
  AnnotationChart = 'AnnotationChart',
  AreaChart = 'AreaChart',
  Bar = 'Bar',
  BarChart = 'BarChart',
  BubbleChart = 'BubbleChart',
  Calendar = 'Calendar',
  CandlestickChart = 'CandlestickChart',
  ColumnChart = 'ColumnChart',
  ComboChart = 'ComboChart',
  Gantt = 'Gantt',
  Gauge = 'Gauge',
  GeoChart = 'GeoChart',
  Histogram = 'Histogram',
  Line = 'Line',
  LineChart = 'LineChart',
  Map = 'Map',
  OrgChart = 'OrgChart',
  PieChart = 'PieChart',
  Sankey = 'Sankey',
  Scatter = 'Scatter',
  ScatterChart = 'ScatterChart',
  SteppedAreaChart = 'SteppedAreaChart',
  Table = 'Table',
  Timeline = 'Timeline',
  TreeMap = 'TreeMap',
  Wordtree = 'wordtree'
}

export enum CheckinLogSection {
  Flight = 'FLIGHT',
  Fuel = 'FUEL',
  Passengers = 'PASSENGERS',
  Signoff = 'SIGNOFF',
  Weather = 'WEATHER'
}

/**
 * Tiered check-in setting: NONE = no check-in, PDF = paper signature sheet only,
 * ONLINE = online check-in + paper sheet.
 */
export enum CheckinMode {
  None = 'NONE',
  Online = 'ONLINE',
  Pdf = 'PDF'
}

export enum CheckinNotificationChannel {
  Both = 'BOTH',
  Email = 'EMAIL',
  None = 'NONE',
  Whatsapp = 'WHATSAPP'
}

/** Whitelist of pilot-editable parameters during mobile check-in (112). All optional; omitted = untouched. */
export type CheckinParametersInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Planned takeoff time as HH:mm on the flight's own date */
  hour?: InputMaybe<Scalars['String']['input']>;
  /** Overrides the cylinder-derived maximum flight time (manual override, like the weather fields) */
  maximumFlightTime?: InputMaybe<Scalars['PositiveInt']['input']>;
  plannedFlightTime?: InputMaybe<Scalars['PositiveInt']['input']>;
  /** Maximum envelope temperature (degrees C) used in the lift computation - overrides the balloon default (issue #69, cair) */
  tempBalloon?: InputMaybe<Scalars['PositiveInt']['input']>;
  tempTakeoff?: InputMaybe<Scalars['Int']['input']>;
  weatherQnh?: InputMaybe<Scalars['Int']['input']>;
  windGl?: InputMaybe<Scalars['Int']['input']>;
  windGlDirection?: InputMaybe<Scalars['Int']['input']>;
};

export type ClassGroup = {
  __typename?: 'ClassGroup';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export enum ContactLanguage {
  De = 'de',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Nl = 'nl'
}

export type Country = {
  __typename?: 'Country';
  country?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Crew = ICrew & {
  __typename?: 'Crew';
  FlightAppId?: Maybe<Scalars['String']['output']>;
  FlightAppKey?: Maybe<Scalars['String']['output']>;
  callSignPopularity?: Maybe<Array<Maybe<CallSignPopularity>>>;
  driverLicense?: Maybe<Scalars['Boolean']['output']>;
  driverLicenseCategory?: Maybe<DriverLicense>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  emailNotifications?: Maybe<Scalars['EmailAddress']['output']>;
  fireExtinguisherExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  firstAidExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  groundCrew?: Maybe<Scalars['Boolean']['output']>;
  groundCrewTrainingExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  isCurrent?: Maybe<Scalars['Int']['output']>;
  isGroundCrewCurrent?: Maybe<Scalars['Int']['output']>;
  isPilot?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<ContactLanguage>;
  licenseExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  licenseExtraCrew?: Maybe<Scalars['Boolean']['output']>;
  licenseGas?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupA?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupB?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupC?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupD?: Maybe<Scalars['Boolean']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  logbook?: Maybe<LogBook>;
  medicalExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  medicalWeight?: Maybe<Scalars['PositiveInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  pilotLicense?: Maybe<PilotLicense>;
  /** 228 US8: balloons whose learned preferred crew includes this person */
  preferredCrewOf?: Maybe<Array<Maybe<Balloon>>>;
  proficiencyLatestBpl?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightA?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightB?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightC?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightD?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestGas?: Maybe<Scalars['DateTime']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  smsLatest?: Maybe<SmsLatest>;
  smsType?: Maybe<SmsConversationType>;
  smsUnread?: Maybe<Scalars['NonNegativeInt']['output']>;
  status?: Maybe<CrewStatus>;
  totalWeight?: Maybe<Scalars['PositiveInt']['output']>;
  trackingDates?: Maybe<Array<Maybe<TrackingDate>>>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['ID']['output']>;
  userRole?: Maybe<UserRole>;
};

export enum CrewAvailability {
  Maybe = 'MAYBE',
  No = 'NO',
  Unk = 'UNK',
  Yes = 'YES'
}

export type CrewAvailabilityInput = {
  availability: CrewAvailability;
  crewId?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  period: FlightPeriod;
  type?: InputMaybe<EventType>;
};

export type CrewCalendarDay = {
  __typename?: 'CrewCalendarDay';
  flightsEvening?: Maybe<CrewDayContent>;
  flightsMorning?: Maybe<CrewDayContent>;
};

export type CrewCalendarItem = {
  __typename?: 'CrewCalendarItem';
  meta?: Maybe<CrewCalendarDay>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type CrewDayContent = {
  __typename?: 'CrewDayContent';
  crewEvent?: Maybe<Event>;
  flights?: Maybe<Array<Maybe<Flight>>>;
  operatorEvents?: Maybe<Array<Maybe<Event>>>;
  selectedFlights?: Maybe<Array<Maybe<Flight>>>;
  totalFlights?: Maybe<Scalars['Int']['output']>;
};

export type CrewInFlight = {
  __typename?: 'CrewInFlight';
  crew?: Maybe<CrewPerFlight>;
  status?: Maybe<CrewStatus>;
};

export type CrewInput = {
  driverLicense?: InputMaybe<Scalars['Boolean']['input']>;
  driverLicenseCategory?: InputMaybe<DriverLicense>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  emailNotifications?: InputMaybe<Scalars['EmailAddress']['input']>;
  fireExtinguisherExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  firstAidExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  groundCrew?: InputMaybe<Scalars['Boolean']['input']>;
  groundCrewTrainingExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  language?: InputMaybe<ContactLanguage>;
  licenseExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  licenseExtraCrew?: InputMaybe<Scalars['Boolean']['input']>;
  licenseGas?: InputMaybe<Scalars['Boolean']['input']>;
  licenseGroupA?: InputMaybe<Scalars['Boolean']['input']>;
  licenseGroupB?: InputMaybe<Scalars['Boolean']['input']>;
  licenseGroupC?: InputMaybe<Scalars['Boolean']['input']>;
  licenseGroupD?: InputMaybe<Scalars['Boolean']['input']>;
  licenseNumber?: InputMaybe<Scalars['String']['input']>;
  medicalExpiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  medicalWeight?: InputMaybe<Scalars['PositiveInt']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  pilotLicense?: InputMaybe<PilotLicense>;
  userRole?: InputMaybe<UserRole>;
};

export type CrewPerFlight = ICrew & {
  __typename?: 'CrewPerFlight';
  FlightAppId?: Maybe<Scalars['String']['output']>;
  FlightAppKey?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<CrewAvailability>;
  availabilityReason?: Maybe<Scalars['String']['output']>;
  callSignPopularity?: Maybe<Array<Maybe<CallSignPopularity>>>;
  driverLicense?: Maybe<Scalars['Boolean']['output']>;
  driverLicenseCategory?: Maybe<DriverLicense>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  emailNotifications?: Maybe<Scalars['EmailAddress']['output']>;
  fireExtinguisherExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  firstAidExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  groundCrew?: Maybe<Scalars['Boolean']['output']>;
  groundCrewTrainingExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  isCurrent?: Maybe<Scalars['Int']['output']>;
  isGroundCrewCurrent?: Maybe<Scalars['Int']['output']>;
  isPilot?: Maybe<Scalars['Boolean']['output']>;
  language?: Maybe<ContactLanguage>;
  licenseExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  licenseExtraCrew?: Maybe<Scalars['Boolean']['output']>;
  licenseGas?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupA?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupB?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupC?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupD?: Maybe<Scalars['Boolean']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  logbook?: Maybe<LogBook>;
  medicalExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  medicalWeight?: Maybe<Scalars['PositiveInt']['output']>;
  mostPopular?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  otherFlight?: Maybe<Flight>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  pilotLicense?: Maybe<PilotLicense>;
  popularity?: Maybe<Scalars['NonNegativeInt']['output']>;
  proficiencyLatestBpl?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightA?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightB?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightC?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightD?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestGas?: Maybe<Scalars['DateTime']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<CrewStatus>;
  totalWeight?: Maybe<Scalars['PositiveInt']['output']>;
  trackingDates?: Maybe<Array<Maybe<TrackingDate>>>;
  userId?: Maybe<Scalars['ID']['output']>;
  userRole?: Maybe<UserRole>;
};

export enum CrewReadyChannel {
  Both = 'BOTH',
  Email = 'EMAIL',
  None = 'NONE',
  Whatsapp = 'WHATSAPP'
}

export enum CrewStatus {
  Con = 'CON',
  Dec = 'DEC',
  Inv = 'INV',
  Unk = 'UNK'
}

export type Cylinder = {
  __typename?: 'Cylinder';
  emptyWeight?: Maybe<Scalars['PositiveInt']['output']>;
  fullWeight?: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  manufacturer?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['NonNegativeInt']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['PositiveInt']['output']>;
};

export type CylinderInput = {
  emptyWeight?: InputMaybe<Scalars['PositiveInt']['input']>;
  fullWeight?: InputMaybe<Scalars['PositiveInt']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  serialNumber?: InputMaybe<Scalars['String']['input']>;
  volume?: InputMaybe<Scalars['PositiveInt']['input']>;
};

export type DashboardOptions = {
  __typename?: 'DashboardOptions';
  preferredDateToday?: Maybe<Scalars['Boolean']['output']>;
  recent?: Maybe<Scalars['NonNegativeInt']['output']>;
  toConfirm?: Maybe<Scalars['Boolean']['output']>;
};

export type DatePart = {
  __typename?: 'DatePart';
  part?: Maybe<DatePartType>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum DatePartType {
  Sunrise = 'SUNRISE',
  Sunset = 'SUNSET'
}

export type DebtorValidation = {
  __typename?: 'DebtorValidation';
  checkedAt?: Maybe<Scalars['DateTime']['output']>;
  issues: Array<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type DisplayedColumn = {
  __typename?: 'DisplayedColumn';
  active?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  mobile?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type DisplayedColumns = {
  __typename?: 'DisplayedColumns';
  bookingsDashboard?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsDashboardDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlight?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightAll?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightAllDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightCancelled?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightCancelledDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightEnd?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightEndDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightPayment?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsFlightPaymentDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsHistory?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsHistoryDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsOpen?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsOpenDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsPayment?: Maybe<Array<Maybe<DisplayedColumn>>>;
  bookingsPaymentDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  flightsBooking?: Maybe<Array<Maybe<DisplayedColumn>>>;
  flightsBookingDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  flightsHistory?: Maybe<Array<Maybe<DisplayedColumn>>>;
  flightsHistoryDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
  flightsUpcoming?: Maybe<Array<Maybe<DisplayedColumn>>>;
  flightsUpcomingDefault?: Maybe<Array<Maybe<DisplayedColumn>>>;
};

export enum DriverLicense {
  B = 'B',
  Be = 'BE',
  None = 'NONE'
}

export type ElevationResult = {
  __typename?: 'ElevationResult';
  elevation: Scalars['Float']['output'];
  location?: Maybe<Mapslocation>;
  resolution?: Maybe<Scalars['Float']['output']>;
};

export type Email = {
  __typename?: 'Email';
  attachments: Array<Maybe<EmailAttachment>>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  events?: Maybe<Array<Maybe<EmailEvent>>>;
  flightId?: Maybe<Scalars['ID']['output']>;
  from?: Maybe<EmailAddressObject>;
  html?: Maybe<Scalars['String']['output']>;
  locationId?: Maybe<Scalars['ID']['output']>;
  messageId?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['JSONObject']['output']>;
  replyTo?: Maybe<EmailAddressObject>;
  result?: Maybe<Scalars['String']['output']>;
  resultAt?: Maybe<Scalars['DateTime']['output']>;
  resultError?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  to?: Maybe<Scalars['String']['output']>;
};

export type EmailAddressInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmailAddressObject = {
  __typename?: 'EmailAddressObject';
  email?: Maybe<Scalars['EmailAddress']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type EmailAttachment = {
  __typename?: 'EmailAttachment';
  filename?: Maybe<Scalars['String']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type EmailAttachmentInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  reference?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EmailEvent = {
  __typename?: 'EmailEvent';
  attempt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  ip?: Maybe<Scalars['String']['output']>;
  response?: Maybe<Scalars['String']['output']>;
  sg_content_type?: Maybe<Scalars['String']['output']>;
  sg_event_id?: Maybe<Scalars['String']['output']>;
  sg_machine_open?: Maybe<Scalars['String']['output']>;
  sg_message_id?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
  useragent?: Maybe<Scalars['String']['output']>;
};

export type EmailInput = {
  attachments: Array<InputMaybe<EmailAttachmentInput>>;
  bcc?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  bookingId?: InputMaybe<Scalars['String']['input']>;
  cc?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  crewId?: InputMaybe<Scalars['String']['input']>;
  flightId?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<EmailAddressInput>;
  html?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  replyTo?: InputMaybe<EmailAddressInput>;
  subject?: InputMaybe<Scalars['String']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type EmailLanguages = {
  __typename?: 'EmailLanguages';
  de?: Maybe<EmailTemplateByLanguage>;
  en?: Maybe<EmailTemplateByLanguage>;
  fr?: Maybe<EmailTemplateByLanguage>;
  nl?: Maybe<EmailTemplateByLanguage>;
};

export type EmailLanguagesInput = {
  de?: InputMaybe<EmailTemplateByLanguageInput>;
  en?: InputMaybe<EmailTemplateByLanguageInput>;
  fr?: InputMaybe<EmailTemplateByLanguageInput>;
  nl?: InputMaybe<EmailTemplateByLanguageInput>;
};

export type EmailSettingsTemplate = {
  __typename?: 'EmailSettingsTemplate';
  id: Scalars['ID']['output'];
  template?: Maybe<EmailLanguages>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<EmailTemplateType>;
};

export type EmailTemplateByLanguage = {
  __typename?: 'EmailTemplateByLanguage';
  attachments?: Maybe<Array<Maybe<EmailAttachment>>>;
  body: Scalars['String']['output'];
  subject: Scalars['String']['output'];
};

export type EmailTemplateByLanguageInput = {
  attachments?: InputMaybe<Array<InputMaybe<EmailAttachmentInput>>>;
  body: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type EmailTemplateInput = {
  template?: InputMaybe<EmailLanguagesInput>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum EmailTemplateType {
  BookingConfirmEmail = 'bookingConfirmEmail',
  BookingFlightCancelEmail = 'bookingFlightCancelEmail',
  BookingFlightConfirmEmail = 'bookingFlightConfirmEmail',
  CheckinNotificationEmail = 'checkinNotificationEmail',
  CrewFlightEmail = 'crewFlightEmail',
  CrewOtpEmail = 'crewOtpEmail',
  LocationContactEmail = 'locationContactEmail',
  PilotFlightEmail = 'pilotFlightEmail'
}

export type Event = {
  __typename?: 'Event';
  availability?: Maybe<CrewAvailability>;
  crew?: Maybe<Crew>;
  date: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  period?: Maybe<FlightPeriod>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<EventType>;
};

export type EventData = {
  __typename?: 'EventData';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type EventInput = {
  crewId?: InputMaybe<Scalars['ID']['input']>;
  date: Scalars['DateTime']['input'];
  description: Scalars['String']['input'];
  type?: InputMaybe<EventType>;
};

export enum EventType {
  Cre = 'CRE',
  Opr = 'OPR'
}

export type FilterRange = {
  __typename?: 'FilterRange';
  endDate?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type FilterRangeInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
};

export type Flight = {
  __typename?: 'Flight';
  _created?: Maybe<Scalars['DateTime']['output']>;
  _modified?: Maybe<Scalars['DateTime']['output']>;
  api?: Maybe<FlightApi>;
  balloon?: Maybe<Balloon>;
  balloonCapacityReduction?: Maybe<Scalars['NonNegativeInt']['output']>;
  bookings: FlightBookings;
  bookingsData?: Maybe<BookingsData>;
  /** 222: reasonCode of the cancel template variant that was sent */
  cancelMessageReason?: Maybe<Scalars['String']['output']>;
  /** 222: true once a cancelSms to passengers was queued; false = cancelled without telling passengers; null = unknown */
  cancelMessageSent?: Maybe<Scalars['Boolean']['output']>;
  cancelReason?: Maybe<Scalars['String']['output']>;
  /** Bookings that were on this flight at its last cancellation, resolved live. Empty for flights never cancelled or cancelled before this feature; deleted bookings are omitted. */
  cancelledBookings?: Maybe<Array<Booking>>;
  /** Append-only log of changes made through mobile check-in (112). Lazy sub-resolver - never select in list queries. */
  checkinLogs?: Maybe<Array<FlightCheckinLog>>;
  comment?: Maybe<Scalars['String']['output']>;
  crewComments?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['DateTime']['output']>;
  events: Array<Maybe<Event>>;
  eventsData?: Maybe<Array<Maybe<EventData>>>;
  flightDistance?: Maybe<Scalars['Float']['output']>;
  flightDuplicates?: Maybe<Array<Maybe<Flight>>>;
  flightDuplicatesBlocking?: Maybe<Scalars['Boolean']['output']>;
  flightHeading?: Maybe<Scalars['Float']['output']>;
  flightTime?: Maybe<Scalars['PositiveInt']['output']>;
  flightsAtSameDay: FlightsAtSameDay;
  flyability?: Maybe<FlyabilityAssessment>;
  groundCrews: Array<Maybe<CrewInFlight>>;
  hour?: Maybe<Scalars['DateTime']['output']>;
  hourMeeting?: Maybe<Scalars['DateTime']['output']>;
  icon: Icon;
  id: Scalars['ID']['output'];
  landingDetails?: Maybe<Scalars['String']['output']>;
  landingLatitude?: Maybe<Scalars['Float']['output']>;
  landingLocation?: Maybe<Scalars['String']['output']>;
  landingLongitude?: Maybe<Scalars['Float']['output']>;
  landingTime?: Maybe<Scalars['DateTime']['output']>;
  liftAvailable?: Maybe<Scalars['Float']['output']>;
  liftDataMismatch?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  liftNeeded?: Maybe<Scalars['Float']['output']>;
  liftPassengers?: Maybe<Scalars['Float']['output']>;
  liftSpare?: Maybe<Scalars['Float']['output']>;
  liftWarningLevel?: Maybe<LiftWarningLevel>;
  location?: Maybe<Location>;
  locationEmail?: Maybe<MailEventLatest>;
  locationSmsLatest?: Maybe<SmsLatest>;
  locationType?: Maybe<LocationType>;
  logs?: Maybe<Array<Maybe<BookingLog>>>;
  maximumFlightTime?: Maybe<Scalars['PositiveInt']['output']>;
  /** True once the pilot overrode the maximum flight time in mobile check-in: the stored value beats the cylinder-derived one (112) */
  maximumFlightTimeManual?: Maybe<Scalars['Boolean']['output']>;
  maximumHeight?: Maybe<Scalars['PositiveInt']['output']>;
  meetingPointAddress?: Maybe<Scalars['String']['output']>;
  meetingPointCity?: Maybe<Scalars['String']['output']>;
  meetingPointLatitude?: Maybe<Scalars['Float']['output']>;
  meetingPointLongitude?: Maybe<Scalars['Float']['output']>;
  meetingPointSameAsTakeOff?: Maybe<Scalars['Boolean']['output']>;
  meetingPointURL?: Maybe<Scalars['String']['output']>;
  meteo?: Maybe<MeteoblueForecastSlot>;
  /** 228: status of the calling crew member on this flight (null when not on it) */
  myCrewStatus?: Maybe<CrewStatus>;
  /** Denormalized NOTAM indicator from the flight document (zero extra reads) — planning list / cards (095, FR-005) */
  notam?: Maybe<FlightNotamSummary>;
  /** Lazy full NOTAM assessment (trajectory-refined) — flight detail only, never in list queries (Constitution V) */
  notamAssessment?: Maybe<NotamAssessment>;
  number?: Maybe<Scalars['NonNegativeInt']['output']>;
  passengerCounters: FlightPassengerCounters;
  passengersConfirmed?: Maybe<Scalars['Int']['output']>;
  passengersCount?: Maybe<Scalars['Int']['output']>;
  passengersData?: Maybe<PassengerData>;
  passengersOccupancy?: Maybe<Scalars['NonNegativeInt']['output']>;
  period?: Maybe<FlightPeriod>;
  pilot?: Maybe<CrewInFlight>;
  pilotActionNeeded?: Maybe<Scalars['Boolean']['output']>;
  pilotComments?: Maybe<Scalars['String']['output']>;
  pilotSignOffDate?: Maybe<Scalars['DateTime']['output']>;
  pilotSignature?: Maybe<Scalars['String']['output']>;
  pilotSignoff?: Maybe<Scalars['String']['output']>;
  pilotStatus?: Maybe<CrewStatus>;
  plannedFlightTime?: Maybe<Scalars['PositiveInt']['output']>;
  /** 228: visible to every crew member in 'Mijn week'; assigned crew always see their own flight. Absent = false. */
  published?: Maybe<Scalars['Boolean']['output']>;
  refuelVolume?: Maybe<Scalars['PositiveInt']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  skeyesForecast?: Maybe<FlightSkeyesForecast>;
  spareFlightTime?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<FlightStatus>;
  sunriseSunset?: Maybe<SunriseSunset>;
  tags?: Maybe<Array<Maybe<FlightTag>>>;
  tagsData?: Maybe<Array<Maybe<TagData>>>;
  takeoffTime?: Maybe<Scalars['DateTime']['output']>;
  tempBalloon?: Maybe<Scalars['PositiveInt']['output']>;
  tempMax?: Maybe<Scalars['Int']['output']>;
  tempTakeoff?: Maybe<Scalars['Int']['output']>;
  tempTakeoffManual?: Maybe<Scalars['Boolean']['output']>;
  trajectory?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory200?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory300?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory400?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory500?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory600?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory700?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory800?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory925?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory950?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectory1000?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectoryCustom?: Maybe<Array<Maybe<Mapslocation>>>;
  trajectoryImageUrl?: Maybe<Scalars['String']['output']>;
  upcoming?: Maybe<Scalars['Boolean']['output']>;
  vfrClouds?: Maybe<Scalars['Int']['output']>;
  vfrVisual?: Maybe<Scalars['Int']['output']>;
  visibility?: Maybe<VisibilityType>;
  weatherForecastDate?: Maybe<Scalars['DateTime']['output']>;
  /** True once the pilot corrected any weather value in mobile check-in: stored weather beats the live forecast overlay (112) */
  weatherManual?: Maybe<Scalars['Boolean']['output']>;
  weatherPmax?: Maybe<Scalars['Int']['output']>;
  weatherQnh?: Maybe<Scalars['Int']['output']>;
  weatherSource?: Maybe<Scalars['String']['output']>;
  wind10?: Maybe<Scalars['Int']['output']>;
  wind10Direction?: Maybe<Scalars['Int']['output']>;
  wind20?: Maybe<Scalars['Int']['output']>;
  wind20Direction?: Maybe<Scalars['Int']['output']>;
  windGl?: Maybe<Scalars['Int']['output']>;
  windGlDirection?: Maybe<Scalars['Int']['output']>;
  windSummary?: Maybe<Scalars['String']['output']>;
};

export type FlightApi = {
  __typename?: 'FlightApi';
  balloonCapacity?: Maybe<Scalars['NonNegativeInt']['output']>;
  balloonName?: Maybe<Scalars['String']['output']>;
  confirmedPassengers?: Maybe<Scalars['NonNegativeInt']['output']>;
  flightDate?: Maybe<Scalars['String']['output']>;
  flightHour?: Maybe<Scalars['String']['output']>;
  flightId?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['NonNegativeInt']['output']>;
  flightPeriod?: Maybe<Scalars['String']['output']>;
  freeCapacity?: Maybe<Scalars['NonNegativeInt']['output']>;
  locationAddress?: Maybe<Scalars['String']['output']>;
  locationCity?: Maybe<Scalars['String']['output']>;
  locationName?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  regionNumber?: Maybe<Scalars['String']['output']>;
  toConfirmPassengers?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type FlightAppAircraft = {
  __typename?: 'FlightAppAircraft';
  aircraft?: Maybe<FlightAppAircraftDetails>;
  balloonId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type FlightAppAircraftDetails = {
  __typename?: 'FlightAppAircraftDetails';
  aircraft_type?: Maybe<FlightAppAircraftType>;
  callsign?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  serial_number?: Maybe<Scalars['String']['output']>;
  total_flight_duration?: Maybe<Scalars['Float']['output']>;
  total_flight_duration_human?: Maybe<Scalars['String']['output']>;
  weight_category?: Maybe<Scalars['String']['output']>;
};

export type FlightAppAircraftType = {
  __typename?: 'FlightAppAircraftType';
  aircraft_category?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  weight_category?: Maybe<Scalars['String']['output']>;
};

export type FlightAppAirport = {
  __typename?: 'FlightAppAirport';
  city?: Maybe<Scalars['String']['output']>;
  countryIso?: Maybe<Scalars['String']['output']>;
  icao?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FlightAppApiKey = {
  __typename?: 'FlightAppApiKey';
  aircraftsIds?: Maybe<Array<Maybe<FlightAppAircraft>>>;
  key?: Maybe<Scalars['String']['output']>;
  pilotIds?: Maybe<FlightAppPilot>;
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type FlightAppIntegration = {
  __typename?: 'FlightAppIntegration';
  enabled?: Maybe<Scalars['Boolean']['output']>;
  keys?: Maybe<Array<Maybe<FlightAppApiKey>>>;
};

export type FlightAppLog = {
  __typename?: 'FlightAppLog';
  arrivalTime?: Maybe<Scalars['DateTime']['output']>;
  departureAirport?: Maybe<FlightAppAirport>;
  departureTime?: Maybe<Scalars['DateTime']['output']>;
  destinationAirport?: Maybe<FlightAppAirport>;
  flightDuration?: Maybe<Scalars['NonNegativeInt']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  natureOfFlight?: Maybe<Scalars['String']['output']>;
  numberOfPassengers?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type FlightAppLogList = {
  __typename?: 'FlightAppLogList';
  logs?: Maybe<Array<Maybe<FlightAppLog>>>;
  meta?: Maybe<Scalars['JSON']['output']>;
};

export type FlightAppPilot = {
  __typename?: 'FlightAppPilot';
  id?: Maybe<Scalars['String']['output']>;
  pilot?: Maybe<FlightAppPilotDetails>;
  pilotId?: Maybe<Scalars['String']['output']>;
};

export type FlightAppPilotDetails = {
  __typename?: 'FlightAppPilotDetails';
  id?: Maybe<Scalars['String']['output']>;
  license_number?: Maybe<Scalars['String']['output']>;
  number_of_entries?: Maybe<Scalars['NonNegativeInt']['output']>;
  pilot?: Maybe<FlightAppPilotObject>;
  total_flight_time?: Maybe<Scalars['NonNegativeInt']['output']>;
  total_flight_time_in_hours?: Maybe<Scalars['Float']['output']>;
};

export type FlightAppPilotObject = {
  __typename?: 'FlightAppPilotObject';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type FlightBookings = {
  __typename?: 'FlightBookings';
  addedCount: Scalars['NonNegativeInt']['output'];
  count: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  list: Array<Maybe<Booking>>;
  notConfirmedCount: Scalars['NonNegativeInt']['output'];
  notConfirmedNames: Scalars['String']['output'];
};

export type FlightCheckinLog = {
  __typename?: 'FlightCheckinLog';
  date: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  newValue?: Maybe<Scalars['String']['output']>;
  oldValue?: Maybe<Scalars['String']['output']>;
  parameter: Scalars['String']['output'];
  passengerName?: Maybe<Scalars['String']['output']>;
  section: CheckinLogSection;
  /** Pilot signature snapshot (data URL) - only on SIGNOFF 'signed' entries */
  signature?: Maybe<Scalars['String']['output']>;
  user: Scalars['String']['output'];
};

export type FlightCounters = {
  __typename?: 'FlightCounters';
  historical?: Maybe<Scalars['NonNegativeInt']['output']>;
  scheduled?: Maybe<Scalars['NonNegativeInt']['output']>;
  statusCounters?: Maybe<Array<Maybe<StatusCounter>>>;
  upcoming?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Upcoming-status (SCH/REA) flights dated more than 7 days in the past (before midnight UTC) — the flight list's Not closed (older) status */
  upcomingOlder?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type FlightCrewInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  isPilot?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<CrewStatus>;
};

export type FlightInput = {
  balloon?: InputMaybe<Scalars['ID']['input']>;
  balloonCapacityReduction?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  crewComments?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  hour?: InputMaybe<Scalars['DateTime']['input']>;
  hourMeeting?: InputMaybe<Scalars['DateTime']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  locationType?: InputMaybe<LocationType>;
  maximumHeight?: InputMaybe<Scalars['PositiveInt']['input']>;
  meetingPointAddress?: InputMaybe<Scalars['String']['input']>;
  meetingPointCity?: InputMaybe<Scalars['String']['input']>;
  meetingPointLatitude?: InputMaybe<Scalars['Float']['input']>;
  meetingPointLongitude?: InputMaybe<Scalars['Float']['input']>;
  meetingPointSameAsTakeOff?: InputMaybe<Scalars['Boolean']['input']>;
  meetingPointURL?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<FlightPeriod>;
  plannedFlightTime?: InputMaybe<Scalars['PositiveInt']['input']>;
  refuelVolume?: InputMaybe<Scalars['PositiveInt']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tempBalloon?: InputMaybe<Scalars['PositiveInt']['input']>;
  tempTakeoff?: InputMaybe<Scalars['Int']['input']>;
  tempTakeoffManual?: InputMaybe<Scalars['Boolean']['input']>;
  vfrClouds?: InputMaybe<Scalars['Int']['input']>;
  vfrVisual?: InputMaybe<Scalars['Int']['input']>;
  visibility?: InputMaybe<VisibilityType>;
  weatherForecastDate?: InputMaybe<Scalars['DateTime']['input']>;
  weatherQnh?: InputMaybe<Scalars['Int']['input']>;
  weatherSource?: InputMaybe<Scalars['String']['input']>;
  wind10?: InputMaybe<Scalars['Int']['input']>;
  wind10Direction?: InputMaybe<Scalars['Int']['input']>;
  wind20?: InputMaybe<Scalars['Int']['input']>;
  wind20Direction?: InputMaybe<Scalars['Int']['input']>;
  windGl?: InputMaybe<Scalars['Int']['input']>;
  windGlDirection?: InputMaybe<Scalars['Int']['input']>;
  windSummary?: InputMaybe<Scalars['String']['input']>;
};

/** Denormalized indicator stored on the flight document — the ONLY field flight list queries may select. */
export type FlightNotamSummary = {
  __typename?: 'FlightNotamSummary';
  at?: Maybe<Scalars['DateTime']['output']>;
  count?: Maybe<Scalars['NonNegativeInt']['output']>;
  noData?: Maybe<Scalars['Boolean']['output']>;
  severity?: Maybe<NotamSeverity>;
};

export type FlightPassengerCounters = {
  __typename?: 'FlightPassengerCounters';
  freeSpots: Scalars['NonNegativeInt']['output'];
  id: Scalars['ID']['output'];
  occupancy: Scalars['NonNegativeInt']['output'];
  passengersCount: Scalars['NonNegativeInt']['output'];
  passengersCountAdded: Scalars['NonNegativeInt']['output'];
  passengersCountConfirmed: Scalars['NonNegativeInt']['output'];
  passengersCountInvited: Scalars['NonNegativeInt']['output'];
  passengersWeight: Scalars['NonNegativeInt']['output'];
};

export enum FlightPeriod {
  Eve = 'EVE',
  Mor = 'MOR'
}

export type FlightPeriodCounters = {
  __typename?: 'FlightPeriodCounters';
  flightsCount: Scalars['NonNegativeInt']['output'];
  freeSpots: Scalars['NonNegativeInt']['output'];
  passengersCount: Scalars['NonNegativeInt']['output'];
  passengersCountAdded: Scalars['NonNegativeInt']['output'];
  passengersCountConfirmed: Scalars['NonNegativeInt']['output'];
  passengersCountInvited: Scalars['NonNegativeInt']['output'];
};

export type FlightPeriodCountersPerPeriod = {
  __typename?: 'FlightPeriodCountersPerPeriod';
  EVE?: Maybe<FlightPeriodCounters>;
  MOR?: Maybe<FlightPeriodCounters>;
  endDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
};

export type FlightPeriods = {
  __typename?: 'FlightPeriods';
  day?: Maybe<Array<Maybe<FlightPeriodCountersPerPeriod>>>;
  month?: Maybe<Array<Maybe<FlightPeriodCountersPerPeriod>>>;
  week?: Maybe<Array<Maybe<FlightPeriodCountersPerPeriod>>>;
};

export type FlightSearchCounts = {
  __typename?: 'FlightSearchCounts';
  /** Spec 235: of upcoming, the flight list's Upcoming status (getFlightsList scope CURRENT) */
  current?: Maybe<Scalars['NonNegativeInt']['output']>;
  historical: Scalars['NonNegativeInt']['output'];
  /** Spec 235: of upcoming, the flight list's Not closed (older) status (getFlightsList scope OLDER; no free-spots filter) */
  older?: Maybe<Scalars['NonNegativeInt']['output']>;
  upcoming: Scalars['NonNegativeInt']['output'];
};

export type FlightSkeyesForecast = {
  __typename?: 'FlightSkeyesForecast';
  date?: Maybe<Scalars['DateTime']['output']>;
  forecast?: Maybe<SkeyesForecast>;
  username?: Maybe<Scalars['String']['output']>;
};

export enum FlightStatus {
  Can = 'CAN',
  Fin = 'FIN',
  Rea = 'REA',
  Sch = 'SCH'
}

export type FlightTag = Tag & {
  __typename?: 'FlightTag';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  bookingTags?: Maybe<Array<Maybe<BookingTag>>>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  onlyAllowedFlightTags?: Maybe<Scalars['Boolean']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TagType>;
  upcoming?: Maybe<Scalars['PositiveInt']['output']>;
};

export type FlightsAtSameDay = {
  __typename?: 'FlightsAtSameDay';
  count: Scalars['NonNegativeInt']['output'];
  flights: Array<Maybe<Flight>>;
  names: Scalars['String']['output'];
};

export type FlyabilityAssessment = {
  __typename?: 'FlyabilityAssessment';
  parameters: Array<FlyabilityParameter>;
  verdict: FlyabilityVerdict;
};

export enum FlyabilityBand {
  Good = 'GOOD',
  Marginal = 'MARGINAL',
  Nogo = 'NOGO',
  Unknown = 'UNKNOWN'
}

export type FlyabilityParameter = {
  __typename?: 'FlyabilityParameter';
  band: FlyabilityBand;
  key: Scalars['String']['output'];
  value?: Maybe<Scalars['Float']['output']>;
};

export type FlyabilityThreshold = {
  __typename?: 'FlyabilityThreshold';
  goodMax?: Maybe<Scalars['Float']['output']>;
  goodMin?: Maybe<Scalars['Float']['output']>;
  parameter: Scalars['String']['output'];
  warnMax?: Maybe<Scalars['Float']['output']>;
  warnMin?: Maybe<Scalars['Float']['output']>;
};

export type FlyabilityThresholdInput = {
  goodMax?: InputMaybe<Scalars['Float']['input']>;
  goodMin?: InputMaybe<Scalars['Float']['input']>;
  parameter: Scalars['String']['input'];
  warnMax?: InputMaybe<Scalars['Float']['input']>;
  warnMin?: InputMaybe<Scalars['Float']['input']>;
};

export enum FlyabilityVerdict {
  Good = 'GOOD',
  Marginal = 'MARGINAL',
  Nogo = 'NOGO'
}

export type GcpipUser = {
  __typename?: 'GCPIPUser';
  accessToken: Scalars['String']['output'];
  customClaims?: Maybe<Scalars['JSON']['output']>;
  email: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  uid: Scalars['ID']['output'];
  userData?: Maybe<User>;
};

export type GcpipUserInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<UserRole>;
};

export type GeocodeResult = {
  __typename?: 'GeocodeResult';
  address_components?: Maybe<Array<Maybe<AddressComponent>>>;
  elevation?: Maybe<Array<Maybe<ElevationResult>>>;
  formatted_address?: Maybe<Scalars['String']['output']>;
  geometry?: Maybe<Geometry>;
  partial_match?: Maybe<Scalars['Boolean']['output']>;
  place_id?: Maybe<Scalars['String']['output']>;
  plus_code?: Maybe<Pluscode>;
  types?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Geometry = {
  __typename?: 'Geometry';
  location?: Maybe<Mapslocation>;
  location_type?: Maybe<Scalars['String']['output']>;
  viewport?: Maybe<Viewport>;
};

export type ICrew = {
  FlightAppId?: Maybe<Scalars['String']['output']>;
  FlightAppKey?: Maybe<Scalars['String']['output']>;
  callSignPopularity?: Maybe<Array<Maybe<CallSignPopularity>>>;
  driverLicense?: Maybe<Scalars['Boolean']['output']>;
  driverLicenseCategory?: Maybe<DriverLicense>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  emailNotifications?: Maybe<Scalars['EmailAddress']['output']>;
  fireExtinguisherExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  firstAidExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  groundCrew?: Maybe<Scalars['Boolean']['output']>;
  groundCrewTrainingExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  language?: Maybe<ContactLanguage>;
  licenseExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  licenseExtraCrew?: Maybe<Scalars['Boolean']['output']>;
  licenseGas?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupA?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupB?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupC?: Maybe<Scalars['Boolean']['output']>;
  licenseGroupD?: Maybe<Scalars['Boolean']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  logbook?: Maybe<LogBook>;
  medicalExpiryDate?: Maybe<Scalars['DateTime']['output']>;
  medicalWeight?: Maybe<Scalars['PositiveInt']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['PhoneNumber']['output']>;
  pilotLicense?: Maybe<PilotLicense>;
  proficiencyLatestBpl?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightA?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightB?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightC?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestFlightD?: Maybe<Scalars['DateTime']['output']>;
  proficiencyLatestGas?: Maybe<Scalars['DateTime']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  trackingDates?: Maybe<Array<Maybe<TrackingDate>>>;
  userId?: Maybe<Scalars['ID']['output']>;
  userRole?: Maybe<UserRole>;
};

export type Icon = {
  __typename?: 'Icon';
  color: Scalars['String']['output'];
  sign: Scalars['String']['output'];
};

export type ImportLogBook = {
  __typename?: 'ImportLogBook';
  balloon?: Maybe<Balloon>;
  logs: Array<Maybe<Log>>;
  logsCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  pilot?: Maybe<Crew>;
  type: LogBookType;
};

export type InputDashboardOptions = {
  preferredDateToday?: InputMaybe<Scalars['Boolean']['input']>;
  recent?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  toConfirm?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputDisplayedColumn = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  disabled?: InputMaybe<Scalars['Boolean']['input']>;
  minSize?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  mobile?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputDisplayedColumns = {
  bookingsDashboard?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  bookingsFlight?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  bookingsFlightAll?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  bookingsFlightCancelled?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  bookingsFlightEnd?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  bookingsFlightPayment?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  bookingsHistory?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  bookingsOpen?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  bookingsPayment?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  flightsBooking?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  flightsHistory?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  flightsUpcoming?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
};

export type InputEmailAddressObject = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type InputFlightAppAircraft = {
  balloonId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
};

export type InputFlightAppApiKey = {
  aircraftsIds?: InputMaybe<Array<InputMaybe<InputFlightAppAircraft>>>;
  key?: InputMaybe<Scalars['String']['input']>;
  pilotIds?: InputMaybe<InputFlightAppPilot>;
  valid?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputFlightAppIntegration = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  keys?: InputMaybe<Array<InputMaybe<InputFlightAppApiKey>>>;
};

export type InputFlightAppPilot = {
  id?: InputMaybe<Scalars['String']['input']>;
  pilotId?: InputMaybe<Scalars['String']['input']>;
};

export type InputIntegrations = {
  FlightApp?: InputMaybe<InputFlightAppIntegration>;
  callbackUrl?: InputMaybe<Scalars['String']['input']>;
};

export type InputLocationOptions = {
  defaultLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type InputMessageRetention = {
  closedBookingsYears?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  crewYears?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type InputOperatorSettings = {
  backup?: InputMaybe<InputOperatorSettingsBackup>;
  bookings?: InputMaybe<InputOperatorSettingsBookings>;
  crew?: InputMaybe<InputOperatorSettingsCrew>;
  currency?: InputMaybe<TenantCurrency>;
  displayedColumns?: InputMaybe<InputDisplayedColumns>;
  flights?: InputMaybe<InputOperatorSettingsFlights>;
  manifest?: InputMaybe<InputOperatorSettingsManifest>;
  myflight?: InputMaybe<InputOperatorSettingsMyFlight>;
  notifications?: InputMaybe<InputOperatorSettingsNotifications>;
  releasenotes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sms?: InputMaybe<InputOperatorSettingsSms>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  trajectoryProfile?: InputMaybe<Array<InputMaybe<InputOperatorSettingsTrajectoryProfile>>>;
  translations?: InputMaybe<Array<InputMaybe<InputTranslation>>>;
  twoFAEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  weatherSource?: InputMaybe<InputOperatorSettingsWeatherSource>;
};

export type InputOperatorSettingsBackup = {
  active: Scalars['Boolean']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
};

export type InputOperatorSettingsBookings = {
  childAge?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  disabledPaymentTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightOptionsCount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  showHistoryCompletedBookings?: InputMaybe<Scalars['Boolean']['input']>;
  showPayments?: InputMaybe<Scalars['Boolean']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputOperatorSettingsCrew = {
  allowFlightSelection?: InputMaybe<Scalars['Boolean']['input']>;
  crewReadyChannel?: InputMaybe<CrewReadyChannel>;
  crewReadyIncludePassengers?: InputMaybe<Scalars['Boolean']['input']>;
  crewReadyIncludeTrajectory?: InputMaybe<Scalars['Boolean']['input']>;
  crewReadyInstructions?: InputMaybe<Scalars['String']['input']>;
  crewReadyLanguage?: InputMaybe<SystemLanguage>;
  shareBookings?: InputMaybe<Scalars['Boolean']['input']>;
  shareEvents?: InputMaybe<Scalars['Boolean']['input']>;
  shareFlightTags?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputOperatorSettingsFlights = {
  defaultPeriod?: InputMaybe<FlightPeriod>;
  displayedColumnsUpcoming?: InputMaybe<Array<InputMaybe<InputDisplayedColumn>>>;
  flightDuplicateProtection?: InputMaybe<Scalars['Boolean']['input']>;
  meetingTimeOffset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  sunriseOffset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  sunsetOffset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type InputOperatorSettingsManifest = {
  footer?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pilotDeclaration?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type InputOperatorSettingsMyFlight = {
  autoConfirm?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirmAPI?: InputMaybe<Scalars['Boolean']['input']>;
  autoConfirmEmailTemplate?: InputMaybe<Scalars['ID']['input']>;
  checkinDaysBefore?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  checkinInstructions?: InputMaybe<Scalars['String']['input']>;
  checkinMode?: InputMaybe<CheckinMode>;
  checkinNotificationChannel?: InputMaybe<CheckinNotificationChannel>;
  colors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endOfSeason?: InputMaybe<Scalars['Boolean']['input']>;
  flights?: InputMaybe<MyflightFlights>;
  logo?: InputMaybe<Scalars['String']['input']>;
};

export type InputOperatorSettingsNotifications = {
  calendar?: InputMaybe<Scalars['Boolean']['input']>;
  calendarClosing?: InputMaybe<Scalars['String']['input']>;
  flightCrew?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputOperatorSettingsSms = {
  footerEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InputOperatorSettingsTrajectoryProfile = {
  duration?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  level?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type InputOperatorSettingsWeatherSource = {
  mapping: Array<InputMaybe<InputWeatherSourceMapping>>;
  mode: WeatherSourceMode;
};

export type InputOrderLine = {
  description?: InputMaybe<Scalars['String']['input']>;
  descriptionDe?: InputMaybe<Scalars['String']['input']>;
  descriptionEn?: InputMaybe<Scalars['String']['input']>;
  descriptionFr?: InputMaybe<Scalars['String']['input']>;
  maxSeats?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  plan?: InputMaybe<SubscriptionPlanEnum>;
  productCode?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type InputReleaseNote = {
  date?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentation?: InputMaybe<Scalars['String']['input']>;
  oneliner?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<Scalars['String']['input']>;
};

export type InputSmsSettings = {
  from?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<SmsProvider>;
  to?: InputMaybe<Scalars['String']['input']>;
};

export type InputSubscription = {
  custom?: InputMaybe<Scalars['Boolean']['input']>;
  factuursturenClient?: InputMaybe<Scalars['String']['input']>;
  gracePeriodDays?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  plan?: InputMaybe<InputSubscriptionPlan>;
  sms?: InputMaybe<InputSubscriptionSms>;
};

export type InputSubscriptionPlan = {
  expiredSince?: InputMaybe<Scalars['DateTime']['input']>;
  invalidSince?: InputMaybe<Scalars['DateTime']['input']>;
  name?: InputMaybe<SubscriptionPlanEnum>;
  pctUsed?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  seats?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  status?: InputMaybe<SubscriptionPlanStatus>;
  suggestedOrderLines?: InputMaybe<Array<InputMaybe<InputOrderLine>>>;
  suggestedUpgrade?: InputMaybe<SubscriptionPlanEnum>;
  used?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  valid?: InputMaybe<Scalars['Boolean']['input']>;
  validUntil?: InputMaybe<Scalars['DateTime']['input']>;
};

export type InputSubscriptionSms = {
  available?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  ignoreWarning?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<SubscriptionSmsStatus>;
  suggestedOrderLines?: InputMaybe<Array<InputMaybe<InputOrderLine>>>;
  usedSMS?: InputMaybe<Array<InputMaybe<InputUsedSms>>>;
};

export type InputTenantSetting = {
  apiCacheEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  apiKey?: InputMaybe<Scalars['String']['input']>;
  dashboardOptions?: InputMaybe<InputDashboardOptions>;
  factuursturenClient?: InputMaybe<Scalars['String']['input']>;
  icsId?: InputMaybe<Scalars['String']['input']>;
  integrations?: InputMaybe<InputIntegrations>;
  locationOptions?: InputMaybe<InputLocationOptions>;
  logo?: InputMaybe<Scalars['String']['input']>;
  mailAccountant?: InputMaybe<InputEmailAddressObject>;
  mailFrom?: InputMaybe<InputEmailAddressObject>;
  mailReplyTo?: InputMaybe<InputEmailAddressObject>;
  name?: InputMaybe<Scalars['String']['input']>;
  operatorSettings?: InputMaybe<InputOperatorSettings>;
  planName?: InputMaybe<SubscriptionPlanEnum>;
  releasenotes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sms?: InputMaybe<InputSmsSettings>;
  smsAvailable?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  subscription?: InputMaybe<InputSubscription>;
  trial?: InputMaybe<Scalars['Boolean']['input']>;
  trialEnds?: InputMaybe<Scalars['DateTime']['input']>;
  upEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  whatsapp?: InputMaybe<InputWhatsappSettings>;
};

export type InputTranslation = {
  key?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<ContactLanguage>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type InputUsedSms = {
  month?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  used?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  usedWA?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  waAuthentication?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  waBillable?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  waEstimatedCost?: InputMaybe<Scalars['Float']['input']>;
  waFree?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  waMarketing?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  waService?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  waUtility?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  year?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};

export type InputWeatherSourceMapping = {
  country: Scalars['String']['input'];
  source: Scalars['String']['input'];
};

export type InputWhatsappSettings = {
  costAlertMonthlyBillable?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fallbackSms?: InputMaybe<Scalars['Boolean']['input']>;
  migrationStatus?: InputMaybe<WaMigrationStatus>;
  paymentConfirmedAt?: InputMaybe<Scalars['DateTime']['input']>;
  phoneNumberId?: InputMaybe<Scalars['String']['input']>;
  port?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<WhatsappProvider>;
  wabaId?: InputMaybe<Scalars['String']['input']>;
};

export type Integrations = {
  __typename?: 'Integrations';
  FlightApp?: Maybe<FlightAppIntegration>;
  callbackUrl?: Maybe<Scalars['String']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  amountExcludingTax: Scalars['Float']['output'];
  amountIncludingTax: Scalars['Float']['output'];
  amountOutstanding: Scalars['Float']['output'];
  amountPaid: Scalars['Float']['output'];
  companyName?: Maybe<Scalars['String']['output']>;
  currency: Scalars['String']['output'];
  debtorCode: Scalars['String']['output'];
  debtorId: Scalars['Int']['output'];
  dueDate: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  initials?: Maybe<Scalars['String']['output']>;
  invoiceDate: Scalars['Date']['output'];
  invoiceNumber: Scalars['String']['output'];
  lines: Array<InvoiceLine>;
  paymentDate?: Maybe<Scalars['Date']['output']>;
  paymentTerm: Scalars['Int']['output'];
  sent: Scalars['Boolean']['output'];
  sentDate?: Maybe<Scalars['DateTime']['output']>;
  status: InvoiceStatus;
  statusLabel: Scalars['String']['output'];
  surname?: Maybe<Scalars['String']['output']>;
  taxAmount: Scalars['Float']['output'];
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  hasNextPage: Scalars['Boolean']['output'];
  invoices: Array<Invoice>;
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type InvoiceDownload = {
  __typename?: 'InvoiceDownload';
  contentType: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  invoiceId: Scalars['ID']['output'];
  invoiceNumber: Scalars['String']['output'];
  pdfData: Scalars['String']['output'];
};

export type InvoiceLine = {
  __typename?: 'InvoiceLine';
  description: Scalars['String']['output'];
  discountPercentage?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  lineNumber: Scalars['Int']['output'];
  periods?: Maybe<Scalars['Int']['output']>;
  productCode?: Maybe<Scalars['String']['output']>;
  taxPercentage: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  unitPrice: Scalars['Float']['output'];
};

export type InvoiceListInput = {
  dateFrom?: InputMaybe<Scalars['Date']['input']>;
  dateTo?: InputMaybe<Scalars['Date']['input']>;
  dueFrom?: InputMaybe<Scalars['Date']['input']>;
  dueTo?: InputMaybe<Scalars['Date']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  paymentFrom?: InputMaybe<Scalars['Date']['input']>;
  paymentTo?: InputMaybe<Scalars['Date']['input']>;
  sortBy?: InputMaybe<InvoiceSortField>;
  sortOrder?: InputMaybe<SortOrder>;
  status?: InputMaybe<InvoiceStatus>;
};

export enum InvoiceSortField {
  AmountIncludingTax = 'AMOUNT_INCLUDING_TAX',
  AmountOutstanding = 'AMOUNT_OUTSTANDING',
  CompanyName = 'COMPANY_NAME',
  DueDate = 'DUE_DATE',
  InvoiceDate = 'INVOICE_DATE',
  InvoiceNumber = 'INVOICE_NUMBER',
  PaymentDate = 'PAYMENT_DATE'
}

export enum InvoiceStatus {
  Draft = 'DRAFT',
  Expired = 'EXPIRED',
  Paid = 'PAID',
  Reminded = 'REMINDED',
  Sent = 'SENT',
  Summation = 'SUMMATION'
}

export type LandingInput = {
  landingDetails?: InputMaybe<Scalars['String']['input']>;
  landingLatitude?: InputMaybe<Scalars['Float']['input']>;
  landingLocation?: InputMaybe<Scalars['String']['input']>;
  landingLongitude?: InputMaybe<Scalars['Float']['input']>;
  landingTime?: InputMaybe<Scalars['DateTime']['input']>;
  refuelVolume?: InputMaybe<Scalars['PositiveInt']['input']>;
  takeoffLocation?: InputMaybe<Scalars['String']['input']>;
  takeoffTime?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum LiftWarningLevel {
  Blue = 'BLUE',
  Green = 'GREEN',
  Orange = 'ORANGE',
  Red = 'RED'
}

export type Location = {
  __typename?: 'Location';
  address?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contact?: Maybe<LocationContact>;
  country?: Maybe<Scalars['String']['output']>;
  default?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  forecasts?: Maybe<Array<Maybe<MeteoblueForecastSlot>>>;
  height?: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  isHotAirfield?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  maximumHeight?: Maybe<Scalars['Float']['output']>;
  meetingPointAddress?: Maybe<Scalars['String']['output']>;
  meetingPointCity?: Maybe<Scalars['String']['output']>;
  meetingPointLatitude?: Maybe<Scalars['Float']['output']>;
  meetingPointLongitude?: Maybe<Scalars['Float']['output']>;
  meetingPointSameAsTakeOff?: Maybe<Scalars['Boolean']['output']>;
  meetingPointURL?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['NonNegativeInt']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  region: Array<Maybe<Region>>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  windDirections?: Maybe<WindDirections>;
  windRestrictions?: Maybe<Array<Maybe<WindDirection>>>;
};

export type LocationContact = {
  __typename?: 'LocationContact';
  comment?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailTemplate?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<ContactLanguage>;
  media?: Maybe<LocationContactMedia>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  smsTemplate?: Maybe<Scalars['ID']['output']>;
};

export type LocationContactInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  emailTemplate?: InputMaybe<Scalars['ID']['input']>;
  language?: InputMaybe<ContactLanguage>;
  media?: InputMaybe<LocationContactMedia>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  smsTemplate?: InputMaybe<Scalars['ID']['input']>;
};

export enum LocationContactMedia {
  Mail = 'MAIL',
  Nomsg = 'NOMSG',
  Sms = 'SMS'
}

export type LocationInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  contact?: InputMaybe<LocationContactInput>;
  country?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['PositiveInt']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  maximumHeight?: InputMaybe<Scalars['Float']['input']>;
  meetingPointAddress?: InputMaybe<Scalars['String']['input']>;
  meetingPointCity?: InputMaybe<Scalars['String']['input']>;
  meetingPointLatitude?: InputMaybe<Scalars['Float']['input']>;
  meetingPointLongitude?: InputMaybe<Scalars['Float']['input']>;
  meetingPointSameAsTakeOff?: InputMaybe<Scalars['Boolean']['input']>;
  meetingPointURL?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
};

/** Compact per-location result for the location picker (batch query). */
export type LocationNotamSummary = {
  __typename?: 'LocationNotamSummary';
  count: Scalars['NonNegativeInt']['output'];
  locationId: Scalars['ID']['output'];
  severity?: Maybe<NotamSeverity>;
  stale: Scalars['Boolean']['output'];
};

export type LocationOptions = {
  __typename?: 'LocationOptions';
  defaultLocation?: Maybe<Location>;
};

export enum LocationType {
  Fixe = 'FIXE',
  Priv = 'PRIV',
  Regi = 'REGI'
}

export type Log = {
  __typename?: 'Log';
  FlightAppId?: Maybe<Scalars['String']['output']>;
  arrivalDateTime?: Maybe<Scalars['DateTime']['output']>;
  arrivalLocation?: Maybe<Scalars['String']['output']>;
  balloon?: Maybe<LogBalloon>;
  crew?: Maybe<Scalars['String']['output']>;
  flightDate?: Maybe<Scalars['DateTime']['output']>;
  flightDuration?: Maybe<Scalars['NonNegativeInt']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  passengerCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  pic?: Maybe<LogPic>;
  refuelVolume?: Maybe<Scalars['PositiveInt']['output']>;
  remarks?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  takeoffDateTime?: Maybe<Scalars['DateTime']['output']>;
  takeoffLocation?: Maybe<Scalars['String']['output']>;
};

export type LogBalloon = {
  __typename?: 'LogBalloon';
  callSign?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type LogBalloonInput = {
  callSign?: InputMaybe<Scalars['String']['input']>;
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export type LogBook = {
  __typename?: 'LogBook';
  FlightAppLogList?: Maybe<FlightAppLogList>;
  balloon?: Maybe<Balloon>;
  id?: Maybe<Scalars['ID']['output']>;
  /** Pre-digital number of flights, as recorded in the paper logbook. */
  initialFlights?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Pre-digital flight time in minutes, as recorded in the paper logbook. */
  initialHours?: Maybe<Scalars['NonNegativeInt']['output']>;
  logs: Array<Maybe<Log>>;
  logsCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  pilot?: Maybe<Crew>;
  /** Date from which system flights are pulled into the logbook (set-once boundary; replaces the 2000-01-01 fallback). */
  startDate?: Maybe<Scalars['DateTime']['output']>;
  /** Composed totals (initial paper values + saved logbook entries) for the header/KPI display. */
  statistics?: Maybe<LogBookStatistics>;
  type: LogBookType;
};

export type LogBookInput = {
  balloon?: InputMaybe<Scalars['ID']['input']>;
  pilot?: InputMaybe<Scalars['ID']['input']>;
  type: LogBookType;
};

export type LogBookSettingsInput = {
  initialFlights?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  initialHours?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Aggregated logbook totals: the pre-digital initial values plus the saved logbook entries. */
export type LogBookStatistics = {
  __typename?: 'LogBookStatistics';
  /** Pre-digital number of flights carried over from the paper logbook. */
  initialFlights?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Pre-digital flight time carried over from the paper logbook, in minutes. */
  initialMinutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Number of saved logbook entries (excludes not-yet-added system flights). */
  loggedFlightCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Summed duration of saved logbook entries, in minutes. */
  loggedFlightMinutes?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** initialFlights + loggedFlightCount. */
  totalFlightCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** initialMinutes + loggedFlightMinutes. */
  totalFlightMinutes?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export enum LogBookType {
  Balloon = 'balloon',
  Pilot = 'pilot'
}

export type LogInput = {
  FlightAppId?: InputMaybe<Scalars['String']['input']>;
  arrivalDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  arrivalLocation?: InputMaybe<Scalars['String']['input']>;
  balloon?: InputMaybe<LogBalloonInput>;
  crew?: InputMaybe<Scalars['String']['input']>;
  flightDate?: InputMaybe<Scalars['DateTime']['input']>;
  flightDuration?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  passengerCount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  pic?: InputMaybe<LogPicInput>;
  refuelVolume?: InputMaybe<Scalars['PositiveInt']['input']>;
  remarks?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  takeoffDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  takeoffLocation?: InputMaybe<Scalars['String']['input']>;
};

export type LogPic = {
  __typename?: 'LogPic';
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type LogPicInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type MlText = {
  __typename?: 'MLText';
  lang?: Maybe<ContactLanguage>;
  text?: Maybe<Scalars['String']['output']>;
};

export type MlTextInput = {
  lang?: InputMaybe<ContactLanguage>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type MailEventLatest = {
  __typename?: 'MailEventLatest';
  date?: Maybe<Scalars['DateTime']['output']>;
  event?: Maybe<Scalars['String']['output']>;
};

export type Manufacturers = {
  __typename?: 'Manufacturers';
  basketManufacturers: Array<Maybe<Scalars['String']['output']>>;
  burnerManufacturers: Array<Maybe<Scalars['String']['output']>>;
  cylinderManufacturers: Array<Maybe<Scalars['String']['output']>>;
  envelopeManufacturers: Array<Maybe<Scalars['String']['output']>>;
};

export type Mapslocation = {
  __typename?: 'Mapslocation';
  alt?: Maybe<Scalars['NonNegativeInt']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type MessageInput = {
  /** 037 FR-007: flight context for template parameter values */
  flightId?: InputMaybe<Scalars['ID']['input']>;
  flightOptions?: InputMaybe<Scalars['Boolean']['input']>;
  images?: InputMaybe<Array<InputMaybe<Scalars['URL']['input']>>>;
  /**
   * Path of the message doc whose open Monty proposal this send resolves
   * (088). Absent on manual replies — those expire any open proposal.
   */
  montyProposalPath?: InputMaybe<Scalars['String']['input']>;
  negativeReply?: InputMaybe<Scalars['String']['input']>;
  positiveReply?: InputMaybe<Scalars['String']['input']>;
  repeat?: InputMaybe<SmsRepeat>;
  /** 037 FR-029: the variant doc whose wording was rendered */
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** 037 FR-007 (2026-09-02): message type behind this send — drives the approved-template choice out-of-window. dialog-wa already sent these four fields; MessageInput never declared them, so GraphQL rejected the whole request (gap 7). */
  smsType?: InputMaybe<Scalars['String']['input']>;
  /** 037 FR-006b: operator changed the rendered text */
  templateEdited?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  up?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Message retention (GDPR storage limitation). Values are years (1-10);
 * 0 = never delete (backwards compatibility only — new tenants default to 2).
 * The API always answers with explicit values, never null. Messages on open
 * bookings are never deleted. "never" on closedBookingsYears blocks pairing
 * a new WhatsApp connection.
 */
export type MessageRetention = {
  __typename?: 'MessageRetention';
  closedBookingsYears?: Maybe<Scalars['NonNegativeInt']['output']>;
  crewYears?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type MessageRetentionImpact = {
  __typename?: 'MessageRetentionImpact';
  closedBookingMessages: Scalars['NonNegativeInt']['output'];
  crewMessages: Scalars['NonNegativeInt']['output'];
};

export type MessageRetentionStatus = {
  __typename?: 'MessageRetentionStatus';
  flaggedMessages: Scalars['NonNegativeInt']['output'];
  nextPurgeAt?: Maybe<Scalars['DateTime']['output']>;
};

export type MeteoblueForecast = {
  __typename?: 'MeteoblueForecast';
  _created?: Maybe<Scalars['DateTime']['output']>;
  datepart?: Maybe<Array<Maybe<DatePart>>>;
  daytime?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  flytime?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  profilewind?: Maybe<MeteoblueProfilewind>;
  trendpro?: Maybe<MeteoblueTrendpro>;
};

export type MeteoblueForecastSlot = {
  __typename?: 'MeteoblueForecastSlot';
  flyability?: Maybe<FlyabilityAssessment>;
  forecast?: Maybe<SlotForecast>;
  slot?: Maybe<Scalars['String']['output']>;
  tempTakeoff?: Maybe<Scalars['Int']['output']>;
  vfrVisual?: Maybe<Scalars['Int']['output']>;
  weatherLocationId?: Maybe<Scalars['String']['output']>;
  weatherQnh?: Maybe<Scalars['Int']['output']>;
  wind10?: Maybe<Scalars['Int']['output']>;
  wind10Direction?: Maybe<Scalars['Int']['output']>;
  wind20?: Maybe<Scalars['Int']['output']>;
  wind20Direction?: Maybe<Scalars['Int']['output']>;
  windGl?: Maybe<Scalars['Int']['output']>;
  windGlDirection?: Maybe<Scalars['Int']['output']>;
};

export type MeteoblueProfileWindData = {
  __typename?: 'MeteoblueProfileWindData';
  time?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  winddirectionprofile200_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile250_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile300_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile350_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile400_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile450_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile500_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile550_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile600_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile650_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile700_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile750_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile800_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile850_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile875_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile900_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile925_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile950_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile975_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  winddirectionprofile1000_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_200_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_250_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_300_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_350_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_400_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_450_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_500_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_550_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_600_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_650_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_700_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_750_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_800_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_850_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_875_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_900_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_925_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_950_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_975_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeedprofile_1000_mb?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type MeteoblueProfilewind = {
  __typename?: 'MeteoblueProfilewind';
  data_1h?: Maybe<MeteoblueProfileWindData>;
  metadata?: Maybe<Scalars['JSON']['output']>;
  units?: Maybe<Scalars['JSON']['output']>;
};

export type MeteoblueTrendpro = {
  __typename?: 'MeteoblueTrendpro';
  metadata?: Maybe<Scalars['JSON']['output']>;
  trend_1h?: Maybe<MeteoblueTrendproData>;
  units?: Maybe<Scalars['JSON']['output']>;
};

export type MeteoblueTrendproData = {
  __typename?: 'MeteoblueTrendproData';
  cape?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  dewpointtemperature?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  evapotranspiration?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  extraterrestrialradiation_backwards?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  ghi_backwards?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  gust?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  hiclouds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  liftedindex?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  lowclouds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  midclouds?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  pictocode?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  precipitation?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  precipitation_probability?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  precipitation_spread?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  referenceevapotranspiration_fao?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  relativehumidity?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sealevelpressure?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  skintemperature?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  snowfraction?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sunshinetime?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  temperature?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  temperature_spread?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  time?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  totalcloudcover?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  totalcloudcover_spread?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  visibility?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  winddirection?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  windspeed?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windspeed_spread?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type MontyAction = {
  __typename?: 'MontyAction';
  acceptedAt?: Maybe<Scalars['DateTime']['output']>;
  acceptedBy?: Maybe<Scalars['String']['output']>;
  acceptedFlightId?: Maybe<Scalars['String']['output']>;
  alternatives?: Maybe<Array<MontyFlightOption>>;
  dismissed?: Maybe<Scalars['Boolean']['output']>;
  flightId: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: MontyActionType;
};

export type MontyActionResult = {
  __typename?: 'MontyActionResult';
  failureReason?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
};

export enum MontyActionType {
  ConfirmOnFlight = 'CONFIRM_ON_FLIGHT',
  MoveToFlight = 'MOVE_TO_FLIGHT',
  RemoveFromFlight = 'REMOVE_FROM_FLIGHT'
}

export type MontyClassification = {
  __typename?: 'MontyClassification';
  at?: Maybe<Scalars['DateTime']['output']>;
  conf?: Maybe<Scalars['Float']['output']>;
  lang?: Maybe<Scalars['String']['output']>;
  tag: MontyTag;
};

export type MontyFlightOption = {
  __typename?: 'MontyFlightOption';
  flightId: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type MontyInstructions = {
  __typename?: 'MontyInstructions';
  learnedDraft?: Maybe<Scalars['String']['output']>;
  learnedFrom?: Maybe<MontyLearnedFrom>;
  manual: Scalars['String']['output'];
  tag: MontyTag;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MontyKeyResult = {
  __typename?: 'MontyKeyResult';
  error?: Maybe<Scalars['String']['output']>;
  ok: Scalars['Boolean']['output'];
  status: MontyTenantStatus;
};

export type MontyLearnEstimate = {
  __typename?: 'MontyLearnEstimate';
  estimatedCostEur: Scalars['Float']['output'];
  messageCount: Scalars['Int']['output'];
  months: Scalars['Int']['output'];
};

export type MontyLearnRun = {
  __typename?: 'MontyLearnRun';
  alreadyTaggedMessages: Scalars['Int']['output'];
  estimatedCostEur: Scalars['Float']['output'];
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  months: Scalars['Int']['output'];
  phase: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  startedBy?: Maybe<Scalars['String']['output']>;
  state: MontyLearnState;
  taggedMessages: Scalars['Int']['output'];
  totalMessages: Scalars['Int']['output'];
};

export enum MontyLearnState {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Running = 'RUNNING',
  StoppedNoCredits = 'STOPPED_NO_CREDITS'
}

export type MontyLearnedFrom = {
  __typename?: 'MontyLearnedFrom';
  at?: Maybe<Scalars['DateTime']['output']>;
  months: Scalars['Int']['output'];
  msgCount: Scalars['Int']['output'];
};

export type MontyProposal = {
  __typename?: 'MontyProposal';
  action?: Maybe<MontyAction>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** 224: a weekday written next to a date disagreed with it (the date was used) */
  dateConflict?: Maybe<Scalars['Boolean']['output']>;
  /** 224: the reply mentions a date or time that is not among the checked facts */
  needsReview?: Maybe<Scalars['Boolean']['output']>;
  replyLang: Scalars['String']['output'];
  replyText: Scalars['String']['output'];
  /** 224: the dates the customer asked for, in message order, with what QR found */
  requested?: Maybe<Array<MontyRequestedDate>>;
  status: MontyProposalStatus;
  unverified?: Maybe<Array<Scalars['String']['output']>>;
};

export enum MontyProposalStatus {
  Accepted = 'ACCEPTED',
  DismissedAction = 'DISMISSED_ACTION',
  Edited = 'EDITED',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Open = 'OPEN',
  Refused = 'REFUSED'
}

export type MontyRequestedDate = {
  __typename?: 'MontyRequestedDate';
  /** YYYY-MM-DD in the tenant timezone */
  date: Scalars['String']['output'];
  flightId?: Maybe<Scalars['String']['output']>;
  /** dd/mm · HH:mm */
  flightLabel?: Maybe<Scalars['String']['output']>;
  freeSpots?: Maybe<Scalars['Int']['output']>;
  outcome: MontyRequestedOutcome;
};

/** 224: what QR found on a day the customer asked for (decided deterministically, not by the model) */
export enum MontyRequestedOutcome {
  Current = 'CURRENT',
  Full = 'FULL',
  Match = 'MATCH',
  NotPlanned = 'NOT_PLANNED',
  OutOfValidity = 'OUT_OF_VALIDITY',
  Past = 'PAST',
  PrivateOnly = 'PRIVATE_ONLY'
}

export type MontyStatusInfo = {
  __typename?: 'MontyStatusInfo';
  lastOkAt?: Maybe<Scalars['DateTime']['output']>;
  since?: Maybe<Scalars['DateTime']['output']>;
  status: MontyTenantStatus;
};

export enum MontyTag {
  C = 'C',
  N = 'N',
  P = 'P',
  Q = 'Q',
  W = 'W'
}

export enum MontyTenantStatus {
  Active = 'ACTIVE',
  KeyInvalid = 'KEY_INVALID',
  NoCredits = 'NO_CREDITS',
  Off = 'OFF'
}

export type MontyUsageMonth = {
  __typename?: 'MontyUsageMonth';
  classifications: Scalars['Int']['output'];
  estimatedCostEur: Scalars['Float']['output'];
  inTokens: Scalars['Int']['output'];
  learnRuns: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  outTokens: Scalars['Int']['output'];
  proposals: Scalars['Int']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptMontyAction: MontyActionResult;
  /** 037 FR-022: prereq-gated flip to provider=cloud */
  activateWhatsappCloud?: Maybe<WhatsappSettings>;
  addAndConfirmBookingsToFlight?: Maybe<Scalars['NonNegativeInt']['output']>;
  addBookingToMyFlight: Scalars['ID']['output'];
  addBookingsToFlight?: Maybe<Scalars['NonNegativeInt']['output']>;
  addCrewToFlightFromCalendar: Scalars['ID']['output'];
  addEmailOut: Scalars['ID']['output'];
  addEmailTemplateLocationContact?: Maybe<EmailSettingsTemplate>;
  addFlightAppApiKey?: Maybe<Scalars['String']['output']>;
  addOrderLine: Order;
  addPassengers?: Maybe<Scalars['Int']['output']>;
  addReleaseNote?: Maybe<ReleaseNote>;
  addSmsTemplateLocationContact?: Maybe<SmsTemplate>;
  approveOrder: Order;
  /** Max 100 flightIds (BULK_LIMIT_EXCEEDED otherwise). Never sends messages. */
  bulkFlightAction: BulkFlightAction;
  cancelMontyLearnRun: Scalars['Boolean']['output'];
  cancelOrder: Order;
  /** 222: cancelReason is written in the same call as the status (omitted = keep stored value); cancelMessageSent=false marks 'cancel without message' */
  changeFlightStatus: Flight;
  checkinPassengers?: Maybe<Scalars['Int']['output']>;
  /**
   * Clear the pilot sign-off (112): pilotSignature and pilotSignOffDate become null, pilotComments
   * is kept and a SIGNOFF log entry is written. The flight counts as not signed off until re-signed.
   */
  clearPilotSignOff: Flight;
  confirmBookingToFlight: Scalars['ID']['output'];
  confirmBookingToMyFlight: Scalars['ID']['output'];
  /** 228 US7: the calling crew member confirms their own place on the flight (status CON) */
  confirmMyFlight: Flight;
  confirmOrder: Order;
  /** 037 FR-024: operator confirms the payment method on their own WABA */
  confirmWhatsappCloudPayment?: Maybe<WhatsappSettings>;
  copyEmailTemplate?: Maybe<EmailSettingsTemplate>;
  copyFlight: Scalars['ID']['output'];
  copyWeather: Scalars['ID']['output'];
  createApiKey?: Maybe<Scalars['String']['output']>;
  createBalloonLogbook: Scalars['ID']['output'];
  createBooking: Scalars['ID']['output'];
  createBookingFromVoucher: Scalars['ID']['output'];
  createIcsId?: Maybe<Scalars['String']['output']>;
  createIcsIdUser?: Maybe<Scalars['String']['output']>;
  createOrder: Order;
  createPilotLogbook: Scalars['ID']['output'];
  createTenant: Tenant;
  createUser: GcpipUser;
  create_booking_tenant?: Maybe<Scalars['JSONObject']['output']>;
  create_flight_tenant?: Maybe<Scalars['JSONObject']['output']>;
  create_voucher_tenant?: Maybe<Scalars['JSONObject']['output']>;
  /** 037 FR-027: guided switch-back — deregister (best effort) and flip to provider=container */
  deactivateWhatsappCloud?: Maybe<WhatsappSettings>;
  deleteBalloon: Scalars['ID']['output'];
  deleteBooking: Scalars['ID']['output'];
  deleteCategory: Scalars['ID']['output'];
  deleteCrew: Scalars['ID']['output'];
  deleteCylinder: Scalars['ID']['output'];
  deleteEmailTemplate: Scalars['ID']['output'];
  deleteEvent: Scalars['ID']['output'];
  deleteFlight: Scalars['ID']['output'];
  deleteFlightAppApiKey?: Maybe<Scalars['String']['output']>;
  deleteLocation: Scalars['ID']['output'];
  deleteLog: Scalars['ID']['output'];
  deleteLogbook: Scalars['ID']['output'];
  /**
   * Soft-delete a single stored log entry from a balloon or pilot logbook.
   * Only stored logs (with an id) are deletable; system-derived logs have no id.
   * Named deleteLogbookLog (not deleteLog) to avoid the booking domain's deleteLog on the merged Mutation root.
   * Returns the deleted logId.
   */
  deleteLogbookLog: Scalars['ID']['output'];
  deleteMonthAvailabilityEvents?: Maybe<Scalars['ID']['output']>;
  deleteOrder: Scalars['Boolean']['output'];
  deleteOrderLine: Order;
  deletePassenger: Scalars['ID']['output'];
  deleteQuestion: Scalars['ID']['output'];
  deleteRegion: Scalars['ID']['output'];
  deleteReleaseNote?: Maybe<Scalars['Boolean']['output']>;
  deleteTag: Scalars['ID']['output'];
  deleteUser: Scalars['ID']['output'];
  deleteVoucher: Scalars['ID']['output'];
  /** Removes the stored authorization, the tenant's fetched NOTAM data, and resets status */
  disconnectAutorouter: AutorouterConnection;
  fetchHolidays?: Maybe<Scalars['PositiveInt']['output']>;
  forgetTrustedDevice: Scalars['Boolean']['output'];
  initializeTenant?: Maybe<Scalars['String']['output']>;
  inviteBookingsToFlight?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** 228 US7 'Ik ga mee': join a published flight without ground crew as crew (status CON) */
  joinFlightAsCrew: Flight;
  markBookingMessagesRead?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  markBookingPaid: Scalars['ID']['output'];
  markCrewMessagesRead?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  markReleaseNoteAsRead?: Maybe<Scalars['NonNegativeInt']['output']>;
  mergeBookings?: Maybe<Booking>;
  onlineCheckin: Scalars['Boolean']['output'];
  refreshTenantSubscriptionUsedSms?: Maybe<Scalars['Boolean']['output']>;
  rejectBookingToMyFlight: Scalars['ID']['output'];
  removeBookingFromFlight: Scalars['ID']['output'];
  removeMontyApiKey: MontyKeyResult;
  /** 037 FR-029: soft-remove a template variant (at least one non-removed doc per type is kept) */
  removeSmsTemplate?: Maybe<Scalars['ID']['output']>;
  remove_booking_flight_tenant?: Maybe<Scalars['JSONObject']['output']>;
  resolveMontyProposal: Scalars['Boolean']['output'];
  /** Restore a cancelled flight: set it back to SCH and re-attach (CONF) every recorded booking that is still open and unassigned. Errors if the flight is not CAN or has no recorded bookings. */
  restoreCancelledFlight: RestoreFlightResult;
  resumeMontyLearnRun?: Maybe<MontyLearnRun>;
  saveAircraftLogsToFlightApp?: Maybe<Scalars['NonNegativeInt']['output']>;
  saveBalloon: Scalars['ID']['output'];
  saveBooking: Scalars['ID']['output'];
  saveBookingPayment: Booking;
  saveCategory: Scalars['ID']['output'];
  /**
   * Save whitelisted mobile check-in parameters (112). Rejects when the flight is signed off or a
   * value fails validation; writes one FlightCheckinLog entry per actually-changed field in the
   * same transaction. Editing a weather field sets weatherManual (and tempTakeoffManual for temp).
   */
  saveCheckinParameters: Flight;
  saveCrew: Scalars['ID']['output'];
  saveCrewAvailability?: Maybe<Scalars['ID']['output']>;
  saveCylinder: Scalars['ID']['output'];
  saveEmailTemplate?: Maybe<EmailSettingsTemplate>;
  saveEvent: Scalars['ID']['output'];
  saveFlight: Scalars['ID']['output'];
  saveFlightCrew: Flight;
  saveFlightLanding: Scalars['ID']['output'];
  saveLanguageSetting: Scalars['ID']['output'];
  saveLocation: Scalars['ID']['output'];
  saveLogs?: Maybe<Scalars['NonNegativeInt']['output']>;
  saveMontyApiKey: MontyKeyResult;
  saveMontyInstructions: MontyInstructions;
  /** checkinFlightId (112): set only by mobile check-in; a weight correction is then logged on that flight's checkinLog */
  savePassenger: Scalars['ID']['output'];
  savePassengerPayment?: Maybe<Passenger>;
  savePilotSignOff: Scalars['ID']['output'];
  saveQuestionOrder: Scalars['ID']['output'];
  saveQuestionText: Scalars['ID']['output'];
  saveRegion: Scalars['ID']['output'];
  /** 037 FR-029: smsTemplateId null creates a new variant doc of the given type */
  saveSmsTemplate?: Maybe<SmsTemplate>;
  saveTag: TagUnion;
  saveUserViewState: User;
  saveVoucher: Scalars['ID']['output'];
  sendBookingMessage?: Maybe<Scalars['ID']['output']>;
  sendBookingSms?: Maybe<Scalars['ID']['output']>;
  sendCheckinNotification: Scalars['DateTime']['output'];
  sendCrewMessage?: Maybe<Scalars['ID']['output']>;
  sendCrewSms?: Maybe<Scalars['ID']['output']>;
  sendFlightSms?: Maybe<Scalars['ID']['output']>;
  sendLocationSms?: Maybe<Scalars['ID']['output']>;
  sendLoginLink: AuthMailResult;
  sendPasswordResetEmail: Scalars['String']['output'];
  sendPasswordResetLink: AuthMailResult;
  sendTwoFAEmail: Scalars['Boolean']['output'];
  /** 228: operator/owner toggle of crew visibility (publish to crew) */
  setFlightPublished: Flight;
  setMonthAvailability?: Maybe<Scalars['ID']['output']>;
  startMontyLearnRun: MontyLearnRun;
  subscriptionSmsIgnoreWarning?: Maybe<Scalars['Boolean']['output']>;
  toggleFlightVisibility: Flight;
  toggleQuestionActive: Scalars['ID']['output'];
  toggleTenantOperatorSettingsBookingsShowPayments?: Maybe<TenantSetting>;
  toggleTenantWAfallbackSMS?: Maybe<TenantSetting>;
  /** Once, within 24 h. feature.flight.bulk (+ feature.flight.delete for an undo of DELETE) */
  undoBulkFlightAction: BulkFlightAction;
  updateBookingComments: Scalars['ID']['output'];
  updateBookingPayment?: Maybe<Booking>;
  updateBookingPreferredFlights: Scalars['ID']['output'];
  updateBookingTags: Scalars['ID']['output'];
  updateFlightComments: Flight;
  updateFlightTags: Flight;
  /** Owner/operator: replaces the tenant's flyability threshold overrides and, when given, switches the whole display on or off. The submitted list is the complete override set — omit a parameter to reset it to the platform default, submit an empty list to reset all (104) */
  updateFlyabilitySettings?: Maybe<TenantSetting>;
  /** Persist the per-logbook settings (start date + pre-digital initial hours). */
  updateLogbookSettings: Scalars['Boolean']['output'];
  updateMeteo?: Maybe<Scalars['Boolean']['output']>;
  updateMyBooking?: Maybe<Scalars['ID']['output']>;
  updateMyPassenger: Scalars['ID']['output'];
  updatePassengerPaymentStatus?: Maybe<Passenger>;
  updateReleaseNote?: Maybe<ReleaseNote>;
  updateTenantCallbackUrl?: Maybe<TenantSetting>;
  updateTenantLocationOptions?: Maybe<TenantSetting>;
  /** Set message retention periods (096). Values in years 1-10, null = keep forever. */
  updateTenantMessageRetention?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsBackup?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsBookingsChildAge?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsBookingsFlightOptionsCount?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsBookingsSources?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsCrew?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsDisabledPaymentTypes?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsDisplayedColumns?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsFlights?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsFlightsCancelReasons?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsMyFlight?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsNotifications?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsSms?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsTrajectoryProfile?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsTranslation?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsTwoFA?: Maybe<TenantSetting>;
  updateTenantOperatorSettingsWeatherSource?: Maybe<TenantSetting>;
  updateTenantSettingAdmin?: Maybe<TenantSetting>;
  update_booking_flight_tenant?: Maybe<Scalars['JSONObject']['output']>;
  verifyTwoFACode: Scalars['Boolean']['output'];
  /** 037 FR-016: exchange the Embedded Signup authorization code — connect WABA, store token, create the template catalogue */
  whatsappCloudOnboard: WhatsappOnboardResult;
};


export type MutationAcceptMontyActionArgs = {
  flightId?: InputMaybe<Scalars['String']['input']>;
  messagePath: Scalars['String']['input'];
};


export type MutationAddAndConfirmBookingsToFlightArgs = {
  bookings: Array<InputMaybe<Scalars['ID']['input']>>;
  flightId: Scalars['ID']['input'];
};


export type MutationAddBookingToMyFlightArgs = {
  myBookingId: Scalars['ID']['input'];
  myFlightId: Scalars['ID']['input'];
  myTenantId: Scalars['ID']['input'];
};


export type MutationAddBookingsToFlightArgs = {
  bookings: Array<InputMaybe<Scalars['ID']['input']>>;
  flightId: Scalars['ID']['input'];
};


export type MutationAddCrewToFlightFromCalendarArgs = {
  flightCrewInput?: InputMaybe<FlightCrewInput>;
  flightId: Scalars['ID']['input'];
};


export type MutationAddEmailOutArgs = {
  emailInput: EmailInput;
};


export type MutationAddFlightAppApiKeyArgs = {
  key: Scalars['String']['input'];
};


export type MutationAddOrderLineArgs = {
  line: OrderLineInput;
  orderId: Scalars['ID']['input'];
};


export type MutationAddPassengersArgs = {
  bookingId: Scalars['ID']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationAddReleaseNoteArgs = {
  releaseNote: InputReleaseNote;
};


export type MutationApproveOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationBulkFlightActionArgs = {
  flightIds: Array<Scalars['ID']['input']>;
  input: BulkFlightActionInput;
};


export type MutationCancelMontyLearnRunArgs = {
  runId: Scalars['String']['input'];
};


export type MutationCancelOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationChangeFlightStatusArgs = {
  cancelMessageSent?: InputMaybe<Scalars['Boolean']['input']>;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  flightId: Scalars['ID']['input'];
  flightStatus: FlightStatus;
};


export type MutationCheckinPassengersArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationClearPilotSignOffArgs = {
  flightId: Scalars['ID']['input'];
};


export type MutationConfirmBookingToFlightArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationConfirmBookingToMyFlightArgs = {
  myBookingId: Scalars['ID']['input'];
  myTenantId: Scalars['ID']['input'];
};


export type MutationConfirmMyFlightArgs = {
  flightId: Scalars['ID']['input'];
};


export type MutationConfirmOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationCopyEmailTemplateArgs = {
  emailTemplateId: Scalars['ID']['input'];
};


export type MutationCopyFlightArgs = {
  destinationDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceFlightId: Scalars['ID']['input'];
};


export type MutationCopyWeatherArgs = {
  destinationFlightIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  sourceFlightId: Scalars['ID']['input'];
};


export type MutationCreateBalloonLogbookArgs = {
  balloonId: Scalars['ID']['input'];
};


export type MutationCreateBookingArgs = {
  flightId: Scalars['ID']['input'];
};


export type MutationCreateBookingFromVoucherArgs = {
  voucherId: Scalars['ID']['input'];
};


export type MutationCreateIcsIdUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationCreatePilotLogbookArgs = {
  pilotId: Scalars['ID']['input'];
};


export type MutationCreateTenantArgs = {
  displayName: Scalars['String']['input'];
};


export type MutationCreateUserArgs = {
  GcpipUserInput?: InputMaybe<GcpipUserInput>;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreate_Booking_TenantArgs = {
  bookingInput?: InputMaybe<ApiBookingInput>;
};


export type MutationCreate_Flight_TenantArgs = {
  flightInput?: InputMaybe<ApiFlightInput>;
};


export type MutationCreate_Voucher_TenantArgs = {
  voucherInput?: InputMaybe<ApiVoucherInput>;
};


export type MutationDeleteBalloonArgs = {
  balloonId: Scalars['ID']['input'];
};


export type MutationDeleteBookingArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationDeleteCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type MutationDeleteCrewArgs = {
  crewId: Scalars['ID']['input'];
};


export type MutationDeleteCylinderArgs = {
  cylinderId: Scalars['ID']['input'];
};


export type MutationDeleteEmailTemplateArgs = {
  emailTemplateId: Scalars['ID']['input'];
};


export type MutationDeleteEventArgs = {
  eventId: Scalars['ID']['input'];
};


export type MutationDeleteFlightArgs = {
  flightId: Scalars['ID']['input'];
};


export type MutationDeleteFlightAppApiKeyArgs = {
  key: Scalars['String']['input'];
};


export type MutationDeleteLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type MutationDeleteLogArgs = {
  bookingId: Scalars['ID']['input'];
  logId: Scalars['ID']['input'];
};


export type MutationDeleteLogbookArgs = {
  logbookId: Scalars['ID']['input'];
};


export type MutationDeleteLogbookLogArgs = {
  logId: Scalars['ID']['input'];
  logbookId: Scalars['ID']['input'];
};


export type MutationDeleteMonthAvailabilityEventsArgs = {
  crewId: Scalars['ID']['input'];
  month: Scalars['PositiveInt']['input'];
  year: Scalars['PositiveInt']['input'];
};


export type MutationDeleteOrderArgs = {
  orderId: Scalars['ID']['input'];
};


export type MutationDeleteOrderLineArgs = {
  lineId: Scalars['ID']['input'];
  orderId: Scalars['ID']['input'];
};


export type MutationDeletePassengerArgs = {
  bookingId: Scalars['ID']['input'];
  passengerId: Scalars['ID']['input'];
};


export type MutationDeleteQuestionArgs = {
  questionId: Scalars['ID']['input'];
};


export type MutationDeleteRegionArgs = {
  regionId: Scalars['ID']['input'];
  targetRegionId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationDeleteReleaseNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTagArgs = {
  tagId: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  tenantId?: InputMaybe<Scalars['ID']['input']>;
  uid: Scalars['String']['input'];
};


export type MutationDeleteVoucherArgs = {
  voucherId: Scalars['ID']['input'];
};


export type MutationFetchHolidaysArgs = {
  countryCode?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['PositiveInt']['input'];
};


export type MutationForgetTrustedDeviceArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationInitializeTenantArgs = {
  tenantId: Scalars['ID']['input'];
};


export type MutationInviteBookingsToFlightArgs = {
  bookings: Array<InputMaybe<Scalars['ID']['input']>>;
  flightId: Scalars['ID']['input'];
};


export type MutationJoinFlightAsCrewArgs = {
  flightId: Scalars['ID']['input'];
};


export type MutationMarkBookingMessagesReadArgs = {
  bookingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MutationMarkBookingPaidArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationMarkCrewMessagesReadArgs = {
  crewIds: Array<Scalars['ID']['input']>;
};


export type MutationMarkReleaseNoteAsReadArgs = {
  releaseNoteIds: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationMergeBookingsArgs = {
  bookingIdFrom: Scalars['ID']['input'];
  bookingIdTo: Scalars['ID']['input'];
};


export type MutationOnlineCheckinArgs = {
  bookingId: Scalars['ID']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationRejectBookingToMyFlightArgs = {
  myBookingId: Scalars['ID']['input'];
  myTenantId: Scalars['ID']['input'];
};


export type MutationRemoveBookingFromFlightArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationRemoveSmsTemplateArgs = {
  smsTemplateId: Scalars['ID']['input'];
};


export type MutationRemove_Booking_Flight_TenantArgs = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationResolveMontyProposalArgs = {
  messagePath: Scalars['String']['input'];
  resolution: MontyProposalStatus;
};


export type MutationRestoreCancelledFlightArgs = {
  flightId: Scalars['ID']['input'];
};


export type MutationResumeMontyLearnRunArgs = {
  runId: Scalars['String']['input'];
};


export type MutationSaveAircraftLogsToFlightAppArgs = {
  logbookId: Scalars['ID']['input'];
  logs: Array<InputMaybe<LogInput>>;
};


export type MutationSaveBalloonArgs = {
  balloonId?: InputMaybe<Scalars['ID']['input']>;
  balloonInput: BalloonInput;
  cylinders: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationSaveBookingArgs = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  bookingInput: BookingInput;
  locationInput?: InputMaybe<LocationInput>;
};


export type MutationSaveBookingPaymentArgs = {
  bookingId: Scalars['ID']['input'];
  bookingPaymentInput: BookingPaymentInput;
};


export type MutationSaveCategoryArgs = {
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  categoryInput: CategoryInput;
};


export type MutationSaveCheckinParametersArgs = {
  checkinParametersInput: CheckinParametersInput;
  flightId: Scalars['ID']['input'];
};


export type MutationSaveCrewArgs = {
  crewId?: InputMaybe<Scalars['ID']['input']>;
  crewInput: CrewInput;
};


export type MutationSaveCrewAvailabilityArgs = {
  crewAvailabilityInput: CrewAvailabilityInput;
  eventId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSaveCylinderArgs = {
  cylinderId?: InputMaybe<Scalars['ID']['input']>;
  cylinderInput: CylinderInput;
};


export type MutationSaveEmailTemplateArgs = {
  emailTemplateId: Scalars['ID']['input'];
  emailTemplateInput?: InputMaybe<EmailTemplateInput>;
};


export type MutationSaveEventArgs = {
  eventId?: InputMaybe<Scalars['ID']['input']>;
  eventInput: EventInput;
};


export type MutationSaveFlightArgs = {
  flightId?: InputMaybe<Scalars['ID']['input']>;
  flightInput: FlightInput;
};


export type MutationSaveFlightCrewArgs = {
  flightCrewInput?: InputMaybe<Array<InputMaybe<FlightCrewInput>>>;
  flightId: Scalars['ID']['input'];
};


export type MutationSaveFlightLandingArgs = {
  flightId: Scalars['ID']['input'];
  landingInput: LandingInput;
};


export type MutationSaveLanguageSettingArgs = {
  systemLanguage: Scalars['String']['input'];
};


export type MutationSaveLocationArgs = {
  locationId?: InputMaybe<Scalars['ID']['input']>;
  locationInput: LocationInput;
  regions: Array<InputMaybe<Scalars['ID']['input']>>;
};


export type MutationSaveLogsArgs = {
  logbookId: Scalars['ID']['input'];
  logs: Array<InputMaybe<LogInput>>;
};


export type MutationSaveMontyApiKeyArgs = {
  key: Scalars['String']['input'];
};


export type MutationSaveMontyInstructionsArgs = {
  learnedDraft?: InputMaybe<Scalars['String']['input']>;
  manual: Scalars['String']['input'];
  tag: MontyTag;
};


export type MutationSavePassengerArgs = {
  bookingId: Scalars['ID']['input'];
  checkinFlightId?: InputMaybe<Scalars['ID']['input']>;
  passengerId?: InputMaybe<Scalars['ID']['input']>;
  passengerInput: PassengerInput;
};


export type MutationSavePassengerPaymentArgs = {
  bookingId: Scalars['ID']['input'];
  passengerId: Scalars['ID']['input'];
  passengerPaymentInput: PassengerPaymentInput;
};


export type MutationSavePilotSignOffArgs = {
  flightId: Scalars['ID']['input'];
  pilotSignOffInput: PilotSignOffInput;
};


export type MutationSaveQuestionOrderArgs = {
  order: Scalars['NonNegativeInt']['input'];
  questionId: Scalars['ID']['input'];
};


export type MutationSaveQuestionTextArgs = {
  questionId: Scalars['ID']['input'];
  questionInput: QuestionInput;
};


export type MutationSaveRegionArgs = {
  regionId?: InputMaybe<Scalars['ID']['input']>;
  regionInput: RegionInput;
};


export type MutationSaveSmsTemplateArgs = {
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
  smsTemplateInput: SmsTemplateInput;
};


export type MutationSaveTagArgs = {
  tagId?: InputMaybe<Scalars['ID']['input']>;
  tagInput: TagInput;
};


export type MutationSaveUserViewStateArgs = {
  viewState: Scalars['JSONObject']['input'];
};


export type MutationSaveVoucherArgs = {
  voucherId?: InputMaybe<Scalars['ID']['input']>;
  voucherInput: VoucherInput;
};


export type MutationSendBookingMessageArgs = {
  bookingId: Scalars['ID']['input'];
  messageInput: MessageInput;
};


export type MutationSendBookingSmsArgs = {
  bookingId: Scalars['ID']['input'];
  smsInput: SmsInput;
};


export type MutationSendCheckinNotificationArgs = {
  bookingId: Scalars['ID']['input'];
};


export type MutationSendCrewMessageArgs = {
  crewId: Scalars['ID']['input'];
  messageInput: MessageInput;
};


export type MutationSendCrewSmsArgs = {
  crewId: Scalars['ID']['input'];
  smsInput: SmsInput;
};


export type MutationSendFlightSmsArgs = {
  flightId: Scalars['ID']['input'];
  smsInput: SmsInput;
};


export type MutationSendLocationSmsArgs = {
  flightId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
  smsInput: SmsInput;
};


export type MutationSendLoginLinkArgs = {
  email: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationSendPasswordResetEmailArgs = {
  email: Scalars['ID']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSendPasswordResetLinkArgs = {
  email: Scalars['String']['input'];
  tenantId: Scalars['ID']['input'];
};


export type MutationSendTwoFaEmailArgs = {
  deviceId: Scalars['String']['input'];
};


export type MutationSetFlightPublishedArgs = {
  flightId: Scalars['ID']['input'];
  published: Scalars['Boolean']['input'];
};


export type MutationSetMonthAvailabilityArgs = {
  availability: CrewAvailability;
  crewId: Scalars['ID']['input'];
  month: Scalars['PositiveInt']['input'];
  year: Scalars['PositiveInt']['input'];
};


export type MutationStartMontyLearnRunArgs = {
  months: Scalars['Int']['input'];
};


export type MutationSubscriptionSmsIgnoreWarningArgs = {
  ignore: Scalars['Boolean']['input'];
};


export type MutationToggleFlightVisibilityArgs = {
  flightId: Scalars['ID']['input'];
};


export type MutationToggleQuestionActiveArgs = {
  questionId: Scalars['ID']['input'];
};


export type MutationUndoBulkFlightActionArgs = {
  actionId: Scalars['ID']['input'];
};


export type MutationUpdateBookingCommentsArgs = {
  bookingId: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateBookingPaymentArgs = {
  bookingId: Scalars['ID']['input'];
  paymentType: PaymentType;
};


export type MutationUpdateBookingPreferredFlightsArgs = {
  bookingId: Scalars['ID']['input'];
  preferredFlights?: InputMaybe<Array<InputMaybe<PreferredFlightInput>>>;
};


export type MutationUpdateBookingTagsArgs = {
  bookingId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateFlightCommentsArgs = {
  comment?: InputMaybe<Scalars['String']['input']>;
  flightId: Scalars['ID']['input'];
};


export type MutationUpdateFlightTagsArgs = {
  flightId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateFlyabilitySettingsArgs = {
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  thresholds: Array<FlyabilityThresholdInput>;
};


export type MutationUpdateLogbookSettingsArgs = {
  logbookId: Scalars['ID']['input'];
  settings: LogBookSettingsInput;
};


export type MutationUpdateMeteoArgs = {
  flightId: Scalars['ID']['input'];
  locationId: Scalars['ID']['input'];
};


export type MutationUpdateMyBookingArgs = {
  myBookingId: Scalars['ID']['input'];
  myBookingInput: MyBookingInput;
  myTenantId: Scalars['ID']['input'];
};


export type MutationUpdateMyPassengerArgs = {
  myBookingId: Scalars['ID']['input'];
  myPassengerId: Scalars['ID']['input'];
  myPassengerInput: MyPassengerInput;
  myTenantId: Scalars['ID']['input'];
};


export type MutationUpdatePassengerPaymentStatusArgs = {
  bookingId: Scalars['ID']['input'];
  passengerId: Scalars['ID']['input'];
  paymentStatus: PaymentStatus;
};


export type MutationUpdateReleaseNoteArgs = {
  id: Scalars['ID']['input'];
  releaseNote: InputReleaseNote;
};


export type MutationUpdateTenantCallbackUrlArgs = {
  callbackUrl: Scalars['String']['input'];
};


export type MutationUpdateTenantLocationOptionsArgs = {
  options: InputLocationOptions;
};


export type MutationUpdateTenantMessageRetentionArgs = {
  messageRetention: InputMessageRetention;
};


export type MutationUpdateTenantOperatorSettingsBackupArgs = {
  settings: InputOperatorSettingsBackup;
};


export type MutationUpdateTenantOperatorSettingsBookingsChildAgeArgs = {
  childAge?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type MutationUpdateTenantOperatorSettingsBookingsFlightOptionsCountArgs = {
  flightOptionsCount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type MutationUpdateTenantOperatorSettingsBookingsSourcesArgs = {
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationUpdateTenantOperatorSettingsCrewArgs = {
  settings: InputOperatorSettingsCrew;
};


export type MutationUpdateTenantOperatorSettingsDisabledPaymentTypesArgs = {
  disabledPaymentTypes: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUpdateTenantOperatorSettingsDisplayedColumnsArgs = {
  displayedColumns?: InputMaybe<InputDisplayedColumns>;
};


export type MutationUpdateTenantOperatorSettingsFlightsArgs = {
  settings: InputOperatorSettingsFlights;
  updateHours?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateTenantOperatorSettingsFlightsCancelReasonsArgs = {
  cancelReasons: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationUpdateTenantOperatorSettingsMyFlightArgs = {
  settings: InputOperatorSettingsMyFlight;
};


export type MutationUpdateTenantOperatorSettingsNotificationsArgs = {
  settings: InputOperatorSettingsNotifications;
};


export type MutationUpdateTenantOperatorSettingsSmsArgs = {
  settings: InputOperatorSettingsSms;
};


export type MutationUpdateTenantOperatorSettingsTrajectoryProfileArgs = {
  settings: Array<InputMaybe<InputOperatorSettingsTrajectoryProfile>>;
};


export type MutationUpdateTenantOperatorSettingsTranslationArgs = {
  apiKey: Scalars['String']['input'];
  key: Scalars['String']['input'];
  lang: ContactLanguage;
  myTenantId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};


export type MutationUpdateTenantOperatorSettingsTwoFaArgs = {
  twoFAEnabled: Scalars['Boolean']['input'];
};


export type MutationUpdateTenantOperatorSettingsWeatherSourceArgs = {
  settings: InputOperatorSettingsWeatherSource;
};


export type MutationUpdateTenantSettingAdminArgs = {
  settings: InputTenantSetting;
  tenantId: Scalars['ID']['input'];
};


export type MutationUpdate_Booking_Flight_TenantArgs = {
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  flightId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationVerifyTwoFaCodeArgs = {
  code: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
};


export type MutationWhatsappCloudOnboardArgs = {
  code: Scalars['String']['input'];
};

export type MyBookingInput = {
  contactEmail: Scalars['String']['input'];
  contactLanguage?: InputMaybe<ContactLanguage>;
  contactName: Scalars['String']['input'];
  contactPhone: Scalars['PhoneNumber']['input'];
};

export type MyPassengerInput = {
  age?: InputMaybe<Scalars['PositiveInt']['input']>;
  child?: InputMaybe<Scalars['Boolean']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  disability?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  luggage?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  transport?: InputMaybe<Scalars['Boolean']['input']>;
  weight?: InputMaybe<Scalars['PositiveInt']['input']>;
  weightIsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MyWeek = {
  __typename?: 'MyWeek';
  availability?: Maybe<Array<Maybe<Event>>>;
  crewId?: Maybe<Scalars['ID']['output']>;
  crewName?: Maybe<Scalars['String']['output']>;
  days?: Maybe<Array<Maybe<CalendarWeekDay>>>;
  flights?: Maybe<Array<Maybe<Flight>>>;
};

export type Myflight = {
  __typename?: 'Myflight';
  booking?: Maybe<Booking>;
  flights?: Maybe<Array<Maybe<Flight>>>;
  messagesCollection?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Array<Maybe<Region>>>;
  tenantSetting?: Maybe<TenantSetting>;
};

export type MyflightBooking = {
  __typename?: 'MyflightBooking';
  booking?: Maybe<Booking>;
  messagesCollection?: Maybe<Scalars['String']['output']>;
  regions?: Maybe<Array<Maybe<Region>>>;
  tenantSetting?: Maybe<TenantSetting>;
};

export enum MyflightFlights {
  All = 'ALL',
  None = 'NONE',
  Regional = 'REGIONAL'
}

/** Result of the relevance filter for one flight or one location+slot. */
export type NotamAssessment = {
  __typename?: 'NotamAssessment';
  count: Scalars['NonNegativeInt']['output'];
  /** Location has no coordinates — no assessment possible (edge case) */
  noData?: Maybe<Scalars['Boolean']['output']>;
  notams: Array<NotamInfo>;
  severity?: Maybe<NotamSeverity>;
  /** True when data missing or older than 12h — display explicit stale state, never 'no NOTAMs' */
  stale: Scalars['Boolean']['output'];
  /** Data freshness of the underlying FIR fetch (FR-007/FR-008) */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  wideAreaNotams: Array<NotamInfo>;
};

export enum NotamCategory {
  Aerodrome = 'AERODROME',
  Obstacle = 'OBSTACLE',
  Restriction = 'RESTRICTION',
  Unclassified = 'UNCLASSIFIED',
  Warning = 'WARNING'
}

/** One relevant NOTAM as presented to the operator (weather panel, map layer, dashboard dialog). */
export type NotamInfo = {
  __typename?: 'NotamInfo';
  bearingDeg?: Maybe<Scalars['Float']['output']>;
  category: NotamCategory;
  /** Official designator, e.g. B1234/26 */
  designator: Scalars['String']['output'];
  /** Distance/bearing from the launch location (per-flight and per-location assessments) */
  distanceKm?: Maybe<Scalars['Float']['output']>;
  fir: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Centre + radius for the trajectory-map layer (circle-only MVP) */
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  lowerFt?: Maybe<Scalars['NonNegativeInt']['output']>;
  radiusKm?: Maybe<Scalars['Float']['output']>;
  /** Raw item D daily schedule, shown verbatim when present */
  schedule?: Maybe<Scalars['String']['output']>;
  severity: NotamSeverity;
  /** Full raw NOTAM text (item E), shown on demand */
  text: Scalars['String']['output'];
  upperFt?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** Structured readable summary fields (FR-006) — category label is translated client-side from category */
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
  /** Wide-area notice (FR-010): listed in collapsed group, not drawn by default */
  wideArea?: Maybe<Scalars['Boolean']['output']>;
};

export enum NotamSeverity {
  Amber = 'AMBER',
  Red = 'RED'
}

export type OpenBookingDemand = {
  __typename?: 'OpenBookingDemand';
  count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  period?: Maybe<FlightPeriod>;
  region?: Maybe<Region>;
};

export type OperatorSettings = {
  __typename?: 'OperatorSettings';
  backup?: Maybe<OperatorSettingsBackup>;
  bookings?: Maybe<OperatorSettingsBookings>;
  crew?: Maybe<OperatorSettingsCrew>;
  currency?: Maybe<TenantCurrency>;
  displayedColumns?: Maybe<DisplayedColumns>;
  flights?: Maybe<OperatorSettingsFlights>;
  id: Scalars['ID']['output'];
  manifest?: Maybe<OperatorSettingsManifest>;
  myflight?: Maybe<OperatorSettingsMyflight>;
  notifications?: Maybe<OperatorSettingsNotifications>;
  releasenotes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sms?: Maybe<OperatorSettingsSms>;
  timezone?: Maybe<Scalars['String']['output']>;
  trajectoryProfile?: Maybe<Array<Maybe<TrajectoryProfile>>>;
  translations?: Maybe<Array<Maybe<Translation>>>;
  twoFAEnabled?: Maybe<Scalars['Boolean']['output']>;
  weatherSource?: Maybe<OperatorSettingsWeatherSource>;
};

export type OperatorSettingsBackup = {
  __typename?: 'OperatorSettingsBackup';
  active?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
};

export type OperatorSettingsBookings = {
  __typename?: 'OperatorSettingsBookings';
  childAge?: Maybe<Scalars['NonNegativeInt']['output']>;
  disabledPaymentTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  flightOptionsCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  showHistoryCompletedBookings?: Maybe<Scalars['Boolean']['output']>;
  showPayments?: Maybe<Scalars['Boolean']['output']>;
  sources?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OperatorSettingsCrew = {
  __typename?: 'OperatorSettingsCrew';
  allowFlightSelection?: Maybe<Scalars['Boolean']['output']>;
  crewReadyChannel?: Maybe<CrewReadyChannel>;
  crewReadyIncludePassengers?: Maybe<Scalars['Boolean']['output']>;
  crewReadyIncludeTrajectory?: Maybe<Scalars['Boolean']['output']>;
  crewReadyInstructions?: Maybe<Scalars['String']['output']>;
  crewReadyLanguage?: Maybe<SystemLanguage>;
  shareBookings?: Maybe<Scalars['Boolean']['output']>;
  shareEvents?: Maybe<Scalars['Boolean']['output']>;
  shareFlightTags?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorSettingsFlights = {
  __typename?: 'OperatorSettingsFlights';
  cancelReasons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  defaultPeriod?: Maybe<FlightPeriod>;
  flightDuplicateProtection?: Maybe<Scalars['Boolean']['output']>;
  meetingTimeOffset?: Maybe<Scalars['NonNegativeInt']['output']>;
  sunriseOffset?: Maybe<Scalars['NonNegativeInt']['output']>;
  sunsetOffset?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type OperatorSettingsManifest = {
  __typename?: 'OperatorSettingsManifest';
  footer?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  pilotDeclaration?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type OperatorSettingsMyflight = {
  __typename?: 'OperatorSettingsMyflight';
  autoConfirm?: Maybe<Scalars['Boolean']['output']>;
  autoConfirmAPI?: Maybe<Scalars['Boolean']['output']>;
  autoConfirmEmailTemplate?: Maybe<Scalars['ID']['output']>;
  checkinDaysBefore?: Maybe<Scalars['NonNegativeInt']['output']>;
  checkinInstructions?: Maybe<Scalars['String']['output']>;
  checkinMode?: Maybe<CheckinMode>;
  checkinNotificationChannel?: Maybe<CheckinNotificationChannel>;
  colors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endOfSeason?: Maybe<Scalars['Boolean']['output']>;
  flights?: Maybe<MyflightFlights>;
  id: Scalars['ID']['output'];
  logo?: Maybe<Scalars['String']['output']>;
};

export type OperatorSettingsNotifications = {
  __typename?: 'OperatorSettingsNotifications';
  calendar?: Maybe<Scalars['Boolean']['output']>;
  calendarClosing?: Maybe<Scalars['String']['output']>;
  flightCrew?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorSettingsSms = {
  __typename?: 'OperatorSettingsSms';
  footerEnabled?: Maybe<Scalars['Boolean']['output']>;
};

export type OperatorSettingsWeatherSource = {
  __typename?: 'OperatorSettingsWeatherSource';
  mapping?: Maybe<Array<Maybe<WeatherSourceMapping>>>;
  mode?: Maybe<WeatherSourceMode>;
};

export type Order = {
  __typename?: 'Order';
  amountExcludingTax: Scalars['Float']['output'];
  createdByUserId?: Maybe<Scalars['ID']['output']>;
  createdByUserLanguage?: Maybe<SystemLanguage>;
  debtorCode: Scalars['String']['output'];
  debtorId: Scalars['Int']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  invoiceNumber?: Maybe<Scalars['String']['output']>;
  lines: Array<OrderLine>;
  orderDate: Scalars['DateTime']['output'];
  status: OrderStatus;
};

export enum OrderByBooking {
  BookingDate = 'bookingDate',
  ContactName = 'contactName',
  PreferredDate = 'preferredDate'
}

export enum OrderByFlight {
  Date = 'date',
  Status = 'status'
}

export enum OrderByVoucher {
  ContactName = 'contactName',
  IssueDate = 'issueDate',
  VoucherReference = 'voucherReference'
}

export enum OrderDirection {
  Asc = 'asc',
  Desc = 'desc'
}

export type OrderLine = {
  __typename?: 'OrderLine';
  description: Scalars['String']['output'];
  descriptionDe: Scalars['String']['output'];
  descriptionEn: Scalars['String']['output'];
  descriptionFr: Scalars['String']['output'];
  maxSeats?: Maybe<Scalars['Int']['output']>;
  periodEnd?: Maybe<Scalars['DateTime']['output']>;
  periodStart?: Maybe<Scalars['DateTime']['output']>;
  plan?: Maybe<Scalars['String']['output']>;
  productCode: Scalars['String']['output'];
  quantity: Scalars['Int']['output'];
  sms?: Maybe<Scalars['Int']['output']>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  unitPrice: Scalars['Float']['output'];
};

export type OrderLineInput = {
  description: Scalars['String']['input'];
  descriptionDe: Scalars['String']['input'];
  descriptionEn: Scalars['String']['input'];
  descriptionFr: Scalars['String']['input'];
  maxSeats?: InputMaybe<Scalars['Int']['input']>;
  periodEnd?: InputMaybe<Scalars['DateTime']['input']>;
  periodStart?: InputMaybe<Scalars['DateTime']['input']>;
  plan?: InputMaybe<Scalars['String']['input']>;
  productCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  sms?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  unitPrice: Scalars['Float']['input'];
};

export enum OrderStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Confirmed = 'CONFIRMED',
  Pending = 'PENDING'
}

export type Passenger = {
  __typename?: 'Passenger';
  accompany?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['PositiveInt']['output']>;
  category?: Maybe<Category>;
  child?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  disability?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  luggage?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  paymentAmount?: Maybe<Scalars['Float']['output']>;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentReference?: Maybe<Scalars['String']['output']>;
  paymentStatus?: Maybe<PaymentStatus>;
  paymentType?: Maybe<PaymentType>;
  postalCode?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  signature?: Maybe<Scalars['String']['output']>;
  totalWeight?: Maybe<Scalars['PositiveInt']['output']>;
  transport?: Maybe<Scalars['Boolean']['output']>;
  voucher?: Maybe<Voucher>;
  voucherNumber?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['PositiveInt']['output']>;
  weightIsDefault: Scalars['Boolean']['output'];
};

export type PassengerCounters = {
  __typename?: 'PassengerCounters';
  childCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  disabilityCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  luggageCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  openAmount?: Maybe<Scalars['NonNegativeInt']['output']>;
  paidAmount?: Maybe<Scalars['NonNegativeInt']['output']>;
  passengerCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  totalAmount?: Maybe<Scalars['NonNegativeInt']['output']>;
  totalWeight?: Maybe<Scalars['NonNegativeInt']['output']>;
  transportCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  unpaidPassengerCount?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type PassengerData = {
  __typename?: 'PassengerData';
  childCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  disabilityCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  freeSpots?: Maybe<Scalars['NonNegativeInt']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  occupancy?: Maybe<Scalars['NonNegativeInt']['output']>;
  openAmount?: Maybe<Scalars['NonNegativeInt']['output']>;
  passengersCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  passengersCountAdded?: Maybe<Scalars['NonNegativeInt']['output']>;
  passengersCountConfirmed?: Maybe<Scalars['NonNegativeInt']['output']>;
  passengersCountInvited?: Maybe<Scalars['NonNegativeInt']['output']>;
  passengersWeight?: Maybe<Scalars['NonNegativeInt']['output']>;
  transportCount?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type PassengerInput = {
  accompany?: InputMaybe<Scalars['String']['input']>;
  address?: InputMaybe<Scalars['String']['input']>;
  age?: InputMaybe<Scalars['PositiveInt']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  child: Scalars['Boolean']['input'];
  city?: InputMaybe<Scalars['String']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  disability?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  luggage?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentReference?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  signature?: InputMaybe<Scalars['String']['input']>;
  transport?: InputMaybe<Scalars['Boolean']['input']>;
  voucherId?: InputMaybe<Scalars['ID']['input']>;
  voucherNumber?: InputMaybe<Scalars['String']['input']>;
  weight?: InputMaybe<Scalars['PositiveInt']['input']>;
  weightIsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PassengerPaymentInput = {
  category?: InputMaybe<Scalars['ID']['input']>;
  child?: InputMaybe<Scalars['Boolean']['input']>;
  paymentAmount?: InputMaybe<Scalars['Float']['input']>;
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentReference?: InputMaybe<Scalars['String']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  voucherId?: InputMaybe<Scalars['ID']['input']>;
  voucherNumber?: InputMaybe<Scalars['String']['input']>;
};

export enum PaymentStatus {
  Open = 'OPEN',
  Paid = 'PAID',
  Refunded = 'REFUNDED'
}

export enum PaymentType {
  Banc = 'BANC',
  Cash = 'CASH',
  Cheq = 'CHEQ',
  Coup = 'COUP',
  Cred = 'CRED',
  Invo = 'INVO',
  Nopa = 'NOPA',
  Onli = 'ONLI',
  Vouc = 'VOUC',
  Wire = 'WIRE'
}

export enum PilotLicense {
  Com = 'COM',
  Nco = 'NCO',
  Nol = 'NOL'
}

export type PilotSignOffInput = {
  pilotComments?: InputMaybe<Scalars['String']['input']>;
  pilotSignature?: InputMaybe<Scalars['String']['input']>;
};

export enum PlanState {
  Active = 'ACTIVE',
  ExpiredFinal = 'EXPIRED_FINAL',
  ExpiredGrace = 'EXPIRED_GRACE',
  Expiring = 'EXPIRING'
}

export type Pluscode = {
  __typename?: 'Pluscode';
  compound_code?: Maybe<Scalars['String']['output']>;
  global_code?: Maybe<Scalars['String']['output']>;
};

export type PreferredCrew = {
  __typename?: 'PreferredCrew';
  balloon?: Maybe<Balloon>;
  crew?: Maybe<Array<Maybe<Crew>>>;
  driver?: Maybe<Crew>;
  pilot?: Maybe<Crew>;
};

export type PreferredDateInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<FlightPeriod>;
};

export type PreferredFlight = {
  __typename?: 'PreferredFlight';
  date?: Maybe<Scalars['String']['output']>;
  period?: Maybe<FlightPeriod>;
};

export type PreferredFlightInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<FlightPeriod>;
};

export type Query = {
  __typename?: 'Query';
  allReleaseNotes?: Maybe<Array<Maybe<ReleaseNote>>>;
  /** Settings block + notConnected states on NOTAM surfaces */
  autorouterStatus: AutorouterConnection;
  balloon: Balloon;
  balloonWeight: BalloonWeight;
  balloons: Array<Maybe<Balloon>>;
  booking?: Maybe<Booking>;
  bookingConversations: Array<Maybe<Booking>>;
  bookingCounters?: Maybe<BookingCounters>;
  /** Spec 235 v3: counts of the booking list filter row (Open amount chip + tag chips) for a status (+ search in filter) */
  bookingFilterCounts: BookingFilterCounts;
  /** Spec 235 FR-017: bookings hidden by the flight picker because they expire before the flight date */
  bookingPickerExpiredCount: Scalars['NonNegativeInt']['output'];
  bookingPoolCounts: BookingPoolCounts;
  /** Spec 235 FR-012: per-set match counts for a booking list search (v3: + Open amount chip, tag: terms combine with the search) */
  bookingSearchCounts: BookingSearchCounts;
  bookingsPreferredDate: Array<Maybe<Booking>>;
  /** Dry run: what the action would do. feature.flight.bulk (+ feature.flight.delete for DELETE) */
  bulkFlightActionPreview: BulkFlightPreview;
  /** Ids of all upcoming flights matching the flight-list filter (same semantics as getFlightsList). feature.flight.bulk (Owner + Operator) */
  bulkFlightSelection: BulkFlightSelection;
  calendar: Calendar;
  calendarWeek: CalendarWeek;
  categories: Array<Maybe<Category>>;
  category: Category;
  copyProductionToDevelopment: Scalars['NonNegativeInt']['output'];
  countries: Array<Maybe<Country>>;
  crew: Crew;
  crewCalendar: Array<Maybe<CrewCalendarItem>>;
  crewConversations: Array<Maybe<Crew>>;
  crews: Array<Maybe<Crew>>;
  crewsPerFlight: Array<Maybe<CrewPerFlight>>;
  cylinder: Cylinder;
  cylinders: Array<Maybe<Cylinder>>;
  dashboardBookings: Array<Maybe<Booking>>;
  defaultCategory: Category;
  events: Array<Maybe<Event>>;
  expiredVouchers: Array<Maybe<Voucher>>;
  fetchSkeyesForecast?: Maybe<FlightSkeyesForecast>;
  firstBookingWithFlight?: Maybe<Array<Maybe<Booking>>>;
  flight: Flight;
  flightCounters?: Maybe<FlightCounters>;
  flightPeriods?: Maybe<FlightPeriods>;
  /** Spec 235 FR-025: flights matching a flight list search in each set (Upcoming / Finished & cancelled). filterRange applies to both sets, freeSpots only to upcoming — as in the lists. */
  flightSearchCounts: FlightSearchCounts;
  flightsOfDashboard: Array<Maybe<Flight>>;
  flightsOfDate: Array<Maybe<Flight>>;
  flightsOfDateCrew: Array<Maybe<Flight>>;
  /** Platform flyability thresholds without tenant overrides — what a reset restores (104) */
  flyabilityDefaults?: Maybe<Array<FlyabilityThreshold>>;
  geocode: Array<Maybe<GeocodeResult>>;
  getAllEmailTemplates: Array<Maybe<EmailSettingsTemplate>>;
  getAllSmsTemplates: Array<Maybe<SmsTemplate>>;
  getAllTags: Array<Maybe<TagUnion>>;
  getBookingPassengerEmails: Array<Maybe<BookingPassengerEmail>>;
  getBookingsIS: Array<Maybe<Booking>>;
  getEmailTemplate: EmailSettingsTemplate;
  getEmailTemplateByID: EmailSettingsTemplate;
  getEmailTemplateByLanguage: EmailTemplateByLanguage;
  getEmailTemplates: Array<Maybe<EmailSettingsTemplate>>;
  getFlightsList: Array<Maybe<Flight>>;
  getHistoricalFlightsList: Array<Maybe<Flight>>;
  getSkeyesForecast?: Maybe<SkeyesForecast>;
  getSmsTemplates: Array<Maybe<SmsTemplate>>;
  getTag: TagUnion;
  getTagsOfType: Array<Maybe<TagUnion>>;
  getTenant: Tenant;
  getTenantByDisplayName: Tenant;
  getTenants: Array<Maybe<Tenant>>;
  getUser?: Maybe<GcpipUser>;
  getUsers: Array<Maybe<GcpipUser>>;
  get_balloons_tenant?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  get_booking_tenant?: Maybe<Scalars['JSONObject']['output']>;
  get_bookings_tenant?: Maybe<Scalars['JSONObject']['output']>;
  get_crew_ics?: Maybe<Scalars['JSON']['output']>;
  get_flights_tenant?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  get_locations_tenant?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  get_regions_tenant?: Maybe<Array<Maybe<Scalars['JSONObject']['output']>>>;
  get_voucher_tenant?: Maybe<Scalars['JSONObject']['output']>;
  historicalBookings: Array<Maybe<Booking>>;
  invoice?: Maybe<Invoice>;
  invoiceDownload: InvoiceDownload;
  invoices: InvoiceConnection;
  location: Location;
  /** Dashboard weather-card strip: favourite location + selected forecast slot (FR-011) */
  locationNotamAssessment?: Maybe<NotamAssessment>;
  /** Location picker: batch summaries for all candidate locations of a flight window (FR-012) */
  locationNotamSummaries: Array<LocationNotamSummary>;
  locations: Array<Maybe<Location>>;
  logbook: LogBook;
  logbooks: Array<Maybe<LogBook>>;
  logsFromFile?: Maybe<Array<Maybe<ImportLogBook>>>;
  manufacturers?: Maybe<Manufacturers>;
  /** How many messages the retention sweep would flag for deletion with these prospective settings (096). 0 years = never. */
  messageRetentionImpact: MessageRetentionImpact;
  /** Messages already flagged by the retention sweep and when the first of them is purged for good (096) */
  messageRetentionStatus: MessageRetentionStatus;
  montyInstructions: Array<MontyInstructions>;
  montyLearnEstimate: Array<MontyLearnEstimate>;
  montyLearnRun?: Maybe<MontyLearnRun>;
  montyStatus: MontyStatusInfo;
  montyUsage: Array<MontyUsageMonth>;
  myWeek: MyWeek;
  myflight?: Maybe<Myflight>;
  myflightBooking?: Maybe<MyflightBooking>;
  myflightFlights?: Maybe<Array<Maybe<Flight>>>;
  myflightLegacy?: Maybe<Myflight>;
  openVouchers: Array<Maybe<Voucher>>;
  orders: Array<Order>;
  parseEmailTemplate: EmailTemplateByLanguage;
  passengerCounters?: Maybe<PassengerCounters>;
  passengerRegionDistribution?: Maybe<Chart>;
  pilotsPerFlight: Array<Maybe<CrewPerFlight>>;
  questions: Array<Maybe<Question>>;
  receive?: Maybe<Scalars['String']['output']>;
  /** Bulk actions of the last 24 h, newest first. feature.flight.bulk */
  recentBulkFlightActions: Array<BulkFlightAction>;
  region: Region;
  regions: Array<Maybe<Region>>;
  releaseNote?: Maybe<ReleaseNote>;
  releaseNotes?: Maybe<Array<Maybe<ReleaseNote>>>;
  releaseNotesCount?: Maybe<Scalars['NonNegativeInt']['output']>;
  reports?: Maybe<Reports>;
  reverseGeocode?: Maybe<Scalars['String']['output']>;
  scheduledFlights: Array<Maybe<Flight>>;
  serverStatus?: Maybe<ServerStatus>;
  smsByBooking?: Maybe<Array<Maybe<Sms>>>;
  smsByCrew?: Maybe<Array<Maybe<Sms>>>;
  smsByFlight?: Maybe<Array<Maybe<Sms>>>;
  smsByPhone?: Maybe<Array<Maybe<Sms>>>;
  sunriseSunset: SunriseSunset;
  tenant?: Maybe<TenantInfo>;
  tenantActions: Array<TenantAction>;
  tenantSetting?: Maybe<TenantSetting>;
  upFlights?: Maybe<Array<Flight>>;
  upUrl?: Maybe<Scalars['String']['output']>;
  upcomingBookings: Array<Maybe<Booking>>;
  upcomingFlights: Array<Maybe<Flight>>;
  usedVouchers: Array<Maybe<Voucher>>;
  voucher?: Maybe<Voucher>;
  voucherCounters?: Maybe<VoucherCounters>;
  vouchers: Array<Maybe<Voucher>>;
  weatherSourceDefaults?: Maybe<Array<Maybe<WeatherSourceMapping>>>;
  wefactDebtors: WefactDebtorConnection;
  /** 037 FR-023: estimated monthly Meta cost from message history — null when no history/export is available */
  whatsappCloudCostEstimate?: Maybe<WhatsappCostEstimate>;
  whatsappConnectionStatus: WhatsAppConnectionStatus;
  whatsappDevices?: Maybe<WhatsappDevices>;
  whatsappLogin?: Maybe<WhatsappLogin>;
  whatsappLogout?: Maybe<WhatsappLogout>;
  /** 037 FR-006c: window state for up to 100 recipient phones (cloud tenants; container answers all-open) */
  whatsappWindowStates: Array<WhatsappWindowState>;
};


export type QueryBalloonArgs = {
  balloonId: Scalars['ID']['input'];
};


export type QueryBalloonWeightArgs = {
  balloonId: Scalars['ID']['input'];
};


export type QueryBookingArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBookingConversationsArgs = {
  offset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryBookingFilterCountsArgs = {
  bookingFilter: BookingFilter;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBookingPickerExpiredCountArgs = {
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightId: Scalars['ID']['input'];
  flightOnlyMatching?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBookingSearchCountsArgs = {
  filter: Array<InputMaybe<Scalars['String']['input']>>;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBookingsPreferredDateArgs = {
  preferredDateInput?: InputMaybe<PreferredDateInput>;
  search?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBulkFlightActionPreviewArgs = {
  flightIds: Array<Scalars['ID']['input']>;
  input: BulkFlightActionInput;
};


export type QueryBulkFlightSelectionArgs = {
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterRange?: InputMaybe<FilterRangeInput>;
  floorDate?: InputMaybe<Scalars['String']['input']>;
  freeSpots?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UpcomingFlightScope>;
};


export type QueryCalendarArgs = {
  month: Scalars['PositiveInt']['input'];
  year: Scalars['PositiveInt']['input'];
};


export type QueryCalendarWeekArgs = {
  week: Scalars['PositiveInt']['input'];
  year: Scalars['PositiveInt']['input'];
};


export type QueryCategoryArgs = {
  categoryId: Scalars['ID']['input'];
};


export type QueryCopyProductionToDevelopmentArgs = {
  copyHistory?: InputMaybe<Scalars['Boolean']['input']>;
  copyUsers?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCrewArgs = {
  crewId: Scalars['ID']['input'];
};


export type QueryCrewCalendarArgs = {
  month: Scalars['PositiveInt']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  year: Scalars['PositiveInt']['input'];
};


export type QueryCrewConversationsArgs = {
  offset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryCrewsPerFlightArgs = {
  flightId: Scalars['ID']['input'];
};


export type QueryCylinderArgs = {
  cylinderId: Scalars['ID']['input'];
};


export type QueryExpiredVouchersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByVoucher>;
  orderDirection?: InputMaybe<OrderDirection>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFetchSkeyesForecastArgs = {
  flightId: Scalars['ID']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type QueryFlightArgs = {
  flightId: Scalars['ID']['input'];
};


export type QueryFlightSearchCountsArgs = {
  filter: Array<InputMaybe<Scalars['String']['input']>>;
  filterRange?: InputMaybe<FilterRangeInput>;
  freeSpots?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFlightsOfDateArgs = {
  date: Scalars['String']['input'];
};


export type QueryFlightsOfDateCrewArgs = {
  date: Scalars['String']['input'];
};


export type QueryGeocodeArgs = {
  address: Scalars['String']['input'];
};


export type QueryGetBookingPassengerEmailsArgs = {
  bookingFilter?: InputMaybe<BookingFilter>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
  showUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetBookingsIsArgs = {
  bookingFilter?: InputMaybe<BookingFilter>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  endAt?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightId?: InputMaybe<Scalars['ID']['input']>;
  flightOnlyMatching?: InputMaybe<Scalars['Boolean']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<OrderByBooking>;
  orderDirection?: InputMaybe<OrderDirection>;
  showUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetEmailTemplateArgs = {
  type: EmailTemplateType;
};


export type QueryGetEmailTemplateByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryGetEmailTemplateByLanguageArgs = {
  lang?: InputMaybe<ContactLanguage>;
  type: EmailTemplateType;
};


export type QueryGetEmailTemplatesArgs = {
  type: EmailTemplateType;
};


export type QueryGetFlightsListArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterRange?: InputMaybe<FilterRangeInput>;
  freeSpots?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  scope?: InputMaybe<UpcomingFlightScope>;
};


export type QueryGetHistoricalFlightsListArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filterRange?: InputMaybe<FilterRangeInput>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryGetSkeyesForecastArgs = {
  slot: Scalars['String']['input'];
};


export type QueryGetSmsTemplatesArgs = {
  type: Scalars['String']['input'];
};


export type QueryGetTagArgs = {
  tagId: Scalars['ID']['input'];
};


export type QueryGetTagsOfTypeArgs = {
  tagType?: InputMaybe<TagType>;
};


export type QueryGetTenantArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGetTenantByDisplayNameArgs = {
  displayName: Scalars['String']['input'];
};


export type QueryGetUsersArgs = {
  tenantId: Scalars['String']['input'];
};


export type QueryGet_Booking_TenantArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryGet_Bookings_TenantArgs = {
  cursor?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGet_Voucher_TenantArgs = {
  voucherId?: InputMaybe<Scalars['ID']['input']>;
  voucherReference?: InputMaybe<Scalars['String']['input']>;
};


export type QueryHistoricalBookingsArgs = {
  bookingFilter?: InputMaybe<BookingFilter>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByBooking>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryInvoiceArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoiceDownloadArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
};


export type QueryInvoicesArgs = {
  input?: InputMaybe<InvoiceListInput>;
};


export type QueryLocationArgs = {
  locationId: Scalars['ID']['input'];
};


export type QueryLocationNotamAssessmentArgs = {
  date: Scalars['Date']['input'];
  locationId: Scalars['ID']['input'];
  period: FlightPeriod;
};


export type QueryLocationNotamSummariesArgs = {
  date: Scalars['Date']['input'];
  locationIds: Array<Scalars['ID']['input']>;
  period: FlightPeriod;
};


export type QueryLogbookArgs = {
  logbookId: Scalars['ID']['input'];
};


export type QueryLogsFromFileArgs = {
  file: Scalars['String']['input'];
  fromDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryMessageRetentionImpactArgs = {
  closedBookingsYears?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  crewYears?: InputMaybe<Scalars['NonNegativeInt']['input']>;
};


export type QueryMontyUsageArgs = {
  months?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMyWeekArgs = {
  week: Scalars['PositiveInt']['input'];
  year: Scalars['PositiveInt']['input'];
};


export type QueryMyflightArgs = {
  bookingEmail?: InputMaybe<Scalars['String']['input']>;
  bookingReference?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyflightBookingArgs = {
  bookingEmail?: InputMaybe<Scalars['String']['input']>;
  bookingReference?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyflightFlightsArgs = {
  bookingEmail?: InputMaybe<Scalars['String']['input']>;
  bookingReference?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMyflightLegacyArgs = {
  legacyBooking: Scalars['String']['input'];
};


export type QueryOpenVouchersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByVoucher>;
  orderDirection?: InputMaybe<OrderDirection>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryParseEmailTemplateArgs = {
  emailBody: Scalars['String']['input'];
  flightPeriod: Scalars['String']['input'];
  language: Scalars['String']['input'];
};


export type QueryPassengerCountersArgs = {
  passengers: Array<InputMaybe<PassengerInput>>;
};


export type QueryPilotsPerFlightArgs = {
  flightId: Scalars['ID']['input'];
};


export type QueryQuestionsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryReceiveArgs = {
  msisdn: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type QueryRegionArgs = {
  regionId: Scalars['ID']['input'];
};


export type QueryReleaseNoteArgs = {
  releaseNoteId: Scalars['ID']['input'];
};


export type QueryReverseGeocodeArgs = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};


export type QueryScheduledFlightsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByFlight>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QuerySmsByBookingArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QuerySmsByCrewArgs = {
  crewId: Scalars['ID']['input'];
};


export type QuerySmsByFlightArgs = {
  flightId: Scalars['ID']['input'];
};


export type QuerySmsByPhoneArgs = {
  phone?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySunriseSunsetArgs = {
  sunriseSunsetInput?: InputMaybe<SunriseSunsetInput>;
};


export type QueryUpUrlArgs = {
  bookingId: Scalars['ID']['input'];
};


export type QueryUpcomingBookingsArgs = {
  bookingFilter?: InputMaybe<BookingFilter>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightId?: InputMaybe<Scalars['ID']['input']>;
  flightOnlyMatching?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByBooking>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryUpcomingFlightsArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByFlight>;
  orderDirection?: InputMaybe<OrderDirection>;
};


export type QueryUsedVouchersArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  orderBy?: InputMaybe<OrderByVoucher>;
  orderDirection?: InputMaybe<OrderDirection>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVoucherArgs = {
  id: Scalars['ID']['input'];
};


export type QueryWefactDebtorsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryWhatsappWindowStatesArgs = {
  phones: Array<Scalars['String']['input']>;
};

export type Question = {
  __typename?: 'Question';
  active?: Maybe<Scalars['Boolean']['output']>;
  code?: Maybe<QuestionTemplate>;
  content?: Maybe<QuestionContent>;
  id: Scalars['ID']['output'];
  kind?: Maybe<QuestionKind>;
};

export type QuestionContent = {
  __typename?: 'QuestionContent';
  description?: Maybe<Array<Maybe<MlText>>>;
  order: Scalars['PositiveInt']['output'];
  title: Array<Maybe<MlText>>;
};

export type QuestionContentInput = {
  description?: InputMaybe<Array<InputMaybe<MlTextInput>>>;
  order: Scalars['PositiveInt']['input'];
  title: Array<InputMaybe<MlTextInput>>;
};

export type QuestionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  lang?: InputMaybe<SystemLanguage>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export enum QuestionKind {
  Mandatory = 'mandatory',
  Optional = 'optional'
}

export enum QuestionTemplate {
  Accompany = 'accompany',
  Address = 'address',
  Child = 'child',
  Email = 'email',
  Luggage = 'luggage',
  Name = 'name',
  Pay = 'pay',
  Signature = 'signature',
  Weight = 'weight'
}

export type Region = {
  __typename?: 'Region';
  color?: Maybe<Scalars['String']['output']>;
  countOpenBookings?: Maybe<Scalars['NonNegativeInt']['output']>;
  defaultColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  locations: Array<Maybe<Location>>;
  name?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['NonNegativeInt']['output']>;
  ref?: Maybe<Scalars['JSONObject']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
};

export type RegionInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type ReleaseNote = {
  __typename?: 'ReleaseNote';
  date?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentation?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  oneliner?: Maybe<Scalars['String']['output']>;
  tenants?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  video?: Maybe<Scalars['String']['output']>;
};

export type Reports = {
  __typename?: 'Reports';
  bookings?: Maybe<Scalars['URL']['output']>;
  bookingsOpen?: Maybe<Scalars['URL']['output']>;
  flights?: Maybe<Scalars['URL']['output']>;
  payments?: Maybe<Scalars['URL']['output']>;
  sms?: Maybe<Scalars['URL']['output']>;
  vouchers?: Maybe<Scalars['URL']['output']>;
};

export type RestoreFlightResult = {
  __typename?: 'RestoreFlightResult';
  flight: Flight;
  restored: Array<Booking>;
  skipped: Array<SkippedRestoreBooking>;
};

export enum RestoreSkipReason {
  /** Booking no longer exists (deleted/removed) */
  Deleted = 'DELETED',
  /** Booking exists and is unassigned but not in OPEN status */
  NotOpen = 'NOT_OPEN',
  /** Booking is meanwhile attached to another flight */
  OnOtherFlight = 'ON_OTHER_FLIGHT'
}

export type ServerStatus = {
  __typename?: 'ServerStatus';
  expectedDuration?: Maybe<Scalars['NonNegativeInt']['output']>;
  maintenance?: Maybe<Scalars['Boolean']['output']>;
  purpose?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['DateTime']['output']>;
};

export type SkeyesForecast = {
  __typename?: 'SkeyesForecast';
  datetime?: Maybe<Scalars['DateTime']['output']>;
  full?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  inversions?: Maybe<Scalars['String']['output']>;
  issued?: Maybe<Scalars['DateTime']['output']>;
  outlook?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  slot?: Maybe<Scalars['String']['output']>;
  weather?: Maybe<Scalars['String']['output']>;
  winds?: Maybe<Scalars['String']['output']>;
};

export type SkippedRestoreBooking = {
  __typename?: 'SkippedRestoreBooking';
  /** Null when the booking was deleted */
  booking?: Maybe<Booking>;
  bookingId: Scalars['ID']['output'];
  reason: RestoreSkipReason;
};

export type Sms = {
  __typename?: 'Sms';
  date?: Maybe<SmsDates>;
  direction?: Maybe<SmsDirection>;
  eventSummary?: Maybe<SmsEventSummary>;
  /**
   * Indicates if SMS fallback was used because WhatsApp failed.
   * Only true when original attempt was WhatsApp but delivered via SMS.
   */
  fallbackUsed?: Maybe<Scalars['Boolean']['output']>;
  flight?: Maybe<Flight>;
  id: Scalars['ID']['output'];
  /**
   * The originally intended channel (always WHATSAPP when messaging is enabled).
   * Used to identify messages that were meant for WhatsApp but fell back to SMS.
   */
  intendedChannel?: Maybe<Scalars['String']['output']>;
  messageIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  monty?: Maybe<MontyClassification>;
  montyProposal?: Maybe<MontyProposal>;
  nexmo?: Maybe<Scalars['JSONObject']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<SmsProvider>;
  raspberry?: Maybe<Scalars['JSONObject']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  wa?: Maybe<Scalars['JSONObject']['output']>;
  waImage?: Maybe<Scalars['URL']['output']>;
  waLink?: Maybe<Scalars['URL']['output']>;
};

export type SmsConversation = {
  __typename?: 'SmsConversation';
  booking?: Maybe<Booking>;
  bookingId?: Maybe<Scalars['ID']['output']>;
  crew?: Maybe<Crew>;
  crewId?: Maybe<Scalars['ID']['output']>;
  latest?: Maybe<SmsSummary>;
  type?: Maybe<SmsConversationType>;
  unread?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export enum SmsConversationType {
  Boo = 'BOO',
  Cre = 'CRE'
}

export type SmsDates = {
  __typename?: 'SmsDates';
  processed?: Maybe<Scalars['DateTime']['output']>;
  read?: Maybe<Scalars['DateTime']['output']>;
  sms?: Maybe<Scalars['DateTime']['output']>;
};

export enum SmsDirection {
  In = 'IN',
  Out = 'OUT'
}

export type SmsEventSummary = {
  __typename?: 'SmsEventSummary';
  error?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type SmsInput = {
  /** 037 FR-007: flight context for template parameter values (date/hour/balloon/…) */
  flightId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Path of the message doc whose open Monty proposal this send resolves
   * (088). Absent on manual replies — those expire any open proposal.
   */
  montyProposalPath?: InputMaybe<Scalars['String']['input']>;
  negativeReply?: InputMaybe<Scalars['String']['input']>;
  positiveReply?: InputMaybe<Scalars['String']['input']>;
  repeat?: InputMaybe<SmsRepeat>;
  /** 037 FR-029: the variant doc whose wording was rendered */
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
  /** 037 FR-007: message type the send dialog rendered (drives the approved-template choice out-of-window) */
  smsType?: InputMaybe<Scalars['String']['input']>;
  /** 037 FR-006b: operator changed the rendered text — edited text never goes out as a template */
  templateEdited?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  up?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SmsLatest = {
  __typename?: 'SmsLatest';
  date?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<SmsDirection>;
  error?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export enum SmsProvider {
  Eimers = 'EIMERS',
  Nexmo = 'NEXMO',
  Whatsapp = 'WHATSAPP'
}

export enum SmsRepeat {
  All = 'ALL',
  Pax = 'PAX',
  Single = 'SINGLE'
}

export type SmsSettings = {
  __typename?: 'SmsSettings';
  from?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<SmsProvider>;
  to?: Maybe<Scalars['String']['output']>;
};

export type SmsSummary = {
  __typename?: 'SmsSummary';
  date?: Maybe<Scalars['DateTime']['output']>;
  direction?: Maybe<SmsDirection>;
  messageId?: Maybe<Scalars['ID']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type SmsTemplate = {
  __typename?: 'SmsTemplate';
  id: Scalars['ID']['output'];
  /** 037 FR-029: variant name shown in the template picker (a type may have several variants) */
  label?: Maybe<Scalars['String']['output']>;
  /** 222: cancel reason this cancelSms variant is for (one of operatorSettings.flights.cancelReasons); null = general */
  reasonCode?: Maybe<Scalars['String']['output']>;
  template: Template;
  type: Scalars['String']['output'];
};

export type SmsTemplateInput = {
  /** 037 FR-029: variant name */
  label?: InputMaybe<Scalars['String']['input']>;
  /** 222: only honoured for type cancelSms; unique per tenant; explicit null clears */
  reasonCode?: InputMaybe<Scalars['String']['input']>;
  template?: InputMaybe<TemplateInput>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export enum SmsType {
  /** 2026-09-04: reservation confirmation — no flight variables; the send can carry the UP url and upcoming flight options alongside (US7) */
  BookingConfirmationSms = 'bookingConfirmationSms',
  CancelSms = 'cancelSms',
  CheckinNotificationSms = 'checkinNotificationSms',
  CrewInvitationSms = 'crewInvitationSms',
  LocationContactSms = 'locationContactSms',
  PassengerInvitationSms = 'passengerInvitationSms',
  PilotInvitationSms = 'pilotInvitationSms',
  ReminderSms = 'reminderSms'
}

export enum SortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StatusCounter = {
  __typename?: 'StatusCounter';
  count?: Maybe<Scalars['NonNegativeInt']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  bookingCountersUpdated?: Maybe<BookingCounters>;
  custom?: Maybe<Scalars['Boolean']['output']>;
  debtorValidation?: Maybe<DebtorValidation>;
  factuursturenClient?: Maybe<Scalars['String']['output']>;
  flightCountersUpdated?: Maybe<FlightCounters>;
  gracePeriodDays?: Maybe<Scalars['NonNegativeInt']['output']>;
  isBlocked: Scalars['Boolean']['output'];
  newSms?: Maybe<Array<Maybe<Sms>>>;
  plan?: Maybe<SubscriptionPlan>;
  planState: PlanState;
  sms?: Maybe<SubscriptionSms>;
  voucherCountersUpdated?: Maybe<VoucherCounters>;
};

export type SubscriptionPlan = {
  __typename?: 'SubscriptionPlan';
  blockedEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  expiredEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  expiredSince?: Maybe<Scalars['DateTime']['output']>;
  invalidEmailSentAt?: Maybe<Scalars['DateTime']['output']>;
  invalidSince?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<SubscriptionPlanEnum>;
  pctUsed?: Maybe<Scalars['NonNegativeInt']['output']>;
  seats?: Maybe<Scalars['NonNegativeInt']['output']>;
  status?: Maybe<SubscriptionPlanStatus>;
  suggestedOrderLines?: Maybe<Array<Maybe<OrderLine>>>;
  suggestedUpgrade?: Maybe<SubscriptionPlanEnum>;
  used?: Maybe<Scalars['NonNegativeInt']['output']>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  validUntil?: Maybe<Scalars['DateTime']['output']>;
};

export enum SubscriptionPlanEnum {
  Meso = 'MESO',
  Strato = 'STRATO',
  Trial = 'TRIAL',
  Tropo = 'TROPO'
}

export enum SubscriptionPlanStatus {
  Active = 'ACTIVE',
  Expired = 'EXPIRED'
}

export type SubscriptionSms = {
  __typename?: 'SubscriptionSMS';
  available?: Maybe<Scalars['NonNegativeInt']['output']>;
  ignoreWarning?: Maybe<Scalars['Boolean']['output']>;
  pctUsed?: Maybe<Scalars['NonNegativeInt']['output']>;
  status?: Maybe<SubscriptionSmsStatus>;
  suggestedOrderLines?: Maybe<Array<Maybe<OrderLine>>>;
  used?: Maybe<Scalars['NonNegativeInt']['output']>;
  usedSMS?: Maybe<Array<Maybe<UsedSms>>>;
};

export enum SubscriptionSmsStatus {
  Active = 'ACTIVE',
  Empty = 'EMPTY'
}

export type SunriseSunset = {
  __typename?: 'SunriseSunset';
  eveningFlight?: Maybe<Scalars['String']['output']>;
  morningFlight?: Maybe<Scalars['String']['output']>;
  sunrise?: Maybe<Scalars['String']['output']>;
  sunset?: Maybe<Scalars['String']['output']>;
};

export type SunriseSunsetInput = {
  flightDate?: InputMaybe<Scalars['DateTime']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export enum SystemLanguage {
  De = 'de',
  Du = 'du',
  En = 'en',
  Es = 'es',
  Fr = 'fr',
  Nl = 'nl'
}

export type Tag = {
  backgroundColor?: Maybe<Scalars['String']['output']>;
  dashboard?: Maybe<Scalars['Boolean']['output']>;
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Scalars['PositiveInt']['output']>;
  id: Scalars['ID']['output'];
  locked?: Maybe<Scalars['Boolean']['output']>;
  tag?: Maybe<Scalars['String']['output']>;
  type?: Maybe<TagType>;
  upcoming?: Maybe<Scalars['PositiveInt']['output']>;
};

export type TagData = {
  __typename?: 'TagData';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  fontColor?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  tag?: Maybe<Scalars['String']['output']>;
};

export type TagInput = {
  allowedFlightTags?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  backgroundColor?: InputMaybe<Scalars['String']['input']>;
  dashboard?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fontColor?: InputMaybe<Scalars['String']['input']>;
  onlyAllowedFlightTags?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<TagType>;
};

export enum TagType {
  Booking = 'booking',
  Flight = 'flight'
}

export type TagUnion = BookingTag | FlightTag;

export type Template = {
  __typename?: 'Template';
  de: Scalars['String']['output'];
  en: Scalars['String']['output'];
  fr: Scalars['String']['output'];
  nl: Scalars['String']['output'];
};

export type TemplateInput = {
  de: Scalars['String']['input'];
  en: Scalars['String']['input'];
  fr: Scalars['String']['input'];
  nl: Scalars['String']['input'];
};

export type Tenant = {
  __typename?: 'Tenant';
  displayName: Scalars['String']['output'];
  tenantId?: Maybe<Scalars['String']['output']>;
  tenantSetting?: Maybe<TenantSetting>;
};

export type TenantAction = {
  __typename?: 'TenantAction';
  deepLinkRoute: Scalars['String']['output'];
  severity: TenantActionSeverity;
  since: Scalars['DateTime']['output'];
  type: TenantActionType;
};

export enum TenantActionSeverity {
  Error = 'ERROR',
  Warning = 'WARNING'
}

export enum TenantActionType {
  WhatsappPairRequired = 'WHATSAPP_PAIR_REQUIRED',
  WhatsappSessionDisconnected = 'WHATSAPP_SESSION_DISCONNECTED'
}

export enum TenantCurrency {
  Chf = 'CHF',
  Eur = 'EUR',
  Gbp = 'GBP'
}

export type TenantInfo = {
  __typename?: 'TenantInfo';
  colors?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type TenantSetting = {
  __typename?: 'TenantSetting';
  apiCacheEnabled?: Maybe<Scalars['Boolean']['output']>;
  apiKey?: Maybe<Scalars['String']['output']>;
  dashboardOptions?: Maybe<DashboardOptions>;
  flyability?: Maybe<Array<FlyabilityThreshold>>;
  /** Whether this tenant shows flyability verdicts at all. Absent on tenants that predate the feature, which reads as off (104) */
  flyabilityEnabled: Scalars['Boolean']['output'];
  icsId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  integrations?: Maybe<Integrations>;
  locationOptions?: Maybe<LocationOptions>;
  logo?: Maybe<Scalars['String']['output']>;
  mailAccountant?: Maybe<EmailAddressObject>;
  mailFrom?: Maybe<EmailAddressObject>;
  mailReplyTo?: Maybe<EmailAddressObject>;
  messageRetention?: Maybe<MessageRetention>;
  name?: Maybe<Scalars['String']['output']>;
  operatorSettings?: Maybe<OperatorSettings>;
  releasenotes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sms?: Maybe<SmsSettings>;
  subscription?: Maybe<Subscription>;
  tenantId: Scalars['String']['output'];
  trial?: Maybe<Scalars['Boolean']['output']>;
  trialEnds?: Maybe<Scalars['DateTime']['output']>;
  upEnabled?: Maybe<Scalars['Boolean']['output']>;
  whatsapp?: Maybe<WhatsappSettings>;
};

export type Ticket = {
  __typename?: 'Ticket';
  booking?: Maybe<Booking>;
  flight?: Maybe<Flight>;
  passenger?: Maybe<Passenger>;
};

export type TrackingDate = {
  __typename?: 'TrackingDate';
  date?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  tracking?: Maybe<Scalars['Boolean']['output']>;
  validity?: Maybe<Scalars['PositiveInt']['output']>;
  warning?: Maybe<Scalars['PositiveInt']['output']>;
};

export type TrajectoryProfile = {
  __typename?: 'TrajectoryProfile';
  duration?: Maybe<Scalars['NonNegativeInt']['output']>;
  level?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type Translation = {
  __typename?: 'Translation';
  key?: Maybe<Scalars['String']['output']>;
  lang?: Maybe<ContactLanguage>;
  value?: Maybe<Scalars['String']['output']>;
};

export type TrustedDevice = {
  __typename?: 'TrustedDevice';
  deviceId: Scalars['String']['output'];
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  lastTwoFAVerification: Scalars['DateTime']['output'];
};

/** Spec 235: the part of the upcoming-status (SCH/REA) flights a flight list shows, split 7 days back (midnight UTC) */
export enum UpcomingFlightScope {
  Current = 'CURRENT',
  Older = 'OLDER'
}

export type User = {
  __typename?: 'User';
  crew?: Maybe<Crew>;
  dateJoined?: Maybe<Scalars['DateTime']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['EmailAddress']['output']>;
  icsId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<SystemLanguage>;
  lastLogin?: Maybe<Scalars['DateTime']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  removed?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UserRole>;
  tenant?: Maybe<Scalars['String']['output']>;
  trustedDevices?: Maybe<Array<Maybe<TrustedDevice>>>;
  twoFAOTP?: Maybe<Scalars['String']['output']>;
  twoFAOTPExpiresAt?: Maybe<Scalars['DateTime']['output']>;
  userRef?: Maybe<Scalars['String']['output']>;
  viewState?: Maybe<Scalars['JSONObject']['output']>;
};

export enum UserRole {
  Ass = 'ASS',
  Cre = 'CRE',
  Met = 'MET',
  Noa = 'NOA',
  Opr = 'OPR',
  Own = 'OWN',
  Rep = 'REP'
}

export type Viewport = {
  __typename?: 'Viewport';
  northeast?: Maybe<Mapslocation>;
  southwest?: Maybe<Mapslocation>;
};

export enum VisibilityType {
  Pri = 'PRI',
  Pub = 'PUB'
}

export type Voucher = {
  __typename?: 'Voucher';
  adults?: Maybe<Scalars['PositiveInt']['output']>;
  adultsAvailable?: Maybe<Scalars['PositiveInt']['output']>;
  adultsUsed?: Maybe<Scalars['PositiveInt']['output']>;
  children?: Maybe<Scalars['PositiveInt']['output']>;
  childrenAvailable?: Maybe<Scalars['PositiveInt']['output']>;
  childrenUsed?: Maybe<Scalars['PositiveInt']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contactCity?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  contactLanguage?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactPhone?: Maybe<Scalars['PhoneNumber']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  external?: Maybe<Scalars['Boolean']['output']>;
  externalSource?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  issueDate?: Maybe<Scalars['DateTime']['output']>;
  paymentAmount?: Maybe<Scalars['PositiveInt']['output']>;
  paymentDate?: Maybe<Scalars['DateTime']['output']>;
  paymentStatus?: Maybe<PaymentStatus>;
  paymentType?: Maybe<PaymentType>;
  recipientAddress?: Maybe<Scalars['String']['output']>;
  recipientCity?: Maybe<Scalars['String']['output']>;
  recipientCountry?: Maybe<Scalars['String']['output']>;
  recipientEmail?: Maybe<Scalars['String']['output']>;
  recipientLanguage?: Maybe<ContactLanguage>;
  recipientName?: Maybe<Scalars['String']['output']>;
  recipientPhone?: Maybe<Scalars['PhoneNumber']['output']>;
  recipientPostalCode?: Maybe<Scalars['String']['output']>;
  ref?: Maybe<Scalars['JSONObject']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Array<Maybe<Ticket>>>;
  voucherReference?: Maybe<Scalars['String']['output']>;
  voucherType?: Maybe<Scalars['String']['output']>;
};

export type VoucherCounters = {
  __typename?: 'VoucherCounters';
  statusCounters?: Maybe<VoucherStatusCounters>;
  voucherTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VoucherInput = {
  adults?: InputMaybe<Scalars['PositiveInt']['input']>;
  children?: InputMaybe<Scalars['PositiveInt']['input']>;
  comments?: InputMaybe<Scalars['String']['input']>;
  contactCity?: InputMaybe<Scalars['String']['input']>;
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  contactLanguage?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<Scalars['String']['input']>;
  contactPhone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  expiryDate?: InputMaybe<Scalars['DateTime']['input']>;
  external?: InputMaybe<Scalars['Boolean']['input']>;
  externalSource?: InputMaybe<Scalars['String']['input']>;
  issueDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentAmount?: InputMaybe<Scalars['PositiveInt']['input']>;
  paymentDate?: InputMaybe<Scalars['DateTime']['input']>;
  paymentStatus?: InputMaybe<PaymentStatus>;
  paymentType?: InputMaybe<PaymentType>;
  recipientAddress?: InputMaybe<Scalars['String']['input']>;
  recipientCity?: InputMaybe<Scalars['String']['input']>;
  recipientCountry?: InputMaybe<Scalars['String']['input']>;
  recipientEmail?: InputMaybe<Scalars['String']['input']>;
  recipientLanguage?: InputMaybe<ContactLanguage>;
  recipientName?: InputMaybe<Scalars['String']['input']>;
  recipientPhone?: InputMaybe<Scalars['PhoneNumber']['input']>;
  recipientPostalCode?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  voucherReference?: InputMaybe<Scalars['String']['input']>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
};

export enum VoucherStatus {
  Avai = 'AVAI',
  Expi = 'EXPI',
  Used = 'USED'
}

export type VoucherStatusCounters = {
  __typename?: 'VoucherStatusCounters';
  AVAI?: Maybe<Scalars['PositiveInt']['output']>;
  EXPI?: Maybe<Scalars['PositiveInt']['output']>;
  USED?: Maybe<Scalars['PositiveInt']['output']>;
};

export enum WaMigrationStatus {
  Cloud = 'CLOUD',
  Container = 'CONTAINER',
  Cutover = 'CUTOVER',
  Provisioning = 'PROVISIONING'
}

export type WeatherSourceMapping = {
  __typename?: 'WeatherSourceMapping';
  country?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export enum WeatherSourceMode {
  Free = 'FREE',
  Mapped = 'MAPPED'
}

export type WefactDebtor = {
  __typename?: 'WefactDebtor';
  companyName?: Maybe<Scalars['String']['output']>;
  debtorCode: Scalars['String']['output'];
  emailAddress?: Maybe<Scalars['String']['output']>;
  initials?: Maybe<Scalars['String']['output']>;
  surname?: Maybe<Scalars['String']['output']>;
};

export type WefactDebtorConnection = {
  __typename?: 'WefactDebtorConnection';
  debtors: Array<WefactDebtor>;
  hasNextPage: Scalars['Boolean']['output'];
  offset: Scalars['Int']['output'];
  totalCount: Scalars['Int']['output'];
};

export type WhatsAppConnectionStatus = {
  __typename?: 'WhatsAppConnectionStatus';
  connected: Scalars['Boolean']['output'];
  deviceInfo?: Maybe<Scalars['String']['output']>;
  lastSeen?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * 037 FR-023: pre-connect cost estimate from the tenant's own message history (BigQuery export).
 * The 24h window is reconstructed per conversation — outbound within 24h after an inbound counts
 * as free/in-window; only the rest would need a paid template. Indicative, NOT a Meta quote.
 */
export type WhatsappCostEstimate = {
  __typename?: 'WhatsappCostEstimate';
  /** average outbound messages per sampled month estimated OUTSIDE the 24h window (billable) */
  avgMonthlyBillable: Scalars['NonNegativeInt']['output'];
  /** average outbound messages per sampled month */
  avgMonthlyMessages: Scalars['NonNegativeInt']['output'];
  /** true when the tenant has no WhatsApp history and the SMS history was used as basis */
  basedOnSmsHistory: Scalars['Boolean']['output'];
  /** indicative EUR per month: avgMonthlyBillable × utility rate */
  estimatedMonthlyCost: Scalars['Float']['output'];
  /** number of sampled calendar months that had outbound traffic */
  monthsSampled: Scalars['NonNegativeInt']['output'];
  /** utility rate used for the estimate (EUR) */
  ratePerMessage: Scalars['Float']['output'];
};

export type WhatsappDevices = {
  __typename?: 'WhatsappDevices';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Array<Maybe<WhatsappDevicesResults>>>;
};

export type WhatsappDevicesResults = {
  __typename?: 'WhatsappDevicesResults';
  device?: Maybe<Scalars['String']['output']>;
  jid?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type WhatsappLogin = {
  __typename?: 'WhatsappLogin';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  results?: Maybe<WhatsappLoginResults>;
};

export type WhatsappLoginResults = {
  __typename?: 'WhatsappLoginResults';
  qr_duration?: Maybe<Scalars['PositiveInt']['output']>;
  qr_image?: Maybe<Scalars['String']['output']>;
  qr_link?: Maybe<Scalars['URL']['output']>;
};

export type WhatsappLogout = {
  __typename?: 'WhatsappLogout';
  code?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  results?: Maybe<Scalars['JSONObject']['output']>;
};

/** 037: result of the Embedded Signup code exchange (FR-016/FR-020). No tokens are ever returned. */
export type WhatsappOnboardResult = {
  __typename?: 'WhatsappOnboardResult';
  displayPhoneNumber?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  messagingTier?: Maybe<Scalars['String']['output']>;
  phoneNumberId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  templatesSubmitted?: Maybe<Scalars['NonNegativeInt']['output']>;
  wabaId?: Maybe<Scalars['String']['output']>;
};

export enum WhatsappProvider {
  Cloud = 'CLOUD',
  Container = 'CONTAINER'
}

/**
 * 037: WhatsApp connectivity. provider = CONTAINER (WhatsApp free, linked device) | CLOUD (official
 * Meta Cloud API on the operator's own WABA). Both are standing choices (FR-027). Access tokens are
 * never exposed here — Secret Manager only (FR-009).
 */
export type WhatsappSettings = {
  __typename?: 'WhatsappSettings';
  /**
   * 037 FR-032: platform-side enablement flag. The WhatsApp Business (Cloud API) channel is offered
   * to the operator only where this is true. Set by Quick Release (scripts/wa-cloud-enable.ts), never
   * through the operator settings — deliberately absent from InputWhatsappSettings. Reads true while
   * the tenant already runs on provider=cloud, so an active channel is never hidden.
   */
  cloudEnabled: Scalars['Boolean']['output'];
  /** 037 FR-013: alert when this month's billable Cloud API messages pass this count (0/absent = off) */
  costAlertMonthlyBillable?: Maybe<Scalars['NonNegativeInt']['output']>;
  enabled: Scalars['Boolean']['output'];
  fallbackSms?: Maybe<Scalars['Boolean']['output']>;
  /** 037 FR-021: current Meta messaging-limit tier of the connected number */
  messagingTier?: Maybe<Scalars['String']['output']>;
  migrationStatus?: Maybe<WaMigrationStatus>;
  paymentConfirmedAt?: Maybe<Scalars['DateTime']['output']>;
  /** 037 FR-024: last Meta payment/eligibility error — the settings screen shows the action-needed state */
  paymentError?: Maybe<Scalars['String']['output']>;
  /** 037: connected number for display (from Embedded Signup discovery) */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  phoneNumberId?: Maybe<Scalars['String']['output']>;
  port?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<WhatsappProvider>;
  /**
   * Platform-side emergency switch (bug #215): when true, every outbound send for this tenant skips
   * WhatsApp entirely and goes straight to SMS via the existing fallback path — for a tenant whose
   * WhatsApp container/cloud channel is down. Set by Quick Release (scripts/wa-smsonly-toggle.ts),
   * never through the operator settings — deliberately absent from InputWhatsappSettings. Requires
   * whatsapp.enabled and whatsapp.fallbackSms to both be true, or nothing sends at all.
   */
  smsOnly: Scalars['Boolean']['output'];
  /** 037 FR-021: per-version template approval rows (resolved from tenants/{t}/whatsappTemplate) */
  templates?: Maybe<Array<WhatsappTemplateStatus>>;
  wabaId?: Maybe<Scalars['String']['output']>;
};

/** 037 FR-021: one row per generated template version for the provisioning step list */
export type WhatsappTemplateStatus = {
  __typename?: 'WhatsappTemplateStatus';
  approvalStatus?: Maybe<Scalars['String']['output']>;
  key: Scalars['ID']['output'];
  label?: Maybe<Scalars['String']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  rejectionReason?: Maybe<Scalars['String']['output']>;
  serving?: Maybe<Scalars['Boolean']['output']>;
  /** when this version was last submitted to Meta — lets the UI show how long a review is running */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  validationIssues?: Maybe<Array<Scalars['String']['output']>>;
};

/** 037 FR-006c: 24h customer-service-window state per recipient, for the send-dialog warning */
export type WhatsappWindowState = {
  __typename?: 'WhatsappWindowState';
  open: Scalars['Boolean']['output'];
  openUntil?: Maybe<Scalars['DateTime']['output']>;
  phone: Scalars['String']['output'];
};

export enum WindDirection {
  E = 'E',
  Ene = 'ENE',
  Ese = 'ESE',
  N = 'N',
  Ne = 'NE',
  Nne = 'NNE',
  Nnw = 'NNW',
  Nw = 'NW',
  S = 'S',
  Se = 'SE',
  Sse = 'SSE',
  Ssw = 'SSW',
  Sw = 'SW',
  W = 'W',
  Wnw = 'WNW',
  Wsw = 'WSW'
}

export type WindDirections = {
  __typename?: 'WindDirections';
  E?: Maybe<Scalars['NonNegativeInt']['output']>;
  ENE?: Maybe<Scalars['NonNegativeInt']['output']>;
  ESE?: Maybe<Scalars['NonNegativeInt']['output']>;
  N?: Maybe<Scalars['NonNegativeInt']['output']>;
  NE?: Maybe<Scalars['NonNegativeInt']['output']>;
  NNE?: Maybe<Scalars['NonNegativeInt']['output']>;
  NNW?: Maybe<Scalars['NonNegativeInt']['output']>;
  NW?: Maybe<Scalars['NonNegativeInt']['output']>;
  S?: Maybe<Scalars['NonNegativeInt']['output']>;
  SE?: Maybe<Scalars['NonNegativeInt']['output']>;
  SSE?: Maybe<Scalars['NonNegativeInt']['output']>;
  SSW?: Maybe<Scalars['NonNegativeInt']['output']>;
  SW?: Maybe<Scalars['NonNegativeInt']['output']>;
  W?: Maybe<Scalars['NonNegativeInt']['output']>;
  WNW?: Maybe<Scalars['NonNegativeInt']['output']>;
  WSW?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type SlotForecast = {
  __typename?: 'slotForecast';
  datepart?: Maybe<Array<Maybe<DatePart>>>;
  daytime?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  flytime?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  lastUpdate?: Maybe<Scalars['DateTime']['output']>;
  latitude?: Maybe<Scalars['String']['output']>;
  longitude?: Maybe<Scalars['String']['output']>;
  lowCloudsData?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  pictoCodeData?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  precipitationData?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  pressureData?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  sunrise?: Maybe<Scalars['DateTime']['output']>;
  sunset?: Maybe<Scalars['DateTime']['output']>;
  temperatureData?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  time?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  utc_timeoffset?: Maybe<Scalars['Int']['output']>;
  visibilityData?: Maybe<Array<Maybe<Scalars['NonNegativeInt']['output']>>>;
  windDirectionData?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_200?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_250?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_300?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_350?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_400?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_450?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_500?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_550?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_600?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_650?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_700?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_750?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_800?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_925?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_950?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_975?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windDirectionData_1000?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windGustData?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_200?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_250?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_300?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_350?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_400?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_450?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_500?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_550?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_600?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_650?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_700?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_750?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_800?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_925?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_950?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_975?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  windSpeedData_1000?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type UpdateResult = {
  __typename?: 'updateResult';
  message?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UsedSms = {
  __typename?: 'usedSMS';
  month?: Maybe<Scalars['NonNegativeInt']['output']>;
  used?: Maybe<Scalars['NonNegativeInt']['output']>;
  usedWA?: Maybe<Scalars['NonNegativeInt']['output']>;
  waAuthentication?: Maybe<Scalars['NonNegativeInt']['output']>;
  waBillable?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** indicative EUR estimate over billable messages — NOT Meta's invoice */
  waEstimatedCost?: Maybe<Scalars['Float']['output']>;
  waFree?: Maybe<Scalars['NonNegativeInt']['output']>;
  waMarketing?: Maybe<Scalars['NonNegativeInt']['output']>;
  waService?: Maybe<Scalars['NonNegativeInt']['output']>;
  /** 037 FR-004/FR-012: Cloud API cost buckets (informational — Meta invoices the operator directly) */
  waUtility?: Maybe<Scalars['NonNegativeInt']['output']>;
  year?: Maybe<Scalars['NonNegativeInt']['output']>;
};

export type GetBalloonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBalloonsQuery = { __typename?: 'Query', balloons: Array<{ __typename?: 'Balloon', isCurrent?: number | null, callSign?: string | null, capacity?: any | null, id: string, name?: string | null, thumbUrl?: string | null } | null> };

export type GetLogBooksBalloonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLogBooksBalloonsQuery = { __typename?: 'Query', balloons: Array<{ __typename?: 'Balloon', isCurrent?: number | null, callSign?: string | null, capacity?: any | null, id: string, name?: string | null, envelopeManufacturer?: string | null, envelopeType?: string | null, logbook?: { __typename?: 'LogBook', id?: string | null, statistics?: { __typename?: 'LogBookStatistics', totalFlightCount?: any | null, totalFlightMinutes?: any | null } | null } | null } | null> };

export type GetBalloonQueryVariables = Exact<{
  balloonId: Scalars['ID']['input'];
}>;


export type GetBalloonQuery = { __typename?: 'Query', balloon: { __typename?: 'Balloon', id: string, isCurrent?: number | null, name?: string | null, callSign?: string | null, capacity?: any | null, imageUrl?: string | null, thumbUrl?: string | null, classGroups?: string | null, mlm?: any | null, mtom?: any | null, liftWarningRedBelow?: any | null, liftWarningOrangeBelow?: any | null, minFuel?: any | null, balloonTemp?: any | null, envelopeManufacturer?: string | null, envelopeType?: string | null, envelopeVolume?: any | null, envelopeWeight?: any | null, envelopeHours?: any | null, envelopeInspectionDate?: any | null, burnerManufacturer?: string | null, burnerType?: string | null, burnerWeight?: any | null, basketManufacturer?: string | null, basketType?: string | null, basketWeight?: any | null, insuranceCompany?: string | null, insuranceDueDate?: any | null, cylinder: Array<{ __typename?: 'Cylinder', id: string, emptyWeight?: any | null, fullWeight?: any | null, manufacturer?: string | null, volume?: any | null, number?: any | null, serialNumber?: string | null } | null>, classGroup: Array<{ __typename?: 'ClassGroup', id: string, description: string } | null>, balloonWeight?: { __typename?: 'BalloonWeight', totalWeight: any, cylindersWeight: any } | null } };

export type GetManufacturersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManufacturersQuery = { __typename?: 'Query', manufacturers?: { __typename?: 'Manufacturers', envelopeManufacturers: Array<string | null>, basketManufacturers: Array<string | null>, burnerManufacturers: Array<string | null>, cylinderManufacturers: Array<string | null> } | null };

export type BalloonWeightQueryVariables = Exact<{
  balloonId: Scalars['ID']['input'];
}>;


export type BalloonWeightQuery = { __typename?: 'Query', balloonWeight: { __typename?: 'BalloonWeight', totalWeight: any, cylindersWeight: any } };

export type SaveBalloonMutationVariables = Exact<{
  balloonInput: BalloonInput;
  cylinders: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  balloonId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveBalloonMutation = { __typename?: 'Mutation', saveBalloon: string };

export type DeleteBalloonMutationVariables = Exact<{
  balloonId: Scalars['ID']['input'];
}>;


export type DeleteBalloonMutation = { __typename?: 'Mutation', deleteBalloon: string };

export type GetBookingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, inviteCount?: number | null, status?: BookingStatus | null, onlineCheckinAt?: any | null, icon?: string | null, iconColor?: string | null, bookingDate?: any | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: any | null, contactLanguage?: ContactLanguage | null, comments?: string | null, bookingCode?: string | null, startDate?: any | null, endDate?: any | null, daysExpired?: any | null, external?: boolean | null, externalSource?: string | null, city?: string | null, source?: string | null, locationType?: LocationType | null, availabilityType?: AvailabilityType | null, availabilityMondayMorning?: boolean | null, availabilityTuesdayMorning?: boolean | null, availabilityWednesdayMorning?: boolean | null, availabilityThursdayMorning?: boolean | null, availabilityFridayMorning?: boolean | null, availabilitySaturdayMorning?: boolean | null, availabilitySundayMorning?: boolean | null, availabilityMondayEvening?: boolean | null, availabilityTuesdayEvening?: boolean | null, availabilityWednesdayEvening?: boolean | null, availabilityThursdayEvening?: boolean | null, availabilityFridayEvening?: boolean | null, availabilitySaturdayEvening?: boolean | null, availabilitySundayEvening?: boolean | null, prepaymentAmount?: number | null, prepaymentDate?: any | null, invoiceName?: string | null, VATnumber?: string | null, smsType?: SmsConversationType | null, smsUnread?: any | null, logsRemoved?: any | null, upUrl?: string | null, region?: { __typename?: 'Region', color?: string | null, id: string, name?: string | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, address?: string | null, city?: string | null, country?: string | null, height?: any | null, latitude?: number | null, longitude?: number | null, postalCode?: string | null, private?: boolean | null } | null, mailEventLatest?: { __typename?: 'MailEventLatest', date?: any | null, event?: string | null } | null, preferredFlights?: Array<{ __typename?: 'PreferredFlight', date?: string | null, period?: FlightPeriod | null } | null> | null, passengers: Array<{ __typename?: 'Passenger', id: string, name?: string | null, age?: any | null, transport?: boolean | null, luggage?: boolean | null, child?: boolean | null, comments?: string | null, disability?: boolean | null, weight?: any | null, weightIsDefault: boolean, paymentType?: PaymentType | null, paymentReference?: string | null, paymentAmount?: number | null, paymentStatus?: PaymentStatus | null, paymentDate?: any | null, email?: string | null, address?: string | null, postalCode?: string | null, city?: string | null, country?: string | null, signature?: string | null, voucherNumber?: string | null, category?: { __typename?: 'Category', id: string, passengerId?: string | null, name?: string | null, description?: string | null, price?: number | null, default?: boolean | null } | null, voucher?: { __typename?: 'Voucher', id: string, voucherReference?: string | null, voucherType?: string | null, paymentStatus?: PaymentStatus | null } | null } | null>, passengerCounters?: { __typename?: 'PassengerCounters', passengerCount?: any | null, unpaidPassengerCount?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, totalWeight?: any | null, totalAmount?: any | null, paidAmount?: any | null, openAmount?: any | null } | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, status?: string | null, error?: string | null } | null, flight?: { __typename?: 'Flight', id: string, date?: any | null, hour?: any | null, hourMeeting?: any | null, period?: FlightPeriod | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null } | null } | null, mergeCandidates?: Array<{ __typename?: 'Booking', bookingDate?: any | null, contactName?: string | null, id: string, flight?: { __typename?: 'Flight', date?: any | null } | null } | null> | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null };

export type GetBookingFlightOptionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingFlightOptionsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, flightOptions?: Array<{ __typename?: 'Flight', id: string, date?: any | null, hour?: any | null, hourMeeting?: any | null, period?: FlightPeriod | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null } | null } | null> | null } | null };

export type GetFirstBookingWithFlightQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFirstBookingWithFlightQuery = { __typename?: 'Query', firstBookingWithFlight?: Array<{ __typename?: 'Booking', id: string, availabilityType?: AvailabilityType | null, status?: BookingStatus | null, contactName?: string | null, contactPhone?: any | null, contactLanguage?: ContactLanguage | null, contactEmail?: string | null, comments?: string | null, bookingDate?: any | null, bookingCode?: string | null, smsType?: SmsConversationType | null, smsUnread?: any | null, upUrl?: string | null, region?: { __typename?: 'Region', name?: string | null } | null, passengerCounters?: { __typename?: 'PassengerCounters', childCount?: any | null, passengerCount?: any | null, totalWeight?: any | null, totalAmount?: any | null, openAmount?: any | null, disabilityCount?: any | null, transportCount?: any | null } | null, flight?: { __typename?: 'Flight', date?: any | null, period?: FlightPeriod | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', email?: any | null, id: string, language?: ContactLanguage | null, name?: string | null, pilotLicense?: PilotLicense | null } | null } | null> } | null } | null> | null };

export type GetBookingLogsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingLogsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', logs?: Array<{ __typename?: 'BookingLog', id: string, date?: any | null, user?: string | null, action?: BookingLogAction | null, reason?: string | null, flight?: { __typename?: 'Flight', id: string, hour?: any | null, removed?: any | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null } | null } | null> | null, logsMerged?: Array<{ __typename?: 'BookingLog', id: string, date?: any | null, user?: string | null, action?: BookingLogAction | null, reason?: string | null, flight?: { __typename?: 'Flight', id: string, hour?: any | null, removed?: any | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null } | null } | null> | null } | null };

export type GetBookingMailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingMailsQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', mails?: Array<{ __typename?: 'Email', to?: string | null, subject?: string | null, text?: string | null, html?: string | null, result?: string | null, resultAt?: any | null, resultError?: string | null, from?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, replyTo?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, attachments: Array<{ __typename?: 'EmailAttachment', filename?: string | null } | null>, events?: Array<{ __typename?: 'EmailEvent', event?: string | null, timestamp?: any | null, url?: any | null } | null> | null } | null> | null, mailsMerged?: Array<{ __typename?: 'Email', to?: string | null, subject?: string | null, text?: string | null, html?: string | null, result?: string | null, resultAt?: any | null, resultError?: string | null, from?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, replyTo?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, attachments: Array<{ __typename?: 'EmailAttachment', filename?: string | null } | null>, events?: Array<{ __typename?: 'EmailEvent', event?: string | null, timestamp?: any | null, url?: any | null } | null> | null } | null> | null } | null };

export type GetUpcomingBookingsQueryVariables = Exact<{
  orderBy?: InputMaybe<OrderByBooking>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  bookingFilter?: InputMaybe<BookingFilter>;
  flightId?: InputMaybe<Scalars['ID']['input']>;
  flightOnlyMatching?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUpcomingBookingsQuery = { __typename?: 'Query', upcomingBookings: Array<{ __typename?: 'Booking', availabilityType?: AvailabilityType | null, status?: BookingStatus | null, onlineCheckinAt?: any | null, icon?: string | null, iconColor?: string | null, id: string, inviteCount?: number | null, contactName?: string | null, contactPhone?: any | null, comments?: string | null, bookingCode?: string | null, bookingDate?: any | null, daysExpired?: any | null, city?: string | null, external?: boolean | null, externalSource?: string | null, locationType?: LocationType | null, smsUnread?: any | null, preferredDate?: string | null, mismatchReasons?: Array<string | null> | null, upUrl?: string | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null } | null, mailEventLatest?: { __typename?: 'MailEventLatest', date?: any | null, event?: string | null } | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, text?: string | null, status?: string | null, error?: string | null } | null, region?: { __typename?: 'Region', color?: string | null, name?: string | null } | null, passengers: Array<{ __typename?: 'Passenger', name?: string | null, comments?: string | null, child?: boolean | null, disability?: boolean | null, weight?: any | null, weightIsDefault: boolean } | null>, passengerCounters?: { __typename?: 'PassengerCounters', passengerCount?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, totalWeight?: any | null, totalAmount?: any | null, paidAmount?: any | null, openAmount?: any | null } | null, preferredFlights?: Array<{ __typename?: 'PreferredFlight', date?: string | null, period?: FlightPeriod | null } | null> | null, flight?: { __typename?: 'Flight', id: string, date?: any | null, period?: FlightPeriod | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', email?: any | null, id: string, language?: ContactLanguage | null, name?: string | null, pilotLicense?: PilotLicense | null } | null } | null> } | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetHistoricalBookingsQueryVariables = Exact<{
  orderBy?: InputMaybe<OrderByBooking>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetHistoricalBookingsQuery = { __typename?: 'Query', historicalBookings: Array<{ __typename?: 'Booking', availabilityType?: AvailabilityType | null, status?: BookingStatus | null, icon?: string | null, iconColor?: string | null, id: string, bookingDate?: any | null, daysExpired?: any | null, contactName?: string | null, contactPhone?: any | null, comments?: string | null, bookingCode?: string | null, external?: boolean | null, externalSource?: string | null, locationType?: LocationType | null, city?: string | null, preferredDate?: string | null, upUrl?: string | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null } | null, region?: { __typename?: 'Region', color?: string | null, name?: string | null } | null, passengers: Array<{ __typename?: 'Passenger', name?: string | null, weightIsDefault: boolean } | null>, passengerCounters?: { __typename?: 'PassengerCounters', passengerCount?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, totalWeight?: any | null, totalAmount?: any | null, paidAmount?: any | null, openAmount?: any | null } | null, preferredFlights?: Array<{ __typename?: 'PreferredFlight', date?: string | null, period?: FlightPeriod | null } | null> | null, flight?: { __typename?: 'Flight', id: string, date?: any | null, period?: FlightPeriod | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', email?: any | null, id: string, language?: ContactLanguage | null, name?: string | null, pilotLicense?: PilotLicense | null } | null } | null> } | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetUpcomingBookingsIsQueryVariables = Exact<{
  showUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<OrderByBooking>;
  orderDirection?: InputMaybe<OrderDirection>;
  bookingFilter?: InputMaybe<BookingFilter>;
  flightId?: InputMaybe<Scalars['ID']['input']>;
  flightOnlyMatching?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetUpcomingBookingsIsQuery = { __typename?: 'Query', getBookingsIS: Array<{ __typename?: 'Booking', availabilityType?: AvailabilityType | null, status?: BookingStatus | null, onlineCheckinAt?: any | null, icon?: string | null, iconColor?: string | null, id: string, inviteCount?: number | null, contactName?: string | null, contactPhone?: any | null, comments?: string | null, bookingCode?: string | null, bookingDate?: any | null, endDate?: any | null, daysExpired?: any | null, validUntil?: any | null, city?: string | null, external?: boolean | null, externalSource?: string | null, locationType?: LocationType | null, smsUnread?: any | null, preferredDate?: string | null, logsRemoved?: any | null, mismatchReasons?: Array<string | null> | null, upUrl?: string | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null } | null, mailEventLatest?: { __typename?: 'MailEventLatest', date?: any | null, event?: string | null } | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, text?: string | null, status?: string | null, error?: string | null } | null, region?: { __typename?: 'Region', id: string, color?: string | null, name?: string | null } | null, passengers: Array<{ __typename?: 'Passenger', name?: string | null, comments?: string | null, child?: boolean | null, disability?: boolean | null, weight?: any | null, weightIsDefault: boolean } | null>, passengerCounters?: { __typename?: 'PassengerCounters', passengerCount?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, totalWeight?: any | null, totalAmount?: any | null, paidAmount?: any | null, openAmount?: any | null } | null, preferredFlights?: Array<{ __typename?: 'PreferredFlight', date?: string | null, period?: FlightPeriod | null } | null> | null, flight?: { __typename?: 'Flight', id: string, date?: any | null, hour?: any | null, period?: FlightPeriod | null, balloonCapacityReduction?: any | null, passengersOccupancy?: any | null, passengersCount?: number | null, balloon?: { __typename?: 'Balloon', name?: string | null, capacity?: any | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', email?: any | null, id: string, language?: ContactLanguage | null, name?: string | null, pilotLicense?: PilotLicense | null } | null } | null> } | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetHistoricalBookingsIsQueryVariables = Exact<{
  showUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  orderBy?: InputMaybe<OrderByBooking>;
  orderDirection?: InputMaybe<OrderDirection>;
  bookingFilter?: InputMaybe<BookingFilter>;
  flightId?: InputMaybe<Scalars['ID']['input']>;
  flightOnlyMatching?: InputMaybe<Scalars['Boolean']['input']>;
  endAt?: InputMaybe<Scalars['Boolean']['input']>;
  includeExpired?: InputMaybe<Scalars['Boolean']['input']>;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetHistoricalBookingsIsQuery = { __typename?: 'Query', getBookingsIS: Array<{ __typename?: 'Booking', availabilityType?: AvailabilityType | null, status?: BookingStatus | null, onlineCheckinAt?: any | null, icon?: string | null, iconColor?: string | null, id: string, bookingDate?: any | null, daysExpired?: any | null, contactName?: string | null, contactPhone?: any | null, comments?: string | null, bookingCode?: string | null, external?: boolean | null, externalSource?: string | null, locationType?: LocationType | null, city?: string | null, preferredDate?: string | null, upUrl?: string | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null } | null, region?: { __typename?: 'Region', color?: string | null, name?: string | null } | null, passengers: Array<{ __typename?: 'Passenger', name?: string | null, weightIsDefault: boolean } | null>, passengerCounters?: { __typename?: 'PassengerCounters', passengerCount?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, totalWeight?: any | null, totalAmount?: any | null, paidAmount?: any | null, openAmount?: any | null } | null, preferredFlights?: Array<{ __typename?: 'PreferredFlight', date?: string | null, period?: FlightPeriod | null } | null> | null, flight?: { __typename?: 'Flight', id: string, date?: any | null, period?: FlightPeriod | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', email?: any | null, id: string, language?: ContactLanguage | null, name?: string | null, pilotLicense?: PilotLicense | null } | null } | null> } | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type DashboardBookingsQueryVariables = Exact<{ [key: string]: never; }>;


export type DashboardBookingsQuery = { __typename?: 'Query', dashboardBookings: Array<{ __typename?: 'Booking', availabilityType?: AvailabilityType | null, status?: BookingStatus | null, onlineCheckinAt?: any | null, icon?: string | null, iconColor?: string | null, id: string, inviteCount?: number | null, bookingDate?: any | null, daysExpired?: any | null, city?: string | null, contactName?: string | null, contactPhone?: any | null, comments?: string | null, external?: boolean | null, externalSource?: string | null, locationType?: LocationType | null, smsUnread?: any | null, preferredDate?: string | null, mergeCandidates?: Array<{ __typename?: 'Booking', id: string, flight?: { __typename?: 'Flight', date?: any | null } | null } | null> | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null } | null, mailEventLatest?: { __typename?: 'MailEventLatest', date?: any | null, event?: string | null } | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, text?: string | null, status?: string | null, error?: string | null } | null, region?: { __typename?: 'Region', color?: string | null, name?: string | null } | null, preferredFlights?: Array<{ __typename?: 'PreferredFlight', date?: string | null, period?: FlightPeriod | null } | null> | null, flight?: { __typename?: 'Flight', id: string, balloonCapacityReduction?: any | null, date?: any | null, period?: FlightPeriod | null, passengersOccupancy?: any | null, passengersCount?: number | null, balloon?: { __typename?: 'Balloon', name?: string | null, capacity?: any | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', email?: any | null, id: string, language?: ContactLanguage | null, name?: string | null, pilotLicense?: PilotLicense | null } | null } | null> } | null, passengers: Array<{ __typename?: 'Passenger', name?: string | null, weightIsDefault: boolean } | null>, passengerCounters?: { __typename?: 'PassengerCounters', passengerCount?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, totalWeight?: any | null, totalAmount?: any | null, paidAmount?: any | null, openAmount?: any | null } | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type BookingsPreferredDateQueryVariables = Exact<{
  preferredDateInput?: InputMaybe<PreferredDateInput>;
}>;


export type BookingsPreferredDateQuery = { __typename?: 'Query', bookingsPreferredDate: Array<{ __typename?: 'Booking', id: string, flight?: { __typename?: 'Flight', id: string } | null, region?: { __typename?: 'Region', color?: string | null, name?: string | null } | null } | null> };

export type PassengerCountersQueryVariables = Exact<{
  passengers: Array<InputMaybe<PassengerInput>> | InputMaybe<PassengerInput>;
}>;


export type PassengerCountersQuery = { __typename?: 'Query', passengerCounters?: { __typename?: 'PassengerCounters', passengerCount?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, totalWeight?: any | null } | null };

export type BookingCountersQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingCountersQuery = { __typename?: 'Query', bookingCounters?: { __typename?: 'BookingCounters', upcoming?: any | null, historical?: any | null, toConfirm?: any | null, active?: any | null, expired?: any | null, toPlan?: any | null, invited?: any | null, confirmed?: any | null } | null };

export type BookingSearchCountsQueryVariables = Exact<{
  filter: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BookingSearchCountsQuery = { __typename?: 'Query', bookingSearchCounts: { __typename?: 'BookingSearchCounts', active: any, expired: any, history: any } };

export type BookingFilterCountsQueryVariables = Exact<{
  bookingFilter: BookingFilter;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BookingFilterCountsQuery = { __typename?: 'Query', bookingFilterCounts: { __typename?: 'BookingFilterCounts', openAmount: any, tags: Array<{ __typename?: 'BookingTagCount', id: string, count: any }> } };

export type BookingPickerExpiredCountQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
  flightOnlyMatching?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type BookingPickerExpiredCountQuery = { __typename?: 'Query', bookingPickerExpiredCount: any };

export type BookingConversationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type BookingConversationsQuery = { __typename?: 'Query', bookingConversations: Array<{ __typename?: 'Booking', id: string, contactName?: string | null, contactPhone?: any | null, contactLanguage?: ContactLanguage | null, smsType?: SmsConversationType | null, smsUnread?: any | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, status?: string | null, error?: string | null } | null } | null> };

export type GetBookingsOfFlightQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetBookingsOfFlightQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', bookings: { __typename?: 'FlightBookings', id: string, list: Array<{ __typename?: 'Booking', id: string } | null> } } };

export type GetBookingForPaymentFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBookingForPaymentFormQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, icon?: string | null, iconColor?: string | null, contactName?: string | null, contactPhone?: any | null, contactEmail?: string | null, comments?: string | null, invoiceName?: string | null, VATnumber?: string | null, prepaymentAmount?: number | null, prepaymentDate?: any | null, passengers: Array<{ __typename?: 'Passenger', id: string, child?: boolean | null, name?: string | null, paymentAmount?: number | null, paymentReference?: string | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, paymentDate?: any | null, weight?: any | null, voucherNumber?: string | null, category?: { __typename?: 'Category', id: string, passengerId?: string | null, name?: string | null, description?: string | null, price?: number | null, default?: boolean | null } | null, voucher?: { __typename?: 'Voucher', id: string, voucherReference?: string | null, voucherType?: string | null, paymentStatus?: PaymentStatus | null } | null } | null>, passengerCounters?: { __typename?: 'PassengerCounters', id?: string | null, openAmount?: any | null, paidAmount?: any | null, totalAmount?: any | null } | null } | null };

export type UpdateBookingCommentsMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBookingCommentsMutation = { __typename?: 'Mutation', updateBookingComments: string };

export type UpdateBookingTagsMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateBookingTagsMutation = { __typename?: 'Mutation', updateBookingTags: string };

export type UpdateBookingPreferredFlightsMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  preferredFlights?: InputMaybe<Array<InputMaybe<PreferredFlightInput>> | InputMaybe<PreferredFlightInput>>;
}>;


export type UpdateBookingPreferredFlightsMutation = { __typename?: 'Mutation', updateBookingPreferredFlights: string };

export type SaveBookingMutationVariables = Exact<{
  bookingInput: BookingInput;
  bookingId?: InputMaybe<Scalars['ID']['input']>;
  locationInput?: InputMaybe<LocationInput>;
}>;


export type SaveBookingMutation = { __typename?: 'Mutation', saveBooking: string };

export type DeleteBookingMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type DeleteBookingMutation = { __typename?: 'Mutation', deleteBooking: string };

export type CreateBookingMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking: string };

export type SavePassengerMutationVariables = Exact<{
  passengerInput: PassengerInput;
  passengerId?: InputMaybe<Scalars['ID']['input']>;
  bookingId: Scalars['ID']['input'];
  checkinFlightId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SavePassengerMutation = { __typename?: 'Mutation', savePassenger: string };

export type DeletePassengerMutationVariables = Exact<{
  passengerId: Scalars['ID']['input'];
  bookingId: Scalars['ID']['input'];
}>;


export type DeletePassengerMutation = { __typename?: 'Mutation', deletePassenger: string };

export type AddPassengersMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AddPassengersMutation = { __typename?: 'Mutation', addPassengers?: number | null };

export type CheckinPassengersMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type CheckinPassengersMutation = { __typename?: 'Mutation', checkinPassengers?: number | null };

export type MarkBookingPaidMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type MarkBookingPaidMutation = { __typename?: 'Mutation', markBookingPaid: string };

export type AddBookingsToFlightMutationVariables = Exact<{
  bookings: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  flightId: Scalars['ID']['input'];
}>;


export type AddBookingsToFlightMutation = { __typename?: 'Mutation', addBookingsToFlight?: any | null };

export type InviteBookingsToFlightMutationVariables = Exact<{
  bookings: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  flightId: Scalars['ID']['input'];
}>;


export type InviteBookingsToFlightMutation = { __typename?: 'Mutation', inviteBookingsToFlight?: any | null };

export type AddAndConfirmBookingsToFlightMutationVariables = Exact<{
  bookings: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  flightId: Scalars['ID']['input'];
}>;


export type AddAndConfirmBookingsToFlightMutation = { __typename?: 'Mutation', addAndConfirmBookingsToFlight?: any | null };

export type ConfirmBookingToFlightMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type ConfirmBookingToFlightMutation = { __typename?: 'Mutation', confirmBookingToFlight: string };

export type RemoveBookingFromFlightMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type RemoveBookingFromFlightMutation = { __typename?: 'Mutation', removeBookingFromFlight: string };

export type SaveBookingPaymentMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  bookingPaymentInput: BookingPaymentInput;
}>;


export type SaveBookingPaymentMutation = { __typename?: 'Mutation', saveBookingPayment: { __typename?: 'Booking', id: string, contactPhone?: any | null, contactEmail?: string | null, invoiceName?: string | null, VATnumber?: string | null, prepaymentDate?: any | null, prepaymentAmount?: number | null, passengerCounters?: { __typename?: 'PassengerCounters', id?: string | null, openAmount?: any | null, totalAmount?: any | null } | null } };

export type SavePassengerPaymentMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  passengerId: Scalars['ID']['input'];
  passengerPaymentInput: PassengerPaymentInput;
}>;


export type SavePassengerPaymentMutation = { __typename?: 'Mutation', savePassengerPayment?: { __typename?: 'Passenger', id: string, paymentReference?: string | null, child?: boolean | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, paymentDate?: any | null, paymentAmount?: number | null, voucherNumber?: string | null, category?: { __typename?: 'Category', id: string, passengerId?: string | null } | null, voucher?: { __typename?: 'Voucher', id: string } | null } | null };

export type UpdatePassengerPaymentStatusMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  passengerId: Scalars['ID']['input'];
  paymentStatus: PaymentStatus;
}>;


export type UpdatePassengerPaymentStatusMutation = { __typename?: 'Mutation', updatePassengerPaymentStatus?: { __typename?: 'Passenger', id: string, paymentStatus?: PaymentStatus | null, paymentDate?: any | null } | null };

export type UpdateBookingPaymentMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  paymentType: PaymentType;
}>;


export type UpdateBookingPaymentMutation = { __typename?: 'Mutation', updateBookingPayment?: { __typename?: 'Booking', id: string, contactEmail?: string | null, contactPhone?: any | null, prepaymentAmount?: number | null, prepaymentDate?: any | null, passengerCounters?: { __typename?: 'PassengerCounters', openAmount?: any | null } | null, passengers: Array<{ __typename?: 'Passenger', id: string, paymentReference?: string | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, paymentDate?: any | null, voucherNumber?: string | null, category?: { __typename?: 'Category', id: string, passengerId?: string | null } | null, voucher?: { __typename?: 'Voucher', id: string } | null } | null> } | null };

export type MergeBookingsMutationVariables = Exact<{
  bookingIdFrom: Scalars['ID']['input'];
  bookingIdTo: Scalars['ID']['input'];
}>;


export type MergeBookingsMutation = { __typename?: 'Mutation', mergeBookings?: { __typename?: 'Booking', id: string } | null };

export type DeleteLogMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  logId: Scalars['ID']['input'];
}>;


export type DeleteLogMutation = { __typename?: 'Mutation', deleteLog: string };

export type SendCheckinNotificationMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type SendCheckinNotificationMutation = { __typename?: 'Mutation', sendCheckinNotification: any };

export type GetBookingPassengerEmailsQueryVariables = Exact<{
  showUpcoming?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  bookingFilter?: InputMaybe<BookingFilter>;
  openAmountOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetBookingPassengerEmailsQuery = { __typename?: 'Query', getBookingPassengerEmails: Array<{ __typename?: 'BookingPassengerEmail', bookingId: string, language?: ContactLanguage | null, email: string } | null> };

export type BookingPoolCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingPoolCountsQuery = { __typename?: 'Query', bookingPoolCounts: { __typename?: 'BookingPoolCounts', total: number, toConfirm: number, unplanned: number, voucherExpiring: number, openAmount: number, favourite: number, tags: Array<{ __typename?: 'BookingPoolTagCount', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null, count: number }> } };

export type CalendarWeekQueryVariables = Exact<{
  year: Scalars['PositiveInt']['input'];
  week: Scalars['PositiveInt']['input'];
}>;


export type CalendarWeekQuery = { __typename?: 'Query', calendarWeek: { __typename?: 'CalendarWeek', availabilityActive?: boolean | null, flights?: Array<{ __typename?: 'Flight', id: string, comment?: string | null, balloonCapacityReduction?: any | null, date?: any | null, hour?: any | null, period?: FlightPeriod | null, status?: FlightStatus | null, published?: boolean | null, liftSpare?: number | null, tempTakeoff?: number | null, tempTakeoffManual?: boolean | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, thumbUrl?: string | null, liftWarningOrangeBelow?: any | null, liftWarningRedBelow?: any | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null, driverLicenseCategory?: DriverLicense | null } | null } | null>, location?: { __typename?: 'Location', id: string, name?: string | null, latitude?: number | null, longitude?: number | null, region: Array<{ __typename?: 'Region', color?: string | null } | null> } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null } | null } | null, icon: { __typename?: 'Icon', sign: string, color: string }, passengerCounters: { __typename?: 'FlightPassengerCounters', passengersCountConfirmed: any, passengersCountAdded: any }, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, meteo?: { __typename?: 'MeteoblueForecastSlot', tempTakeoff?: number | null, windGl?: number | null, flyability?: { __typename?: 'FlyabilityAssessment', verdict: FlyabilityVerdict } | null } | null } | null> | null, events?: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any, type?: EventType | null, availability?: CrewAvailability | null, period?: FlightPeriod | null, crew?: { __typename?: 'Crew', id: string, name?: string | null, isPilot?: boolean | null, driverLicenseCategory?: DriverLicense | null } | null } | null> | null, preferredCrews?: Array<{ __typename?: 'PreferredCrew', balloon?: { __typename?: 'Balloon', id: string, name?: string | null, callSign?: string | null } | null, pilot?: { __typename?: 'Crew', id: string, name?: string | null } | null, driver?: { __typename?: 'Crew', id: string, name?: string | null } | null, crew?: Array<{ __typename?: 'Crew', id: string, name?: string | null } | null> | null } | null> | null, openBookings?: Array<{ __typename?: 'OpenBookingDemand', date?: string | null, period?: FlightPeriod | null, count?: number | null, region?: { __typename?: 'Region', id: string, name?: string | null, color?: string | null } | null } | null> | null, days?: Array<{ __typename?: 'CalendarWeekDay', date?: string | null, sunrise?: string | null, sunset?: string | null, flyability?: Array<{ __typename?: 'CalendarDayFlyability', period?: FlightPeriod | null, assessment?: { __typename?: 'FlyabilityAssessment', verdict: FlyabilityVerdict, parameters: Array<{ __typename?: 'FlyabilityParameter', key: string, band: FlyabilityBand }> } | null } | null> | null } | null> | null, defaultLocation?: { __typename?: 'Location', id: string, name?: string | null } | null } };

export type CalendarQueryVariables = Exact<{
  year: Scalars['PositiveInt']['input'];
  month: Scalars['PositiveInt']['input'];
}>;


export type CalendarQuery = { __typename?: 'Query', calendar: { __typename?: 'Calendar', flights?: Array<{ __typename?: 'Flight', id: string, comment?: string | null, balloonCapacityReduction?: any | null, date?: any | null, hour?: any | null, period?: FlightPeriod | null, status?: FlightStatus | null, passengersCount?: number | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, callSign?: string | null, capacity?: any | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null, isPilot?: boolean | null } | null } | null>, location?: { __typename?: 'Location', id: string, name?: string | null, region: Array<{ __typename?: 'Region', name?: string | null, id: string, color?: string | null } | null> } | null, pilot?: { __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null, isCurrent?: number | null, isPilot?: boolean | null } | null } | null } | null> | null, events?: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any, type?: EventType | null, availability?: CrewAvailability | null, period?: FlightPeriod | null, crew?: { __typename?: 'Crew', id: string, name?: string | null, isCurrent?: number | null, isGroundCrewCurrent?: number | null, isPilot?: boolean | null, driverLicenseCategory?: DriverLicense | null } | null } | null> | null } };

export type CrewCalendarQueryVariables = Exact<{
  year: Scalars['PositiveInt']['input'];
  month: Scalars['PositiveInt']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CrewCalendarQuery = { __typename?: 'Query', crewCalendar: Array<{ __typename?: 'CrewCalendarItem', start?: any | null, meta?: { __typename?: 'CrewCalendarDay', flightsMorning?: { __typename?: 'CrewDayContent', totalFlights?: number | null, flights?: Array<{ __typename?: 'Flight', id: string, location?: { __typename?: 'Location', region: Array<{ __typename?: 'Region', name?: string | null, id: string, color?: string | null } | null> } | null } | null> | null, crewEvent?: { __typename?: 'Event', id: string, date: any, type?: EventType | null, availability?: CrewAvailability | null, period?: FlightPeriod | null, description?: string | null } | null, operatorEvents?: Array<{ __typename?: 'Event', id: string, date: any, type?: EventType | null, description?: string | null, period?: FlightPeriod | null } | null> | null, selectedFlights?: Array<{ __typename?: 'Flight', id: string, comment?: string | null, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null } | null } | null>, location?: { __typename?: 'Location', id: string, city?: string | null, name?: string | null, region: Array<{ __typename?: 'Region', name?: string | null, id: string, color?: string | null } | null> } | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> | null } | null, flightsEvening?: { __typename?: 'CrewDayContent', totalFlights?: number | null, flights?: Array<{ __typename?: 'Flight', id: string, location?: { __typename?: 'Location', region: Array<{ __typename?: 'Region', name?: string | null, id: string, color?: string | null } | null> } | null } | null> | null, crewEvent?: { __typename?: 'Event', id: string, date: any, type?: EventType | null, availability?: CrewAvailability | null, period?: FlightPeriod | null, description?: string | null } | null, operatorEvents?: Array<{ __typename?: 'Event', id: string, date: any, type?: EventType | null, description?: string | null, period?: FlightPeriod | null } | null> | null, selectedFlights?: Array<{ __typename?: 'Flight', id: string, comment?: string | null, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, balloon?: { __typename?: 'Balloon', name?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null } | null } | null>, location?: { __typename?: 'Location', id: string, city?: string | null, name?: string | null, region: Array<{ __typename?: 'Region', name?: string | null, id: string, color?: string | null } | null> } | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> | null } | null } | null } | null> };

export type GetCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCategoriesQuery = { __typename?: 'Query', categories: Array<{ __typename?: 'Category', id: string, passengerId?: string | null, child?: boolean | null, default?: boolean | null, description?: string | null, name?: string | null, price?: number | null } | null> };

export type GetCategoryQueryVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type GetCategoryQuery = { __typename?: 'Query', category: { __typename?: 'Category', id: string, passengerId?: string | null, child?: boolean | null, default?: boolean | null, description?: string | null, name?: string | null, price?: number | null } };

export type SaveCategoryMutationVariables = Exact<{
  categoryInput: CategoryInput;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveCategoryMutation = { __typename?: 'Mutation', saveCategory: string };

export type DeleteCategoryMutationVariables = Exact<{
  categoryId: Scalars['ID']['input'];
}>;


export type DeleteCategoryMutation = { __typename?: 'Mutation', deleteCategory: string };

export type PassengerRegionDistributionQueryVariables = Exact<{ [key: string]: never; }>;


export type PassengerRegionDistributionQuery = { __typename?: 'Query', passengerRegionDistribution?: { __typename?: 'Chart', type?: ChartType | null, data?: any | null } | null };

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'Query', countries: Array<{ __typename?: 'Country', id?: string | null, country?: string | null } | null> };

export type GetCrewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCrewsQuery = { __typename?: 'Query', crews: Array<{ __typename?: 'Crew', driverLicense?: boolean | null, driverLicenseCategory?: DriverLicense | null, groundCrew?: boolean | null, id: string, isCurrent?: number | null, isGroundCrewCurrent?: number | null, isPilot?: boolean | null, language?: ContactLanguage | null, licenseExpiryDate?: any | null, licenseGas?: boolean | null, licenseGroupA?: boolean | null, licenseGroupB?: boolean | null, licenseGroupC?: boolean | null, licenseGroupD?: boolean | null, medicalExpiryDate?: any | null, name?: string | null, phone?: any | null, pilotLicense?: PilotLicense | null } | null> };

export type GetLogBooksCrewsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLogBooksCrewsQuery = { __typename?: 'Query', crews: Array<{ __typename?: 'Crew', id: string, isCurrent?: number | null, isGroundCrewCurrent?: number | null, isPilot?: boolean | null, medicalExpiryDate?: any | null, name?: string | null, email?: any | null, phone?: any | null, pilotLicense?: PilotLicense | null, logbook?: { __typename?: 'LogBook', id?: string | null, statistics?: { __typename?: 'LogBookStatistics', totalFlightCount?: any | null, totalFlightMinutes?: any | null } | null } | null } | null> };

export type GetCrewQueryVariables = Exact<{
  crewId: Scalars['ID']['input'];
}>;


export type GetCrewQuery = { __typename?: 'Query', crew: { __typename?: 'Crew', driverLicense?: boolean | null, driverLicenseCategory?: DriverLicense | null, email?: any | null, emailNotifications?: any | null, groundCrew?: boolean | null, groundCrewTrainingExpiryDate?: any | null, id: string, isCurrent?: number | null, isGroundCrewCurrent?: number | null, isPilot?: boolean | null, language?: ContactLanguage | null, licenseExpiryDate?: any | null, licenseExtraCrew?: boolean | null, licenseGas?: boolean | null, licenseGroupA?: boolean | null, licenseGroupB?: boolean | null, licenseGroupC?: boolean | null, licenseGroupD?: boolean | null, licenseNumber?: string | null, medicalExpiryDate?: any | null, firstAidExpiryDate?: any | null, fireExtinguisherExpiryDate?: any | null, medicalWeight?: any | null, name?: string | null, phone?: any | null, pilotLicense?: PilotLicense | null, smsType?: SmsConversationType | null, smsUnread?: any | null, userRole?: UserRole | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, status?: string | null, error?: string | null } | null } };

export type CrewConversationsQueryVariables = Exact<{
  offset?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type CrewConversationsQuery = { __typename?: 'Query', crewConversations: Array<{ __typename?: 'Crew', id: string, name?: string | null, phone?: any | null, language?: ContactLanguage | null, smsType?: SmsConversationType | null, smsUnread?: any | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, status?: string | null, error?: string | null } | null } | null> };

export type CrewsPerFlightQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type CrewsPerFlightQuery = { __typename?: 'Query', crewsPerFlight: Array<{ __typename?: 'CrewPerFlight', availability?: CrewAvailability | null, availabilityReason?: string | null, driverLicenseCategory?: DriverLicense | null, groundCrew?: boolean | null, id: string, isCurrent?: number | null, isGroundCrewCurrent?: number | null, isPilot?: boolean | null, name?: string | null, pilotLicense?: PilotLicense | null, popularity?: any | null, mostPopular?: boolean | null, otherFlight?: { __typename?: 'Flight', id: string, balloon?: { __typename?: 'Balloon', name?: string | null } | null } | null } | null> };

export type PilotsPerFlightQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type PilotsPerFlightQuery = { __typename?: 'Query', crewsPerFlight: Array<{ __typename?: 'CrewPerFlight', availability?: CrewAvailability | null, availabilityReason?: string | null, groundCrew?: boolean | null, id: string, isCurrent?: number | null, isPilot?: boolean | null, name?: string | null, pilotLicense?: PilotLicense | null, popularity?: any | null, otherFlight?: { __typename?: 'Flight', id: string, balloon?: { __typename?: 'Balloon', name?: string | null } | null } | null } | null> };

export type GetAllCrewForDialogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllCrewForDialogQuery = { __typename?: 'Query', crews: Array<{ __typename?: 'Crew', id: string, name?: string | null, isCurrent?: number | null, isGroundCrewCurrent?: number | null, isPilot?: boolean | null, driverLicenseCategory?: DriverLicense | null } | null> };

export type SaveCrewMutationVariables = Exact<{
  crewInput: CrewInput;
  crewId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveCrewMutation = { __typename?: 'Mutation', saveCrew: string };

export type DeleteCrewMutationVariables = Exact<{
  crewId: Scalars['ID']['input'];
}>;


export type DeleteCrewMutation = { __typename?: 'Mutation', deleteCrew: string };

export type GetCylindersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCylindersQuery = { __typename?: 'Query', cylinders: Array<{ __typename?: 'Cylinder', id: string, number?: any | null, emptyWeight?: any | null, fullWeight?: any | null, manufacturer?: string | null, serialNumber?: string | null, volume?: any | null } | null> };

export type GetCylinderQueryVariables = Exact<{
  cylinderId: Scalars['ID']['input'];
}>;


export type GetCylinderQuery = { __typename?: 'Query', cylinder: { __typename?: 'Cylinder', emptyWeight?: any | null, fullWeight?: any | null, id: string, manufacturer?: string | null, serialNumber?: string | null, volume?: any | null } };

export type SaveCylinderMutationVariables = Exact<{
  cylinderInput: CylinderInput;
  cylinderId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveCylinderMutation = { __typename?: 'Mutation', saveCylinder: string };

export type DeleteCylinderMutationVariables = Exact<{
  cylinderId: Scalars['ID']['input'];
}>;


export type DeleteCylinderMutation = { __typename?: 'Mutation', deleteCylinder: string };

export type GetAllEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEmailTemplatesQuery = { __typename?: 'Query', getAllEmailTemplates: Array<{ __typename?: 'EmailSettingsTemplate', id: string, type?: EmailTemplateType | null, title?: string | null, template?: { __typename?: 'EmailLanguages', en?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, fr?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, nl?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, de?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null } | null } | null> };

export type ParseEmailTemplateQueryVariables = Exact<{
  emailBody: Scalars['String']['input'];
  language: Scalars['String']['input'];
  flightPeriod: Scalars['String']['input'];
}>;


export type ParseEmailTemplateQuery = { __typename?: 'Query', parseEmailTemplate: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } };

export type GetEmailTemplateQueryVariables = Exact<{
  type: EmailTemplateType;
}>;


export type GetEmailTemplateQuery = { __typename?: 'Query', getEmailTemplate: { __typename?: 'EmailSettingsTemplate', id: string, title?: string | null, type?: EmailTemplateType | null, template?: { __typename?: 'EmailLanguages', en?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, fr?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, nl?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, de?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null } | null } };

export type GetEmailTemplateByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmailTemplateByIdQuery = { __typename?: 'Query', getEmailTemplateByID: { __typename?: 'EmailSettingsTemplate', id: string, title?: string | null, type?: EmailTemplateType | null, template?: { __typename?: 'EmailLanguages', en?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, fr?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, nl?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, de?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null } | null } };

export type GetEmailTemplatesQueryVariables = Exact<{
  type: EmailTemplateType;
}>;


export type GetEmailTemplatesQuery = { __typename?: 'Query', getEmailTemplates: Array<{ __typename?: 'EmailSettingsTemplate', id: string, title?: string | null, type?: EmailTemplateType | null, template?: { __typename?: 'EmailLanguages', en?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, fr?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, nl?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, de?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null } | null } | null> };

export type GetEmailTemplateByLanguageQueryVariables = Exact<{
  type: EmailTemplateType;
  lang: ContactLanguage;
}>;


export type GetEmailTemplateByLanguageQuery = { __typename?: 'Query', getEmailTemplateByLanguage: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string } };

export type AddEmailOutMutationVariables = Exact<{
  emailInput: EmailInput;
}>;


export type AddEmailOutMutation = { __typename?: 'Mutation', addEmailOut: string };

export type CopyEmailTemplateMutationVariables = Exact<{
  emailTemplateId: Scalars['ID']['input'];
}>;


export type CopyEmailTemplateMutation = { __typename?: 'Mutation', copyEmailTemplate?: { __typename?: 'EmailSettingsTemplate', id: string, type?: EmailTemplateType | null, title?: string | null, template?: { __typename?: 'EmailLanguages', en?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, fr?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, nl?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, de?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null } | null } | null };

export type AddEmailTemplateLocationContactMutationVariables = Exact<{ [key: string]: never; }>;


export type AddEmailTemplateLocationContactMutation = { __typename?: 'Mutation', addEmailTemplateLocationContact?: { __typename?: 'EmailSettingsTemplate', id: string, type?: EmailTemplateType | null, title?: string | null, template?: { __typename?: 'EmailLanguages', en?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, fr?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, nl?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, de?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null } | null } | null };

export type DeleteEmailTemplateMutationVariables = Exact<{
  emailTemplateId: Scalars['ID']['input'];
}>;


export type DeleteEmailTemplateMutation = { __typename?: 'Mutation', deleteEmailTemplate: string };

export type SaveEmailTemplateMutationVariables = Exact<{
  emailTemplateInput?: InputMaybe<EmailTemplateInput>;
  emailTemplateId: Scalars['ID']['input'];
}>;


export type SaveEmailTemplateMutation = { __typename?: 'Mutation', saveEmailTemplate?: { __typename?: 'EmailSettingsTemplate', id: string, type?: EmailTemplateType | null, title?: string | null, template?: { __typename?: 'EmailLanguages', en?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, fr?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, nl?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null, de?: { __typename?: 'EmailTemplateByLanguage', body: string, subject: string, attachments?: Array<{ __typename?: 'EmailAttachment', filename?: string | null, reference?: string | null, type?: string | null } | null> | null } | null } | null } | null };

export type GetEventsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEventsQuery = { __typename?: 'Query', events: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any } | null> };

export type DeleteEventMutationVariables = Exact<{
  eventId: Scalars['ID']['input'];
}>;


export type DeleteEventMutation = { __typename?: 'Mutation', deleteEvent: string };

export type SaveEventMutationVariables = Exact<{
  eventInput: EventInput;
  eventId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveEventMutation = { __typename?: 'Mutation', saveEvent: string };

export type SaveCrewAvailabilityMutationVariables = Exact<{
  crewAvailabilityInput: CrewAvailabilityInput;
  eventId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveCrewAvailabilityMutation = { __typename?: 'Mutation', saveCrewAvailability?: string | null };

export type SetMonthAvailabilityMutationVariables = Exact<{
  availability: CrewAvailability;
  year: Scalars['PositiveInt']['input'];
  month: Scalars['PositiveInt']['input'];
  crewId: Scalars['ID']['input'];
}>;


export type SetMonthAvailabilityMutation = { __typename?: 'Mutation', setMonthAvailability?: string | null };

export type DeleteMonthAvailabilityEventsMutationVariables = Exact<{
  year: Scalars['PositiveInt']['input'];
  month: Scalars['PositiveInt']['input'];
  crewId: Scalars['ID']['input'];
}>;


export type DeleteMonthAvailabilityEventsMutation = { __typename?: 'Mutation', deleteMonthAvailabilityEvents?: string | null };

export type FetchHolidaysMutationVariables = Exact<{
  year: Scalars['PositiveInt']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  language?: InputMaybe<Scalars['String']['input']>;
}>;


export type FetchHolidaysMutation = { __typename?: 'Mutation', fetchHolidays?: any | null };

export type BulkFlightActionFieldsFragment = { __typename?: 'BulkFlightAction', id: string, action: BulkFlightActionType, visibility?: VisibilityType | null, tagName?: string | null, cancelReason?: string | null, user: string, createdAt: any, undoExpiresAt: any, undoable: boolean, undoneAt?: any | null, undoneBy?: string | null, updated: any, unchanged: any, skipped: any, flights: Array<{ __typename?: 'BulkFlightActionFlight', flightId: string, date?: any | null, locationName?: string | null, result: string, skipReason?: BulkFlightSkipReason | null, undoResult?: string | null, undoSkipReason?: BulkFlightUndoSkipReason | null, bookingsNotRestored?: Array<{ __typename?: 'BulkFlightBookingNotRestored', bookingId: string, reason: BulkFlightUndoSkipReason }> | null }> };

export type BulkFlightSelectionQueryVariables = Exact<{
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filterRange?: InputMaybe<FilterRangeInput>;
  freeSpots?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UpcomingFlightScope>;
}>;


export type BulkFlightSelectionQuery = { __typename?: 'Query', bulkFlightSelection: { __typename?: 'BulkFlightSelection', total: any, flightIds: Array<string>, limit: any } };

export type BulkFlightActionPreviewQueryVariables = Exact<{
  flightIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: BulkFlightActionInput;
}>;


export type BulkFlightActionPreviewQuery = { __typename?: 'Query', bulkFlightActionPreview: { __typename?: 'BulkFlightPreview', willUpdate: any, unchanged: any, firstDate?: any | null, lastDate?: any | null, bookingsAffected: any, passengersAffected: any, skipped: Array<{ __typename?: 'BulkFlightSkipCount', reason: BulkFlightSkipReason, count: any }> } };

export type RecentBulkFlightActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RecentBulkFlightActionsQuery = { __typename?: 'Query', recentBulkFlightActions: Array<{ __typename?: 'BulkFlightAction', id: string, action: BulkFlightActionType, visibility?: VisibilityType | null, tagName?: string | null, cancelReason?: string | null, user: string, createdAt: any, undoExpiresAt: any, undoable: boolean, undoneAt?: any | null, undoneBy?: string | null, updated: any, unchanged: any, skipped: any, flights: Array<{ __typename?: 'BulkFlightActionFlight', flightId: string, date?: any | null, locationName?: string | null, result: string, skipReason?: BulkFlightSkipReason | null, undoResult?: string | null, undoSkipReason?: BulkFlightUndoSkipReason | null, bookingsNotRestored?: Array<{ __typename?: 'BulkFlightBookingNotRestored', bookingId: string, reason: BulkFlightUndoSkipReason }> | null }> }> };

export type BulkFlightActionMutationVariables = Exact<{
  flightIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: BulkFlightActionInput;
}>;


export type BulkFlightActionMutation = { __typename?: 'Mutation', bulkFlightAction: { __typename?: 'BulkFlightAction', id: string, action: BulkFlightActionType, visibility?: VisibilityType | null, tagName?: string | null, cancelReason?: string | null, user: string, createdAt: any, undoExpiresAt: any, undoable: boolean, undoneAt?: any | null, undoneBy?: string | null, updated: any, unchanged: any, skipped: any, flights: Array<{ __typename?: 'BulkFlightActionFlight', flightId: string, date?: any | null, locationName?: string | null, result: string, skipReason?: BulkFlightSkipReason | null, undoResult?: string | null, undoSkipReason?: BulkFlightUndoSkipReason | null, bookingsNotRestored?: Array<{ __typename?: 'BulkFlightBookingNotRestored', bookingId: string, reason: BulkFlightUndoSkipReason }> | null }> } };

export type UndoBulkFlightActionMutationVariables = Exact<{
  actionId: Scalars['ID']['input'];
}>;


export type UndoBulkFlightActionMutation = { __typename?: 'Mutation', undoBulkFlightAction: { __typename?: 'BulkFlightAction', id: string, action: BulkFlightActionType, visibility?: VisibilityType | null, tagName?: string | null, cancelReason?: string | null, user: string, createdAt: any, undoExpiresAt: any, undoable: boolean, undoneAt?: any | null, undoneBy?: string | null, updated: any, unchanged: any, skipped: any, flights: Array<{ __typename?: 'BulkFlightActionFlight', flightId: string, date?: any | null, locationName?: string | null, result: string, skipReason?: BulkFlightSkipReason | null, undoResult?: string | null, undoSkipReason?: BulkFlightUndoSkipReason | null, bookingsNotRestored?: Array<{ __typename?: 'BulkFlightBookingNotRestored', bookingId: string, reason: BulkFlightUndoSkipReason }> | null }> } };

export type GetFlightQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetFlightQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', comment?: string | null, published?: boolean | null, removed?: any | null, crewComments?: string | null, cancelReason?: string | null, date?: any | null, hour?: any | null, hourMeeting?: any | null, id: string, cancelMessageSent?: boolean | null, cancelMessageReason?: string | null, landingLocation?: string | null, landingTime?: any | null, landingDetails?: string | null, landingLatitude?: number | null, landingLongitude?: number | null, liftAvailable?: number | null, liftDataMismatch?: Array<string | null> | null, liftNeeded?: number | null, liftPassengers?: number | null, liftSpare?: number | null, liftWarningLevel?: LiftWarningLevel | null, locationType?: LocationType | null, meetingPointSameAsTakeOff?: boolean | null, meetingPointAddress?: string | null, meetingPointLatitude?: number | null, meetingPointLongitude?: number | null, meetingPointURL?: string | null, meetingPointCity?: string | null, maximumFlightTime?: any | null, maximumHeight?: any | null, period?: FlightPeriod | null, pilotComments?: string | null, plannedFlightTime?: any | null, status?: FlightStatus | null, takeoffTime?: any | null, tempBalloon?: any | null, tempMax?: number | null, tempTakeoff?: number | null, tempTakeoffManual?: boolean | null, vfrClouds?: number | null, vfrVisual?: number | null, visibility?: VisibilityType | null, weatherForecastDate?: any | null, weatherPmax?: number | null, weatherQnh?: number | null, weatherSource?: string | null, wind10?: number | null, wind10Direction?: number | null, wind20?: number | null, wind20Direction?: number | null, windGl?: number | null, windGlDirection?: number | null, windSummary?: string | null, refuelVolume?: any | null, passengersCount?: number | null, passengersOccupancy?: any | null, flightDuplicatesBlocking?: boolean | null, flightTime?: any | null, flightDistance?: number | null, flightHeading?: number | null, balloonCapacityReduction?: any | null, icon: { __typename?: 'Icon', color: string, sign: string }, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', availability?: CrewAvailability | null, availabilityReason?: string | null, driverLicenseCategory?: DriverLicense | null, email?: any | null, emailNotifications?: any | null, id: string, language?: ContactLanguage | null, name?: string | null, pilotLicense?: PilotLicense | null } | null } | null>, pilot?: { __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, name?: string | null, language?: ContactLanguage | null, email?: any | null, emailNotifications?: any | null, pilotLicense?: PilotLicense | null, isCurrent?: number | null, medicalWeight?: any | null, phone?: any | null, totalWeight?: any | null } | null } | null, flightsAtSameDay: { __typename?: 'FlightsAtSameDay', count: any, names: string, flights: Array<{ __typename?: 'Flight', id: string } | null> }, flightDuplicates?: Array<{ __typename?: 'Flight', id: string } | null> | null, notam?: { __typename?: 'FlightNotamSummary', severity?: NotamSeverity | null, count?: any | null, at?: any | null, noData?: boolean | null } | null, balloon?: { __typename?: 'Balloon', balloonTemp?: any | null, basketWeight?: any | null, burnerWeight?: any | null, callSign?: string | null, capacity?: any | null, envelopeType?: string | null, envelopeVolume?: any | null, envelopeWeight?: any | null, id: string, isCurrent?: number | null, name?: string | null, minFuel?: any | null, balloonWeight?: { __typename?: 'BalloonWeight', cylindersWeight: any } | null } | null, location?: { __typename?: 'Location', id: string, address?: string | null, city?: string | null, country?: string | null, meetingPointSameAsTakeOff?: boolean | null, meetingPointAddress?: string | null, meetingPointLatitude?: number | null, meetingPointLongitude?: number | null, meetingPointURL?: string | null, meetingPointCity?: string | null, description?: string | null, height?: any | null, latitude?: number | null, longitude?: number | null, maximumHeight?: number | null, name?: string | null, postalCode?: string | null, timezone?: string | null, contact?: { __typename?: 'LocationContact', comment?: string | null, email?: string | null, emailTemplate?: string | null, name?: string | null, phone?: string | null, language?: ContactLanguage | null, smsTemplate?: string | null, media?: LocationContactMedia | null } | null, region: Array<{ __typename?: 'Region', id: string, name?: string | null } | null> } | null, locationEmail?: { __typename?: 'MailEventLatest', date?: any | null, event?: string | null } | null, locationSmsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, status?: string | null, error?: string | null } | null, sunriseSunset?: { __typename?: 'SunriseSunset', sunrise?: string | null, sunset?: string | null, morningFlight?: string | null, eveningFlight?: string | null } | null, meteo?: { __typename?: 'MeteoblueForecastSlot', slot?: string | null, tempTakeoff?: number | null, vfrVisual?: number | null, weatherQnh?: number | null, wind10?: number | null, wind10Direction?: number | null, wind20?: number | null, wind20Direction?: number | null, windGl?: number | null, windGlDirection?: number | null, flyability?: { __typename?: 'FlyabilityAssessment', verdict: FlyabilityVerdict, parameters: Array<{ __typename?: 'FlyabilityParameter', key: string, value?: number | null, band: FlyabilityBand }> } | null, forecast?: { __typename?: 'slotForecast', daytime?: Array<any | null> | null, flytime?: Array<any | null> | null, lastUpdate?: any | null, latitude?: string | null, longitude?: string | null, lowCloudsData?: Array<any | null> | null, pictoCodeData?: Array<any | null> | null, precipitationData?: Array<number | null> | null, pressureData?: Array<any | null> | null, sunrise?: any | null, sunset?: any | null, temperatureData?: Array<any | null> | null, time?: Array<string | null> | null, utc_timeoffset?: number | null, visibilityData?: Array<any | null> | null, windDirectionData?: Array<number | null> | null, windDirectionData_1000?: Array<number | null> | null, windDirectionData_500?: Array<number | null> | null, windDirectionData_550?: Array<number | null> | null, windDirectionData_600?: Array<number | null> | null, windDirectionData_650?: Array<number | null> | null, windDirectionData_700?: Array<number | null> | null, windDirectionData_750?: Array<number | null> | null, windDirectionData_800?: Array<number | null> | null, windDirectionData_925?: Array<number | null> | null, windDirectionData_950?: Array<number | null> | null, windDirectionData_975?: Array<number | null> | null, windGustData?: Array<number | null> | null, windSpeedData?: Array<number | null> | null, windSpeedData_1000?: Array<number | null> | null, windSpeedData_500?: Array<number | null> | null, windSpeedData_550?: Array<number | null> | null, windSpeedData_600?: Array<number | null> | null, windSpeedData_650?: Array<number | null> | null, windSpeedData_700?: Array<number | null> | null, windSpeedData_750?: Array<number | null> | null, windSpeedData_800?: Array<number | null> | null, windSpeedData_925?: Array<number | null> | null, windSpeedData_950?: Array<number | null> | null, windSpeedData_975?: Array<number | null> | null, datepart?: Array<{ __typename?: 'DatePart', part?: DatePartType | null, text?: string | null } | null> | null } | null } | null, bookings: { __typename?: 'FlightBookings', id: string, addedCount: any, notConfirmedCount: any, notConfirmedNames: string, list: Array<{ __typename?: 'Booking', id: string, icon?: string | null, iconColor?: string | null, inviteCount?: number | null, city?: string | null, contactName?: string | null, contactPhone?: any | null, contactEmail?: string | null, contactLanguage?: ContactLanguage | null, comments?: string | null, status?: BookingStatus | null, onlineCheckinAt?: any | null, checkinNotifiedAt?: any | null, prepaymentAmount?: number | null, prepaymentDate?: any | null, invoiceName?: string | null, VATnumber?: string | null, mismatchReasons?: Array<string | null> | null, logsRemoved?: any | null, locationType?: LocationType | null, smsType?: SmsConversationType | null, smsUnread?: any | null, upUrl?: string | null, region?: { __typename?: 'Region', name?: string | null } | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null, description?: string | null, height?: any | null, id: string, latitude?: number | null, longitude?: number | null, maximumHeight?: number | null, name?: string | null } | null, passengers: Array<{ __typename?: 'Passenger', age?: any | null, transport?: boolean | null, child?: boolean | null, comments?: string | null, disability?: boolean | null, luggage?: boolean | null, name?: string | null, paymentAmount?: number | null, paymentReference?: string | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, totalWeight?: any | null, weight?: any | null, weightIsDefault: boolean, voucherNumber?: string | null, category?: { __typename?: 'Category', id: string, passengerId?: string | null, name?: string | null, description?: string | null } | null, voucher?: { __typename?: 'Voucher', voucherReference?: string | null } | null } | null>, passengerCounters?: { __typename?: 'PassengerCounters', id?: string | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, openAmount?: any | null, paidAmount?: any | null, passengerCount?: any | null, totalAmount?: any | null, totalWeight?: any | null, unpaidPassengerCount?: any | null } | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, status?: string | null, error?: string | null } | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> }, cancelledBookings?: Array<{ __typename?: 'Booking', id: string, icon?: string | null, iconColor?: string | null, inviteCount?: number | null, city?: string | null, contactName?: string | null, contactPhone?: any | null, contactEmail?: string | null, contactLanguage?: ContactLanguage | null, comments?: string | null, status?: BookingStatus | null, prepaymentAmount?: number | null, prepaymentDate?: any | null, invoiceName?: string | null, VATnumber?: string | null, mismatchReasons?: Array<string | null> | null, logsRemoved?: any | null, locationType?: LocationType | null, smsType?: SmsConversationType | null, smsUnread?: any | null, upUrl?: string | null, region?: { __typename?: 'Region', name?: string | null } | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null, description?: string | null, height?: any | null, id: string, latitude?: number | null, longitude?: number | null, maximumHeight?: number | null, name?: string | null } | null, passengers: Array<{ __typename?: 'Passenger', age?: any | null, transport?: boolean | null, child?: boolean | null, comments?: string | null, disability?: boolean | null, luggage?: boolean | null, name?: string | null, paymentAmount?: number | null, paymentReference?: string | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, totalWeight?: any | null, weight?: any | null, weightIsDefault: boolean, voucherNumber?: string | null, category?: { __typename?: 'Category', id: string, passengerId?: string | null, name?: string | null, description?: string | null } | null, voucher?: { __typename?: 'Voucher', voucherReference?: string | null } | null } | null>, passengerCounters?: { __typename?: 'PassengerCounters', id?: string | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, openAmount?: any | null, paidAmount?: any | null, passengerCount?: any | null, totalAmount?: any | null, totalWeight?: any | null, unpaidPassengerCount?: any | null } | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, status?: string | null, error?: string | null } | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, flight?: { __typename?: 'Flight', id: string, date?: any | null, period?: FlightPeriod | null, balloonCapacityReduction?: any | null, passengersOccupancy?: any | null, passengersCount?: number | null, balloon?: { __typename?: 'Balloon', name?: string | null, capacity?: any | null } | null } | null }> | null, passengerCounters: { __typename?: 'FlightPassengerCounters', id: string, passengersCountAdded: any, passengersCountInvited: any, passengersCountConfirmed: any, passengersWeight: any }, logs?: Array<{ __typename?: 'BookingLog', date?: any | null } | null> | null, trajectory?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, trajectoryCustom?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, trajectory1000?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, trajectory950?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, trajectory925?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, trajectory800?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, trajectory700?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, trajectory600?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, trajectory500?: Array<{ __typename?: 'Mapslocation', lat?: number | null, lng?: number | null, alt?: any | null, distance?: number | null } | null> | null, tags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, skeyesForecast?: { __typename?: 'FlightSkeyesForecast', username?: string | null, date?: any | null, forecast?: { __typename?: 'SkeyesForecast', datetime?: any | null, full?: string | null, inversions?: string | null, issued?: any | null, outlook?: string | null, period?: string | null, slot?: string | null, weather?: string | null, winds?: string | null } | null } | null } };

export type GetFlightDashboardQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetFlightDashboardQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', date?: any | null, hour?: any | null, hourMeeting?: any | null, id: string, period?: FlightPeriod | null, status?: FlightStatus | null, liftSpare?: number | null, liftWarningLevel?: LiftWarningLevel | null, tempTakeoff?: number | null, tempTakeoffManual?: boolean | null, balloonCapacityReduction?: any | null, icon: { __typename?: 'Icon', color: string, sign: string }, notam?: { __typename?: 'FlightNotamSummary', severity?: NotamSeverity | null, count?: any | null, at?: any | null, noData?: boolean | null } | null, meteo?: { __typename?: 'MeteoblueForecastSlot', tempTakeoff?: number | null, weatherQnh?: number | null, wind10?: number | null, wind10Direction?: number | null, wind20?: number | null, wind20Direction?: number | null, windGl?: number | null, windGlDirection?: number | null } | null, passengerCounters: { __typename?: 'FlightPassengerCounters', id: string, passengersCountAdded: any, passengersCountInvited: any, passengersCountConfirmed: any, passengersWeight: any }, pilot?: { __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, isGroundCrewCurrent?: number | null, isPilot?: boolean | null, name?: string | null, language?: ContactLanguage | null, email?: any | null, emailNotifications?: any | null, pilotLicense?: PilotLicense | null, isCurrent?: number | null, medicalWeight?: any | null, phone?: any | null, totalWeight?: any | null } | null } | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, bookings: { __typename?: 'FlightBookings', id: string, addedCount: any, notConfirmedCount: any, notConfirmedNames: string, list: Array<{ __typename?: 'Booking', id: string, icon?: string | null, iconColor?: string | null, inviteCount?: number | null, city?: string | null, contactName?: string | null, contactPhone?: any | null, contactEmail?: string | null, contactLanguage?: ContactLanguage | null, comments?: string | null, status?: BookingStatus | null, onlineCheckinAt?: any | null, prepaymentAmount?: number | null, prepaymentDate?: any | null, invoiceName?: string | null, VATnumber?: string | null, mismatchReasons?: Array<string | null> | null, locationType?: LocationType | null, smsType?: SmsConversationType | null, smsUnread?: any | null, upUrl?: string | null, region?: { __typename?: 'Region', name?: string | null } | null, location?: { __typename?: 'Location', address?: string | null, city?: string | null, description?: string | null, height?: any | null, id: string, latitude?: number | null, longitude?: number | null, maximumHeight?: number | null, name?: string | null } | null, passengers: Array<{ __typename?: 'Passenger', age?: any | null, transport?: boolean | null, child?: boolean | null, comments?: string | null, disability?: boolean | null, luggage?: boolean | null, name?: string | null, paymentAmount?: number | null, paymentReference?: string | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, totalWeight?: any | null, weight?: any | null, weightIsDefault: boolean, voucherNumber?: string | null, category?: { __typename?: 'Category', id: string, passengerId?: string | null, name?: string | null, description?: string | null } | null, voucher?: { __typename?: 'Voucher', voucherReference?: string | null } | null } | null>, passengerCounters?: { __typename?: 'PassengerCounters', id?: string | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, openAmount?: any | null, paidAmount?: any | null, passengerCount?: any | null, totalAmount?: any | null, totalWeight?: any | null, unpaidPassengerCount?: any | null } | null, smsLatest?: { __typename?: 'SmsLatest', date?: any | null, direction?: SmsDirection | null, summary?: string | null, status?: string | null, error?: string | null } | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> } } };

export type GetFlightLogsQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetFlightLogsQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', logs?: Array<{ __typename?: 'BookingLog', id: string, date?: any | null, user?: string | null, action?: BookingLogAction | null, reason?: string | null, booking?: { __typename?: 'Booking', id: string, contactName?: string | null, removed?: any | null, status?: BookingStatus | null } | null } | null> | null } };

export type GetBookingFlightQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetBookingFlightQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', id: string, date?: any | null, hour?: any | null, hourMeeting?: any | null, comment?: string | null, period?: FlightPeriod | null, balloonCapacityReduction?: any | null, icon: { __typename?: 'Icon', sign: string, color: string }, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isCurrent?: number | null, isPilot?: boolean | null, licenseExpiryDate?: any | null, medicalExpiryDate?: any | null, name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, name?: string | null, driverLicenseCategory?: DriverLicense | null } | null } | null>, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, passengersData?: { __typename?: 'PassengerData', occupancy?: any | null, passengersCount?: any | null, openAmount?: any | null } | null, passengerCounters: { __typename?: 'FlightPassengerCounters', passengersCountConfirmed: any } } };

export type GetMobileFlightQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetMobileFlightQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', comment?: string | null, crewComments?: string | null, date?: any | null, hour?: any | null, hourMeeting?: any | null, id: string, landingTime?: any | null, landingDetails?: string | null, landingLatitude?: number | null, landingLongitude?: number | null, landingLocation?: string | null, liftAvailable?: number | null, liftNeeded?: number | null, liftSpare?: number | null, liftWarningLevel?: LiftWarningLevel | null, meetingPointSameAsTakeOff?: boolean | null, meetingPointAddress?: string | null, meetingPointLatitude?: number | null, meetingPointLongitude?: number | null, meetingPointURL?: string | null, meetingPointCity?: string | null, maximumFlightTime?: any | null, period?: FlightPeriod | null, plannedFlightTime?: any | null, spareFlightTime?: number | null, takeoffTime?: any | null, tempBalloon?: any | null, tempTakeoff?: number | null, weatherQnh?: number | null, wind10?: number | null, wind10Direction?: number | null, wind20?: number | null, wind20Direction?: number | null, windGl?: number | null, windGlDirection?: number | null, windSummary?: string | null, refuelVolume?: any | null, pilotComments?: string | null, pilotSignature?: string | null, pilotSignOffDate?: any | null, balloonCapacityReduction?: any | null, icon: { __typename?: 'Icon', sign: string, color: string }, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isCurrent?: number | null, isPilot?: boolean | null, licenseExpiryDate?: any | null, medicalExpiryDate?: any | null, name?: string | null } | null } | null, balloon?: { __typename?: 'Balloon', id: string, balloonTemp?: any | null, capacity?: any | null, envelopeInspectionDate?: any | null, envelopeType?: string | null, insuranceDueDate?: any | null, isCurrent?: number | null, name?: string | null } | null, location?: { __typename?: 'Location', address?: string | null, name?: string | null } | null, passengerCounters: { __typename?: 'FlightPassengerCounters', passengersCountConfirmed: any }, bookings: { __typename?: 'FlightBookings', list: Array<{ __typename?: 'Booking', comments?: string | null, contactLanguage?: ContactLanguage | null, contactName?: string | null, contactPhone?: any | null, id: string, status?: BookingStatus | null, tags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, passengerCounters?: { __typename?: 'PassengerCounters', openAmount?: any | null } | null, passengers: Array<{ __typename?: 'Passenger', accompany?: string | null, address?: string | null, age?: any | null, transport?: boolean | null, child?: boolean | null, city?: string | null, country?: string | null, comments?: string | null, disability?: boolean | null, email?: string | null, id: string, luggage?: boolean | null, name?: string | null, paymentAmount?: number | null, paymentReference?: string | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, postalCode?: string | null, signature?: string | null, weight?: any | null, voucherNumber?: string | null, category?: { __typename?: 'Category', id: string, passengerId?: string | null, name?: string | null, description?: string | null } | null } | null> } | null> } } };

export type GetCertificateFlightQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetCertificateFlightQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', date?: any | null, location?: { __typename?: 'Location', name?: string | null } | null, bookings: { __typename?: 'FlightBookings', list: Array<{ __typename?: 'Booking', passengers: Array<{ __typename?: 'Passenger', name?: string | null } | null> } | null> } } };

export type GetFlightsOfDashboardQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFlightsOfDashboardQuery = { __typename?: 'Query', flightsOfDashboard: Array<{ __typename?: 'Flight', id: string, period?: FlightPeriod | null, date?: any | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, isCurrent?: number | null } | null } | null> };

export type GetUpcomingFlightsQueryVariables = Exact<{
  orderBy?: InputMaybe<OrderByFlight>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUpcomingFlightsQuery = { __typename?: 'Query', upcomingFlights: Array<{ __typename?: 'Flight', id: string, cancelMessageSent?: boolean | null, cancelMessageReason?: string | null, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, visibility?: VisibilityType | null, comment?: string | null, cancelReason?: string | null, balloonCapacityReduction?: any | null, passengersCount?: number | null, passengersOccupancy?: any | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, isCurrent?: number | null, name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null, driverLicenseCategory?: DriverLicense | null } | null } | null>, icon: { __typename?: 'Icon', sign: string, color: string }, bookings: { __typename?: 'FlightBookings', id: string, count: any, list: Array<{ __typename?: 'Booking', id: string, status?: BookingStatus | null, contactName?: string | null, passengers: Array<{ __typename?: 'Passenger', id: string, name?: string | null } | null> } | null> }, passengersData?: { __typename?: 'PassengerData', passengersCount?: any | null, passengersWeight?: any | null, freeSpots?: any | null, occupancy?: any | null, openAmount?: any | null } | null, events: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any } | null>, tags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetUpcomingFlightQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetUpcomingFlightQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', id: string, cancelMessageSent?: boolean | null, cancelMessageReason?: string | null, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, visibility?: VisibilityType | null, comment?: string | null, cancelReason?: string | null, balloonCapacityReduction?: any | null, passengersCount?: number | null, passengersOccupancy?: any | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', isPilot?: boolean | null, isCurrent?: number | null, name?: string | null } | null } | null, icon: { __typename?: 'Icon', sign: string, color: string }, bookings: { __typename?: 'FlightBookings', id: string, count: any, list: Array<{ __typename?: 'Booking', id: string, status?: BookingStatus | null, contactName?: string | null, passengers: Array<{ __typename?: 'Passenger', name?: string | null } | null> } | null> }, passengerCounters: { __typename?: 'FlightPassengerCounters', id: string, passengersWeight: any, freeSpots: any }, passengersData?: { __typename?: 'PassengerData', passengersCount?: any | null, passengersWeight?: any | null, freeSpots?: any | null, occupancy?: any | null, openAmount?: any | null } | null, events: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any } | null>, tags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } };

export type GetScheduledFlightsQueryVariables = Exact<{
  orderBy?: InputMaybe<OrderByFlight>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetScheduledFlightsQuery = { __typename?: 'Query', scheduledFlights: Array<{ __typename?: 'Flight', id: string, period?: FlightPeriod | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null } | null } | null> };

export type GetFlightsListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filterRange?: InputMaybe<FilterRangeInput>;
  freeSpots?: InputMaybe<Scalars['Int']['input']>;
  scope?: InputMaybe<UpcomingFlightScope>;
}>;


export type GetFlightsListQuery = { __typename?: 'Query', getFlightsList: Array<{ __typename?: 'Flight', id: string, cancelMessageSent?: boolean | null, cancelMessageReason?: string | null, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, visibility?: VisibilityType | null, comment?: string | null, cancelReason?: string | null, balloonCapacityReduction?: any | null, notam?: { __typename?: 'FlightNotamSummary', severity?: NotamSeverity | null, count?: any | null, at?: any | null, noData?: boolean | null } | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, isCurrent?: number | null, name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null, driverLicenseCategory?: DriverLicense | null } | null } | null>, icon: { __typename?: 'Icon', sign: string, color: string }, bookingsData?: { __typename?: 'BookingsData', id?: string | null, count?: any | null, list?: Array<{ __typename?: 'BookingData', id: string, status?: string | null, icon?: string | null, iconColor?: string | null, contactName?: string | null, onlineCheckinAt?: any | null, passengers?: Array<{ __typename?: 'PassengerData', name?: string | null } | null> | null } | null> | null } | null, passengersData?: { __typename?: 'PassengerData', passengersCount?: any | null, passengersWeight?: any | null, freeSpots?: any | null, occupancy?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, openAmount?: any | null } | null, eventsData?: Array<{ __typename?: 'EventData', id: string, description?: string | null } | null> | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetHistoricalFlightsListQueryVariables = Exact<{
  cursor?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  filter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  filterRange?: InputMaybe<FilterRangeInput>;
}>;


export type GetHistoricalFlightsListQuery = { __typename?: 'Query', getHistoricalFlightsList: Array<{ __typename?: 'Flight', id: string, cancelMessageSent?: boolean | null, cancelMessageReason?: string | null, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, visibility?: VisibilityType | null, comment?: string | null, cancelReason?: string | null, balloonCapacityReduction?: any | null, passengersCount?: number | null, passengersOccupancy?: any | null, notam?: { __typename?: 'FlightNotamSummary', severity?: NotamSeverity | null, count?: any | null, at?: any | null, noData?: boolean | null } | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, isCurrent?: number | null, name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null, driverLicenseCategory?: DriverLicense | null } | null } | null>, icon: { __typename?: 'Icon', sign: string, color: string }, bookingsData?: { __typename?: 'BookingsData', id?: string | null, count?: any | null, list?: Array<{ __typename?: 'BookingData', id: string, status?: string | null, contactName?: string | null, onlineCheckinAt?: any | null, passengers?: Array<{ __typename?: 'PassengerData', id?: string | null, name?: string | null } | null> | null } | null> | null } | null, passengersData?: { __typename?: 'PassengerData', passengersCount?: any | null, passengersWeight?: any | null, freeSpots?: any | null, occupancy?: any | null, childCount?: any | null, disabilityCount?: any | null, transportCount?: any | null, openAmount?: any | null } | null, events: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any } | null>, tags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetFlightsListFromDateQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetFlightsListFromDateQuery = { __typename?: 'Query', flightsOfDate: Array<{ __typename?: 'Flight', id: string, cancelMessageSent?: boolean | null, cancelMessageReason?: string | null, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, visibility?: VisibilityType | null, comment?: string | null, cancelReason?: string | null, balloonCapacityReduction?: any | null, passengersCount?: number | null, passengersOccupancy?: any | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, isCurrent?: number | null, name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', availability?: CrewAvailability | null, availabilityReason?: string | null, id: string, name?: string | null, isPilot?: boolean | null, driverLicenseCategory?: DriverLicense | null } | null } | null>, icon: { __typename?: 'Icon', sign: string, color: string }, bookingsData?: { __typename?: 'BookingsData', count?: any | null, list?: Array<{ __typename?: 'BookingData', id: string, status?: string | null, contactName?: string | null, onlineCheckinAt?: any | null, passengers?: Array<{ __typename?: 'PassengerData', name?: string | null } | null> | null } | null> | null } | null, passengerCounters: { __typename?: 'FlightPassengerCounters', passengersWeight: any, freeSpots: any }, events: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any } | null>, eventsData?: Array<{ __typename?: 'EventData', id: string, description?: string | null } | null> | null } | null> };

export type GetFlightsListFromDateCrewQueryVariables = Exact<{
  date: Scalars['String']['input'];
}>;


export type GetFlightsListFromDateCrewQuery = { __typename?: 'Query', flightsOfDateCrew: Array<{ __typename?: 'Flight', id: string, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, visibility?: VisibilityType | null, comment?: string | null, cancelReason?: string | null, balloonCapacityReduction?: any | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, isCurrent?: number | null, name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', availability?: CrewAvailability | null, availabilityReason?: string | null, id: string, name?: string | null, isPilot?: boolean | null, driverLicenseCategory?: DriverLicense | null } | null } | null>, icon: { __typename?: 'Icon', sign: string, color: string } } | null> };

export type FlightSearchCountsQueryVariables = Exact<{
  filter: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  filterRange?: InputMaybe<FilterRangeInput>;
  freeSpots?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FlightSearchCountsQuery = { __typename?: 'Query', flightSearchCounts: { __typename?: 'FlightSearchCounts', upcoming: any, current?: any | null, older?: any | null, historical: any } };

export type FlightCountersQueryVariables = Exact<{ [key: string]: never; }>;


export type FlightCountersQuery = { __typename?: 'Query', flightCounters?: { __typename?: 'FlightCounters', upcoming?: any | null, historical?: any | null, upcomingOlder?: any | null } | null };

export type FlightPeriodsQueryVariables = Exact<{ [key: string]: never; }>;


export type FlightPeriodsQuery = { __typename?: 'Query', flightPeriods?: { __typename?: 'FlightPeriods', day?: Array<{ __typename?: 'FlightPeriodCountersPerPeriod', id?: string | null, startDate?: string | null, endDate?: string | null, label?: string | null, EVE?: { __typename?: 'FlightPeriodCounters', flightsCount: any } | null, MOR?: { __typename?: 'FlightPeriodCounters', flightsCount: any } | null } | null> | null, week?: Array<{ __typename?: 'FlightPeriodCountersPerPeriod', id?: string | null, startDate?: string | null, endDate?: string | null, label?: string | null, EVE?: { __typename?: 'FlightPeriodCounters', flightsCount: any } | null, MOR?: { __typename?: 'FlightPeriodCounters', flightsCount: any } | null } | null> | null, month?: Array<{ __typename?: 'FlightPeriodCountersPerPeriod', id?: string | null, startDate?: string | null, endDate?: string | null, label?: string | null, EVE?: { __typename?: 'FlightPeriodCounters', flightsCount: any } | null, MOR?: { __typename?: 'FlightPeriodCounters', flightsCount: any } | null } | null> | null } | null };

export type SaveFlightMutationVariables = Exact<{
  flightInput: FlightInput;
  flightId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveFlightMutation = { __typename?: 'Mutation', saveFlight: string };

export type DeleteFlightMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type DeleteFlightMutation = { __typename?: 'Mutation', deleteFlight: string };

export type ToggleFlightVisibilityMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type ToggleFlightVisibilityMutation = { __typename?: 'Mutation', toggleFlightVisibility: { __typename?: 'Flight', id: string, visibility?: VisibilityType | null } };

export type ChangeFlightStatusMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
  flightStatus: FlightStatus;
  cancelReason?: InputMaybe<Scalars['String']['input']>;
  cancelMessageSent?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type ChangeFlightStatusMutation = { __typename?: 'Mutation', changeFlightStatus: { __typename?: 'Flight', id: string, status?: FlightStatus | null, cancelReason?: string | null, cancelMessageSent?: boolean | null, cancelMessageReason?: string | null } };

export type RestoreCancelledFlightMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type RestoreCancelledFlightMutation = { __typename?: 'Mutation', restoreCancelledFlight: { __typename?: 'RestoreFlightResult', flight: { __typename?: 'Flight', id: string, status?: FlightStatus | null }, restored: Array<{ __typename?: 'Booking', id: string, contactName?: string | null }>, skipped: Array<{ __typename?: 'SkippedRestoreBooking', bookingId: string, reason: RestoreSkipReason, booking?: { __typename?: 'Booking', id: string, contactName?: string | null } | null }> } };

export type SaveFlightCrewMutationVariables = Exact<{
  flightCrewInput?: InputMaybe<Array<InputMaybe<FlightCrewInput>> | InputMaybe<FlightCrewInput>>;
  flightId: Scalars['ID']['input'];
}>;


export type SaveFlightCrewMutation = { __typename?: 'Mutation', saveFlightCrew: { __typename?: 'Flight', id: string, balloonCapacityReduction?: any | null, date?: any | null, hour?: any | null, hourMeeting?: any | null, period?: FlightPeriod | null, status?: FlightStatus | null, passengersCount?: number | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, callSign?: string | null, capacity?: any | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null, isPilot?: boolean | null, driverLicenseCategory?: DriverLicense | null } | null } | null>, location?: { __typename?: 'Location', id: string, name?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', status?: CrewStatus | null, crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null, isPilot?: boolean | null, isCurrent?: number | null } | null } | null } };

export type AddCrewToFlightFromCalendarMutationVariables = Exact<{
  flightCrewInput?: InputMaybe<FlightCrewInput>;
  flightId: Scalars['ID']['input'];
}>;


export type AddCrewToFlightFromCalendarMutation = { __typename?: 'Mutation', addCrewToFlightFromCalendar: string };

export type SavePilotSignOffMutationVariables = Exact<{
  pilotSignOffInput: PilotSignOffInput;
  flightId: Scalars['ID']['input'];
}>;


export type SavePilotSignOffMutation = { __typename?: 'Mutation', savePilotSignOff: string };

export type SaveFlightLandingMutationVariables = Exact<{
  landingInput: LandingInput;
  flightId: Scalars['ID']['input'];
}>;


export type SaveFlightLandingMutation = { __typename?: 'Mutation', saveFlightLanding: string };

export type SaveCheckinParametersMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
  checkinParametersInput: CheckinParametersInput;
}>;


export type SaveCheckinParametersMutation = { __typename?: 'Mutation', saveCheckinParameters: { __typename?: 'Flight', id: string, hour?: any | null, comment?: string | null, tempTakeoff?: number | null, tempTakeoffManual?: boolean | null, weatherManual?: boolean | null, windGl?: number | null, windGlDirection?: number | null, weatherQnh?: number | null, plannedFlightTime?: any | null, maximumFlightTime?: any | null, maximumFlightTimeManual?: boolean | null, tempBalloon?: any | null, spareFlightTime?: number | null, liftAvailable?: number | null, liftNeeded?: number | null, liftSpare?: number | null, liftWarningLevel?: LiftWarningLevel | null } };

export type ClearPilotSignOffMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type ClearPilotSignOffMutation = { __typename?: 'Mutation', clearPilotSignOff: { __typename?: 'Flight', id: string, pilotSignature?: string | null, pilotSignOffDate?: any | null, pilotComments?: string | null } };

export type GetFlightCheckinLogsQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetFlightCheckinLogsQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', id: string, checkinLogs?: Array<{ __typename?: 'FlightCheckinLog', id: string, user: string, date: any, section: CheckinLogSection, parameter: string, oldValue?: string | null, newValue?: string | null, passengerName?: string | null, signature?: string | null }> | null } };

export type CopyWeatherMutationVariables = Exact<{
  sourceFlightId: Scalars['ID']['input'];
  destinationFlightIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>>;
}>;


export type CopyWeatherMutation = { __typename?: 'Mutation', copyWeather: string };

export type CopyFlightMutationVariables = Exact<{
  sourceFlightId: Scalars['ID']['input'];
  destinationDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CopyFlightMutation = { __typename?: 'Mutation', copyFlight: string };

export type UpdateFlightCommentsMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateFlightCommentsMutation = { __typename?: 'Mutation', updateFlightComments: { __typename?: 'Flight', id: string, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, visibility?: VisibilityType | null, comment?: string | null, crewComments?: string | null, cancelReason?: string | null, balloonCapacityReduction?: any | null, passengersCount?: number | null, passengersOccupancy?: any | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, isCurrent?: number | null, name?: string | null } | null } | null, icon: { __typename?: 'Icon', sign: string, color: string }, bookingsData?: { __typename?: 'BookingsData', id?: string | null, count?: any | null, list?: Array<{ __typename?: 'BookingData', id: string, status?: string | null, contactName?: string | null, onlineCheckinAt?: any | null, passengers?: Array<{ __typename?: 'PassengerData', name?: string | null } | null> | null } | null> | null } | null, passengerCounters: { __typename?: 'FlightPassengerCounters', id: string, passengersWeight: any, freeSpots: any }, events: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any } | null>, tags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } };

export type UpdateFlightTagsMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateFlightTagsMutation = { __typename?: 'Mutation', updateFlightTags: { __typename?: 'Flight', id: string, date?: any | null, period?: FlightPeriod | null, hour?: any | null, hourMeeting?: any | null, status?: FlightStatus | null, visibility?: VisibilityType | null, comment?: string | null, crewComments?: string | null, cancelReason?: string | null, balloonCapacityReduction?: any | null, passengersCount?: number | null, passengersOccupancy?: any | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null, isCurrent?: number | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null, city?: string | null, address?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, isPilot?: boolean | null, isCurrent?: number | null, name?: string | null } | null } | null, icon: { __typename?: 'Icon', sign: string, color: string }, bookingsData?: { __typename?: 'BookingsData', id?: string | null, count?: any | null, list?: Array<{ __typename?: 'BookingData', id: string, status?: string | null, contactName?: string | null, onlineCheckinAt?: any | null, passengers?: Array<{ __typename?: 'PassengerData', name?: string | null } | null> | null } | null> | null } | null, passengerCounters: { __typename?: 'FlightPassengerCounters', id: string, passengersWeight: any, freeSpots: any }, passengersData?: { __typename?: 'PassengerData', passengersCount?: any | null, passengersWeight?: any | null, freeSpots?: any | null, occupancy?: any | null, openAmount?: any | null } | null, events: Array<{ __typename?: 'Event', id: string, description?: string | null, date: any } | null>, tags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null, tagsData?: Array<{ __typename?: 'TagData', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } };

export type SetFlightPublishedMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
  published: Scalars['Boolean']['input'];
}>;


export type SetFlightPublishedMutation = { __typename?: 'Mutation', setFlightPublished: { __typename?: 'Flight', id: string, published?: boolean | null } };

export type GetInvoicesQueryVariables = Exact<{
  input?: InputMaybe<InvoiceListInput>;
}>;


export type GetInvoicesQuery = { __typename?: 'Query', invoices: { __typename?: 'InvoiceConnection', totalCount: number, hasNextPage: boolean, offset: number, invoices: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: string, amountIncludingTax: number, currency: string, invoiceDate: any, status: InvoiceStatus, statusLabel: string }> } };

export type GetInvoiceDownloadQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  invoiceNumber?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetInvoiceDownloadQuery = { __typename?: 'Query', invoiceDownload: { __typename?: 'InvoiceDownload', invoiceId: string, invoiceNumber: string, filename: string, pdfData: string, contentType: string } };

export type GetOrdersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrdersQuery = { __typename?: 'Query', orders: Array<{ __typename?: 'Order', id?: string | null, debtorId: number, debtorCode: string, amountExcludingTax: number, orderDate: any, status: OrderStatus, lines: Array<{ __typename?: 'OrderLine', productCode: string, description: string, quantity: number, unitPrice: number, totalPrice?: number | null, sms?: number | null, plan?: string | null, maxSeats?: number | null }> }> };

export type CreateOrderMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateOrderMutation = { __typename?: 'Mutation', createOrder: { __typename?: 'Order', id?: string | null, debtorId: number, debtorCode: string, amountExcludingTax: number, orderDate: any, status: OrderStatus } };

export type AddOrderLineMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  line: OrderLineInput;
}>;


export type AddOrderLineMutation = { __typename?: 'Mutation', addOrderLine: { __typename?: 'Order', id?: string | null, debtorId: number, debtorCode: string, amountExcludingTax: number, orderDate: any, status: OrderStatus, lines: Array<{ __typename?: 'OrderLine', productCode: string, description: string, quantity: number, unitPrice: number, totalPrice?: number | null }> } };

export type DeleteOrderLineMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
  lineId: Scalars['ID']['input'];
}>;


export type DeleteOrderLineMutation = { __typename?: 'Mutation', deleteOrderLine: { __typename?: 'Order', id?: string | null, debtorId: number, debtorCode: string, amountExcludingTax: number, orderDate: any, status: OrderStatus, lines: Array<{ __typename?: 'OrderLine', productCode: string, description: string, quantity: number, unitPrice: number, totalPrice?: number | null }> } };

export type ConfirmOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ConfirmOrderMutation = { __typename?: 'Mutation', confirmOrder: { __typename?: 'Order', id?: string | null, debtorId: number, debtorCode: string, amountExcludingTax: number, orderDate: any, status: OrderStatus } };

export type DeleteOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type DeleteOrderMutation = { __typename?: 'Mutation', deleteOrder: boolean };

export type ApproveOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type ApproveOrderMutation = { __typename?: 'Mutation', approveOrder: { __typename?: 'Order', id?: string | null, status: OrderStatus } };

export type CancelOrderMutationVariables = Exact<{
  orderId: Scalars['ID']['input'];
}>;


export type CancelOrderMutation = { __typename?: 'Mutation', cancelOrder: { __typename?: 'Order', id?: string | null, status: OrderStatus } };

export type GetWefactDebtorsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetWefactDebtorsQuery = { __typename?: 'Query', wefactDebtors: { __typename?: 'WefactDebtorConnection', totalCount: number, hasNextPage: boolean, offset: number, debtors: Array<{ __typename?: 'WefactDebtor', debtorCode: string, companyName?: string | null, initials?: string | null, surname?: string | null, emailAddress?: string | null }> } };

export type GetLocationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLocationsQuery = { __typename?: 'Query', locations: Array<{ __typename?: 'Location', address?: string | null, city?: string | null, country?: string | null, default?: boolean | null, id: string, latitude?: number | null, longitude?: number | null, name?: string | null, postalCode?: string | null, meetingPointSameAsTakeOff?: boolean | null, meetingPointAddress?: string | null, meetingPointLatitude?: number | null, meetingPointLongitude?: number | null, meetingPointURL?: string | null, meetingPointCity?: string | null, region: Array<{ __typename?: 'Region', color?: string | null, name?: string | null } | null>, contact?: { __typename?: 'LocationContact', name?: string | null, media?: LocationContactMedia | null } | null } | null> };

export type GetLocationQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type GetLocationQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, address?: string | null, city?: string | null, country?: string | null, default?: boolean | null, description?: string | null, height?: any | null, latitude?: number | null, longitude?: number | null, maximumHeight?: number | null, meetingPointSameAsTakeOff?: boolean | null, meetingPointAddress?: string | null, meetingPointLatitude?: number | null, meetingPointLongitude?: number | null, meetingPointURL?: string | null, meetingPointCity?: string | null, name?: string | null, postalCode?: string | null, timezone?: string | null, contact?: { __typename?: 'LocationContact', comment?: string | null, email?: string | null, emailTemplate?: string | null, name?: string | null, phone?: string | null, smsTemplate?: string | null, language?: ContactLanguage | null, media?: LocationContactMedia | null } | null, forecasts?: Array<{ __typename?: 'MeteoblueForecastSlot', slot?: string | null, flyability?: { __typename?: 'FlyabilityAssessment', verdict: FlyabilityVerdict, parameters: Array<{ __typename?: 'FlyabilityParameter', key: string, value?: number | null, band: FlyabilityBand }> } | null, forecast?: { __typename?: 'slotForecast', daytime?: Array<any | null> | null, flytime?: Array<any | null> | null, lastUpdate?: any | null, latitude?: string | null, longitude?: string | null, lowCloudsData?: Array<any | null> | null, pictoCodeData?: Array<any | null> | null, precipitationData?: Array<number | null> | null, pressureData?: Array<any | null> | null, sunrise?: any | null, sunset?: any | null, temperatureData?: Array<any | null> | null, time?: Array<string | null> | null, utc_timeoffset?: number | null, visibilityData?: Array<any | null> | null, windDirectionData?: Array<number | null> | null, windDirectionData_1000?: Array<number | null> | null, windDirectionData_500?: Array<number | null> | null, windDirectionData_550?: Array<number | null> | null, windDirectionData_600?: Array<number | null> | null, windDirectionData_650?: Array<number | null> | null, windDirectionData_700?: Array<number | null> | null, windDirectionData_750?: Array<number | null> | null, windDirectionData_800?: Array<number | null> | null, windDirectionData_925?: Array<number | null> | null, windDirectionData_950?: Array<number | null> | null, windDirectionData_975?: Array<number | null> | null, windGustData?: Array<number | null> | null, windSpeedData?: Array<number | null> | null, windSpeedData_1000?: Array<number | null> | null, windSpeedData_500?: Array<number | null> | null, windSpeedData_550?: Array<number | null> | null, windSpeedData_600?: Array<number | null> | null, windSpeedData_650?: Array<number | null> | null, windSpeedData_700?: Array<number | null> | null, windSpeedData_750?: Array<number | null> | null, windSpeedData_800?: Array<number | null> | null, windSpeedData_925?: Array<number | null> | null, windSpeedData_950?: Array<number | null> | null, windSpeedData_975?: Array<number | null> | null, datepart?: Array<{ __typename?: 'DatePart', part?: DatePartType | null, text?: string | null } | null> | null } | null } | null> | null, region: Array<{ __typename?: 'Region', color?: string | null, id: string, name?: string | null } | null>, windDirections?: { __typename?: 'WindDirections', N?: any | null, NNE?: any | null, NE?: any | null, ENE?: any | null, E?: any | null, ESE?: any | null, SE?: any | null, SSE?: any | null, S?: any | null, SSW?: any | null, SW?: any | null, WSW?: any | null, W?: any | null, WNW?: any | null, NW?: any | null, NNW?: any | null } | null } };

export type GetGeocodeQueryVariables = Exact<{
  address: Scalars['String']['input'];
}>;


export type GetGeocodeQuery = { __typename?: 'Query', geocode: Array<{ __typename?: 'GeocodeResult', geometry?: { __typename?: 'Geometry', location?: { __typename?: 'Mapslocation', lat?: number | null, lng?: number | null } | null } | null, elevation?: Array<{ __typename?: 'ElevationResult', elevation: number } | null> | null } | null> };

export type ReverseGeocodeQueryVariables = Exact<{
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
}>;


export type ReverseGeocodeQuery = { __typename?: 'Query', reverseGeocode?: string | null };

export type SaveLocationMutationVariables = Exact<{
  locationInput: LocationInput;
  regions: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
  locationId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveLocationMutation = { __typename?: 'Mutation', saveLocation: string };

export type DeleteLocationMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type DeleteLocationMutation = { __typename?: 'Mutation', deleteLocation: string };

export type UpdateMeteoMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  flightId: Scalars['ID']['input'];
}>;


export type UpdateMeteoMutation = { __typename?: 'Mutation', updateMeteo?: boolean | null };

export type GetLogbookQueryVariables = Exact<{
  logbookId: Scalars['ID']['input'];
}>;


export type GetLogbookQuery = { __typename?: 'Query', logbook: { __typename?: 'LogBook', id?: string | null, type: LogBookType, logsCount?: any | null, startDate?: any | null, initialHours?: any | null, initialFlights?: any | null, balloon?: { __typename?: 'Balloon', id: string, callSign?: string | null, FlightAppKey?: string | null, FlightAppAircraftDetails?: { __typename?: 'FlightAppAircraftDetails', total_flight_duration?: number | null } | null } | null, pilot?: { __typename?: 'Crew', id: string } | null, logs: Array<{ __typename?: 'Log', id?: string | null, flightDate?: any | null, arrivalDateTime?: any | null, arrivalLocation?: string | null, flightDuration?: any | null, passengerCount?: any | null, crew?: string | null, remarks?: string | null, takeoffDateTime?: any | null, takeoffLocation?: string | null, refuelVolume?: any | null, source?: string | null, sourceId?: string | null, FlightAppId?: string | null, balloon?: { __typename?: 'LogBalloon', callSign?: string | null, manufacturer?: string | null, model?: string | null } | null, pic?: { __typename?: 'LogPic', email?: string | null, name?: string | null, role?: string | null } | null } | null>, FlightAppLogList?: { __typename?: 'FlightAppLogList', meta?: any | null } | null } };

export type GetLogbooksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLogbooksQuery = { __typename?: 'Query', logbooks: Array<{ __typename?: 'LogBook', id?: string | null, type: LogBookType, logsCount?: any | null, balloon?: { __typename?: 'Balloon', id: string } | null, pilot?: { __typename?: 'Crew', id: string } | null } | null> };

export type LogFragmentFragment = { __typename?: 'Log', id?: string | null, flightDate?: any | null, arrivalDateTime?: any | null, arrivalLocation?: string | null, flightDuration?: any | null, passengerCount?: any | null, crew?: string | null, remarks?: string | null, takeoffDateTime?: any | null, takeoffLocation?: string | null, refuelVolume?: any | null, source?: string | null, sourceId?: string | null, FlightAppId?: string | null, balloon?: { __typename?: 'LogBalloon', callSign?: string | null, manufacturer?: string | null, model?: string | null } | null, pic?: { __typename?: 'LogPic', email?: string | null, name?: string | null, role?: string | null } | null };

export type CreateBalloonLogbookMutationVariables = Exact<{
  balloonId: Scalars['ID']['input'];
}>;


export type CreateBalloonLogbookMutation = { __typename?: 'Mutation', createBalloonLogbook: string };

export type CreatePilotLogbookMutationVariables = Exact<{
  pilotId: Scalars['ID']['input'];
}>;


export type CreatePilotLogbookMutation = { __typename?: 'Mutation', createPilotLogbook: string };

export type SaveLogsMutationVariables = Exact<{
  logbookId: Scalars['ID']['input'];
  logs: Array<InputMaybe<LogInput>> | InputMaybe<LogInput>;
}>;


export type SaveLogsMutation = { __typename?: 'Mutation', saveLogs?: any | null };

export type DeleteLogbookLogMutationVariables = Exact<{
  logbookId: Scalars['ID']['input'];
  logId: Scalars['ID']['input'];
}>;


export type DeleteLogbookLogMutation = { __typename?: 'Mutation', deleteLogbookLog: string };

export type SaveAircraftLogsToFlightAppMutationVariables = Exact<{
  logbookId: Scalars['ID']['input'];
  logs: Array<InputMaybe<LogInput>> | InputMaybe<LogInput>;
}>;


export type SaveAircraftLogsToFlightAppMutation = { __typename?: 'Mutation', saveAircraftLogsToFlightApp?: any | null };

export type UpdateLogbookSettingsMutationVariables = Exact<{
  logbookId: Scalars['ID']['input'];
  settings: LogBookSettingsInput;
}>;


export type UpdateLogbookSettingsMutation = { __typename?: 'Mutation', updateLogbookSettings: boolean };

export type GetSkeyesForecastQueryVariables = Exact<{
  slot: Scalars['String']['input'];
}>;


export type GetSkeyesForecastQuery = { __typename?: 'Query', getSkeyesForecast?: { __typename?: 'SkeyesForecast', id?: string | null, datetime?: any | null, full?: string | null, inversions?: string | null, issued?: any | null, outlook?: string | null, period?: string | null, slot?: string | null, weather?: string | null, winds?: string | null } | null };

export type FetchSkeyesForecastQueryVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
  flightId: Scalars['ID']['input'];
}>;


export type FetchSkeyesForecastQuery = { __typename?: 'Query', fetchSkeyesForecast?: { __typename?: 'FlightSkeyesForecast', username?: string | null, date?: any | null, forecast?: { __typename?: 'SkeyesForecast', datetime?: any | null, full?: string | null, inversions?: string | null, issued?: any | null, outlook?: string | null, period?: string | null, slot?: string | null, weather?: string | null, winds?: string | null } | null } | null };

export type MontyStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MontyStatusQuery = { __typename?: 'Query', montyStatus: { __typename?: 'MontyStatusInfo', status: MontyTenantStatus, since?: any | null, lastOkAt?: any | null } };

export type MontyUsageQueryVariables = Exact<{
  months?: InputMaybe<Scalars['Int']['input']>;
}>;


export type MontyUsageQuery = { __typename?: 'Query', montyUsage: Array<{ __typename?: 'MontyUsageMonth', month: string, classifications: number, proposals: number, learnRuns: number, inTokens: number, outTokens: number, estimatedCostEur: number }> };

export type SaveMontyApiKeyMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type SaveMontyApiKeyMutation = { __typename?: 'Mutation', saveMontyApiKey: { __typename?: 'MontyKeyResult', ok: boolean, status: MontyTenantStatus, error?: string | null } };

export type RemoveMontyApiKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type RemoveMontyApiKeyMutation = { __typename?: 'Mutation', removeMontyApiKey: { __typename?: 'MontyKeyResult', ok: boolean, status: MontyTenantStatus, error?: string | null } };

export type AcceptMontyActionMutationVariables = Exact<{
  messagePath: Scalars['String']['input'];
  flightId?: InputMaybe<Scalars['String']['input']>;
}>;


export type AcceptMontyActionMutation = { __typename?: 'Mutation', acceptMontyAction: { __typename?: 'MontyActionResult', ok: boolean, failureReason?: string | null } };

export type ResolveMontyProposalMutationVariables = Exact<{
  messagePath: Scalars['String']['input'];
  resolution: MontyProposalStatus;
}>;


export type ResolveMontyProposalMutation = { __typename?: 'Mutation', resolveMontyProposal: boolean };

export type MontyInstructionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MontyInstructionsQuery = { __typename?: 'Query', montyInstructions: Array<{ __typename?: 'MontyInstructions', tag: MontyTag, manual: string, learnedDraft?: string | null, updatedAt?: any | null, updatedBy?: string | null, learnedFrom?: { __typename?: 'MontyLearnedFrom', months: number, msgCount: number, at?: any | null } | null }> };

export type SaveMontyInstructionsMutationVariables = Exact<{
  tag: MontyTag;
  manual: Scalars['String']['input'];
  learnedDraft?: InputMaybe<Scalars['String']['input']>;
}>;


export type SaveMontyInstructionsMutation = { __typename?: 'Mutation', saveMontyInstructions: { __typename?: 'MontyInstructions', tag: MontyTag, manual: string, learnedDraft?: string | null, updatedAt?: any | null, updatedBy?: string | null, learnedFrom?: { __typename?: 'MontyLearnedFrom', months: number, msgCount: number, at?: any | null } | null } };

export type MontyLearnEstimateQueryVariables = Exact<{ [key: string]: never; }>;


export type MontyLearnEstimateQuery = { __typename?: 'Query', montyLearnEstimate: Array<{ __typename?: 'MontyLearnEstimate', months: number, messageCount: number, estimatedCostEur: number }> };

export type MontyLearnRunQueryVariables = Exact<{ [key: string]: never; }>;


export type MontyLearnRunQuery = { __typename?: 'Query', montyLearnRun?: { __typename?: 'MontyLearnRun', id: string, months: number, state: MontyLearnState, phase: string, totalMessages: number, taggedMessages: number, alreadyTaggedMessages: number, estimatedCostEur: number, startedAt?: any | null, startedBy?: string | null, finishedAt?: any | null } | null };

export type StartMontyLearnRunMutationVariables = Exact<{
  months: Scalars['Int']['input'];
}>;


export type StartMontyLearnRunMutation = { __typename?: 'Mutation', startMontyLearnRun: { __typename?: 'MontyLearnRun', id: string, months: number, state: MontyLearnState, phase: string, totalMessages: number, taggedMessages: number, alreadyTaggedMessages: number, estimatedCostEur: number, startedAt?: any | null, startedBy?: string | null, finishedAt?: any | null } };

export type CancelMontyLearnRunMutationVariables = Exact<{
  runId: Scalars['String']['input'];
}>;


export type CancelMontyLearnRunMutation = { __typename?: 'Mutation', cancelMontyLearnRun: boolean };

export type ResumeMontyLearnRunMutationVariables = Exact<{
  runId: Scalars['String']['input'];
}>;


export type ResumeMontyLearnRunMutation = { __typename?: 'Mutation', resumeMontyLearnRun?: { __typename?: 'MontyLearnRun', id: string, months: number, state: MontyLearnState, phase: string, totalMessages: number, taggedMessages: number, alreadyTaggedMessages: number, estimatedCostEur: number, startedAt?: any | null, startedBy?: string | null, finishedAt?: any | null } | null };

export type MyWeekQueryVariables = Exact<{
  year: Scalars['PositiveInt']['input'];
  week: Scalars['PositiveInt']['input'];
}>;


export type MyWeekQuery = { __typename?: 'Query', myWeek: { __typename?: 'MyWeek', crewId?: string | null, crewName?: string | null, days?: Array<{ __typename?: 'CalendarWeekDay', date?: string | null, sunrise?: string | null, sunset?: string | null } | null> | null, availability?: Array<{ __typename?: 'Event', id: string, date: any, period?: FlightPeriod | null, availability?: CrewAvailability | null } | null> | null, flights?: Array<{ __typename?: 'Flight', id: string, date?: any | null, hour?: any | null, period?: FlightPeriod | null, status?: FlightStatus | null, published?: boolean | null, myCrewStatus?: CrewStatus | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null, pilot?: { __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null } | null } | null, groundCrews: Array<{ __typename?: 'CrewInFlight', crew?: { __typename?: 'CrewPerFlight', id: string, name?: string | null } | null } | null> } | null> | null } };

export type ConfirmMyFlightMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type ConfirmMyFlightMutation = { __typename?: 'Mutation', confirmMyFlight: { __typename?: 'Flight', id: string, myCrewStatus?: CrewStatus | null } };

export type JoinFlightAsCrewMutationVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type JoinFlightAsCrewMutation = { __typename?: 'Mutation', joinFlightAsCrew: { __typename?: 'Flight', id: string, myCrewStatus?: CrewStatus | null } };

export type NotamInfoFieldsFragment = { __typename?: 'NotamInfo', id: string, designator: string, fir: string, category: NotamCategory, severity: NotamSeverity, validFrom?: any | null, validTo?: any | null, schedule?: string | null, lowerFt?: any | null, upperFt?: any | null, lat?: number | null, lng?: number | null, radiusKm?: number | null, distanceKm?: number | null, bearingDeg?: number | null, wideArea?: boolean | null, text: string };

export type NotamAssessmentFieldsFragment = { __typename?: 'NotamAssessment', severity?: NotamSeverity | null, count: any, updatedAt?: any | null, stale: boolean, noData?: boolean | null, notams: Array<{ __typename?: 'NotamInfo', id: string, designator: string, fir: string, category: NotamCategory, severity: NotamSeverity, validFrom?: any | null, validTo?: any | null, schedule?: string | null, lowerFt?: any | null, upperFt?: any | null, lat?: number | null, lng?: number | null, radiusKm?: number | null, distanceKm?: number | null, bearingDeg?: number | null, wideArea?: boolean | null, text: string }>, wideAreaNotams: Array<{ __typename?: 'NotamInfo', id: string, designator: string, fir: string, category: NotamCategory, severity: NotamSeverity, validFrom?: any | null, validTo?: any | null, schedule?: string | null, lowerFt?: any | null, upperFt?: any | null, lat?: number | null, lng?: number | null, radiusKm?: number | null, distanceKm?: number | null, bearingDeg?: number | null, wideArea?: boolean | null, text: string }> };

export type GetFlightNotamAssessmentQueryVariables = Exact<{
  flightId: Scalars['ID']['input'];
}>;


export type GetFlightNotamAssessmentQuery = { __typename?: 'Query', flight: { __typename?: 'Flight', id: string, notamAssessment?: { __typename?: 'NotamAssessment', severity?: NotamSeverity | null, count: any, updatedAt?: any | null, stale: boolean, noData?: boolean | null, notams: Array<{ __typename?: 'NotamInfo', id: string, designator: string, fir: string, category: NotamCategory, severity: NotamSeverity, validFrom?: any | null, validTo?: any | null, schedule?: string | null, lowerFt?: any | null, upperFt?: any | null, lat?: number | null, lng?: number | null, radiusKm?: number | null, distanceKm?: number | null, bearingDeg?: number | null, wideArea?: boolean | null, text: string }>, wideAreaNotams: Array<{ __typename?: 'NotamInfo', id: string, designator: string, fir: string, category: NotamCategory, severity: NotamSeverity, validFrom?: any | null, validTo?: any | null, schedule?: string | null, lowerFt?: any | null, upperFt?: any | null, lat?: number | null, lng?: number | null, radiusKm?: number | null, distanceKm?: number | null, bearingDeg?: number | null, wideArea?: boolean | null, text: string }> } | null } };

export type GetLocationNotamAssessmentQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  period: FlightPeriod;
}>;


export type GetLocationNotamAssessmentQuery = { __typename?: 'Query', locationNotamAssessment?: { __typename?: 'NotamAssessment', severity?: NotamSeverity | null, count: any, updatedAt?: any | null, stale: boolean, noData?: boolean | null, notams: Array<{ __typename?: 'NotamInfo', id: string, designator: string, fir: string, category: NotamCategory, severity: NotamSeverity, validFrom?: any | null, validTo?: any | null, schedule?: string | null, lowerFt?: any | null, upperFt?: any | null, lat?: number | null, lng?: number | null, radiusKm?: number | null, distanceKm?: number | null, bearingDeg?: number | null, wideArea?: boolean | null, text: string }>, wideAreaNotams: Array<{ __typename?: 'NotamInfo', id: string, designator: string, fir: string, category: NotamCategory, severity: NotamSeverity, validFrom?: any | null, validTo?: any | null, schedule?: string | null, lowerFt?: any | null, upperFt?: any | null, lat?: number | null, lng?: number | null, radiusKm?: number | null, distanceKm?: number | null, bearingDeg?: number | null, wideArea?: boolean | null, text: string }> } | null };

export type GetLocationNotamSummariesQueryVariables = Exact<{
  locationIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  date: Scalars['Date']['input'];
  period: FlightPeriod;
}>;


export type GetLocationNotamSummariesQuery = { __typename?: 'Query', locationNotamSummaries: Array<{ __typename?: 'LocationNotamSummary', locationId: string, severity?: NotamSeverity | null, count: any, stale: boolean }> };

export type GetAutorouterStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAutorouterStatusQuery = { __typename?: 'Query', autorouterStatus: { __typename?: 'AutorouterConnection', status: AutorouterStatus, account?: string | null, connectedAt?: any | null } };

export type DisconnectAutorouterMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectAutorouterMutation = { __typename?: 'Mutation', disconnectAutorouter: { __typename?: 'AutorouterConnection', status: AutorouterStatus, account?: string | null, connectedAt?: any | null } };

export type QuestionsQueryVariables = Exact<{
  active?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type QuestionsQuery = { __typename?: 'Query', questions: Array<{ __typename?: 'Question', id: string, active?: boolean | null, code?: QuestionTemplate | null, kind?: QuestionKind | null, content?: { __typename?: 'QuestionContent', order: any, description?: Array<{ __typename?: 'MLText', lang?: ContactLanguage | null, text?: string | null } | null> | null, title: Array<{ __typename?: 'MLText', lang?: ContactLanguage | null, text?: string | null } | null> } | null } | null> };

export type SaveQuestionTextMutationVariables = Exact<{
  questionInput: QuestionInput;
  questionId: Scalars['ID']['input'];
}>;


export type SaveQuestionTextMutation = { __typename?: 'Mutation', saveQuestionText: string };

export type SaveQuestionOrderMutationVariables = Exact<{
  order: Scalars['NonNegativeInt']['input'];
  questionId: Scalars['ID']['input'];
}>;


export type SaveQuestionOrderMutation = { __typename?: 'Mutation', saveQuestionOrder: string };

export type ToggleQuestionActiveMutationVariables = Exact<{
  questionId: Scalars['ID']['input'];
}>;


export type ToggleQuestionActiveMutation = { __typename?: 'Mutation', toggleQuestionActive: string };

export type GetRegionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRegionsQuery = { __typename?: 'Query', regions: Array<{ __typename?: 'Region', color?: string | null, defaultColor?: string | null, id: string, name?: string | null, countOpenBookings?: any | null, locations: Array<{ __typename?: 'Location', name?: string | null, id: string } | null> } | null> };

export type GetRegionQueryVariables = Exact<{
  regionId: Scalars['ID']['input'];
}>;


export type GetRegionQuery = { __typename?: 'Query', region: { __typename?: 'Region', color?: string | null, defaultColor?: string | null, name?: string | null, id: string, countOpenBookings?: any | null, locations: Array<{ __typename?: 'Location', name?: string | null, latitude?: number | null, longitude?: number | null, id: string } | null> } };

export type SaveRegionMutationVariables = Exact<{
  regionInput: RegionInput;
  regionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveRegionMutation = { __typename?: 'Mutation', saveRegion: string };

export type DeleteRegionMutationVariables = Exact<{
  regionId: Scalars['ID']['input'];
  targetRegionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteRegionMutation = { __typename?: 'Mutation', deleteRegion: string };

export type GetReportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReportsQuery = { __typename?: 'Query', reports?: { __typename?: 'Reports', flights?: any | null, bookings?: any | null, bookingsOpen?: any | null, vouchers?: any | null, payments?: any | null, sms?: any | null } | null };

export type ServerStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ServerStatusQuery = { __typename?: 'Query', serverStatus?: { __typename?: 'ServerStatus', maintenance?: boolean | null, start?: any | null, purpose?: string | null, expectedDuration?: any | null } | null };

export type SaveLanguageSettingMutationVariables = Exact<{
  systemLanguage: Scalars['String']['input'];
}>;


export type SaveLanguageSettingMutation = { __typename?: 'Mutation', saveLanguageSetting: string };

export type SmsByBookingQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type SmsByBookingQuery = { __typename?: 'Query', smsByBooking?: Array<{ __typename?: 'Sms', direction?: SmsDirection | null, text?: string | null, provider?: SmsProvider | null, fallbackUsed?: boolean | null, date?: { __typename?: 'SmsDates', sms?: any | null, read?: any | null } | null, eventSummary?: { __typename?: 'SmsEventSummary', status?: string | null, error?: string | null } | null } | null> | null };

export type SmsByCrewQueryVariables = Exact<{
  crewId: Scalars['ID']['input'];
}>;


export type SmsByCrewQuery = { __typename?: 'Query', smsByCrew?: Array<{ __typename?: 'Sms', direction?: SmsDirection | null, text?: string | null, provider?: SmsProvider | null, fallbackUsed?: boolean | null, date?: { __typename?: 'SmsDates', sms?: any | null, read?: any | null } | null, eventSummary?: { __typename?: 'SmsEventSummary', status?: string | null, error?: string | null } | null } | null> | null };

export type GetAllSmsTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSmsTemplatesQuery = { __typename?: 'Query', getAllSmsTemplates: Array<{ __typename?: 'SmsTemplate', id: string, type: string, label?: string | null, reasonCode?: string | null, template: { __typename?: 'Template', en: string, fr: string, nl: string, de: string } } | null> };

export type GetSmsTemplatesQueryVariables = Exact<{
  type: Scalars['String']['input'];
}>;


export type GetSmsTemplatesQuery = { __typename?: 'Query', getSmsTemplates: Array<{ __typename?: 'SmsTemplate', id: string, type: string, label?: string | null, reasonCode?: string | null, template: { __typename?: 'Template', en: string, fr: string, nl: string, de: string } } | null> };

export type WhatsappLoginQueryVariables = Exact<{ [key: string]: never; }>;


export type WhatsappLoginQuery = { __typename?: 'Query', whatsappLogin?: { __typename?: 'WhatsappLogin', code?: string | null, message?: string | null, results?: { __typename?: 'WhatsappLoginResults', qr_duration?: any | null, qr_image?: string | null } | null } | null };

export type WhatsappLogoutQueryVariables = Exact<{ [key: string]: never; }>;


export type WhatsappLogoutQuery = { __typename?: 'Query', whatsappLogout?: { __typename?: 'WhatsappLogout', code?: string | null, message?: string | null, results?: any | null } | null };

export type WhatsappDevicesQueryVariables = Exact<{ [key: string]: never; }>;


export type WhatsappDevicesQuery = { __typename?: 'Query', whatsappDevices?: { __typename?: 'WhatsappDevices', code?: string | null, message?: string | null, results?: Array<{ __typename?: 'WhatsappDevicesResults', name?: string | null, device?: string | null, jid?: string | null } | null> | null } | null };

export type WhatsappConnectionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type WhatsappConnectionStatusQuery = { __typename?: 'Query', whatsappConnectionStatus: { __typename?: 'WhatsAppConnectionStatus', connected: boolean, lastSeen?: any | null, deviceInfo?: string | null } };

export type MarkBookingMessagesReadMutationVariables = Exact<{
  bookingIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type MarkBookingMessagesReadMutation = { __typename?: 'Mutation', markBookingMessagesRead?: Array<string | null> | null };

export type AddSmsTemplateLocationContactMutationVariables = Exact<{ [key: string]: never; }>;


export type AddSmsTemplateLocationContactMutation = { __typename?: 'Mutation', addSmsTemplateLocationContact?: { __typename?: 'SmsTemplate', id: string, type: string, template: { __typename?: 'Template', en: string, fr: string, nl: string, de: string } } | null };

export type MarkCrewMessagesReadMutationVariables = Exact<{
  crewIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MarkCrewMessagesReadMutation = { __typename?: 'Mutation', markCrewMessagesRead?: Array<string | null> | null };

export type SaveSmsTemplateMutationVariables = Exact<{
  smsTemplateInput: SmsTemplateInput;
  smsTemplateId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveSmsTemplateMutation = { __typename?: 'Mutation', saveSmsTemplate?: { __typename?: 'SmsTemplate', id: string, type: string, label?: string | null, reasonCode?: string | null, template: { __typename?: 'Template', en: string, fr: string, nl: string, de: string } } | null };

export type RemoveSmsTemplateMutationVariables = Exact<{
  smsTemplateId: Scalars['ID']['input'];
}>;


export type RemoveSmsTemplateMutation = { __typename?: 'Mutation', removeSmsTemplate?: string | null };

export type SendBookingSmsMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  smsInput: SmsInput;
}>;


export type SendBookingSmsMutation = { __typename?: 'Mutation', sendBookingSms?: string | null };

export type SendBookingMessageMutationVariables = Exact<{
  bookingId: Scalars['ID']['input'];
  messageInput: MessageInput;
}>;


export type SendBookingMessageMutation = { __typename?: 'Mutation', sendBookingMessage?: string | null };

export type SendCrewMessageMutationVariables = Exact<{
  crewId: Scalars['ID']['input'];
  messageInput: MessageInput;
}>;


export type SendCrewMessageMutation = { __typename?: 'Mutation', sendCrewMessage?: string | null };

export type SendLocationSmsMutationVariables = Exact<{
  locationId: Scalars['ID']['input'];
  flightId: Scalars['ID']['input'];
  smsInput: SmsInput;
}>;


export type SendLocationSmsMutation = { __typename?: 'Mutation', sendLocationSms?: string | null };

export type SendCrewSmsMutationVariables = Exact<{
  crewId: Scalars['ID']['input'];
  smsInput: SmsInput;
}>;


export type SendCrewSmsMutation = { __typename?: 'Mutation', sendCrewSms?: string | null };

export type SunriseSunsetQueryVariables = Exact<{
  sunriseSunsetInput: SunriseSunsetInput;
}>;


export type SunriseSunsetQuery = { __typename?: 'Query', sunriseSunset: { __typename?: 'SunriseSunset', sunrise?: string | null, sunset?: string | null, morningFlight?: string | null, eveningFlight?: string | null } };

export type GetAllTagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTagsQuery = { __typename?: 'Query', getAllTags: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, allowedFlightTags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null } | null> | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetAllTagsWithCountersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllTagsWithCountersQuery = { __typename?: 'Query', getAllTags: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, upcoming?: any | null, history?: any | null, allowedFlightTags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null } | null> | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, upcoming?: any | null, history?: any | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetTagQueryVariables = Exact<{
  tagId: Scalars['ID']['input'];
}>;


export type GetTagQuery = { __typename?: 'Query', getTag: { __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, allowedFlightTags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null } | null> | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } };

export type GetTagWithCountersQueryVariables = Exact<{
  tagId: Scalars['ID']['input'];
}>;


export type GetTagWithCountersQuery = { __typename?: 'Query', getTag: { __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, upcoming?: any | null, history?: any | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, upcoming?: any | null, history?: any | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } };

export type GetTagsOfTypeQueryVariables = Exact<{
  tagType: TagType;
}>;


export type GetTagsOfTypeQuery = { __typename?: 'Query', getTagsOfType: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetTagsOfTypeWithCountersQueryVariables = Exact<{
  tagType: TagType;
}>;


export type GetTagsOfTypeWithCountersQuery = { __typename?: 'Query', getTagsOfType: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, upcoming?: any | null, history?: any | null, allowedFlightTags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null } | null> | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, upcoming?: any | null, history?: any | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetTagsOfTypeWithUpcomingCountersQueryVariables = Exact<{
  tagType: TagType;
}>;


export type GetTagsOfTypeWithUpcomingCountersQuery = { __typename?: 'Query', getTagsOfType: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, upcoming?: any | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, upcoming?: any | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type GetTagsOfTypeWithHistoryCountersQueryVariables = Exact<{
  tagType: TagType;
}>;


export type GetTagsOfTypeWithHistoryCountersQuery = { __typename?: 'Query', getTagsOfType: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, history?: any | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, history?: any | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } | null> };

export type SaveTagMutationVariables = Exact<{
  tagInput: TagInput;
  tagId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveTagMutation = { __typename?: 'Mutation', saveTag: { __typename?: 'BookingTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, allowedFlightTags?: Array<{ __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null } | null> | null } | { __typename?: 'FlightTag', id: string, tag?: string | null, type?: TagType | null, backgroundColor?: string | null, fontColor?: string | null, enabled?: boolean | null, locked?: boolean | null, dashboard?: boolean | null, onlyAllowedFlightTags?: boolean | null, bookingTags?: Array<{ __typename?: 'BookingTag', id: string, tag?: string | null, backgroundColor?: string | null, fontColor?: string | null } | null> | null } };

export type DeleteTagMutationVariables = Exact<{
  tagId: Scalars['ID']['input'];
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: string };

export type TenantActionsQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantActionsQuery = { __typename?: 'Query', tenantActions: Array<{ __typename?: 'TenantAction', type: TenantActionType, severity: TenantActionSeverity, since: any, deepLinkRoute: string }> };

export type GetTenantSettingQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantSettingQuery = { __typename?: 'Query', tenantSetting?: { __typename?: 'TenantSetting', id: string, apiKey?: string | null, upEnabled?: boolean | null, icsId?: string | null, tenantId: string, name?: string | null, mailFrom?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, mailReplyTo?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, mailAccountant?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, locationOptions?: { __typename?: 'LocationOptions', defaultLocation?: { __typename?: 'Location', id: string } | null } | null, operatorSettings?: { __typename?: 'OperatorSettings', id: string, currency?: TenantCurrency | null, timezone?: string | null, twoFAEnabled?: boolean | null, backup?: { __typename?: 'OperatorSettingsBackup', active?: boolean | null, email?: string | null } | null, bookings?: { __typename?: 'OperatorSettingsBookings', childAge?: any | null, flightOptionsCount?: any | null, showPayments?: boolean | null, showHistoryCompletedBookings?: boolean | null, disabledPaymentTypes?: Array<string | null> | null, sources?: Array<string | null> | null } | null, crew?: { __typename?: 'OperatorSettingsCrew', shareBookings?: boolean | null, allowFlightSelection?: boolean | null, shareEvents?: boolean | null, shareFlightTags?: boolean | null, crewReadyChannel?: CrewReadyChannel | null, crewReadyLanguage?: SystemLanguage | null, crewReadyInstructions?: string | null, crewReadyIncludePassengers?: boolean | null, crewReadyIncludeTrajectory?: boolean | null } | null, displayedColumns?: { __typename?: 'DisplayedColumns', flightsUpcoming?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsUpcomingDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsBooking?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsBookingDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsHistory?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsHistoryDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsOpen?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsOpenDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsHistory?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsHistoryDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsPayment?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsPaymentDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsDashboard?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsDashboardDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlight?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightEnd?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightEndDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightCancelled?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightCancelledDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightAll?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightAllDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightPayment?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightPaymentDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null } | null, notifications?: { __typename?: 'OperatorSettingsNotifications', calendar?: boolean | null, calendarClosing?: string | null, flightCrew?: boolean | null } | null, flights?: { __typename?: 'OperatorSettingsFlights', sunriseOffset?: any | null, sunsetOffset?: any | null, meetingTimeOffset?: any | null, cancelReasons?: Array<string | null> | null, defaultPeriod?: FlightPeriod | null, flightDuplicateProtection?: boolean | null } | null, sms?: { __typename?: 'OperatorSettingsSms', footerEnabled?: boolean | null } | null, manifest?: { __typename?: 'OperatorSettingsManifest', footer?: Array<string | null> | null, pilotDeclaration?: Array<string | null> | null } | null, myflight?: { __typename?: 'OperatorSettingsMyflight', id: string, autoConfirm?: boolean | null, autoConfirmAPI?: boolean | null, autoConfirmEmailTemplate?: string | null, flights?: MyflightFlights | null, endOfSeason?: boolean | null, checkinMode?: CheckinMode | null, checkinDaysBefore?: any | null, checkinInstructions?: string | null } | null, trajectoryProfile?: Array<{ __typename?: 'TrajectoryProfile', duration?: any | null, level?: any | null } | null> | null, weatherSource?: { __typename?: 'OperatorSettingsWeatherSource', mode?: WeatherSourceMode | null, mapping?: Array<{ __typename?: 'WeatherSourceMapping', country?: string | null, source?: string | null } | null> | null } | null } | null, dashboardOptions?: { __typename?: 'DashboardOptions', preferredDateToday?: boolean | null, recent?: any | null, toConfirm?: boolean | null } | null, subscription?: { __typename?: 'Subscription', custom?: boolean | null, gracePeriodDays?: any | null, planState: PlanState, isBlocked: boolean, plan?: { __typename?: 'SubscriptionPlan', valid?: boolean | null, status?: SubscriptionPlanStatus | null, validUntil?: any | null, invalidSince?: any | null, expiredSince?: any | null, suggestedUpgrade?: SubscriptionPlanEnum | null, suggestedOrderLines?: Array<{ __typename?: 'OrderLine', productCode: string, description: string, descriptionEn: string, descriptionDe: string, descriptionFr: string, quantity: number, unitPrice: number, totalPrice?: number | null, plan?: string | null, maxSeats?: number | null, type?: string | null, periodStart?: any | null, periodEnd?: any | null } | null> | null } | null, sms?: { __typename?: 'SubscriptionSMS', available?: any | null, used?: any | null, pctUsed?: any | null, ignoreWarning?: boolean | null, status?: SubscriptionSmsStatus | null, usedSMS?: Array<{ __typename?: 'usedSMS', year?: any | null, month?: any | null, used?: any | null, usedWA?: any | null, waUtility?: any | null, waService?: any | null, waMarketing?: any | null, waAuthentication?: any | null, waBillable?: any | null, waFree?: any | null, waEstimatedCost?: number | null } | null> | null, suggestedOrderLines?: Array<{ __typename?: 'OrderLine', productCode: string, description: string, descriptionEn: string, descriptionDe: string, descriptionFr: string, quantity: number, unitPrice: number, totalPrice?: number | null, sms?: number | null, periodStart?: any | null, periodEnd?: any | null } | null> | null } | null } | null, whatsapp?: { __typename?: 'WhatsappSettings', enabled: boolean, fallbackSms?: boolean | null, provider?: WhatsappProvider | null } | null, messageRetention?: { __typename?: 'MessageRetention', closedBookingsYears?: any | null, crewYears?: any | null } | null, integrations?: { __typename?: 'Integrations', callbackUrl?: string | null, FlightApp?: { __typename?: 'FlightAppIntegration', keys?: Array<{ __typename?: 'FlightAppApiKey', key?: string | null, valid?: boolean | null, pilotIds?: { __typename?: 'FlightAppPilot', id?: string | null, pilotId?: string | null, pilot?: { __typename?: 'FlightAppPilotDetails', number_of_entries?: any | null, total_flight_time?: any | null, total_flight_time_in_hours?: number | null, license_number?: string | null, pilot?: { __typename?: 'FlightAppPilotObject', name?: string | null, email?: string | null } | null } | null } | null, aircraftsIds?: Array<{ __typename?: 'FlightAppAircraft', id?: string | null, balloonId?: string | null, aircraft?: { __typename?: 'FlightAppAircraftDetails', callsign?: string | null, serial_number?: string | null, weight_category?: string | null, total_flight_duration_human?: string | null, total_flight_duration?: number | null, aircraft_type?: { __typename?: 'FlightAppAircraftType', id?: string | null, name?: string | null, code?: string | null, description?: string | null, manufacturer?: string | null, weight_category?: string | null, aircraft_category?: string | null } | null } | null } | null> | null } | null> | null } | null } | null } | null };

export type GetAllReleaseNotesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllReleaseNotesQuery = { __typename?: 'Query', allReleaseNotes?: Array<{ __typename?: 'ReleaseNote', id?: string | null, date?: any | null, description?: string | null, documentation?: string | null, oneliner?: string | null, video?: string | null, tenants?: Array<string | null> | null } | null> | null };

export type GetReleaseNotesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReleaseNotesQuery = { __typename?: 'Query', releaseNotes?: Array<{ __typename?: 'ReleaseNote', id?: string | null, date?: any | null, description?: string | null, documentation?: string | null, oneliner?: string | null, video?: string | null } | null> | null };

export type GetReleaseNoteQueryVariables = Exact<{
  releaseNoteId: Scalars['ID']['input'];
}>;


export type GetReleaseNoteQuery = { __typename?: 'Query', releaseNote?: { __typename?: 'ReleaseNote', id?: string | null, date?: any | null, description?: string | null, documentation?: string | null, oneliner?: string | null, video?: string | null } | null };

export type GetReleaseNotesCountQueryVariables = Exact<{ [key: string]: never; }>;


export type GetReleaseNotesCountQuery = { __typename?: 'Query', releaseNotesCount?: any | null };

export type GetTenantSettingMyFlightQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantSettingMyFlightQuery = { __typename?: 'Query', tenantSetting?: { __typename?: 'TenantSetting', id: string, operatorSettings?: { __typename?: 'OperatorSettings', id: string, myflight?: { __typename?: 'OperatorSettingsMyflight', id: string, autoConfirm?: boolean | null, autoConfirmAPI?: boolean | null, autoConfirmEmailTemplate?: string | null, flights?: MyflightFlights | null, endOfSeason?: boolean | null, colors?: Array<string | null> | null, logo?: string | null, checkinMode?: CheckinMode | null, checkinDaysBefore?: any | null, checkinNotificationChannel?: CheckinNotificationChannel | null, checkinInstructions?: string | null } | null } | null } | null };

export type GetSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionQuery = { __typename?: 'Query', tenantSetting?: { __typename?: 'TenantSetting', id: string, subscription?: { __typename?: 'Subscription', factuursturenClient?: string | null, custom?: boolean | null, gracePeriodDays?: any | null, debtorValidation?: { __typename?: 'DebtorValidation', valid: boolean, issues: Array<string>, checkedAt?: any | null } | null, sms?: { __typename?: 'SubscriptionSMS', available?: any | null, used?: any | null, pctUsed?: any | null, ignoreWarning?: boolean | null, status?: SubscriptionSmsStatus | null, usedSMS?: Array<{ __typename?: 'usedSMS', year?: any | null, month?: any | null, used?: any | null, usedWA?: any | null, waUtility?: any | null, waService?: any | null, waMarketing?: any | null, waAuthentication?: any | null, waBillable?: any | null, waFree?: any | null, waEstimatedCost?: number | null } | null> | null, suggestedOrderLines?: Array<{ __typename?: 'OrderLine', productCode: string, description: string, descriptionEn: string, descriptionDe: string, descriptionFr: string, quantity: number, unitPrice: number, sms?: number | null, periodStart?: any | null, periodEnd?: any | null } | null> | null } | null, plan?: { __typename?: 'SubscriptionPlan', name?: SubscriptionPlanEnum | null, seats?: any | null, used?: any | null, pctUsed?: any | null, validUntil?: any | null, valid?: boolean | null, status?: SubscriptionPlanStatus | null, invalidSince?: any | null, expiredSince?: any | null, suggestedUpgrade?: SubscriptionPlanEnum | null, suggestedOrderLines?: Array<{ __typename?: 'OrderLine', type?: string | null, productCode: string, description: string, descriptionEn: string, descriptionDe: string, descriptionFr: string, quantity: number, unitPrice: number, totalPrice?: number | null, sms?: number | null, plan?: string | null, maxSeats?: number | null, periodStart?: any | null, periodEnd?: any | null } | null> | null } | null } | null } | null };

export type GetDefaultLocationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultLocationQuery = { __typename?: 'Query', tenantSetting?: { __typename?: 'TenantSetting', id: string, locationOptions?: { __typename?: 'LocationOptions', defaultLocation?: { __typename?: 'Location', id: string, address?: string | null, city?: string | null, country?: string | null, default?: boolean | null, description?: string | null, height?: any | null, latitude?: number | null, longitude?: number | null, maximumHeight?: number | null, name?: string | null, postalCode?: string | null, forecasts?: Array<{ __typename?: 'MeteoblueForecastSlot', slot?: string | null, flyability?: { __typename?: 'FlyabilityAssessment', verdict: FlyabilityVerdict, parameters: Array<{ __typename?: 'FlyabilityParameter', key: string, value?: number | null, band: FlyabilityBand }> } | null, forecast?: { __typename?: 'slotForecast', daytime?: Array<any | null> | null, flytime?: Array<any | null> | null, lastUpdate?: any | null, latitude?: string | null, longitude?: string | null, lowCloudsData?: Array<any | null> | null, pictoCodeData?: Array<any | null> | null, precipitationData?: Array<number | null> | null, pressureData?: Array<any | null> | null, sunrise?: any | null, sunset?: any | null, temperatureData?: Array<any | null> | null, time?: Array<string | null> | null, utc_timeoffset?: number | null, visibilityData?: Array<any | null> | null, windDirectionData?: Array<number | null> | null, windDirectionData_1000?: Array<number | null> | null, windDirectionData_500?: Array<number | null> | null, windDirectionData_550?: Array<number | null> | null, windDirectionData_600?: Array<number | null> | null, windDirectionData_650?: Array<number | null> | null, windDirectionData_700?: Array<number | null> | null, windDirectionData_750?: Array<number | null> | null, windDirectionData_800?: Array<number | null> | null, windDirectionData_925?: Array<number | null> | null, windDirectionData_950?: Array<number | null> | null, windDirectionData_975?: Array<number | null> | null, windGustData?: Array<number | null> | null, windSpeedData?: Array<number | null> | null, windSpeedData_1000?: Array<number | null> | null, windSpeedData_500?: Array<number | null> | null, windSpeedData_550?: Array<number | null> | null, windSpeedData_600?: Array<number | null> | null, windSpeedData_650?: Array<number | null> | null, windSpeedData_700?: Array<number | null> | null, windSpeedData_750?: Array<number | null> | null, windSpeedData_800?: Array<number | null> | null, windSpeedData_925?: Array<number | null> | null, windSpeedData_950?: Array<number | null> | null, windSpeedData_975?: Array<number | null> | null, datepart?: Array<{ __typename?: 'DatePart', part?: DatePartType | null, text?: string | null } | null> | null } | null } | null> | null } | null } | null } | null };

export type GetUpUrlQueryVariables = Exact<{
  bookingId: Scalars['ID']['input'];
}>;


export type GetUpUrlQuery = { __typename?: 'Query', upUrl?: string | null };

export type FlyabilityDefaultsQueryVariables = Exact<{ [key: string]: never; }>;


export type FlyabilityDefaultsQuery = { __typename?: 'Query', flyabilityDefaults?: Array<{ __typename?: 'FlyabilityThreshold', parameter: string, goodMax?: number | null, warnMax?: number | null, goodMin?: number | null, warnMin?: number | null }> | null };

export type FlyabilityThresholdsQueryVariables = Exact<{ [key: string]: never; }>;


export type FlyabilityThresholdsQuery = { __typename?: 'Query', tenantSetting?: { __typename?: 'TenantSetting', id: string, flyabilityEnabled: boolean, flyability?: Array<{ __typename?: 'FlyabilityThreshold', parameter: string, goodMax?: number | null, warnMax?: number | null, goodMin?: number | null, warnMin?: number | null }> | null } | null };

export type UpdateFlyabilitySettingsMutationVariables = Exact<{
  thresholds: Array<FlyabilityThresholdInput> | FlyabilityThresholdInput;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateFlyabilitySettingsMutation = { __typename?: 'Mutation', updateFlyabilitySettings?: { __typename?: 'TenantSetting', id: string, flyabilityEnabled: boolean, flyability?: Array<{ __typename?: 'FlyabilityThreshold', parameter: string, goodMax?: number | null, warnMax?: number | null, goodMin?: number | null, warnMin?: number | null }> | null } | null };

export type UpdateTenantLocationOptionsMutationVariables = Exact<{
  options: InputLocationOptions;
}>;


export type UpdateTenantLocationOptionsMutation = { __typename?: 'Mutation', updateTenantLocationOptions?: { __typename?: 'TenantSetting', locationOptions?: { __typename?: 'LocationOptions', defaultLocation?: { __typename?: 'Location', id: string } | null } | null } | null };

export type UpdateTenantOperatorSettingsBackupMutationVariables = Exact<{
  settings: InputOperatorSettingsBackup;
}>;


export type UpdateTenantOperatorSettingsBackupMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsBackup?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, backup?: { __typename?: 'OperatorSettingsBackup', active?: boolean | null, email?: string | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsDisplayedColumnsMutationVariables = Exact<{
  displayedColumns: InputDisplayedColumns;
}>;


export type UpdateTenantOperatorSettingsDisplayedColumnsMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsDisplayedColumns?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, displayedColumns?: { __typename?: 'DisplayedColumns', flightsUpcoming?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsUpcomingDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsBooking?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsBookingDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsHistory?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, flightsHistoryDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsOpen?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsOpenDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsHistory?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsHistoryDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsPayment?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsPaymentDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsDashboard?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsDashboardDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlight?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightEnd?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightEndDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightCancelled?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightCancelledDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightAll?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightAllDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightPayment?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null, bookingsFlightPaymentDefault?: Array<{ __typename?: 'DisplayedColumn', name?: string | null, active?: boolean | null, mobile?: boolean | null, disabled?: boolean | null } | null> | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsCrewMutationVariables = Exact<{
  settings: InputOperatorSettingsCrew;
}>;


export type UpdateTenantOperatorSettingsCrewMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsCrew?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, crew?: { __typename?: 'OperatorSettingsCrew', shareBookings?: boolean | null, allowFlightSelection?: boolean | null, shareEvents?: boolean | null, shareFlightTags?: boolean | null, crewReadyChannel?: CrewReadyChannel | null, crewReadyLanguage?: SystemLanguage | null, crewReadyInstructions?: string | null, crewReadyIncludePassengers?: boolean | null, crewReadyIncludeTrajectory?: boolean | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsNotificationsMutationVariables = Exact<{
  settings: InputOperatorSettingsNotifications;
}>;


export type UpdateTenantOperatorSettingsNotificationsMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsNotifications?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, notifications?: { __typename?: 'OperatorSettingsNotifications', calendar?: boolean | null, calendarClosing?: string | null, flightCrew?: boolean | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsTrajectoryProfileMutationVariables = Exact<{
  settings: Array<InputMaybe<InputOperatorSettingsTrajectoryProfile>> | InputMaybe<InputOperatorSettingsTrajectoryProfile>;
}>;


export type UpdateTenantOperatorSettingsTrajectoryProfileMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsTrajectoryProfile?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, trajectoryProfile?: Array<{ __typename?: 'TrajectoryProfile', duration?: any | null, level?: any | null } | null> | null } | null } | null };

export type UpdateTenantOperatorSettingsMyFlightMutationVariables = Exact<{
  settings: InputOperatorSettingsMyFlight;
}>;


export type UpdateTenantOperatorSettingsMyFlightMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsMyFlight?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, myflight?: { __typename?: 'OperatorSettingsMyflight', id: string, autoConfirm?: boolean | null, autoConfirmAPI?: boolean | null, autoConfirmEmailTemplate?: string | null, flights?: MyflightFlights | null, endOfSeason?: boolean | null, colors?: Array<string | null> | null, logo?: string | null, checkinMode?: CheckinMode | null, checkinDaysBefore?: any | null, checkinNotificationChannel?: CheckinNotificationChannel | null, checkinInstructions?: string | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsFlightsMutationVariables = Exact<{
  settings: InputOperatorSettingsFlights;
  updateHours?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateTenantOperatorSettingsFlightsMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsFlights?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, flights?: { __typename?: 'OperatorSettingsFlights', sunriseOffset?: any | null, sunsetOffset?: any | null, meetingTimeOffset?: any | null, cancelReasons?: Array<string | null> | null, defaultPeriod?: FlightPeriod | null, flightDuplicateProtection?: boolean | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsFlightsCancelReasonsMutationVariables = Exact<{
  cancelReasons: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTenantOperatorSettingsFlightsCancelReasonsMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsFlightsCancelReasons?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, flights?: { __typename?: 'OperatorSettingsFlights', sunriseOffset?: any | null, sunsetOffset?: any | null, meetingTimeOffset?: any | null, cancelReasons?: Array<string | null> | null, defaultPeriod?: FlightPeriod | null, flightDuplicateProtection?: boolean | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsSmsMutationVariables = Exact<{
  settings: InputOperatorSettingsSms;
}>;


export type UpdateTenantOperatorSettingsSmsMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsSms?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, sms?: { __typename?: 'OperatorSettingsSms', footerEnabled?: boolean | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsBookingsChildAgeMutationVariables = Exact<{
  childAge?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type UpdateTenantOperatorSettingsBookingsChildAgeMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsBookingsChildAge?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, bookings?: { __typename?: 'OperatorSettingsBookings', childAge?: any | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsBookingsFlightOptionsCountMutationVariables = Exact<{
  flightOptionsCount?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type UpdateTenantOperatorSettingsBookingsFlightOptionsCountMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsBookingsFlightOptionsCount?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, bookings?: { __typename?: 'OperatorSettingsBookings', flightOptionsCount?: any | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsBookingsSourcesMutationVariables = Exact<{
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type UpdateTenantOperatorSettingsBookingsSourcesMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsBookingsSources?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, bookings?: { __typename?: 'OperatorSettingsBookings', sources?: Array<string | null> | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsDisabledPaymentTypesMutationVariables = Exact<{
  disabledPaymentTypes: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTenantOperatorSettingsDisabledPaymentTypesMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsDisabledPaymentTypes?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, bookings?: { __typename?: 'OperatorSettingsBookings', disabledPaymentTypes?: Array<string | null> | null } | null } | null } | null };

export type ToggleTenantOperatorSettingsBookingsShowPaymentsMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleTenantOperatorSettingsBookingsShowPaymentsMutation = { __typename?: 'Mutation', toggleTenantOperatorSettingsBookingsShowPayments?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, bookings?: { __typename?: 'OperatorSettingsBookings', showPayments?: boolean | null } | null } | null } | null };

export type ToggleTenantWAfallbackSmsMutationVariables = Exact<{ [key: string]: never; }>;


export type ToggleTenantWAfallbackSmsMutation = { __typename?: 'Mutation', toggleTenantWAfallbackSMS?: { __typename?: 'TenantSetting', whatsapp?: { __typename?: 'WhatsappSettings', enabled: boolean, fallbackSms?: boolean | null } | null } | null };

export type UpdateTenantMessageRetentionMutationVariables = Exact<{
  messageRetention: InputMessageRetention;
}>;


export type UpdateTenantMessageRetentionMutation = { __typename?: 'Mutation', updateTenantMessageRetention?: { __typename?: 'TenantSetting', tenantId: string, messageRetention?: { __typename?: 'MessageRetention', closedBookingsYears?: any | null, crewYears?: any | null } | null } | null };

export type MessageRetentionImpactQueryVariables = Exact<{
  closedBookingsYears?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  crewYears?: InputMaybe<Scalars['NonNegativeInt']['input']>;
}>;


export type MessageRetentionImpactQuery = { __typename?: 'Query', messageRetentionImpact: { __typename?: 'MessageRetentionImpact', closedBookingMessages: any, crewMessages: any } };

export type SubscriptionSmsIgnoreWarningMutationVariables = Exact<{
  ignore: Scalars['Boolean']['input'];
}>;


export type SubscriptionSmsIgnoreWarningMutation = { __typename?: 'Mutation', subscriptionSmsIgnoreWarning?: boolean | null };

export type AddReleaseNoteMutationVariables = Exact<{
  releaseNote: InputReleaseNote;
}>;


export type AddReleaseNoteMutation = { __typename?: 'Mutation', addReleaseNote?: { __typename?: 'ReleaseNote', id?: string | null, date?: any | null, description?: string | null, documentation?: string | null, oneliner?: string | null, video?: string | null } | null };

export type UpdateReleaseNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  releaseNote: InputReleaseNote;
}>;


export type UpdateReleaseNoteMutation = { __typename?: 'Mutation', updateReleaseNote?: { __typename?: 'ReleaseNote', id?: string | null, date?: any | null, description?: string | null, documentation?: string | null, oneliner?: string | null, video?: string | null } | null };

export type DeleteReleaseNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteReleaseNoteMutation = { __typename?: 'Mutation', deleteReleaseNote?: boolean | null };

export type MarkReleaseNoteAsReadMutationVariables = Exact<{
  releaseNoteIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type MarkReleaseNoteAsReadMutation = { __typename?: 'Mutation', markReleaseNoteAsRead?: any | null };

export type CreateIcsIdMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateIcsIdMutation = { __typename?: 'Mutation', createIcsId?: string | null };

export type CreateApiKeyMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateApiKeyMutation = { __typename?: 'Mutation', createApiKey?: string | null };

export type UpdateTenantCallbackUrlMutationVariables = Exact<{
  callbackUrl: Scalars['String']['input'];
}>;


export type UpdateTenantCallbackUrlMutation = { __typename?: 'Mutation', updateTenantCallbackUrl?: { __typename?: 'TenantSetting', id: string, integrations?: { __typename?: 'Integrations', callbackUrl?: string | null } | null } | null };

export type CreateIcsIdUserMutationVariables = Exact<{
  userId: Scalars['String']['input'];
}>;


export type CreateIcsIdUserMutation = { __typename?: 'Mutation', createIcsIdUser?: string | null };

export type AddFlightAppApiKeyMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type AddFlightAppApiKeyMutation = { __typename?: 'Mutation', addFlightAppApiKey?: string | null };

export type DeleteFlightAppApiKeyMutationVariables = Exact<{
  key: Scalars['String']['input'];
}>;


export type DeleteFlightAppApiKeyMutation = { __typename?: 'Mutation', deleteFlightAppApiKey?: string | null };

export type RefreshTenantSubscriptionUsedSmsMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshTenantSubscriptionUsedSmsMutation = { __typename?: 'Mutation', refreshTenantSubscriptionUsedSms?: boolean | null };

export type UpdateTenantSettingMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
  settings: InputTenantSetting;
}>;


export type UpdateTenantSettingMutation = { __typename?: 'Mutation', updateTenantSettingAdmin?: { __typename?: 'TenantSetting', id: string, apiCacheEnabled?: boolean | null, subscription?: { __typename?: 'Subscription', factuursturenClient?: string | null, custom?: boolean | null, gracePeriodDays?: any | null, plan?: { __typename?: 'SubscriptionPlan', name?: SubscriptionPlanEnum | null, seats?: any | null, used?: any | null, pctUsed?: any | null, validUntil?: any | null, valid?: boolean | null, status?: SubscriptionPlanStatus | null, invalidSince?: any | null, expiredSince?: any | null, suggestedUpgrade?: SubscriptionPlanEnum | null } | null, sms?: { __typename?: 'SubscriptionSMS', available?: any | null, used?: any | null, pctUsed?: any | null, ignoreWarning?: boolean | null, status?: SubscriptionSmsStatus | null, usedSMS?: Array<{ __typename?: 'usedSMS', year?: any | null, month?: any | null, used?: any | null, usedWA?: any | null, waUtility?: any | null, waService?: any | null, waMarketing?: any | null, waAuthentication?: any | null, waBillable?: any | null, waFree?: any | null, waEstimatedCost?: number | null } | null> | null } | null } | null } | null };

export type UpdateTenantOperatorSettingsTwoFaMutationVariables = Exact<{
  twoFAEnabled: Scalars['Boolean']['input'];
}>;


export type UpdateTenantOperatorSettingsTwoFaMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsTwoFA?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, twoFAEnabled?: boolean | null } | null } | null };

export type WeatherSourceDefaultsQueryVariables = Exact<{ [key: string]: never; }>;


export type WeatherSourceDefaultsQuery = { __typename?: 'Query', weatherSourceDefaults?: Array<{ __typename?: 'WeatherSourceMapping', country?: string | null, source?: string | null } | null> | null };

export type UpdateTenantOperatorSettingsWeatherSourceMutationVariables = Exact<{
  settings: InputOperatorSettingsWeatherSource;
}>;


export type UpdateTenantOperatorSettingsWeatherSourceMutation = { __typename?: 'Mutation', updateTenantOperatorSettingsWeatherSource?: { __typename?: 'TenantSetting', operatorSettings?: { __typename?: 'OperatorSettings', id: string, weatherSource?: { __typename?: 'OperatorSettingsWeatherSource', mode?: WeatherSourceMode | null, mapping?: Array<{ __typename?: 'WeatherSourceMapping', country?: string | null, source?: string | null } | null> | null } | null } | null } | null };

export type MessageRetentionStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type MessageRetentionStatusQuery = { __typename?: 'Query', messageRetentionStatus: { __typename?: 'MessageRetentionStatus', flaggedMessages: any, nextPurgeAt?: any | null } };

export type GetTenantByDisplayNameQueryVariables = Exact<{
  displayName: Scalars['String']['input'];
}>;


export type GetTenantByDisplayNameQuery = { __typename?: 'Query', getTenantByDisplayName: { __typename?: 'Tenant', tenantId?: string | null, displayName: string } };

export type GetTenantQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type GetTenantQuery = { __typename?: 'Query', getTenant: { __typename?: 'Tenant', displayName: string, tenantSetting?: { __typename?: 'TenantSetting', id: string, apiCacheEnabled?: boolean | null, upEnabled?: boolean | null, tenantId: string, mailFrom?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, mailReplyTo?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, mailAccountant?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, locationOptions?: { __typename?: 'LocationOptions', defaultLocation?: { __typename?: 'Location', id: string } | null } | null, operatorSettings?: { __typename?: 'OperatorSettings', timezone?: string | null, backup?: { __typename?: 'OperatorSettingsBackup', active?: boolean | null, email?: string | null } | null, crew?: { __typename?: 'OperatorSettingsCrew', shareBookings?: boolean | null, allowFlightSelection?: boolean | null } | null, sms?: { __typename?: 'OperatorSettingsSms', footerEnabled?: boolean | null } | null, manifest?: { __typename?: 'OperatorSettingsManifest', footer?: Array<string | null> | null, pilotDeclaration?: Array<string | null> | null } | null, myflight?: { __typename?: 'OperatorSettingsMyflight', autoConfirm?: boolean | null, autoConfirmAPI?: boolean | null, flights?: MyflightFlights | null, endOfSeason?: boolean | null } | null } | null, dashboardOptions?: { __typename?: 'DashboardOptions', preferredDateToday?: boolean | null, recent?: any | null, toConfirm?: boolean | null } | null, subscription?: { __typename?: 'Subscription', factuursturenClient?: string | null, custom?: boolean | null, gracePeriodDays?: any | null, debtorValidation?: { __typename?: 'DebtorValidation', valid: boolean, issues: Array<string>, checkedAt?: any | null } | null, plan?: { __typename?: 'SubscriptionPlan', name?: SubscriptionPlanEnum | null, seats?: any | null, status?: SubscriptionPlanStatus | null, validUntil?: any | null } | null, sms?: { __typename?: 'SubscriptionSMS', available?: any | null, status?: SubscriptionSmsStatus | null } | null } | null } | null } };

export type GetTenantsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTenantsQuery = { __typename?: 'Query', getTenants: Array<{ __typename?: 'Tenant', tenantId?: string | null, displayName: string, tenantSetting?: { __typename?: 'TenantSetting', upEnabled?: boolean | null, tenantId: string, mailFrom?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, mailReplyTo?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, mailAccountant?: { __typename?: 'EmailAddressObject', email?: any | null, name?: string | null } | null, locationOptions?: { __typename?: 'LocationOptions', defaultLocation?: { __typename?: 'Location', id: string } | null } | null, operatorSettings?: { __typename?: 'OperatorSettings', timezone?: string | null, backup?: { __typename?: 'OperatorSettingsBackup', active?: boolean | null, email?: string | null } | null, crew?: { __typename?: 'OperatorSettingsCrew', shareBookings?: boolean | null, allowFlightSelection?: boolean | null } | null, sms?: { __typename?: 'OperatorSettingsSms', footerEnabled?: boolean | null } | null, manifest?: { __typename?: 'OperatorSettingsManifest', footer?: Array<string | null> | null, pilotDeclaration?: Array<string | null> | null } | null, myflight?: { __typename?: 'OperatorSettingsMyflight', autoConfirm?: boolean | null, autoConfirmAPI?: boolean | null, flights?: MyflightFlights | null, endOfSeason?: boolean | null } | null } | null, dashboardOptions?: { __typename?: 'DashboardOptions', preferredDateToday?: boolean | null, recent?: any | null, toConfirm?: boolean | null } | null, subscription?: { __typename?: 'Subscription', factuursturenClient?: string | null, custom?: boolean | null, gracePeriodDays?: any | null, plan?: { __typename?: 'SubscriptionPlan', name?: SubscriptionPlanEnum | null, seats?: any | null, status?: SubscriptionPlanStatus | null, validUntil?: any | null } | null, sms?: { __typename?: 'SubscriptionSMS', available?: any | null, status?: SubscriptionSmsStatus | null } | null } | null } | null } | null> };

export type GetUsersQueryVariables = Exact<{
  tenantId: Scalars['String']['input'];
}>;


export type GetUsersQuery = { __typename?: 'Query', getUsers: Array<{ __typename?: 'GCPIPUser', uid: string, email: string, customClaims?: any | null } | null> };

export type GetUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserQuery = { __typename?: 'Query', getUser?: { __typename?: 'GCPIPUser', uid: string, email: string, userData?: { __typename?: 'User', id?: string | null, icsId?: string | null, email?: any | null, displayName?: string | null, language?: SystemLanguage | null, role?: UserRole | null, viewState?: any | null, tenant?: string | null, crew?: { __typename?: 'Crew', id: string, email?: any | null, emailNotifications?: any | null } | null } | null } | null };

export type TenantQueryVariables = Exact<{ [key: string]: never; }>;


export type TenantQuery = { __typename?: 'Query', tenant?: { __typename?: 'TenantInfo', name?: string | null } | null };

export type CreateTenantMutationVariables = Exact<{
  displayName: Scalars['String']['input'];
}>;


export type CreateTenantMutation = { __typename?: 'Mutation', createTenant: { __typename?: 'Tenant', tenantId?: string | null, displayName: string } };

export type InitializeTenantMutationVariables = Exact<{
  tenantId: Scalars['ID']['input'];
}>;


export type InitializeTenantMutation = { __typename?: 'Mutation', initializeTenant?: string | null };

export type CreateUserMutationVariables = Exact<{
  GcpipUserInput: GcpipUserInput;
  tenantId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUser: { __typename?: 'GCPIPUser', uid: string, email: string, customClaims?: any | null } };

export type DeleteUserMutationVariables = Exact<{
  uid: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: string };

export type SendPasswordResetEmailMutationVariables = Exact<{
  email: Scalars['ID']['input'];
  tenantId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SendPasswordResetEmailMutation = { __typename?: 'Mutation', sendPasswordResetEmail: string };

export type SaveUserViewStateMutationVariables = Exact<{
  viewState: Scalars['JSONObject']['input'];
}>;


export type SaveUserViewStateMutation = { __typename?: 'Mutation', saveUserViewState: { __typename?: 'User', displayName?: string | null, language?: SystemLanguage | null, viewState?: any | null } };

export type SendTwoFaEmailMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type SendTwoFaEmailMutation = { __typename?: 'Mutation', sendTwoFAEmail: boolean };

export type VerifyTwoFaCodeMutationVariables = Exact<{
  code: Scalars['String']['input'];
  deviceId: Scalars['String']['input'];
}>;


export type VerifyTwoFaCodeMutation = { __typename?: 'Mutation', verifyTwoFACode: boolean };

export type ForgetTrustedDeviceMutationVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;


export type ForgetTrustedDeviceMutation = { __typename?: 'Mutation', forgetTrustedDevice: boolean };

export type GetVoucherQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVoucherQuery = { __typename?: 'Query', voucher?: { __typename?: 'Voucher', id: string, adults?: any | null, adultsUsed?: any | null, adultsAvailable?: any | null, children?: any | null, childrenUsed?: any | null, childrenAvailable?: any | null, contactName?: string | null, contactPhone?: any | null, external?: boolean | null, externalSource?: string | null, issueDate?: any | null, paymentAmount?: any | null, paymentDate?: any | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, voucherReference?: string | null, voucherType?: string | null, expiryDate?: any | null, status?: string | null, comments?: string | null, contactCity?: string | null, contactEmail?: string | null, contactLanguage?: string | null, recipientName?: string | null, recipientPhone?: any | null, recipientLanguage?: ContactLanguage | null, recipientEmail?: string | null, recipientAddress?: string | null, recipientPostalCode?: string | null, recipientCity?: string | null, recipientCountry?: string | null, source?: string | null, tickets?: Array<{ __typename?: 'Ticket', passenger?: { __typename?: 'Passenger', id: string, name?: string | null, child?: boolean | null, disability?: boolean | null } | null, booking?: { __typename?: 'Booking', removed?: any | null, id: string, inviteCount?: number | null, status?: BookingStatus | null, icon?: string | null, iconColor?: string | null, contactName?: string | null, contactEmail?: string | null, contactPhone?: any | null, comments?: string | null, startDate?: any | null, endDate?: any | null, city?: string | null } | null, flight?: { __typename?: 'Flight', date?: any | null, period?: FlightPeriod | null, id: string, balloon?: { __typename?: 'Balloon', name?: string | null } | null, location?: { __typename?: 'Location', name?: string | null } | null, icon: { __typename?: 'Icon', sign: string, color: string } } | null } | null> | null } | null };

export type VouchersQueryVariables = Exact<{ [key: string]: never; }>;


export type VouchersQuery = { __typename?: 'Query', vouchers: Array<{ __typename?: 'Voucher', id: string, adults?: any | null, children?: any | null, contactName?: string | null, contactPhone?: any | null, external?: boolean | null, externalSource?: string | null, issueDate?: any | null, paymentAmount?: any | null, paymentDate?: any | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, voucherReference?: string | null, voucherType?: string | null, expiryDate?: any | null, status?: string | null, comments?: string | null, contactCity?: string | null, contactEmail?: string | null, contactLanguage?: string | null } | null> };

export type GetOpenVouchersQueryVariables = Exact<{
  orderBy?: InputMaybe<OrderByVoucher>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOpenVouchersQuery = { __typename?: 'Query', openVouchers: Array<{ __typename?: 'Voucher', id: string, adults?: any | null, adultsUsed?: any | null, adultsAvailable?: any | null, children?: any | null, childrenUsed?: any | null, childrenAvailable?: any | null, contactName?: string | null, contactPhone?: any | null, external?: boolean | null, externalSource?: string | null, issueDate?: any | null, paymentAmount?: any | null, paymentDate?: any | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, voucherReference?: string | null, voucherType?: string | null, expiryDate?: any | null, status?: string | null, comments?: string | null, contactCity?: string | null, contactEmail?: string | null, contactLanguage?: string | null } | null> };

export type GetUsedVouchersQueryVariables = Exact<{
  orderBy?: InputMaybe<OrderByVoucher>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsedVouchersQuery = { __typename?: 'Query', usedVouchers: Array<{ __typename?: 'Voucher', id: string, adults?: any | null, children?: any | null, contactName?: string | null, contactPhone?: any | null, external?: boolean | null, externalSource?: string | null, issueDate?: any | null, paymentAmount?: any | null, paymentDate?: any | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, voucherReference?: string | null, voucherType?: string | null, expiryDate?: any | null, status?: string | null, comments?: string | null, contactCity?: string | null, contactEmail?: string | null, contactLanguage?: string | null } | null> };

export type GetExpiredVouchersQueryVariables = Exact<{
  orderBy?: InputMaybe<OrderByVoucher>;
  orderDirection?: InputMaybe<OrderDirection>;
  limit?: InputMaybe<Scalars['NonNegativeInt']['input']>;
  filter?: InputMaybe<Scalars['String']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
  voucherType?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetExpiredVouchersQuery = { __typename?: 'Query', expiredVouchers: Array<{ __typename?: 'Voucher', id: string, adults?: any | null, children?: any | null, contactName?: string | null, contactPhone?: any | null, external?: boolean | null, externalSource?: string | null, issueDate?: any | null, paymentAmount?: any | null, paymentDate?: any | null, paymentStatus?: PaymentStatus | null, paymentType?: PaymentType | null, voucherReference?: string | null, voucherType?: string | null, expiryDate?: any | null, status?: string | null, comments?: string | null, contactCity?: string | null, contactEmail?: string | null, contactLanguage?: string | null } | null> };

export type VoucherCountersQueryVariables = Exact<{ [key: string]: never; }>;


export type VoucherCountersQuery = { __typename?: 'Query', voucherCounters?: { __typename?: 'VoucherCounters', voucherTypes?: Array<string | null> | null, statusCounters?: { __typename?: 'VoucherStatusCounters', AVAI?: any | null, USED?: any | null, EXPI?: any | null } | null } | null };

export type SaveVoucherMutationVariables = Exact<{
  voucherInput: VoucherInput;
  voucherId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type SaveVoucherMutation = { __typename?: 'Mutation', saveVoucher: string };

export type DeleteVoucherMutationVariables = Exact<{
  voucherId: Scalars['ID']['input'];
}>;


export type DeleteVoucherMutation = { __typename?: 'Mutation', deleteVoucher: string };

export type CreateBookingFromVoucherMutationVariables = Exact<{
  voucherId: Scalars['ID']['input'];
}>;


export type CreateBookingFromVoucherMutation = { __typename?: 'Mutation', createBookingFromVoucher: string };

export type WeekPanelBookingQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WeekPanelBookingQuery = { __typename?: 'Query', booking?: { __typename?: 'Booking', id: string, contactName?: string | null, contactPhone?: any | null, contactEmail?: string | null, city?: string | null, status?: BookingStatus | null, comments?: string | null, endDate?: any | null, bookingCode?: string | null, preferredDate?: string | null, preferredFlights?: Array<{ __typename?: 'PreferredFlight', date?: string | null, period?: FlightPeriod | null } | null> | null, region?: { __typename?: 'Region', id: string, name?: string | null, color?: string | null } | null, passengerCounters?: { __typename?: 'PassengerCounters', passengerCount?: any | null, totalWeight?: any | null, totalAmount?: any | null, paidAmount?: any | null, openAmount?: any | null } | null, passengers: Array<{ __typename?: 'Passenger', name?: string | null, weight?: any | null } | null>, flight?: { __typename?: 'Flight', id: string, date?: any | null, hour?: any | null, period?: FlightPeriod | null, balloon?: { __typename?: 'Balloon', id: string, name?: string | null, capacity?: any | null } | null, location?: { __typename?: 'Location', id: string, name?: string | null } | null } | null } | null };

export type WeekPanelLocationQueryVariables = Exact<{
  locationId: Scalars['ID']['input'];
}>;


export type WeekPanelLocationQuery = { __typename?: 'Query', location: { __typename?: 'Location', id: string, name?: string | null, city?: string | null, address?: string | null, description?: string | null, default?: boolean | null, latitude?: number | null, longitude?: number | null, meetingPointAddress?: string | null, contact?: { __typename?: 'LocationContact', name?: string | null, phone?: string | null, email?: string | null, comment?: string | null } | null, region: Array<{ __typename?: 'Region', id: string, name?: string | null, color?: string | null } | null> } };

export type WeekPanelBalloonCrewQueryVariables = Exact<{
  balloonId: Scalars['ID']['input'];
}>;


export type WeekPanelBalloonCrewQuery = { __typename?: 'Query', balloon: { __typename?: 'Balloon', id: string, preferredCrew?: { __typename?: 'PreferredCrew', pilot?: { __typename?: 'Crew', id: string, name?: string | null } | null, driver?: { __typename?: 'Crew', id: string, name?: string | null } | null, crew?: Array<{ __typename?: 'Crew', id: string, name?: string | null } | null> | null } | null } };

export type WeekPanelCrewOfQueryVariables = Exact<{
  crewId: Scalars['ID']['input'];
}>;


export type WeekPanelCrewOfQuery = { __typename?: 'Query', crew: { __typename?: 'Crew', id: string, preferredCrewOf?: Array<{ __typename?: 'Balloon', id: string, name?: string | null, callSign?: string | null } | null> | null } };

export type WhatsappCloudStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type WhatsappCloudStatusQuery = { __typename?: 'Query', tenantSetting?: { __typename?: 'TenantSetting', tenantId: string, whatsapp?: { __typename?: 'WhatsappSettings', enabled: boolean, fallbackSms?: boolean | null, cloudEnabled: boolean, provider?: WhatsappProvider | null, wabaId?: string | null, phoneNumberId?: string | null, phoneNumber?: string | null, messagingTier?: string | null, migrationStatus?: WaMigrationStatus | null, paymentConfirmedAt?: any | null, paymentError?: string | null, templates?: Array<{ __typename?: 'WhatsappTemplateStatus', key: string, type?: string | null, label?: string | null, language?: string | null, approvalStatus?: string | null, rejectionReason?: string | null, validationIssues?: Array<string> | null, serving?: boolean | null, submittedAt?: any | null }> | null } | null } | null };

export type WhatsappCloudOnboardMutationVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type WhatsappCloudOnboardMutation = { __typename?: 'Mutation', whatsappCloudOnboard: { __typename?: 'WhatsappOnboardResult', success: boolean, wabaId?: string | null, phoneNumberId?: string | null, displayPhoneNumber?: string | null, messagingTier?: string | null, templatesSubmitted?: any | null, error?: string | null } };

export type ActivateWhatsappCloudMutationVariables = Exact<{ [key: string]: never; }>;


export type ActivateWhatsappCloudMutation = { __typename?: 'Mutation', activateWhatsappCloud?: { __typename?: 'WhatsappSettings', provider?: WhatsappProvider | null, migrationStatus?: WaMigrationStatus | null } | null };

export type DeactivateWhatsappCloudMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateWhatsappCloudMutation = { __typename?: 'Mutation', deactivateWhatsappCloud?: { __typename?: 'WhatsappSettings', provider?: WhatsappProvider | null, migrationStatus?: WaMigrationStatus | null } | null };

export type ConfirmWhatsappCloudPaymentMutationVariables = Exact<{ [key: string]: never; }>;


export type ConfirmWhatsappCloudPaymentMutation = { __typename?: 'Mutation', confirmWhatsappCloudPayment?: { __typename?: 'WhatsappSettings', paymentConfirmedAt?: any | null, paymentError?: string | null } | null };

export type WhatsappCloudCostEstimateQueryVariables = Exact<{ [key: string]: never; }>;


export type WhatsappCloudCostEstimateQuery = { __typename?: 'Query', whatsappCloudCostEstimate?: { __typename?: 'WhatsappCostEstimate', monthsSampled: any, avgMonthlyMessages: any, avgMonthlyBillable: any, estimatedMonthlyCost: number, ratePerMessage: number, basedOnSmsHistory: boolean } | null };

export type WhatsappWindowStatesQueryVariables = Exact<{
  phones: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type WhatsappWindowStatesQuery = { __typename?: 'Query', whatsappWindowStates: Array<{ __typename?: 'WhatsappWindowState', phone: string, open: boolean, openUntil?: any | null }> };

export const BulkFlightActionFieldsFragmentDoc = gql`
    fragment BulkFlightActionFields on BulkFlightAction {
  id
  action
  visibility
  tagName
  cancelReason
  user
  createdAt
  undoExpiresAt
  undoable
  undoneAt
  undoneBy
  updated
  unchanged
  skipped
  flights {
    flightId
    date
    locationName
    result
    skipReason
    undoResult
    undoSkipReason
    bookingsNotRestored {
      bookingId
      reason
    }
  }
}
    `;
export const LogFragmentFragmentDoc = gql`
    fragment LogFragment on Log {
  id
  flightDate
  arrivalDateTime
  arrivalLocation
  balloon {
    callSign
    manufacturer
    model
  }
  flightDuration
  passengerCount
  pic {
    email
    name
    role
  }
  crew
  remarks
  takeoffDateTime
  takeoffLocation
  refuelVolume
  source
  sourceId
  FlightAppId
}
    `;
export const NotamInfoFieldsFragmentDoc = gql`
    fragment NotamInfoFields on NotamInfo {
  id
  designator
  fir
  category
  severity
  validFrom
  validTo
  schedule
  lowerFt
  upperFt
  lat
  lng
  radiusKm
  distanceKm
  bearingDeg
  wideArea
  text
}
    `;
export const NotamAssessmentFieldsFragmentDoc = gql`
    fragment NotamAssessmentFields on NotamAssessment {
  severity
  count
  notams {
    ...NotamInfoFields
  }
  wideAreaNotams {
    ...NotamInfoFields
  }
  updatedAt
  stale
  noData
}
    ${NotamInfoFieldsFragmentDoc}`;
export const GetBalloonsDocument = gql`
    query getBalloons {
  balloons {
    isCurrent
    callSign
    capacity
    id
    name
    thumbUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBalloonsGQL extends Apollo.Query<GetBalloonsQuery, GetBalloonsQueryVariables> {
    document = GetBalloonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogBooksBalloonsDocument = gql`
    query getLogBooksBalloons {
  balloons {
    isCurrent
    callSign
    capacity
    id
    name
    envelopeManufacturer
    envelopeType
    logbook {
      id
      statistics {
        totalFlightCount
        totalFlightMinutes
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogBooksBalloonsGQL extends Apollo.Query<GetLogBooksBalloonsQuery, GetLogBooksBalloonsQueryVariables> {
    document = GetLogBooksBalloonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBalloonDocument = gql`
    query getBalloon($balloonId: ID!) {
  balloon(balloonId: $balloonId) {
    id
    isCurrent
    name
    callSign
    capacity
    imageUrl
    thumbUrl
    classGroups
    mlm
    mtom
    liftWarningRedBelow
    liftWarningOrangeBelow
    minFuel
    balloonTemp
    envelopeManufacturer
    envelopeType
    envelopeVolume
    envelopeWeight
    envelopeHours
    envelopeInspectionDate
    burnerManufacturer
    burnerType
    burnerWeight
    basketManufacturer
    basketType
    basketWeight
    insuranceCompany
    insuranceDueDate
    cylinder {
      id
      emptyWeight
      fullWeight
      manufacturer
      volume
      number
      serialNumber
    }
    classGroup {
      id
      description
    }
    balloonWeight {
      totalWeight
      cylindersWeight
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBalloonGQL extends Apollo.Query<GetBalloonQuery, GetBalloonQueryVariables> {
    document = GetBalloonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetManufacturersDocument = gql`
    query getManufacturers {
  manufacturers {
    envelopeManufacturers
    basketManufacturers
    burnerManufacturers
    cylinderManufacturers
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetManufacturersGQL extends Apollo.Query<GetManufacturersQuery, GetManufacturersQueryVariables> {
    document = GetManufacturersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BalloonWeightDocument = gql`
    query balloonWeight($balloonId: ID!) {
  balloonWeight(balloonId: $balloonId) {
    totalWeight
    cylindersWeight
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BalloonWeightGQL extends Apollo.Query<BalloonWeightQuery, BalloonWeightQueryVariables> {
    document = BalloonWeightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveBalloonDocument = gql`
    mutation saveBalloon($balloonInput: BalloonInput!, $cylinders: [ID]!, $balloonId: ID) {
  saveBalloon(
    balloonInput: $balloonInput
    cylinders: $cylinders
    balloonId: $balloonId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBalloonGQL extends Apollo.Mutation<SaveBalloonMutation, SaveBalloonMutationVariables> {
    document = SaveBalloonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBalloonDocument = gql`
    mutation deleteBalloon($balloonId: ID!) {
  deleteBalloon(balloonId: $balloonId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBalloonGQL extends Apollo.Mutation<DeleteBalloonMutation, DeleteBalloonMutationVariables> {
    document = DeleteBalloonDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBookingDocument = gql`
    query getBooking($id: ID!) {
  booking(id: $id) {
    id
    inviteCount
    status
    onlineCheckinAt
    icon
    iconColor
    bookingDate
    contactName
    contactEmail
    contactPhone
    contactLanguage
    comments
    bookingCode
    startDate
    endDate
    daysExpired
    external
    externalSource
    city
    region {
      color
      id
      name
    }
    source
    locationType
    location {
      id
      name
      address
      city
      country
      height
      latitude
      longitude
      postalCode
      private
    }
    mailEventLatest {
      date
      event
    }
    availabilityType
    availabilityMondayMorning
    availabilityTuesdayMorning
    availabilityWednesdayMorning
    availabilityThursdayMorning
    availabilityFridayMorning
    availabilitySaturdayMorning
    availabilitySundayMorning
    availabilityMondayEvening
    availabilityTuesdayEvening
    availabilityWednesdayEvening
    availabilityThursdayEvening
    availabilityFridayEvening
    availabilitySaturdayEvening
    availabilitySundayEvening
    preferredFlights {
      date
      period
    }
    passengers {
      id
      name
      age
      transport
      luggage
      child
      comments
      disability
      weight
      weightIsDefault
      category {
        id
        passengerId
        name
        description
        price
        default
      }
      paymentType
      voucher {
        id
        voucherReference
        voucherType
        paymentStatus
      }
      paymentReference
      paymentAmount
      paymentStatus
      paymentDate
      email
      address
      postalCode
      city
      country
      signature
      voucherNumber
    }
    prepaymentAmount
    prepaymentDate
    invoiceName
    VATnumber
    passengerCounters {
      passengerCount
      unpaidPassengerCount
      childCount
      disabilityCount
      transportCount
      totalWeight
      totalAmount
      paidAmount
      openAmount
    }
    smsLatest {
      date
      direction
      summary
      status
      error
    }
    smsType
    smsUnread
    logsRemoved
    flight {
      id
      date
      hour
      hourMeeting
      period
      balloon {
        name
      }
      location {
        name
      }
    }
    mergeCandidates {
      bookingDate
      contactName
      flight {
        date
      }
      id
    }
    upUrl
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingGQL extends Apollo.Query<GetBookingQuery, GetBookingQueryVariables> {
    document = GetBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBookingFlightOptionsDocument = gql`
    query getBookingFlightOptions($id: ID!) {
  booking(id: $id) {
    id
    flightOptions {
      id
      date
      hour
      hourMeeting
      period
      balloon {
        name
      }
      location {
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingFlightOptionsGQL extends Apollo.Query<GetBookingFlightOptionsQuery, GetBookingFlightOptionsQueryVariables> {
    document = GetBookingFlightOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFirstBookingWithFlightDocument = gql`
    query getFirstBookingWithFlight {
  firstBookingWithFlight {
    id
    availabilityType
    status
    contactName
    contactPhone
    contactLanguage
    contactEmail
    comments
    bookingDate
    bookingCode
    region {
      name
    }
    passengerCounters {
      childCount
      passengerCount
      totalWeight
      totalAmount
      openAmount
      disabilityCount
      transportCount
    }
    smsType
    smsUnread
    flight {
      date
      period
      balloon {
        name
      }
      location {
        name
        city
        address
      }
      pilot {
        crew {
          name
        }
      }
      groundCrews {
        crew {
          email
          id
          language
          name
          pilotLicense
        }
        status
      }
    }
    upUrl
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFirstBookingWithFlightGQL extends Apollo.Query<GetFirstBookingWithFlightQuery, GetFirstBookingWithFlightQueryVariables> {
    document = GetFirstBookingWithFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBookingLogsDocument = gql`
    query getBookingLogs($id: ID!) {
  booking(id: $id) {
    logs {
      id
      date
      user
      action
      reason
      flight {
        id
        balloon {
          name
        }
        hour
        removed
      }
    }
    logsMerged {
      id
      date
      user
      action
      reason
      flight {
        id
        balloon {
          name
        }
        hour
        removed
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingLogsGQL extends Apollo.Query<GetBookingLogsQuery, GetBookingLogsQueryVariables> {
    document = GetBookingLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBookingMailsDocument = gql`
    query getBookingMails($id: ID!) {
  booking(id: $id) {
    mails {
      from {
        email
        name
      }
      replyTo {
        email
        name
      }
      to
      subject
      text
      html
      attachments {
        filename
      }
      result
      resultAt
      resultError
      events {
        event
        timestamp
        url
      }
    }
    mailsMerged {
      from {
        email
        name
      }
      replyTo {
        email
        name
      }
      to
      subject
      text
      html
      attachments {
        filename
      }
      result
      resultAt
      resultError
      events {
        event
        timestamp
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingMailsGQL extends Apollo.Query<GetBookingMailsQuery, GetBookingMailsQueryVariables> {
    document = GetBookingMailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingBookingsDocument = gql`
    query getUpcomingBookings($orderBy: OrderByBooking, $orderDirection: OrderDirection, $limit: NonNegativeInt, $cursor: String, $filter: [String], $bookingFilter: BookingFilter, $flightId: ID, $flightOnlyMatching: Boolean) {
  upcomingBookings(
    orderBy: $orderBy
    orderDirection: $orderDirection
    limit: $limit
    cursor: $cursor
    filter: $filter
    bookingFilter: $bookingFilter
    flightId: $flightId
    flightOnlyMatching: $flightOnlyMatching
  ) {
    availabilityType
    status
    onlineCheckinAt
    icon
    iconColor
    id
    inviteCount
    contactName
    contactPhone
    comments
    bookingCode
    bookingDate
    daysExpired
    city
    external
    externalSource
    locationType
    location {
      name
      city
    }
    mailEventLatest {
      date
      event
    }
    smsLatest {
      date
      direction
      summary
      text
      status
      error
    }
    smsUnread
    region {
      color
      name
    }
    passengers {
      name
      comments
      child
      disability
      weight
      weightIsDefault
    }
    passengerCounters {
      passengerCount
      childCount
      disabilityCount
      transportCount
      totalWeight
      totalAmount
      paidAmount
      openAmount
    }
    preferredDate
    preferredFlights {
      date
      period
    }
    flight {
      id
      date
      period
      balloon {
        name
      }
      location {
        name
        city
        address
      }
      pilot {
        crew {
          name
        }
      }
      groundCrews {
        crew {
          email
          id
          language
          name
          pilotLicense
        }
        status
      }
    }
    mismatchReasons
    upUrl
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUpcomingBookingsGQL extends Apollo.Query<GetUpcomingBookingsQuery, GetUpcomingBookingsQueryVariables> {
    document = GetUpcomingBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetHistoricalBookingsDocument = gql`
    query getHistoricalBookings($orderBy: OrderByBooking, $orderDirection: OrderDirection, $limit: NonNegativeInt, $cursor: String, $filter: [String]) {
  historicalBookings(
    orderBy: $orderBy
    orderDirection: $orderDirection
    limit: $limit
    cursor: $cursor
    filter: $filter
  ) {
    availabilityType
    status
    icon
    iconColor
    id
    bookingDate
    daysExpired
    contactName
    contactPhone
    comments
    bookingCode
    external
    externalSource
    locationType
    location {
      name
      city
    }
    region {
      color
      name
    }
    region {
      color
      name
    }
    city
    passengers {
      name
      weightIsDefault
    }
    passengerCounters {
      passengerCount
      childCount
      disabilityCount
      transportCount
      totalWeight
      totalAmount
      paidAmount
      openAmount
    }
    preferredDate
    preferredFlights {
      date
      period
    }
    flight {
      id
      date
      period
      balloon {
        name
      }
      location {
        name
        city
        address
      }
      pilot {
        crew {
          name
        }
      }
      groundCrews {
        crew {
          email
          id
          language
          name
          pilotLicense
        }
        status
      }
    }
    upUrl
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHistoricalBookingsGQL extends Apollo.Query<GetHistoricalBookingsQuery, GetHistoricalBookingsQueryVariables> {
    document = GetHistoricalBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingBookingsIsDocument = gql`
    query getUpcomingBookingsIS($showUpcoming: Boolean, $limit: NonNegativeInt, $cursor: String, $filter: [String], $orderBy: OrderByBooking, $orderDirection: OrderDirection, $bookingFilter: BookingFilter, $flightId: ID, $flightOnlyMatching: Boolean, $endAt: Boolean, $includeExpired: Boolean, $openAmountOnly: Boolean) {
  getBookingsIS(
    showUpcoming: $showUpcoming
    limit: $limit
    cursor: $cursor
    filter: $filter
    orderBy: $orderBy
    orderDirection: $orderDirection
    bookingFilter: $bookingFilter
    flightId: $flightId
    flightOnlyMatching: $flightOnlyMatching
    endAt: $endAt
    includeExpired: $includeExpired
    openAmountOnly: $openAmountOnly
  ) {
    availabilityType
    status
    onlineCheckinAt
    icon
    iconColor
    id
    inviteCount
    contactName
    contactPhone
    comments
    bookingCode
    bookingDate
    endDate
    daysExpired
    validUntil
    city
    external
    externalSource
    locationType
    location {
      name
      city
    }
    mailEventLatest {
      date
      event
    }
    smsLatest {
      date
      direction
      summary
      text
      status
      error
    }
    smsUnread
    region {
      id
      color
      name
    }
    passengers {
      name
      comments
      child
      disability
      weight
      weightIsDefault
    }
    passengerCounters {
      passengerCount
      childCount
      disabilityCount
      transportCount
      totalWeight
      totalAmount
      paidAmount
      openAmount
    }
    preferredDate
    preferredFlights {
      date
      period
    }
    logsRemoved
    flight {
      id
      date
      hour
      period
      balloonCapacityReduction
      balloon {
        name
        capacity
      }
      location {
        id
        name
        city
        address
      }
      pilot {
        crew {
          name
        }
      }
      groundCrews {
        crew {
          email
          id
          language
          name
          pilotLicense
        }
        status
      }
      passengersOccupancy
      passengersCount
    }
    mismatchReasons
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
    upUrl
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUpcomingBookingsIsGQL extends Apollo.Query<GetUpcomingBookingsIsQuery, GetUpcomingBookingsIsQueryVariables> {
    document = GetUpcomingBookingsIsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetHistoricalBookingsIsDocument = gql`
    query getHistoricalBookingsIS($showUpcoming: Boolean, $limit: NonNegativeInt, $cursor: String, $filter: [String], $orderBy: OrderByBooking, $orderDirection: OrderDirection, $bookingFilter: BookingFilter, $flightId: ID, $flightOnlyMatching: Boolean, $endAt: Boolean, $includeExpired: Boolean, $openAmountOnly: Boolean) {
  getBookingsIS(
    showUpcoming: $showUpcoming
    limit: $limit
    cursor: $cursor
    filter: $filter
    orderBy: $orderBy
    orderDirection: $orderDirection
    bookingFilter: $bookingFilter
    flightId: $flightId
    flightOnlyMatching: $flightOnlyMatching
    endAt: $endAt
    includeExpired: $includeExpired
    openAmountOnly: $openAmountOnly
  ) {
    availabilityType
    status
    onlineCheckinAt
    icon
    iconColor
    id
    bookingDate
    daysExpired
    contactName
    contactPhone
    comments
    bookingCode
    external
    externalSource
    locationType
    location {
      name
      city
    }
    region {
      color
      name
    }
    region {
      color
      name
    }
    city
    passengers {
      name
      weightIsDefault
    }
    passengerCounters {
      passengerCount
      childCount
      disabilityCount
      transportCount
      totalWeight
      totalAmount
      paidAmount
      openAmount
    }
    preferredDate
    preferredFlights {
      date
      period
    }
    flight {
      id
      date
      period
      balloon {
        name
      }
      location {
        name
        city
        address
      }
      pilot {
        crew {
          name
        }
      }
      groundCrews {
        crew {
          email
          id
          language
          name
          pilotLicense
        }
        status
      }
    }
    upUrl
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHistoricalBookingsIsGQL extends Apollo.Query<GetHistoricalBookingsIsQuery, GetHistoricalBookingsIsQueryVariables> {
    document = GetHistoricalBookingsIsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DashboardBookingsDocument = gql`
    query dashboardBookings {
  dashboardBookings {
    availabilityType
    status
    onlineCheckinAt
    icon
    iconColor
    id
    inviteCount
    bookingDate
    daysExpired
    city
    contactName
    contactPhone
    comments
    external
    externalSource
    mergeCandidates {
      id
      flight {
        date
      }
    }
    locationType
    location {
      name
      city
    }
    mailEventLatest {
      date
      event
    }
    smsLatest {
      date
      direction
      summary
      text
      status
      error
    }
    smsUnread
    region {
      color
      name
    }
    region {
      color
      name
    }
    preferredDate
    preferredFlights {
      date
      period
    }
    flight {
      id
      balloonCapacityReduction
      balloon {
        name
        capacity
      }
      date
      period
      passengersOccupancy
      passengersCount
      location {
        name
        city
        address
      }
      pilot {
        crew {
          name
        }
      }
      groundCrews {
        crew {
          email
          id
          language
          name
          pilotLicense
        }
        status
      }
    }
    passengers {
      name
      weightIsDefault
    }
    passengerCounters {
      passengerCount
      childCount
      disabilityCount
      transportCount
      totalWeight
      totalAmount
      paidAmount
      openAmount
    }
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DashboardBookingsGQL extends Apollo.Query<DashboardBookingsQuery, DashboardBookingsQueryVariables> {
    document = DashboardBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BookingsPreferredDateDocument = gql`
    query bookingsPreferredDate($preferredDateInput: PreferredDateInput) {
  bookingsPreferredDate(preferredDateInput: $preferredDateInput) {
    id
    flight {
      id
    }
    region {
      color
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BookingsPreferredDateGQL extends Apollo.Query<BookingsPreferredDateQuery, BookingsPreferredDateQueryVariables> {
    document = BookingsPreferredDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PassengerCountersDocument = gql`
    query passengerCounters($passengers: [PassengerInput]!) {
  passengerCounters(passengers: $passengers) {
    passengerCount
    childCount
    disabilityCount
    transportCount
    totalWeight
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PassengerCountersGQL extends Apollo.Query<PassengerCountersQuery, PassengerCountersQueryVariables> {
    document = PassengerCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BookingCountersDocument = gql`
    query bookingCounters {
  bookingCounters {
    upcoming
    historical
    toConfirm
    active
    expired
    toPlan
    invited
    confirmed
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BookingCountersGQL extends Apollo.Query<BookingCountersQuery, BookingCountersQueryVariables> {
    document = BookingCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BookingSearchCountsDocument = gql`
    query bookingSearchCounts($filter: [String]!, $openAmountOnly: Boolean) {
  bookingSearchCounts(filter: $filter, openAmountOnly: $openAmountOnly) {
    active
    expired
    history
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BookingSearchCountsGQL extends Apollo.Query<BookingSearchCountsQuery, BookingSearchCountsQueryVariables> {
    document = BookingSearchCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BookingFilterCountsDocument = gql`
    query bookingFilterCounts($bookingFilter: BookingFilter!, $openAmountOnly: Boolean, $filter: [String], $fresh: Boolean) {
  bookingFilterCounts(
    bookingFilter: $bookingFilter
    openAmountOnly: $openAmountOnly
    filter: $filter
    fresh: $fresh
  ) {
    openAmount
    tags {
      id
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BookingFilterCountsGQL extends Apollo.Query<BookingFilterCountsQuery, BookingFilterCountsQueryVariables> {
    document = BookingFilterCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BookingPickerExpiredCountDocument = gql`
    query bookingPickerExpiredCount($flightId: ID!, $flightOnlyMatching: Boolean, $filter: [String]) {
  bookingPickerExpiredCount(
    flightId: $flightId
    flightOnlyMatching: $flightOnlyMatching
    filter: $filter
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BookingPickerExpiredCountGQL extends Apollo.Query<BookingPickerExpiredCountQuery, BookingPickerExpiredCountQueryVariables> {
    document = BookingPickerExpiredCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BookingConversationsDocument = gql`
    query bookingConversations($offset: NonNegativeInt) {
  bookingConversations(offset: $offset) {
    id
    contactName
    contactPhone
    contactLanguage
    smsLatest {
      date
      direction
      summary
      status
      error
    }
    smsType
    smsUnread
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BookingConversationsGQL extends Apollo.Query<BookingConversationsQuery, BookingConversationsQueryVariables> {
    document = BookingConversationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBookingsOfFlightDocument = gql`
    query getBookingsOfFlight($flightId: ID!) {
  flight(flightId: $flightId) {
    bookings {
      id
      list {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingsOfFlightGQL extends Apollo.Query<GetBookingsOfFlightQuery, GetBookingsOfFlightQueryVariables> {
    document = GetBookingsOfFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBookingForPaymentFormDocument = gql`
    query getBookingForPaymentForm($id: ID!) {
  booking(id: $id) {
    id
    icon
    iconColor
    contactName
    contactPhone
    contactEmail
    comments
    invoiceName
    VATnumber
    prepaymentAmount
    prepaymentDate
    passengers {
      id
      category {
        id
        passengerId
        name
        description
        price
        default
      }
      child
      name
      paymentAmount
      paymentReference
      paymentStatus
      paymentType
      paymentDate
      weight
      voucher {
        id
        voucherReference
        voucherType
        paymentStatus
      }
      voucherNumber
    }
    passengerCounters {
      id
      openAmount
      paidAmount
      totalAmount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingForPaymentFormGQL extends Apollo.Query<GetBookingForPaymentFormQuery, GetBookingForPaymentFormQueryVariables> {
    document = GetBookingForPaymentFormDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBookingCommentsDocument = gql`
    mutation updateBookingComments($bookingId: ID!, $comments: String) {
  updateBookingComments(bookingId: $bookingId, comments: $comments)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBookingCommentsGQL extends Apollo.Mutation<UpdateBookingCommentsMutation, UpdateBookingCommentsMutationVariables> {
    document = UpdateBookingCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBookingTagsDocument = gql`
    mutation updateBookingTags($bookingId: ID!, $tags: [String]) {
  updateBookingTags(bookingId: $bookingId, tags: $tags)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBookingTagsGQL extends Apollo.Mutation<UpdateBookingTagsMutation, UpdateBookingTagsMutationVariables> {
    document = UpdateBookingTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBookingPreferredFlightsDocument = gql`
    mutation updateBookingPreferredFlights($bookingId: ID!, $preferredFlights: [PreferredFlightInput]) {
  updateBookingPreferredFlights(
    bookingId: $bookingId
    preferredFlights: $preferredFlights
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBookingPreferredFlightsGQL extends Apollo.Mutation<UpdateBookingPreferredFlightsMutation, UpdateBookingPreferredFlightsMutationVariables> {
    document = UpdateBookingPreferredFlightsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveBookingDocument = gql`
    mutation saveBooking($bookingInput: BookingInput!, $bookingId: ID, $locationInput: LocationInput) {
  saveBooking(
    bookingInput: $bookingInput
    bookingId: $bookingId
    locationInput: $locationInput
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBookingGQL extends Apollo.Mutation<SaveBookingMutation, SaveBookingMutationVariables> {
    document = SaveBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteBookingDocument = gql`
    mutation deleteBooking($bookingId: ID!) {
  deleteBooking(bookingId: $bookingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteBookingGQL extends Apollo.Mutation<DeleteBookingMutation, DeleteBookingMutationVariables> {
    document = DeleteBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBookingDocument = gql`
    mutation createBooking($flightId: ID!) {
  createBooking(flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBookingGQL extends Apollo.Mutation<CreateBookingMutation, CreateBookingMutationVariables> {
    document = CreateBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SavePassengerDocument = gql`
    mutation savePassenger($passengerInput: PassengerInput!, $passengerId: ID, $bookingId: ID!, $checkinFlightId: ID) {
  savePassenger(
    passengerInput: $passengerInput
    passengerId: $passengerId
    bookingId: $bookingId
    checkinFlightId: $checkinFlightId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SavePassengerGQL extends Apollo.Mutation<SavePassengerMutation, SavePassengerMutationVariables> {
    document = SavePassengerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePassengerDocument = gql`
    mutation deletePassenger($passengerId: ID!, $bookingId: ID!) {
  deletePassenger(passengerId: $passengerId, bookingId: $bookingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePassengerGQL extends Apollo.Mutation<DeletePassengerMutation, DeletePassengerMutationVariables> {
    document = DeletePassengerDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddPassengersDocument = gql`
    mutation addPassengers($bookingId: ID!, $count: Int) {
  addPassengers(bookingId: $bookingId, count: $count)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddPassengersGQL extends Apollo.Mutation<AddPassengersMutation, AddPassengersMutationVariables> {
    document = AddPassengersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CheckinPassengersDocument = gql`
    mutation checkinPassengers($bookingId: ID!) {
  checkinPassengers(bookingId: $bookingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CheckinPassengersGQL extends Apollo.Mutation<CheckinPassengersMutation, CheckinPassengersMutationVariables> {
    document = CheckinPassengersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkBookingPaidDocument = gql`
    mutation markBookingPaid($bookingId: ID!) {
  markBookingPaid(bookingId: $bookingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkBookingPaidGQL extends Apollo.Mutation<MarkBookingPaidMutation, MarkBookingPaidMutationVariables> {
    document = MarkBookingPaidDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddBookingsToFlightDocument = gql`
    mutation addBookingsToFlight($bookings: [ID]!, $flightId: ID!) {
  addBookingsToFlight(bookings: $bookings, flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddBookingsToFlightGQL extends Apollo.Mutation<AddBookingsToFlightMutation, AddBookingsToFlightMutationVariables> {
    document = AddBookingsToFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InviteBookingsToFlightDocument = gql`
    mutation inviteBookingsToFlight($bookings: [ID]!, $flightId: ID!) {
  inviteBookingsToFlight(bookings: $bookings, flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InviteBookingsToFlightGQL extends Apollo.Mutation<InviteBookingsToFlightMutation, InviteBookingsToFlightMutationVariables> {
    document = InviteBookingsToFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddAndConfirmBookingsToFlightDocument = gql`
    mutation addAndConfirmBookingsToFlight($bookings: [ID]!, $flightId: ID!) {
  addAndConfirmBookingsToFlight(bookings: $bookings, flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddAndConfirmBookingsToFlightGQL extends Apollo.Mutation<AddAndConfirmBookingsToFlightMutation, AddAndConfirmBookingsToFlightMutationVariables> {
    document = AddAndConfirmBookingsToFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmBookingToFlightDocument = gql`
    mutation confirmBookingToFlight($bookingId: ID!) {
  confirmBookingToFlight(bookingId: $bookingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmBookingToFlightGQL extends Apollo.Mutation<ConfirmBookingToFlightMutation, ConfirmBookingToFlightMutationVariables> {
    document = ConfirmBookingToFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveBookingFromFlightDocument = gql`
    mutation removeBookingFromFlight($bookingId: ID!) {
  removeBookingFromFlight(bookingId: $bookingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveBookingFromFlightGQL extends Apollo.Mutation<RemoveBookingFromFlightMutation, RemoveBookingFromFlightMutationVariables> {
    document = RemoveBookingFromFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveBookingPaymentDocument = gql`
    mutation saveBookingPayment($bookingId: ID!, $bookingPaymentInput: BookingPaymentInput!) {
  saveBookingPayment(
    bookingId: $bookingId
    bookingPaymentInput: $bookingPaymentInput
  ) {
    id
    contactPhone
    contactEmail
    invoiceName
    VATnumber
    prepaymentDate
    prepaymentAmount
    passengerCounters {
      id
      openAmount
      totalAmount
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveBookingPaymentGQL extends Apollo.Mutation<SaveBookingPaymentMutation, SaveBookingPaymentMutationVariables> {
    document = SaveBookingPaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SavePassengerPaymentDocument = gql`
    mutation savePassengerPayment($bookingId: ID!, $passengerId: ID!, $passengerPaymentInput: PassengerPaymentInput!) {
  savePassengerPayment(
    bookingId: $bookingId
    passengerId: $passengerId
    passengerPaymentInput: $passengerPaymentInput
  ) {
    id
    category {
      id
      passengerId
    }
    paymentReference
    child
    paymentStatus
    paymentType
    paymentDate
    paymentAmount
    voucher {
      id
    }
    voucherNumber
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SavePassengerPaymentGQL extends Apollo.Mutation<SavePassengerPaymentMutation, SavePassengerPaymentMutationVariables> {
    document = SavePassengerPaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePassengerPaymentStatusDocument = gql`
    mutation updatePassengerPaymentStatus($bookingId: ID!, $passengerId: ID!, $paymentStatus: PaymentStatus!) {
  updatePassengerPaymentStatus(
    bookingId: $bookingId
    passengerId: $passengerId
    paymentStatus: $paymentStatus
  ) {
    id
    paymentStatus
    paymentDate
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePassengerPaymentStatusGQL extends Apollo.Mutation<UpdatePassengerPaymentStatusMutation, UpdatePassengerPaymentStatusMutationVariables> {
    document = UpdatePassengerPaymentStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateBookingPaymentDocument = gql`
    mutation updateBookingPayment($bookingId: ID!, $paymentType: PaymentType!) {
  updateBookingPayment(bookingId: $bookingId, paymentType: $paymentType) {
    id
    contactEmail
    contactPhone
    prepaymentAmount
    prepaymentDate
    passengerCounters {
      openAmount
    }
    passengers {
      id
      category {
        id
        passengerId
      }
      paymentReference
      paymentStatus
      paymentType
      paymentDate
      voucher {
        id
      }
      voucherNumber
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateBookingPaymentGQL extends Apollo.Mutation<UpdateBookingPaymentMutation, UpdateBookingPaymentMutationVariables> {
    document = UpdateBookingPaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MergeBookingsDocument = gql`
    mutation mergeBookings($bookingIdFrom: ID!, $bookingIdTo: ID!) {
  mergeBookings(bookingIdFrom: $bookingIdFrom, bookingIdTo: $bookingIdTo) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MergeBookingsGQL extends Apollo.Mutation<MergeBookingsMutation, MergeBookingsMutationVariables> {
    document = MergeBookingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLogDocument = gql`
    mutation deleteLog($bookingId: ID!, $logId: ID!) {
  deleteLog(bookingId: $bookingId, logId: $logId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLogGQL extends Apollo.Mutation<DeleteLogMutation, DeleteLogMutationVariables> {
    document = DeleteLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendCheckinNotificationDocument = gql`
    mutation sendCheckinNotification($bookingId: ID!) {
  sendCheckinNotification(bookingId: $bookingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendCheckinNotificationGQL extends Apollo.Mutation<SendCheckinNotificationMutation, SendCheckinNotificationMutationVariables> {
    document = SendCheckinNotificationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBookingPassengerEmailsDocument = gql`
    query getBookingPassengerEmails($showUpcoming: Boolean, $filter: [String], $bookingFilter: BookingFilter, $openAmountOnly: Boolean) {
  getBookingPassengerEmails(
    showUpcoming: $showUpcoming
    filter: $filter
    bookingFilter: $bookingFilter
    openAmountOnly: $openAmountOnly
  ) {
    bookingId
    language
    email
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingPassengerEmailsGQL extends Apollo.Query<GetBookingPassengerEmailsQuery, GetBookingPassengerEmailsQueryVariables> {
    document = GetBookingPassengerEmailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BookingPoolCountsDocument = gql`
    query bookingPoolCounts {
  bookingPoolCounts {
    total
    toConfirm
    unplanned
    voucherExpiring
    openAmount
    favourite
    tags {
      id
      tag
      backgroundColor
      fontColor
      count
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BookingPoolCountsGQL extends Apollo.Query<BookingPoolCountsQuery, BookingPoolCountsQueryVariables> {
    document = BookingPoolCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalendarWeekDocument = gql`
    query calendarWeek($year: PositiveInt!, $week: PositiveInt!) {
  calendarWeek(year: $year, week: $week) {
    flights {
      id
      comment
      balloonCapacityReduction
      balloon {
        id
        name
        capacity
        thumbUrl
        liftWarningOrangeBelow
        liftWarningRedBelow
      }
      groundCrews {
        crew {
          id
          name
          driverLicenseCategory
        }
      }
      location {
        id
        name
        latitude
        longitude
        region {
          color
        }
      }
      date
      hour
      period
      pilot {
        crew {
          id
          name
        }
      }
      status
      published
      icon {
        sign
        color
      }
      passengerCounters {
        passengersCountConfirmed
        passengersCountAdded
      }
      tagsData {
        id
        tag
        backgroundColor
        fontColor
      }
      liftSpare
      tempTakeoff
      tempTakeoffManual
      meteo {
        tempTakeoff
        windGl
        flyability {
          verdict
        }
      }
    }
    events {
      id
      description
      date
      type
      availability
      period
      crew {
        id
        name
        isPilot
        driverLicenseCategory
      }
    }
    availabilityActive
    preferredCrews {
      balloon {
        id
        name
        callSign
      }
      pilot {
        id
        name
      }
      driver {
        id
        name
      }
      crew {
        id
        name
      }
    }
    openBookings {
      date
      period
      region {
        id
        name
        color
      }
      count
    }
    days {
      date
      sunrise
      sunset
      flyability {
        period
        assessment {
          verdict
          parameters {
            key
            band
          }
        }
      }
    }
    defaultLocation {
      id
      name
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalendarWeekGQL extends Apollo.Query<CalendarWeekQuery, CalendarWeekQueryVariables> {
    document = CalendarWeekDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalendarDocument = gql`
    query calendar($year: PositiveInt!, $month: PositiveInt!) {
  calendar(year: $year, month: $month) {
    flights {
      id
      comment
      balloonCapacityReduction
      balloon {
        id
        name
        callSign
        capacity
      }
      groundCrews {
        crew {
          id
          name
          isPilot
        }
        status
      }
      location {
        id
        name
        region {
          name
          id
          color
        }
      }
      date
      hour
      period
      pilot {
        crew {
          id
          name
          isCurrent
          isPilot
        }
        status
      }
      status
      passengersCount
    }
    events {
      id
      description
      date
      type
      availability
      period
      crew {
        id
        name
        isCurrent
        isGroundCrewCurrent
        isPilot
        driverLicenseCategory
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalendarGQL extends Apollo.Query<CalendarQuery, CalendarQueryVariables> {
    document = CalendarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CrewCalendarDocument = gql`
    query crewCalendar($year: PositiveInt!, $month: PositiveInt!, $userId: String) {
  crewCalendar(year: $year, month: $month, userId: $userId) {
    start
    meta {
      flightsMorning {
        flights {
          id
          location {
            region {
              name
              id
              color
            }
          }
        }
        totalFlights
        crewEvent {
          id
          date
          type
          availability
          period
          description
        }
        operatorEvents {
          id
          date
          type
          description
          period
        }
        selectedFlights {
          id
          comment
          balloon {
            id
            name
          }
          pilot {
            crew {
              name
            }
            status
          }
          groundCrews {
            crew {
              id
              name
            }
            status
          }
          date
          period
          hour
          hourMeeting
          location {
            id
            city
            name
            region {
              name
              id
              color
            }
          }
          status
          tagsData {
            id
            tag
            backgroundColor
            fontColor
          }
        }
      }
      flightsEvening {
        flights {
          id
          location {
            region {
              name
              id
              color
            }
          }
        }
        totalFlights
        crewEvent {
          id
          date
          type
          availability
          period
          description
        }
        operatorEvents {
          id
          date
          type
          description
          period
        }
        selectedFlights {
          id
          comment
          balloon {
            name
          }
          pilot {
            crew {
              name
            }
            status
          }
          groundCrews {
            crew {
              id
              name
            }
            status
          }
          date
          period
          hour
          hourMeeting
          location {
            id
            city
            name
            region {
              name
              id
              color
            }
          }
          status
          tagsData {
            id
            tag
            backgroundColor
            fontColor
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CrewCalendarGQL extends Apollo.Query<CrewCalendarQuery, CrewCalendarQueryVariables> {
    document = CrewCalendarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCategoriesDocument = gql`
    query getCategories {
  categories {
    id
    passengerId
    child
    default
    description
    name
    price
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCategoriesGQL extends Apollo.Query<GetCategoriesQuery, GetCategoriesQueryVariables> {
    document = GetCategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCategoryDocument = gql`
    query getCategory($categoryId: ID!) {
  category(categoryId: $categoryId) {
    id
    passengerId
    child
    default
    description
    name
    price
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCategoryGQL extends Apollo.Query<GetCategoryQuery, GetCategoryQueryVariables> {
    document = GetCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveCategoryDocument = gql`
    mutation saveCategory($categoryInput: CategoryInput!, $categoryId: ID) {
  saveCategory(categoryInput: $categoryInput, categoryId: $categoryId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveCategoryGQL extends Apollo.Mutation<SaveCategoryMutation, SaveCategoryMutationVariables> {
    document = SaveCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCategoryDocument = gql`
    mutation deleteCategory($categoryId: ID!) {
  deleteCategory(categoryId: $categoryId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCategoryGQL extends Apollo.Mutation<DeleteCategoryMutation, DeleteCategoryMutationVariables> {
    document = DeleteCategoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PassengerRegionDistributionDocument = gql`
    query passengerRegionDistribution {
  passengerRegionDistribution {
    type
    data
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PassengerRegionDistributionGQL extends Apollo.Query<PassengerRegionDistributionQuery, PassengerRegionDistributionQueryVariables> {
    document = PassengerRegionDistributionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCountriesDocument = gql`
    query getCountries {
  countries {
    id
    country
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCountriesGQL extends Apollo.Query<GetCountriesQuery, GetCountriesQueryVariables> {
    document = GetCountriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCrewsDocument = gql`
    query getCrews {
  crews {
    driverLicense
    driverLicenseCategory
    groundCrew
    id
    isCurrent
    isGroundCrewCurrent
    isPilot
    language
    licenseExpiryDate
    licenseGas
    licenseGroupA
    licenseGroupB
    licenseGroupC
    licenseGroupD
    medicalExpiryDate
    name
    phone
    pilotLicense
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCrewsGQL extends Apollo.Query<GetCrewsQuery, GetCrewsQueryVariables> {
    document = GetCrewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogBooksCrewsDocument = gql`
    query getLogBooksCrews {
  crews {
    id
    isCurrent
    isGroundCrewCurrent
    isPilot
    medicalExpiryDate
    name
    email
    phone
    pilotLicense
    logbook {
      id
      statistics {
        totalFlightCount
        totalFlightMinutes
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogBooksCrewsGQL extends Apollo.Query<GetLogBooksCrewsQuery, GetLogBooksCrewsQueryVariables> {
    document = GetLogBooksCrewsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCrewDocument = gql`
    query getCrew($crewId: ID!) {
  crew(crewId: $crewId) {
    driverLicense
    driverLicenseCategory
    email
    emailNotifications
    groundCrew
    groundCrewTrainingExpiryDate
    id
    isCurrent
    isGroundCrewCurrent
    isPilot
    language
    licenseExpiryDate
    licenseExtraCrew
    licenseGas
    licenseGroupA
    licenseGroupB
    licenseGroupC
    licenseGroupD
    licenseNumber
    medicalExpiryDate
    firstAidExpiryDate
    fireExtinguisherExpiryDate
    medicalWeight
    name
    phone
    pilotLicense
    smsLatest {
      date
      direction
      summary
      status
      error
    }
    smsType
    smsUnread
    userRole
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCrewGQL extends Apollo.Query<GetCrewQuery, GetCrewQueryVariables> {
    document = GetCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CrewConversationsDocument = gql`
    query crewConversations($offset: NonNegativeInt) {
  crewConversations(offset: $offset) {
    id
    name
    phone
    language
    smsLatest {
      date
      direction
      summary
      status
      error
    }
    smsType
    smsUnread
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CrewConversationsGQL extends Apollo.Query<CrewConversationsQuery, CrewConversationsQueryVariables> {
    document = CrewConversationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CrewsPerFlightDocument = gql`
    query crewsPerFlight($flightId: ID!) {
  crewsPerFlight(flightId: $flightId) {
    availability
    availabilityReason
    driverLicenseCategory
    groundCrew
    id
    isCurrent
    isGroundCrewCurrent
    isPilot
    name
    pilotLicense
    otherFlight {
      id
      balloon {
        name
      }
    }
    popularity
    mostPopular
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CrewsPerFlightGQL extends Apollo.Query<CrewsPerFlightQuery, CrewsPerFlightQueryVariables> {
    document = CrewsPerFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PilotsPerFlightDocument = gql`
    query pilotsPerFlight($flightId: ID!) {
  crewsPerFlight(flightId: $flightId) {
    availability
    availabilityReason
    groundCrew
    id
    isCurrent
    isPilot
    name
    pilotLicense
    otherFlight {
      id
      balloon {
        name
      }
    }
    popularity
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PilotsPerFlightGQL extends Apollo.Query<PilotsPerFlightQuery, PilotsPerFlightQueryVariables> {
    document = PilotsPerFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllCrewForDialogDocument = gql`
    query getAllCrewForDialog {
  crews {
    id
    name
    isCurrent
    isGroundCrewCurrent
    isPilot
    driverLicenseCategory
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllCrewForDialogGQL extends Apollo.Query<GetAllCrewForDialogQuery, GetAllCrewForDialogQueryVariables> {
    document = GetAllCrewForDialogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveCrewDocument = gql`
    mutation saveCrew($crewInput: CrewInput!, $crewId: ID) {
  saveCrew(crewInput: $crewInput, crewId: $crewId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveCrewGQL extends Apollo.Mutation<SaveCrewMutation, SaveCrewMutationVariables> {
    document = SaveCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCrewDocument = gql`
    mutation deleteCrew($crewId: ID!) {
  deleteCrew(crewId: $crewId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCrewGQL extends Apollo.Mutation<DeleteCrewMutation, DeleteCrewMutationVariables> {
    document = DeleteCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCylindersDocument = gql`
    query getCylinders {
  cylinders {
    id
    number
    emptyWeight
    fullWeight
    manufacturer
    serialNumber
    volume
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCylindersGQL extends Apollo.Query<GetCylindersQuery, GetCylindersQueryVariables> {
    document = GetCylindersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCylinderDocument = gql`
    query getCylinder($cylinderId: ID!) {
  cylinder(cylinderId: $cylinderId) {
    emptyWeight
    fullWeight
    id
    manufacturer
    serialNumber
    volume
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCylinderGQL extends Apollo.Query<GetCylinderQuery, GetCylinderQueryVariables> {
    document = GetCylinderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveCylinderDocument = gql`
    mutation saveCylinder($cylinderInput: CylinderInput!, $cylinderId: ID) {
  saveCylinder(cylinderInput: $cylinderInput, cylinderId: $cylinderId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveCylinderGQL extends Apollo.Mutation<SaveCylinderMutation, SaveCylinderMutationVariables> {
    document = SaveCylinderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCylinderDocument = gql`
    mutation deleteCylinder($cylinderId: ID!) {
  deleteCylinder(cylinderId: $cylinderId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCylinderGQL extends Apollo.Mutation<DeleteCylinderMutation, DeleteCylinderMutationVariables> {
    document = DeleteCylinderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllEmailTemplatesDocument = gql`
    query getAllEmailTemplates {
  getAllEmailTemplates {
    id
    template {
      en {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      fr {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      nl {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      de {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
    }
    type
    title
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllEmailTemplatesGQL extends Apollo.Query<GetAllEmailTemplatesQuery, GetAllEmailTemplatesQueryVariables> {
    document = GetAllEmailTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ParseEmailTemplateDocument = gql`
    query parseEmailTemplate($emailBody: String!, $language: String!, $flightPeriod: String!) {
  parseEmailTemplate(
    emailBody: $emailBody
    language: $language
    flightPeriod: $flightPeriod
  ) {
    body
    subject
    attachments {
      filename
      reference
      type
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ParseEmailTemplateGQL extends Apollo.Query<ParseEmailTemplateQuery, ParseEmailTemplateQueryVariables> {
    document = ParseEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailTemplateDocument = gql`
    query getEmailTemplate($type: EmailTemplateType!) {
  getEmailTemplate(type: $type) {
    id
    title
    type
    template {
      en {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      fr {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      nl {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      de {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmailTemplateGQL extends Apollo.Query<GetEmailTemplateQuery, GetEmailTemplateQueryVariables> {
    document = GetEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailTemplateByIdDocument = gql`
    query getEmailTemplateByID($id: ID!) {
  getEmailTemplateByID(id: $id) {
    id
    title
    type
    template {
      en {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      fr {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      nl {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      de {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmailTemplateByIdGQL extends Apollo.Query<GetEmailTemplateByIdQuery, GetEmailTemplateByIdQueryVariables> {
    document = GetEmailTemplateByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailTemplatesDocument = gql`
    query getEmailTemplates($type: EmailTemplateType!) {
  getEmailTemplates(type: $type) {
    id
    title
    type
    template {
      en {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      fr {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      nl {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      de {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmailTemplatesGQL extends Apollo.Query<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables> {
    document = GetEmailTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEmailTemplateByLanguageDocument = gql`
    query getEmailTemplateByLanguage($type: EmailTemplateType!, $lang: ContactLanguage!) {
  getEmailTemplateByLanguage(type: $type, lang: $lang) {
    body
    subject
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEmailTemplateByLanguageGQL extends Apollo.Query<GetEmailTemplateByLanguageQuery, GetEmailTemplateByLanguageQueryVariables> {
    document = GetEmailTemplateByLanguageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddEmailOutDocument = gql`
    mutation addEmailOut($emailInput: EmailInput!) {
  addEmailOut(emailInput: $emailInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEmailOutGQL extends Apollo.Mutation<AddEmailOutMutation, AddEmailOutMutationVariables> {
    document = AddEmailOutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyEmailTemplateDocument = gql`
    mutation copyEmailTemplate($emailTemplateId: ID!) {
  copyEmailTemplate(emailTemplateId: $emailTemplateId) {
    id
    type
    title
    template {
      en {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      fr {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      nl {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      de {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyEmailTemplateGQL extends Apollo.Mutation<CopyEmailTemplateMutation, CopyEmailTemplateMutationVariables> {
    document = CopyEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddEmailTemplateLocationContactDocument = gql`
    mutation addEmailTemplateLocationContact {
  addEmailTemplateLocationContact {
    id
    type
    title
    template {
      en {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      fr {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      nl {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      de {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddEmailTemplateLocationContactGQL extends Apollo.Mutation<AddEmailTemplateLocationContactMutation, AddEmailTemplateLocationContactMutationVariables> {
    document = AddEmailTemplateLocationContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEmailTemplateDocument = gql`
    mutation deleteEmailTemplate($emailTemplateId: ID!) {
  deleteEmailTemplate(emailTemplateId: $emailTemplateId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEmailTemplateGQL extends Apollo.Mutation<DeleteEmailTemplateMutation, DeleteEmailTemplateMutationVariables> {
    document = DeleteEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveEmailTemplateDocument = gql`
    mutation saveEmailTemplate($emailTemplateInput: EmailTemplateInput, $emailTemplateId: ID!) {
  saveEmailTemplate(
    emailTemplateInput: $emailTemplateInput
    emailTemplateId: $emailTemplateId
  ) {
    id
    type
    title
    template {
      en {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      fr {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      nl {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
      de {
        body
        subject
        attachments {
          filename
          reference
          type
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveEmailTemplateGQL extends Apollo.Mutation<SaveEmailTemplateMutation, SaveEmailTemplateMutationVariables> {
    document = SaveEmailTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEventsDocument = gql`
    query getEvents {
  events {
    id
    description
    date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEventsGQL extends Apollo.Query<GetEventsQuery, GetEventsQueryVariables> {
    document = GetEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteEventDocument = gql`
    mutation deleteEvent($eventId: ID!) {
  deleteEvent(eventId: $eventId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteEventGQL extends Apollo.Mutation<DeleteEventMutation, DeleteEventMutationVariables> {
    document = DeleteEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveEventDocument = gql`
    mutation saveEvent($eventInput: EventInput!, $eventId: ID) {
  saveEvent(eventInput: $eventInput, eventId: $eventId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveEventGQL extends Apollo.Mutation<SaveEventMutation, SaveEventMutationVariables> {
    document = SaveEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveCrewAvailabilityDocument = gql`
    mutation saveCrewAvailability($crewAvailabilityInput: CrewAvailabilityInput!, $eventId: ID) {
  saveCrewAvailability(
    crewAvailabilityInput: $crewAvailabilityInput
    eventId: $eventId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveCrewAvailabilityGQL extends Apollo.Mutation<SaveCrewAvailabilityMutation, SaveCrewAvailabilityMutationVariables> {
    document = SaveCrewAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetMonthAvailabilityDocument = gql`
    mutation setMonthAvailability($availability: CrewAvailability!, $year: PositiveInt!, $month: PositiveInt!, $crewId: ID!) {
  setMonthAvailability(
    availability: $availability
    year: $year
    month: $month
    crewId: $crewId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetMonthAvailabilityGQL extends Apollo.Mutation<SetMonthAvailabilityMutation, SetMonthAvailabilityMutationVariables> {
    document = SetMonthAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteMonthAvailabilityEventsDocument = gql`
    mutation deleteMonthAvailabilityEvents($year: PositiveInt!, $month: PositiveInt!, $crewId: ID!) {
  deleteMonthAvailabilityEvents(year: $year, month: $month, crewId: $crewId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteMonthAvailabilityEventsGQL extends Apollo.Mutation<DeleteMonthAvailabilityEventsMutation, DeleteMonthAvailabilityEventsMutationVariables> {
    document = DeleteMonthAvailabilityEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchHolidaysDocument = gql`
    mutation fetchHolidays($year: PositiveInt!, $countryCode: String, $language: String) {
  fetchHolidays(year: $year, countryCode: $countryCode, language: $language)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchHolidaysGQL extends Apollo.Mutation<FetchHolidaysMutation, FetchHolidaysMutationVariables> {
    document = FetchHolidaysDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkFlightSelectionDocument = gql`
    query bulkFlightSelection($filter: [String], $filterRange: FilterRangeInput, $freeSpots: Int, $scope: UpcomingFlightScope) {
  bulkFlightSelection(
    filter: $filter
    filterRange: $filterRange
    freeSpots: $freeSpots
    scope: $scope
  ) {
    total
    flightIds
    limit
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkFlightSelectionGQL extends Apollo.Query<BulkFlightSelectionQuery, BulkFlightSelectionQueryVariables> {
    document = BulkFlightSelectionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkFlightActionPreviewDocument = gql`
    query bulkFlightActionPreview($flightIds: [ID!]!, $input: BulkFlightActionInput!) {
  bulkFlightActionPreview(flightIds: $flightIds, input: $input) {
    willUpdate
    unchanged
    skipped {
      reason
      count
    }
    firstDate
    lastDate
    bookingsAffected
    passengersAffected
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkFlightActionPreviewGQL extends Apollo.Query<BulkFlightActionPreviewQuery, BulkFlightActionPreviewQueryVariables> {
    document = BulkFlightActionPreviewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RecentBulkFlightActionsDocument = gql`
    query recentBulkFlightActions {
  recentBulkFlightActions {
    ...BulkFlightActionFields
  }
}
    ${BulkFlightActionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RecentBulkFlightActionsGQL extends Apollo.Query<RecentBulkFlightActionsQuery, RecentBulkFlightActionsQueryVariables> {
    document = RecentBulkFlightActionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkFlightActionDocument = gql`
    mutation bulkFlightAction($flightIds: [ID!]!, $input: BulkFlightActionInput!) {
  bulkFlightAction(flightIds: $flightIds, input: $input) {
    ...BulkFlightActionFields
  }
}
    ${BulkFlightActionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkFlightActionGQL extends Apollo.Mutation<BulkFlightActionMutation, BulkFlightActionMutationVariables> {
    document = BulkFlightActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UndoBulkFlightActionDocument = gql`
    mutation undoBulkFlightAction($actionId: ID!) {
  undoBulkFlightAction(actionId: $actionId) {
    ...BulkFlightActionFields
  }
}
    ${BulkFlightActionFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UndoBulkFlightActionGQL extends Apollo.Mutation<UndoBulkFlightActionMutation, UndoBulkFlightActionMutationVariables> {
    document = UndoBulkFlightActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightDocument = gql`
    query getFlight($flightId: ID!) {
  flight(flightId: $flightId) {
    comment
    published
    removed
    crewComments
    cancelReason
    date
    hour
    hourMeeting
    icon {
      color
      sign
    }
    id
    cancelMessageSent
    cancelMessageReason
    landingLocation
    landingTime
    landingDetails
    landingLatitude
    landingLongitude
    liftAvailable
    liftDataMismatch
    liftNeeded
    liftPassengers
    liftSpare
    liftWarningLevel
    locationType
    meetingPointSameAsTakeOff
    meetingPointAddress
    meetingPointLatitude
    meetingPointLongitude
    meetingPointURL
    meetingPointCity
    maximumFlightTime
    maximumHeight
    period
    pilotComments
    plannedFlightTime
    status
    takeoffTime
    tempBalloon
    tempMax
    tempTakeoff
    tempTakeoffManual
    vfrClouds
    vfrVisual
    visibility
    weatherForecastDate
    weatherPmax
    weatherQnh
    weatherSource
    wind10
    wind10Direction
    wind20
    wind20Direction
    windGl
    windGlDirection
    windSummary
    refuelVolume
    groundCrews {
      crew {
        availability
        availabilityReason
        driverLicenseCategory
        email
        emailNotifications
        id
        language
        name
        pilotLicense
      }
      status
    }
    passengersCount
    passengersOccupancy
    pilot {
      crew {
        id
        isPilot
        name
        language
        email
        emailNotifications
        pilotLicense
        isCurrent
        medicalWeight
        phone
        totalWeight
      }
      status
    }
    flightsAtSameDay {
      flights {
        id
      }
      count
      names
    }
    flightDuplicates {
      id
    }
    flightDuplicatesBlocking
    flightTime
    flightDistance
    flightHeading
    notam {
      severity
      count
      at
      noData
    }
    balloonCapacityReduction
    balloon {
      balloonTemp
      basketWeight
      burnerWeight
      callSign
      capacity
      envelopeType
      envelopeVolume
      envelopeWeight
      id
      isCurrent
      name
      minFuel
      balloonWeight {
        cylindersWeight
      }
    }
    location {
      id
      address
      city
      country
      contact {
        comment
        email
        emailTemplate
        name
        phone
        language
        smsTemplate
        media
      }
      meetingPointSameAsTakeOff
      meetingPointAddress
      meetingPointLatitude
      meetingPointLongitude
      meetingPointURL
      meetingPointCity
      description
      height
      id
      latitude
      longitude
      maximumHeight
      name
      postalCode
      timezone
      region {
        id
        name
      }
    }
    locationEmail {
      date
      event
    }
    locationSmsLatest {
      date
      direction
      summary
      status
      error
    }
    sunriseSunset {
      sunrise
      sunset
      morningFlight
      eveningFlight
    }
    meteo {
      slot
      flyability {
        verdict
        parameters {
          key
          value
          band
        }
      }
      forecast {
        datepart {
          part
          text
        }
        daytime
        flytime
        lastUpdate
        latitude
        longitude
        lowCloudsData
        pictoCodeData
        precipitationData
        pressureData
        sunrise
        sunset
        temperatureData
        time
        utc_timeoffset
        visibilityData
        windDirectionData
        windDirectionData_1000
        windDirectionData_500
        windDirectionData_550
        windDirectionData_600
        windDirectionData_650
        windDirectionData_700
        windDirectionData_750
        windDirectionData_800
        windDirectionData_925
        windDirectionData_950
        windDirectionData_975
        windGustData
        windSpeedData
        windSpeedData_1000
        windSpeedData_500
        windSpeedData_550
        windSpeedData_600
        windSpeedData_650
        windSpeedData_700
        windSpeedData_750
        windSpeedData_800
        windSpeedData_925
        windSpeedData_950
        windSpeedData_975
      }
      tempTakeoff
      vfrVisual
      weatherQnh
      wind10
      wind10Direction
      wind20
      wind20Direction
      windGl
      windGlDirection
    }
    bookings {
      id
      list {
        id
        icon
        iconColor
        inviteCount
        city
        contactName
        contactPhone
        contactEmail
        contactLanguage
        comments
        status
        onlineCheckinAt
        checkinNotifiedAt
        prepaymentAmount
        prepaymentDate
        invoiceName
        VATnumber
        mismatchReasons
        region {
          name
        }
        logsRemoved
        locationType
        location {
          address
          city
          description
          height
          id
          latitude
          longitude
          maximumHeight
          name
        }
        passengers {
          age
          transport
          category {
            id
            passengerId
            name
            description
          }
          child
          comments
          disability
          luggage
          name
          paymentAmount
          paymentReference
          paymentStatus
          paymentType
          totalWeight
          weight
          weightIsDefault
          voucherNumber
          voucher {
            voucherReference
          }
        }
        passengerCounters {
          id
          childCount
          disabilityCount
          transportCount
          openAmount
          paidAmount
          passengerCount
          totalAmount
          totalWeight
          unpaidPassengerCount
        }
        smsLatest {
          date
          direction
          summary
          status
          error
        }
        smsType
        smsUnread
        upUrl
        tags {
          id
          tag
          backgroundColor
          fontColor
        }
      }
      addedCount
      notConfirmedCount
      notConfirmedNames
    }
    cancelledBookings {
      id
      icon
      iconColor
      inviteCount
      city
      contactName
      contactPhone
      contactEmail
      contactLanguage
      comments
      status
      prepaymentAmount
      prepaymentDate
      invoiceName
      VATnumber
      mismatchReasons
      region {
        name
      }
      logsRemoved
      locationType
      location {
        address
        city
        description
        height
        id
        latitude
        longitude
        maximumHeight
        name
      }
      passengers {
        age
        transport
        category {
          id
          passengerId
          name
          description
        }
        child
        comments
        disability
        luggage
        name
        paymentAmount
        paymentReference
        paymentStatus
        paymentType
        totalWeight
        weight
        weightIsDefault
        voucherNumber
        voucher {
          voucherReference
        }
      }
      passengerCounters {
        id
        childCount
        disabilityCount
        transportCount
        openAmount
        paidAmount
        passengerCount
        totalAmount
        totalWeight
        unpaidPassengerCount
      }
      smsLatest {
        date
        direction
        summary
        status
        error
      }
      smsType
      smsUnread
      upUrl
      tags {
        id
        tag
        backgroundColor
        fontColor
      }
      flight {
        id
        date
        period
        balloonCapacityReduction
        balloon {
          name
          capacity
        }
        passengersOccupancy
        passengersCount
      }
    }
    passengerCounters {
      id
      passengersCountAdded
      passengersCountInvited
      passengersCountConfirmed
      passengersWeight
    }
    logs {
      date
    }
    trajectory {
      lat
      lng
      alt
      distance
    }
    trajectoryCustom {
      lat
      lng
      alt
      distance
    }
    trajectory1000 {
      lat
      lng
      alt
      distance
    }
    trajectory950 {
      lat
      lng
      alt
      distance
    }
    trajectory925 {
      lat
      lng
      alt
      distance
    }
    trajectory800 {
      lat
      lng
      alt
      distance
    }
    trajectory700 {
      lat
      lng
      alt
      distance
    }
    trajectory600 {
      lat
      lng
      alt
      distance
    }
    trajectory500 {
      lat
      lng
      alt
      distance
    }
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
    skeyesForecast {
      username
      date
      forecast {
        datetime
        full
        inversions
        issued
        outlook
        period
        slot
        weather
        winds
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightGQL extends Apollo.Query<GetFlightQuery, GetFlightQueryVariables> {
    document = GetFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightDashboardDocument = gql`
    query getFlightDashboard($flightId: ID!) {
  flight(flightId: $flightId) {
    date
    hour
    hourMeeting
    icon {
      color
      sign
    }
    id
    period
    status
    liftSpare
    liftWarningLevel
    tempTakeoff
    tempTakeoffManual
    notam {
      severity
      count
      at
      noData
    }
    meteo {
      tempTakeoff
      weatherQnh
      wind10
      wind10Direction
      wind20
      wind20Direction
      windGl
      windGlDirection
    }
    passengerCounters {
      id
      passengersCountAdded
      passengersCountInvited
      passengersCountConfirmed
      passengersWeight
    }
    pilot {
      crew {
        id
        isGroundCrewCurrent
        isPilot
        name
        language
        email
        emailNotifications
        pilotLicense
        isCurrent
        medicalWeight
        phone
        totalWeight
      }
      status
    }
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
    }
    location {
      id
      name
    }
    passengerCounters {
      id
      passengersCountAdded
      passengersCountInvited
      passengersCountConfirmed
      passengersWeight
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
    bookings {
      id
      list {
        id
        icon
        iconColor
        inviteCount
        city
        contactName
        contactPhone
        contactEmail
        contactLanguage
        comments
        status
        onlineCheckinAt
        prepaymentAmount
        prepaymentDate
        invoiceName
        VATnumber
        mismatchReasons
        region {
          name
        }
        locationType
        location {
          address
          city
          description
          height
          id
          latitude
          longitude
          maximumHeight
          name
        }
        passengers {
          age
          transport
          category {
            id
            passengerId
            name
            description
          }
          child
          comments
          disability
          luggage
          name
          paymentAmount
          paymentReference
          paymentStatus
          paymentType
          totalWeight
          weight
          weightIsDefault
          voucherNumber
          voucher {
            voucherReference
          }
        }
        passengerCounters {
          id
          childCount
          disabilityCount
          transportCount
          openAmount
          paidAmount
          passengerCount
          totalAmount
          totalWeight
          unpaidPassengerCount
        }
        smsLatest {
          date
          direction
          summary
          status
          error
        }
        smsType
        smsUnread
        upUrl
        tags {
          id
          tag
          backgroundColor
          fontColor
        }
      }
      addedCount
      notConfirmedCount
      notConfirmedNames
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightDashboardGQL extends Apollo.Query<GetFlightDashboardQuery, GetFlightDashboardQueryVariables> {
    document = GetFlightDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightLogsDocument = gql`
    query getFlightLogs($flightId: ID!) {
  flight(flightId: $flightId) {
    logs {
      id
      date
      user
      action
      reason
      booking {
        id
        contactName
        removed
        status
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightLogsGQL extends Apollo.Query<GetFlightLogsQuery, GetFlightLogsQueryVariables> {
    document = GetFlightLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetBookingFlightDocument = gql`
    query getBookingFlight($flightId: ID!) {
  flight(flightId: $flightId) {
    id
    date
    hour
    hourMeeting
    comment
    period
    icon {
      sign
      color
    }
    pilot {
      crew {
        id
        isCurrent
        isPilot
        licenseExpiryDate
        medicalExpiryDate
        name
      }
    }
    groundCrews {
      crew {
        id
        isPilot
        name
        driverLicenseCategory
      }
    }
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      id
      name
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
    passengersData {
      occupancy
      passengersCount
      openAmount
    }
    passengerCounters {
      passengersCountConfirmed
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetBookingFlightGQL extends Apollo.Query<GetBookingFlightQuery, GetBookingFlightQueryVariables> {
    document = GetBookingFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetMobileFlightDocument = gql`
    query getMobileFlight($flightId: ID!) {
  flight(flightId: $flightId) {
    comment
    crewComments
    date
    hour
    hourMeeting
    id
    landingTime
    landingDetails
    landingLatitude
    landingLongitude
    landingLocation
    liftAvailable
    liftNeeded
    liftSpare
    liftWarningLevel
    meetingPointSameAsTakeOff
    meetingPointAddress
    meetingPointLatitude
    meetingPointLongitude
    meetingPointURL
    meetingPointCity
    maximumFlightTime
    period
    plannedFlightTime
    spareFlightTime
    takeoffTime
    tempBalloon
    tempTakeoff
    weatherQnh
    wind10
    wind10Direction
    wind20
    wind20Direction
    windGl
    windGlDirection
    windSummary
    refuelVolume
    icon {
      sign
      color
    }
    pilot {
      crew {
        id
        isCurrent
        isPilot
        licenseExpiryDate
        medicalExpiryDate
        name
      }
    }
    pilotComments
    pilotSignature
    pilotSignOffDate
    balloonCapacityReduction
    balloon {
      id
      balloonTemp
      capacity
      envelopeInspectionDate
      envelopeType
      insuranceDueDate
      isCurrent
      name
    }
    location {
      address
      name
    }
    passengerCounters {
      passengersCountConfirmed
    }
    bookings {
      list {
        comments
        contactLanguage
        contactName
        contactPhone
        id
        status
        tags {
          id
          tag
          backgroundColor
          fontColor
        }
        passengerCounters {
          openAmount
        }
        passengers {
          accompany
          address
          age
          transport
          category {
            id
            passengerId
            name
            description
          }
          child
          city
          country
          comments
          disability
          email
          id
          luggage
          name
          paymentAmount
          paymentReference
          paymentStatus
          paymentType
          postalCode
          signature
          weight
          voucherNumber
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetMobileFlightGQL extends Apollo.Query<GetMobileFlightQuery, GetMobileFlightQueryVariables> {
    document = GetMobileFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCertificateFlightDocument = gql`
    query getCertificateFlight($flightId: ID!) {
  flight(flightId: $flightId) {
    date
    location {
      name
    }
    bookings {
      list {
        passengers {
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCertificateFlightGQL extends Apollo.Query<GetCertificateFlightQuery, GetCertificateFlightQueryVariables> {
    document = GetCertificateFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightsOfDashboardDocument = gql`
    query getFlightsOfDashboard {
  flightsOfDashboard {
    balloon {
      id
      name
      isCurrent
    }
    id
    period
    date
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightsOfDashboardGQL extends Apollo.Query<GetFlightsOfDashboardQuery, GetFlightsOfDashboardQueryVariables> {
    document = GetFlightsOfDashboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingFlightsDocument = gql`
    query getUpcomingFlights($orderBy: OrderByFlight, $orderDirection: OrderDirection, $limit: NonNegativeInt, $cursor: String, $filter: String) {
  upcomingFlights(
    orderBy: $orderBy
    orderDirection: $orderDirection
    limit: $limit
    cursor: $cursor
    filter: $filter
  ) {
    id
    cancelMessageSent
    cancelMessageReason
    date
    period
    hour
    hourMeeting
    status
    visibility
    comment
    cancelReason
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      id
      name
      city
      address
    }
    passengersCount
    passengersOccupancy
    pilot {
      crew {
        id
        isPilot
        isCurrent
        name
      }
    }
    groundCrews {
      crew {
        id
        name
        driverLicenseCategory
      }
    }
    icon {
      sign
      color
    }
    bookings {
      id
      list {
        id
        status
        contactName
        passengers {
          id
          name
        }
      }
      count
    }
    passengersData {
      passengersCount
      passengersWeight
      freeSpots
      occupancy
      openAmount
    }
    events {
      id
      description
      date
    }
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUpcomingFlightsGQL extends Apollo.Query<GetUpcomingFlightsQuery, GetUpcomingFlightsQueryVariables> {
    document = GetUpcomingFlightsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpcomingFlightDocument = gql`
    query getUpcomingFlight($flightId: ID!) {
  flight(flightId: $flightId) {
    id
    cancelMessageSent
    cancelMessageReason
    date
    period
    hour
    hourMeeting
    status
    visibility
    comment
    cancelReason
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      id
      name
      city
      address
    }
    passengersCount
    passengersOccupancy
    pilot {
      crew {
        isPilot
        isCurrent
        name
      }
    }
    icon {
      sign
      color
    }
    bookings {
      id
      list {
        id
        status
        contactName
        passengers {
          name
        }
      }
      count
    }
    passengerCounters {
      id
      passengersWeight
      freeSpots
    }
    passengersData {
      passengersCount
      passengersWeight
      freeSpots
      occupancy
      openAmount
    }
    events {
      id
      description
      date
    }
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUpcomingFlightGQL extends Apollo.Query<GetUpcomingFlightQuery, GetUpcomingFlightQueryVariables> {
    document = GetUpcomingFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetScheduledFlightsDocument = gql`
    query getScheduledFlights($orderBy: OrderByFlight, $orderDirection: OrderDirection, $limit: NonNegativeInt, $cursor: String, $filter: String) {
  scheduledFlights(
    orderBy: $orderBy
    orderDirection: $orderDirection
    limit: $limit
    cursor: $cursor
    filter: $filter
  ) {
    balloon {
      id
      name
    }
    id
    period
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetScheduledFlightsGQL extends Apollo.Query<GetScheduledFlightsQuery, GetScheduledFlightsQueryVariables> {
    document = GetScheduledFlightsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightsListDocument = gql`
    query getFlightsList($cursor: String, $limit: NonNegativeInt, $filter: [String], $filterRange: FilterRangeInput, $freeSpots: Int, $scope: UpcomingFlightScope) {
  getFlightsList(
    cursor: $cursor
    limit: $limit
    filter: $filter
    filterRange: $filterRange
    freeSpots: $freeSpots
    scope: $scope
  ) {
    id
    cancelMessageSent
    cancelMessageReason
    notam {
      severity
      count
      at
      noData
    }
    date
    period
    hour
    hourMeeting
    status
    visibility
    comment
    cancelReason
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      id
      name
      city
      address
    }
    pilot {
      crew {
        id
        isPilot
        isCurrent
        name
      }
    }
    groundCrews {
      crew {
        id
        name
        driverLicenseCategory
      }
    }
    icon {
      sign
      color
    }
    bookingsData {
      id
      list {
        id
        status
        icon
        iconColor
        contactName
        onlineCheckinAt
        passengers {
          name
        }
      }
      count
    }
    passengersData {
      passengersCount
      passengersWeight
      freeSpots
      occupancy
      childCount
      disabilityCount
      transportCount
      openAmount
    }
    eventsData {
      id
      description
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightsListGQL extends Apollo.Query<GetFlightsListQuery, GetFlightsListQueryVariables> {
    document = GetFlightsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetHistoricalFlightsListDocument = gql`
    query getHistoricalFlightsList($cursor: String, $limit: NonNegativeInt, $filter: [String], $filterRange: FilterRangeInput) {
  getHistoricalFlightsList(
    cursor: $cursor
    limit: $limit
    filter: $filter
    filterRange: $filterRange
  ) {
    id
    cancelMessageSent
    cancelMessageReason
    notam {
      severity
      count
      at
      noData
    }
    date
    period
    hour
    hourMeeting
    status
    visibility
    comment
    cancelReason
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      id
      name
      city
      address
    }
    passengersCount
    passengersOccupancy
    pilot {
      crew {
        id
        isPilot
        isCurrent
        name
      }
    }
    groundCrews {
      crew {
        id
        name
        driverLicenseCategory
      }
    }
    icon {
      sign
      color
    }
    bookingsData {
      id
      list {
        id
        status
        contactName
        onlineCheckinAt
        passengers {
          id
          name
        }
      }
      count
    }
    passengersData {
      passengersCount
      passengersWeight
      freeSpots
      occupancy
      childCount
      disabilityCount
      transportCount
      openAmount
    }
    events {
      id
      description
      date
    }
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetHistoricalFlightsListGQL extends Apollo.Query<GetHistoricalFlightsListQuery, GetHistoricalFlightsListQueryVariables> {
    document = GetHistoricalFlightsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightsListFromDateDocument = gql`
    query getFlightsListFromDate($date: String!) {
  flightsOfDate(date: $date) {
    id
    cancelMessageSent
    cancelMessageReason
    date
    period
    hour
    hourMeeting
    status
    visibility
    comment
    cancelReason
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      name
      city
      address
    }
    passengersCount
    passengersOccupancy
    pilot {
      crew {
        id
        isPilot
        isCurrent
        name
      }
    }
    groundCrews {
      crew {
        availability
        availabilityReason
        id
        name
        isPilot
        driverLicenseCategory
      }
      status
    }
    icon {
      sign
      color
    }
    bookingsData {
      list {
        id
        status
        contactName
        onlineCheckinAt
        passengers {
          name
        }
      }
      count
    }
    passengerCounters {
      passengersWeight
      freeSpots
    }
    events {
      id
      description
      date
    }
    eventsData {
      id
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightsListFromDateGQL extends Apollo.Query<GetFlightsListFromDateQuery, GetFlightsListFromDateQueryVariables> {
    document = GetFlightsListFromDateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightsListFromDateCrewDocument = gql`
    query getFlightsListFromDateCrew($date: String!) {
  flightsOfDateCrew(date: $date) {
    id
    date
    period
    hour
    hourMeeting
    status
    visibility
    comment
    cancelReason
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      name
      city
      address
    }
    pilot {
      status
      crew {
        id
        isPilot
        isCurrent
        name
      }
    }
    groundCrews {
      crew {
        availability
        availabilityReason
        id
        name
        isPilot
        driverLicenseCategory
      }
      status
    }
    icon {
      sign
      color
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightsListFromDateCrewGQL extends Apollo.Query<GetFlightsListFromDateCrewQuery, GetFlightsListFromDateCrewQueryVariables> {
    document = GetFlightsListFromDateCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FlightSearchCountsDocument = gql`
    query flightSearchCounts($filter: [String]!, $filterRange: FilterRangeInput, $freeSpots: Int) {
  flightSearchCounts(
    filter: $filter
    filterRange: $filterRange
    freeSpots: $freeSpots
  ) {
    upcoming
    current
    older
    historical
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FlightSearchCountsGQL extends Apollo.Query<FlightSearchCountsQuery, FlightSearchCountsQueryVariables> {
    document = FlightSearchCountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FlightCountersDocument = gql`
    query flightCounters {
  flightCounters {
    upcoming
    historical
    upcomingOlder
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FlightCountersGQL extends Apollo.Query<FlightCountersQuery, FlightCountersQueryVariables> {
    document = FlightCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FlightPeriodsDocument = gql`
    query flightPeriods {
  flightPeriods {
    day {
      id
      startDate
      endDate
      label
      EVE {
        flightsCount
      }
      MOR {
        flightsCount
      }
    }
    week {
      id
      startDate
      endDate
      label
      EVE {
        flightsCount
      }
      MOR {
        flightsCount
      }
    }
    month {
      id
      startDate
      endDate
      label
      EVE {
        flightsCount
      }
      MOR {
        flightsCount
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FlightPeriodsGQL extends Apollo.Query<FlightPeriodsQuery, FlightPeriodsQueryVariables> {
    document = FlightPeriodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveFlightDocument = gql`
    mutation saveFlight($flightInput: FlightInput!, $flightId: ID) {
  saveFlight(flightInput: $flightInput, flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveFlightGQL extends Apollo.Mutation<SaveFlightMutation, SaveFlightMutationVariables> {
    document = SaveFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFlightDocument = gql`
    mutation deleteFlight($flightId: ID!) {
  deleteFlight(flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFlightGQL extends Apollo.Mutation<DeleteFlightMutation, DeleteFlightMutationVariables> {
    document = DeleteFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleFlightVisibilityDocument = gql`
    mutation toggleFlightVisibility($flightId: ID!) {
  toggleFlightVisibility(flightId: $flightId) {
    id
    visibility
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleFlightVisibilityGQL extends Apollo.Mutation<ToggleFlightVisibilityMutation, ToggleFlightVisibilityMutationVariables> {
    document = ToggleFlightVisibilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ChangeFlightStatusDocument = gql`
    mutation changeFlightStatus($flightId: ID!, $flightStatus: FlightStatus!, $cancelReason: String, $cancelMessageSent: Boolean) {
  changeFlightStatus(
    flightId: $flightId
    flightStatus: $flightStatus
    cancelReason: $cancelReason
    cancelMessageSent: $cancelMessageSent
  ) {
    id
    status
    cancelReason
    cancelMessageSent
    cancelMessageReason
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ChangeFlightStatusGQL extends Apollo.Mutation<ChangeFlightStatusMutation, ChangeFlightStatusMutationVariables> {
    document = ChangeFlightStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RestoreCancelledFlightDocument = gql`
    mutation restoreCancelledFlight($flightId: ID!) {
  restoreCancelledFlight(flightId: $flightId) {
    flight {
      id
      status
    }
    restored {
      id
      contactName
    }
    skipped {
      bookingId
      reason
      booking {
        id
        contactName
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RestoreCancelledFlightGQL extends Apollo.Mutation<RestoreCancelledFlightMutation, RestoreCancelledFlightMutationVariables> {
    document = RestoreCancelledFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveFlightCrewDocument = gql`
    mutation saveFlightCrew($flightCrewInput: [FlightCrewInput], $flightId: ID!) {
  saveFlightCrew(flightCrewInput: $flightCrewInput, flightId: $flightId) {
    id
    balloonCapacityReduction
    balloon {
      id
      name
      callSign
      capacity
    }
    groundCrews {
      crew {
        id
        name
        isPilot
        driverLicenseCategory
      }
      status
    }
    location {
      id
      name
    }
    date
    hour
    hourMeeting
    period
    pilot {
      crew {
        id
        name
        isPilot
        isCurrent
      }
      status
    }
    status
    passengersCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveFlightCrewGQL extends Apollo.Mutation<SaveFlightCrewMutation, SaveFlightCrewMutationVariables> {
    document = SaveFlightCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddCrewToFlightFromCalendarDocument = gql`
    mutation addCrewToFlightFromCalendar($flightCrewInput: FlightCrewInput, $flightId: ID!) {
  addCrewToFlightFromCalendar(
    flightCrewInput: $flightCrewInput
    flightId: $flightId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddCrewToFlightFromCalendarGQL extends Apollo.Mutation<AddCrewToFlightFromCalendarMutation, AddCrewToFlightFromCalendarMutationVariables> {
    document = AddCrewToFlightFromCalendarDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SavePilotSignOffDocument = gql`
    mutation savePilotSignOff($pilotSignOffInput: PilotSignOffInput!, $flightId: ID!) {
  savePilotSignOff(pilotSignOffInput: $pilotSignOffInput, flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SavePilotSignOffGQL extends Apollo.Mutation<SavePilotSignOffMutation, SavePilotSignOffMutationVariables> {
    document = SavePilotSignOffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveFlightLandingDocument = gql`
    mutation saveFlightLanding($landingInput: LandingInput!, $flightId: ID!) {
  saveFlightLanding(landingInput: $landingInput, flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveFlightLandingGQL extends Apollo.Mutation<SaveFlightLandingMutation, SaveFlightLandingMutationVariables> {
    document = SaveFlightLandingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveCheckinParametersDocument = gql`
    mutation saveCheckinParameters($flightId: ID!, $checkinParametersInput: CheckinParametersInput!) {
  saveCheckinParameters(
    flightId: $flightId
    checkinParametersInput: $checkinParametersInput
  ) {
    id
    hour
    comment
    tempTakeoff
    tempTakeoffManual
    weatherManual
    windGl
    windGlDirection
    weatherQnh
    plannedFlightTime
    maximumFlightTime
    maximumFlightTimeManual
    tempBalloon
    spareFlightTime
    liftAvailable
    liftNeeded
    liftSpare
    liftWarningLevel
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveCheckinParametersGQL extends Apollo.Mutation<SaveCheckinParametersMutation, SaveCheckinParametersMutationVariables> {
    document = SaveCheckinParametersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClearPilotSignOffDocument = gql`
    mutation clearPilotSignOff($flightId: ID!) {
  clearPilotSignOff(flightId: $flightId) {
    id
    pilotSignature
    pilotSignOffDate
    pilotComments
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClearPilotSignOffGQL extends Apollo.Mutation<ClearPilotSignOffMutation, ClearPilotSignOffMutationVariables> {
    document = ClearPilotSignOffDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightCheckinLogsDocument = gql`
    query getFlightCheckinLogs($flightId: ID!) {
  flight(flightId: $flightId) {
    id
    checkinLogs {
      id
      user
      date
      section
      parameter
      oldValue
      newValue
      passengerName
      signature
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightCheckinLogsGQL extends Apollo.Query<GetFlightCheckinLogsQuery, GetFlightCheckinLogsQueryVariables> {
    document = GetFlightCheckinLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyWeatherDocument = gql`
    mutation copyWeather($sourceFlightId: ID!, $destinationFlightIds: [ID]) {
  copyWeather(
    sourceFlightId: $sourceFlightId
    destinationFlightIds: $destinationFlightIds
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyWeatherGQL extends Apollo.Mutation<CopyWeatherMutation, CopyWeatherMutationVariables> {
    document = CopyWeatherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CopyFlightDocument = gql`
    mutation copyFlight($sourceFlightId: ID!, $destinationDates: [String]) {
  copyFlight(sourceFlightId: $sourceFlightId, destinationDates: $destinationDates)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CopyFlightGQL extends Apollo.Mutation<CopyFlightMutation, CopyFlightMutationVariables> {
    document = CopyFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFlightCommentsDocument = gql`
    mutation updateFlightComments($flightId: ID!, $comment: String) {
  updateFlightComments(flightId: $flightId, comment: $comment) {
    id
    date
    period
    hour
    hourMeeting
    status
    visibility
    comment
    crewComments
    cancelReason
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      id
      name
      city
      address
    }
    passengersCount
    passengersOccupancy
    pilot {
      crew {
        id
        isPilot
        isCurrent
        name
      }
    }
    icon {
      sign
      color
    }
    bookingsData {
      id
      list {
        id
        status
        contactName
        onlineCheckinAt
        passengers {
          name
        }
      }
      count
    }
    passengerCounters {
      id
      passengersWeight
      freeSpots
    }
    events {
      id
      description
      date
    }
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFlightCommentsGQL extends Apollo.Mutation<UpdateFlightCommentsMutation, UpdateFlightCommentsMutationVariables> {
    document = UpdateFlightCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFlightTagsDocument = gql`
    mutation updateFlightTags($flightId: ID!, $tags: [String]) {
  updateFlightTags(flightId: $flightId, tags: $tags) {
    id
    date
    period
    hour
    hourMeeting
    status
    visibility
    comment
    crewComments
    cancelReason
    balloonCapacityReduction
    balloon {
      id
      name
      capacity
      isCurrent
    }
    location {
      id
      name
      city
      address
    }
    passengersCount
    passengersOccupancy
    pilot {
      crew {
        id
        isPilot
        isCurrent
        name
      }
    }
    icon {
      sign
      color
    }
    bookingsData {
      id
      list {
        id
        status
        contactName
        onlineCheckinAt
        passengers {
          name
        }
      }
      count
    }
    passengerCounters {
      id
      passengersWeight
      freeSpots
    }
    passengersData {
      passengersCount
      passengersWeight
      freeSpots
      occupancy
      openAmount
    }
    events {
      id
      description
      date
    }
    tags {
      id
      tag
      backgroundColor
      fontColor
    }
    tagsData {
      id
      tag
      backgroundColor
      fontColor
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFlightTagsGQL extends Apollo.Mutation<UpdateFlightTagsMutation, UpdateFlightTagsMutationVariables> {
    document = UpdateFlightTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetFlightPublishedDocument = gql`
    mutation setFlightPublished($flightId: ID!, $published: Boolean!) {
  setFlightPublished(flightId: $flightId, published: $published) {
    id
    published
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetFlightPublishedGQL extends Apollo.Mutation<SetFlightPublishedMutation, SetFlightPublishedMutationVariables> {
    document = SetFlightPublishedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvoicesDocument = gql`
    query GetInvoices($input: InvoiceListInput) {
  invoices(input: $input) {
    totalCount
    hasNextPage
    offset
    invoices {
      id
      invoiceNumber
      amountIncludingTax
      currency
      invoiceDate
      status
      statusLabel
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvoicesGQL extends Apollo.Query<GetInvoicesQuery, GetInvoicesQueryVariables> {
    document = GetInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvoiceDownloadDocument = gql`
    query GetInvoiceDownload($id: ID, $invoiceNumber: String) {
  invoiceDownload(id: $id, invoiceNumber: $invoiceNumber) {
    invoiceId
    invoiceNumber
    filename
    pdfData
    contentType
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvoiceDownloadGQL extends Apollo.Query<GetInvoiceDownloadQuery, GetInvoiceDownloadQueryVariables> {
    document = GetInvoiceDownloadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOrdersDocument = gql`
    query GetOrders {
  orders {
    id
    debtorId
    debtorCode
    amountExcludingTax
    orderDate
    status
    lines {
      productCode
      description
      quantity
      unitPrice
      totalPrice
      sms
      plan
      maxSeats
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOrdersGQL extends Apollo.Query<GetOrdersQuery, GetOrdersQueryVariables> {
    document = GetOrdersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateOrderDocument = gql`
    mutation CreateOrder {
  createOrder {
    id
    debtorId
    debtorCode
    amountExcludingTax
    orderDate
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateOrderGQL extends Apollo.Mutation<CreateOrderMutation, CreateOrderMutationVariables> {
    document = CreateOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddOrderLineDocument = gql`
    mutation AddOrderLine($orderId: ID!, $line: OrderLineInput!) {
  addOrderLine(orderId: $orderId, line: $line) {
    id
    debtorId
    debtorCode
    amountExcludingTax
    orderDate
    status
    lines {
      productCode
      description
      quantity
      unitPrice
      totalPrice
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddOrderLineGQL extends Apollo.Mutation<AddOrderLineMutation, AddOrderLineMutationVariables> {
    document = AddOrderLineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOrderLineDocument = gql`
    mutation DeleteOrderLine($orderId: ID!, $lineId: ID!) {
  deleteOrderLine(orderId: $orderId, lineId: $lineId) {
    id
    debtorId
    debtorCode
    amountExcludingTax
    orderDate
    status
    lines {
      productCode
      description
      quantity
      unitPrice
      totalPrice
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOrderLineGQL extends Apollo.Mutation<DeleteOrderLineMutation, DeleteOrderLineMutationVariables> {
    document = DeleteOrderLineDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmOrderDocument = gql`
    mutation ConfirmOrder($orderId: ID!) {
  confirmOrder(orderId: $orderId) {
    id
    debtorId
    debtorCode
    amountExcludingTax
    orderDate
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmOrderGQL extends Apollo.Mutation<ConfirmOrderMutation, ConfirmOrderMutationVariables> {
    document = ConfirmOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteOrderDocument = gql`
    mutation DeleteOrder($orderId: ID!) {
  deleteOrder(orderId: $orderId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteOrderGQL extends Apollo.Mutation<DeleteOrderMutation, DeleteOrderMutationVariables> {
    document = DeleteOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ApproveOrderDocument = gql`
    mutation ApproveOrder($orderId: ID!) {
  approveOrder(orderId: $orderId) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ApproveOrderGQL extends Apollo.Mutation<ApproveOrderMutation, ApproveOrderMutationVariables> {
    document = ApproveOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelOrderDocument = gql`
    mutation CancelOrder($orderId: ID!) {
  cancelOrder(orderId: $orderId) {
    id
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelOrderGQL extends Apollo.Mutation<CancelOrderMutation, CancelOrderMutationVariables> {
    document = CancelOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetWefactDebtorsDocument = gql`
    query GetWefactDebtors($limit: Int = 200, $offset: Int = 0) {
  wefactDebtors(limit: $limit, offset: $offset) {
    debtors {
      debtorCode
      companyName
      initials
      surname
      emailAddress
    }
    totalCount
    hasNextPage
    offset
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetWefactDebtorsGQL extends Apollo.Query<GetWefactDebtorsQuery, GetWefactDebtorsQueryVariables> {
    document = GetWefactDebtorsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationsDocument = gql`
    query getLocations {
  locations {
    address
    city
    country
    default
    id
    latitude
    longitude
    name
    postalCode
    region {
      color
      name
    }
    meetingPointSameAsTakeOff
    meetingPointAddress
    meetingPointLatitude
    meetingPointLongitude
    meetingPointURL
    meetingPointCity
    contact {
      name
      media
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationsGQL extends Apollo.Query<GetLocationsQuery, GetLocationsQueryVariables> {
    document = GetLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationDocument = gql`
    query getLocation($locationId: ID!) {
  location(locationId: $locationId) {
    id
    address
    city
    country
    contact {
      comment
      email
      emailTemplate
      name
      phone
      smsTemplate
      language
      media
    }
    default
    description
    height
    latitude
    longitude
    maximumHeight
    meetingPointSameAsTakeOff
    meetingPointAddress
    meetingPointLatitude
    meetingPointLongitude
    meetingPointURL
    meetingPointCity
    name
    postalCode
    timezone
    forecasts {
      slot
      flyability {
        verdict
        parameters {
          key
          value
          band
        }
      }
      forecast {
        datepart {
          part
          text
        }
        daytime
        flytime
        lastUpdate
        latitude
        longitude
        lowCloudsData
        pictoCodeData
        precipitationData
        pressureData
        sunrise
        sunset
        temperatureData
        time
        utc_timeoffset
        visibilityData
        windDirectionData
        windDirectionData_1000
        windDirectionData_500
        windDirectionData_550
        windDirectionData_600
        windDirectionData_650
        windDirectionData_700
        windDirectionData_750
        windDirectionData_800
        windDirectionData_925
        windDirectionData_950
        windDirectionData_975
        windGustData
        windSpeedData
        windSpeedData_1000
        windSpeedData_500
        windSpeedData_550
        windSpeedData_600
        windSpeedData_650
        windSpeedData_700
        windSpeedData_750
        windSpeedData_800
        windSpeedData_925
        windSpeedData_950
        windSpeedData_975
      }
    }
    region {
      color
      id
      name
    }
    windDirections {
      N
      NNE
      NE
      ENE
      E
      ESE
      SE
      SSE
      S
      SSW
      SW
      WSW
      W
      WNW
      NW
      NNW
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationGQL extends Apollo.Query<GetLocationQuery, GetLocationQueryVariables> {
    document = GetLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetGeocodeDocument = gql`
    query getGeocode($address: String!) {
  geocode(address: $address) {
    geometry {
      location {
        lat
        lng
      }
    }
    elevation {
      elevation
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetGeocodeGQL extends Apollo.Query<GetGeocodeQuery, GetGeocodeQueryVariables> {
    document = GetGeocodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReverseGeocodeDocument = gql`
    query reverseGeocode($lat: Float!, $lng: Float!) {
  reverseGeocode(lat: $lat, lng: $lng)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ReverseGeocodeGQL extends Apollo.Query<ReverseGeocodeQuery, ReverseGeocodeQueryVariables> {
    document = ReverseGeocodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveLocationDocument = gql`
    mutation saveLocation($locationInput: LocationInput!, $regions: [ID]!, $locationId: ID) {
  saveLocation(
    locationInput: $locationInput
    regions: $regions
    locationId: $locationId
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveLocationGQL extends Apollo.Mutation<SaveLocationMutation, SaveLocationMutationVariables> {
    document = SaveLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLocationDocument = gql`
    mutation deleteLocation($locationId: ID!) {
  deleteLocation(locationId: $locationId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLocationGQL extends Apollo.Mutation<DeleteLocationMutation, DeleteLocationMutationVariables> {
    document = DeleteLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMeteoDocument = gql`
    mutation updateMeteo($locationId: ID!, $flightId: ID!) {
  updateMeteo(locationId: $locationId, flightId: $flightId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMeteoGQL extends Apollo.Mutation<UpdateMeteoMutation, UpdateMeteoMutationVariables> {
    document = UpdateMeteoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogbookDocument = gql`
    query getLogbook($logbookId: ID!) {
  logbook(logbookId: $logbookId) {
    id
    type
    balloon {
      id
      callSign
      FlightAppKey
      FlightAppAircraftDetails {
        total_flight_duration
      }
    }
    pilot {
      id
    }
    logsCount
    startDate
    initialHours
    initialFlights
    logs {
      ...LogFragment
    }
    FlightAppLogList {
      meta
    }
  }
}
    ${LogFragmentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogbookGQL extends Apollo.Query<GetLogbookQuery, GetLogbookQueryVariables> {
    document = GetLogbookDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLogbooksDocument = gql`
    query getLogbooks {
  logbooks {
    id
    type
    balloon {
      id
    }
    pilot {
      id
    }
    logsCount
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLogbooksGQL extends Apollo.Query<GetLogbooksQuery, GetLogbooksQueryVariables> {
    document = GetLogbooksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBalloonLogbookDocument = gql`
    mutation createBalloonLogbook($balloonId: ID!) {
  createBalloonLogbook(balloonId: $balloonId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBalloonLogbookGQL extends Apollo.Mutation<CreateBalloonLogbookMutation, CreateBalloonLogbookMutationVariables> {
    document = CreateBalloonLogbookDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePilotLogbookDocument = gql`
    mutation createPilotLogbook($pilotId: ID!) {
  createPilotLogbook(pilotId: $pilotId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePilotLogbookGQL extends Apollo.Mutation<CreatePilotLogbookMutation, CreatePilotLogbookMutationVariables> {
    document = CreatePilotLogbookDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveLogsDocument = gql`
    mutation saveLogs($logbookId: ID!, $logs: [LogInput]!) {
  saveLogs(logbookId: $logbookId, logs: $logs)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveLogsGQL extends Apollo.Mutation<SaveLogsMutation, SaveLogsMutationVariables> {
    document = SaveLogsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteLogbookLogDocument = gql`
    mutation deleteLogbookLog($logbookId: ID!, $logId: ID!) {
  deleteLogbookLog(logbookId: $logbookId, logId: $logId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteLogbookLogGQL extends Apollo.Mutation<DeleteLogbookLogMutation, DeleteLogbookLogMutationVariables> {
    document = DeleteLogbookLogDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveAircraftLogsToFlightAppDocument = gql`
    mutation saveAircraftLogsToFlightApp($logbookId: ID!, $logs: [LogInput]!) {
  saveAircraftLogsToFlightApp(logbookId: $logbookId, logs: $logs)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveAircraftLogsToFlightAppGQL extends Apollo.Mutation<SaveAircraftLogsToFlightAppMutation, SaveAircraftLogsToFlightAppMutationVariables> {
    document = SaveAircraftLogsToFlightAppDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateLogbookSettingsDocument = gql`
    mutation updateLogbookSettings($logbookId: ID!, $settings: LogBookSettingsInput!) {
  updateLogbookSettings(logbookId: $logbookId, settings: $settings)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateLogbookSettingsGQL extends Apollo.Mutation<UpdateLogbookSettingsMutation, UpdateLogbookSettingsMutationVariables> {
    document = UpdateLogbookSettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSkeyesForecastDocument = gql`
    query getSkeyesForecast($slot: String!) {
  getSkeyesForecast(slot: $slot) {
    id
    datetime
    full
    inversions
    issued
    outlook
    period
    slot
    weather
    winds
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSkeyesForecastGQL extends Apollo.Query<GetSkeyesForecastQuery, GetSkeyesForecastQueryVariables> {
    document = GetSkeyesForecastDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FetchSkeyesForecastDocument = gql`
    query fetchSkeyesForecast($username: String!, $password: String!, $flightId: ID!) {
  fetchSkeyesForecast(
    username: $username
    password: $password
    flightId: $flightId
  ) {
    username
    date
    forecast {
      datetime
      full
      inversions
      issued
      outlook
      period
      slot
      weather
      winds
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FetchSkeyesForecastGQL extends Apollo.Query<FetchSkeyesForecastQuery, FetchSkeyesForecastQueryVariables> {
    document = FetchSkeyesForecastDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MontyStatusDocument = gql`
    query montyStatus {
  montyStatus {
    status
    since
    lastOkAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MontyStatusGQL extends Apollo.Query<MontyStatusQuery, MontyStatusQueryVariables> {
    document = MontyStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MontyUsageDocument = gql`
    query montyUsage($months: Int) {
  montyUsage(months: $months) {
    month
    classifications
    proposals
    learnRuns
    inTokens
    outTokens
    estimatedCostEur
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MontyUsageGQL extends Apollo.Query<MontyUsageQuery, MontyUsageQueryVariables> {
    document = MontyUsageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveMontyApiKeyDocument = gql`
    mutation saveMontyApiKey($key: String!) {
  saveMontyApiKey(key: $key) {
    ok
    status
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveMontyApiKeyGQL extends Apollo.Mutation<SaveMontyApiKeyMutation, SaveMontyApiKeyMutationVariables> {
    document = SaveMontyApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveMontyApiKeyDocument = gql`
    mutation removeMontyApiKey {
  removeMontyApiKey {
    ok
    status
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveMontyApiKeyGQL extends Apollo.Mutation<RemoveMontyApiKeyMutation, RemoveMontyApiKeyMutationVariables> {
    document = RemoveMontyApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AcceptMontyActionDocument = gql`
    mutation acceptMontyAction($messagePath: String!, $flightId: String) {
  acceptMontyAction(messagePath: $messagePath, flightId: $flightId) {
    ok
    failureReason
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AcceptMontyActionGQL extends Apollo.Mutation<AcceptMontyActionMutation, AcceptMontyActionMutationVariables> {
    document = AcceptMontyActionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResolveMontyProposalDocument = gql`
    mutation resolveMontyProposal($messagePath: String!, $resolution: MontyProposalStatus!) {
  resolveMontyProposal(messagePath: $messagePath, resolution: $resolution)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResolveMontyProposalGQL extends Apollo.Mutation<ResolveMontyProposalMutation, ResolveMontyProposalMutationVariables> {
    document = ResolveMontyProposalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MontyInstructionsDocument = gql`
    query montyInstructions {
  montyInstructions {
    tag
    manual
    learnedDraft
    learnedFrom {
      months
      msgCount
      at
    }
    updatedAt
    updatedBy
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MontyInstructionsGQL extends Apollo.Query<MontyInstructionsQuery, MontyInstructionsQueryVariables> {
    document = MontyInstructionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveMontyInstructionsDocument = gql`
    mutation saveMontyInstructions($tag: MontyTag!, $manual: String!, $learnedDraft: String) {
  saveMontyInstructions(tag: $tag, manual: $manual, learnedDraft: $learnedDraft) {
    tag
    manual
    learnedDraft
    learnedFrom {
      months
      msgCount
      at
    }
    updatedAt
    updatedBy
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveMontyInstructionsGQL extends Apollo.Mutation<SaveMontyInstructionsMutation, SaveMontyInstructionsMutationVariables> {
    document = SaveMontyInstructionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MontyLearnEstimateDocument = gql`
    query montyLearnEstimate {
  montyLearnEstimate {
    months
    messageCount
    estimatedCostEur
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MontyLearnEstimateGQL extends Apollo.Query<MontyLearnEstimateQuery, MontyLearnEstimateQueryVariables> {
    document = MontyLearnEstimateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MontyLearnRunDocument = gql`
    query montyLearnRun {
  montyLearnRun {
    id
    months
    state
    phase
    totalMessages
    taggedMessages
    alreadyTaggedMessages
    estimatedCostEur
    startedAt
    startedBy
    finishedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MontyLearnRunGQL extends Apollo.Query<MontyLearnRunQuery, MontyLearnRunQueryVariables> {
    document = MontyLearnRunDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const StartMontyLearnRunDocument = gql`
    mutation startMontyLearnRun($months: Int!) {
  startMontyLearnRun(months: $months) {
    id
    months
    state
    phase
    totalMessages
    taggedMessages
    alreadyTaggedMessages
    estimatedCostEur
    startedAt
    startedBy
    finishedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class StartMontyLearnRunGQL extends Apollo.Mutation<StartMontyLearnRunMutation, StartMontyLearnRunMutationVariables> {
    document = StartMontyLearnRunDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CancelMontyLearnRunDocument = gql`
    mutation cancelMontyLearnRun($runId: String!) {
  cancelMontyLearnRun(runId: $runId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CancelMontyLearnRunGQL extends Apollo.Mutation<CancelMontyLearnRunMutation, CancelMontyLearnRunMutationVariables> {
    document = CancelMontyLearnRunDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResumeMontyLearnRunDocument = gql`
    mutation resumeMontyLearnRun($runId: String!) {
  resumeMontyLearnRun(runId: $runId) {
    id
    months
    state
    phase
    totalMessages
    taggedMessages
    alreadyTaggedMessages
    estimatedCostEur
    startedAt
    startedBy
    finishedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResumeMontyLearnRunGQL extends Apollo.Mutation<ResumeMontyLearnRunMutation, ResumeMontyLearnRunMutationVariables> {
    document = ResumeMontyLearnRunDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MyWeekDocument = gql`
    query myWeek($year: PositiveInt!, $week: PositiveInt!) {
  myWeek(year: $year, week: $week) {
    crewId
    crewName
    days {
      date
      sunrise
      sunset
    }
    availability {
      id
      date
      period
      availability
    }
    flights {
      id
      date
      hour
      period
      status
      published
      myCrewStatus
      balloon {
        id
        name
      }
      location {
        id
        name
      }
      pilot {
        crew {
          id
          name
        }
      }
      groundCrews {
        crew {
          id
          name
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MyWeekGQL extends Apollo.Query<MyWeekQuery, MyWeekQueryVariables> {
    document = MyWeekDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmMyFlightDocument = gql`
    mutation confirmMyFlight($flightId: ID!) {
  confirmMyFlight(flightId: $flightId) {
    id
    myCrewStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmMyFlightGQL extends Apollo.Mutation<ConfirmMyFlightMutation, ConfirmMyFlightMutationVariables> {
    document = ConfirmMyFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JoinFlightAsCrewDocument = gql`
    mutation joinFlightAsCrew($flightId: ID!) {
  joinFlightAsCrew(flightId: $flightId) {
    id
    myCrewStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JoinFlightAsCrewGQL extends Apollo.Mutation<JoinFlightAsCrewMutation, JoinFlightAsCrewMutationVariables> {
    document = JoinFlightAsCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFlightNotamAssessmentDocument = gql`
    query getFlightNotamAssessment($flightId: ID!) {
  flight(flightId: $flightId) {
    id
    notamAssessment {
      ...NotamAssessmentFields
    }
  }
}
    ${NotamAssessmentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFlightNotamAssessmentGQL extends Apollo.Query<GetFlightNotamAssessmentQuery, GetFlightNotamAssessmentQueryVariables> {
    document = GetFlightNotamAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationNotamAssessmentDocument = gql`
    query getLocationNotamAssessment($locationId: ID!, $date: Date!, $period: FlightPeriod!) {
  locationNotamAssessment(locationId: $locationId, date: $date, period: $period) {
    ...NotamAssessmentFields
  }
}
    ${NotamAssessmentFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationNotamAssessmentGQL extends Apollo.Query<GetLocationNotamAssessmentQuery, GetLocationNotamAssessmentQueryVariables> {
    document = GetLocationNotamAssessmentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetLocationNotamSummariesDocument = gql`
    query getLocationNotamSummaries($locationIds: [ID!]!, $date: Date!, $period: FlightPeriod!) {
  locationNotamSummaries(locationIds: $locationIds, date: $date, period: $period) {
    locationId
    severity
    count
    stale
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetLocationNotamSummariesGQL extends Apollo.Query<GetLocationNotamSummariesQuery, GetLocationNotamSummariesQueryVariables> {
    document = GetLocationNotamSummariesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAutorouterStatusDocument = gql`
    query getAutorouterStatus {
  autorouterStatus {
    status
    account
    connectedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAutorouterStatusGQL extends Apollo.Query<GetAutorouterStatusQuery, GetAutorouterStatusQueryVariables> {
    document = GetAutorouterStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectAutorouterDocument = gql`
    mutation disconnectAutorouter {
  disconnectAutorouter {
    status
    account
    connectedAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectAutorouterGQL extends Apollo.Mutation<DisconnectAutorouterMutation, DisconnectAutorouterMutationVariables> {
    document = DisconnectAutorouterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuestionsDocument = gql`
    query questions($active: Boolean) {
  questions(active: $active) {
    id
    active
    code
    content {
      description {
        lang
        text
      }
      order
      title {
        lang
        text
      }
    }
    kind
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuestionsGQL extends Apollo.Query<QuestionsQuery, QuestionsQueryVariables> {
    document = QuestionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveQuestionTextDocument = gql`
    mutation saveQuestionText($questionInput: QuestionInput!, $questionId: ID!) {
  saveQuestionText(questionInput: $questionInput, questionId: $questionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveQuestionTextGQL extends Apollo.Mutation<SaveQuestionTextMutation, SaveQuestionTextMutationVariables> {
    document = SaveQuestionTextDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveQuestionOrderDocument = gql`
    mutation saveQuestionOrder($order: NonNegativeInt!, $questionId: ID!) {
  saveQuestionOrder(order: $order, questionId: $questionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveQuestionOrderGQL extends Apollo.Mutation<SaveQuestionOrderMutation, SaveQuestionOrderMutationVariables> {
    document = SaveQuestionOrderDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleQuestionActiveDocument = gql`
    mutation toggleQuestionActive($questionId: ID!) {
  toggleQuestionActive(questionId: $questionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleQuestionActiveGQL extends Apollo.Mutation<ToggleQuestionActiveMutation, ToggleQuestionActiveMutationVariables> {
    document = ToggleQuestionActiveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegionsDocument = gql`
    query getRegions {
  regions {
    color
    defaultColor
    id
    name
    locations {
      name
      id
    }
    countOpenBookings
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegionsGQL extends Apollo.Query<GetRegionsQuery, GetRegionsQueryVariables> {
    document = GetRegionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRegionDocument = gql`
    query getRegion($regionId: ID!) {
  region(regionId: $regionId) {
    color
    defaultColor
    name
    id
    locations {
      name
      latitude
      longitude
      id
    }
    countOpenBookings
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRegionGQL extends Apollo.Query<GetRegionQuery, GetRegionQueryVariables> {
    document = GetRegionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveRegionDocument = gql`
    mutation saveRegion($regionInput: RegionInput!, $regionId: ID) {
  saveRegion(regionInput: $regionInput, regionId: $regionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveRegionGQL extends Apollo.Mutation<SaveRegionMutation, SaveRegionMutationVariables> {
    document = SaveRegionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRegionDocument = gql`
    mutation deleteRegion($regionId: ID!, $targetRegionId: ID) {
  deleteRegion(regionId: $regionId, targetRegionId: $targetRegionId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRegionGQL extends Apollo.Mutation<DeleteRegionMutation, DeleteRegionMutationVariables> {
    document = DeleteRegionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReportsDocument = gql`
    query getReports {
  reports {
    flights
    bookings
    bookingsOpen
    vouchers
    payments
    sms
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReportsGQL extends Apollo.Query<GetReportsQuery, GetReportsQueryVariables> {
    document = GetReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ServerStatusDocument = gql`
    query serverStatus {
  serverStatus {
    maintenance
    start
    purpose
    expectedDuration
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ServerStatusGQL extends Apollo.Query<ServerStatusQuery, ServerStatusQueryVariables> {
    document = ServerStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveLanguageSettingDocument = gql`
    mutation saveLanguageSetting($systemLanguage: String!) {
  saveLanguageSetting(systemLanguage: $systemLanguage)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveLanguageSettingGQL extends Apollo.Mutation<SaveLanguageSettingMutation, SaveLanguageSettingMutationVariables> {
    document = SaveLanguageSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SmsByBookingDocument = gql`
    query smsByBooking($bookingId: ID!) {
  smsByBooking(bookingId: $bookingId) {
    date {
      sms
      read
    }
    direction
    text
    provider
    eventSummary {
      status
      error
    }
    fallbackUsed
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SmsByBookingGQL extends Apollo.Query<SmsByBookingQuery, SmsByBookingQueryVariables> {
    document = SmsByBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SmsByCrewDocument = gql`
    query smsByCrew($crewId: ID!) {
  smsByCrew(crewId: $crewId) {
    date {
      sms
      read
    }
    direction
    text
    provider
    eventSummary {
      status
      error
    }
    fallbackUsed
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SmsByCrewGQL extends Apollo.Query<SmsByCrewQuery, SmsByCrewQueryVariables> {
    document = SmsByCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllSmsTemplatesDocument = gql`
    query getAllSmsTemplates {
  getAllSmsTemplates {
    id
    template {
      en
      fr
      nl
      de
    }
    type
    label
    reasonCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllSmsTemplatesGQL extends Apollo.Query<GetAllSmsTemplatesQuery, GetAllSmsTemplatesQueryVariables> {
    document = GetAllSmsTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSmsTemplatesDocument = gql`
    query getSmsTemplates($type: String!) {
  getSmsTemplates(type: $type) {
    id
    template {
      en
      fr
      nl
      de
    }
    type
    label
    reasonCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSmsTemplatesGQL extends Apollo.Query<GetSmsTemplatesQuery, GetSmsTemplatesQueryVariables> {
    document = GetSmsTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhatsappLoginDocument = gql`
    query whatsappLogin {
  whatsappLogin {
    code
    message
    results {
      qr_duration
      qr_image
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhatsappLoginGQL extends Apollo.Query<WhatsappLoginQuery, WhatsappLoginQueryVariables> {
    document = WhatsappLoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhatsappLogoutDocument = gql`
    query whatsappLogout {
  whatsappLogout {
    code
    message
    results
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhatsappLogoutGQL extends Apollo.Query<WhatsappLogoutQuery, WhatsappLogoutQueryVariables> {
    document = WhatsappLogoutDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhatsappDevicesDocument = gql`
    query whatsappDevices {
  whatsappDevices {
    code
    message
    results {
      name
      device
      jid
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhatsappDevicesGQL extends Apollo.Query<WhatsappDevicesQuery, WhatsappDevicesQueryVariables> {
    document = WhatsappDevicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhatsappConnectionStatusDocument = gql`
    query whatsappConnectionStatus {
  whatsappConnectionStatus {
    connected
    lastSeen
    deviceInfo
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhatsappConnectionStatusGQL extends Apollo.Query<WhatsappConnectionStatusQuery, WhatsappConnectionStatusQueryVariables> {
    document = WhatsappConnectionStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkBookingMessagesReadDocument = gql`
    mutation markBookingMessagesRead($bookingIds: [ID!]) {
  markBookingMessagesRead(bookingIds: $bookingIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkBookingMessagesReadGQL extends Apollo.Mutation<MarkBookingMessagesReadMutation, MarkBookingMessagesReadMutationVariables> {
    document = MarkBookingMessagesReadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddSmsTemplateLocationContactDocument = gql`
    mutation addSmsTemplateLocationContact {
  addSmsTemplateLocationContact {
    id
    template {
      en
      fr
      nl
      de
    }
    type
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddSmsTemplateLocationContactGQL extends Apollo.Mutation<AddSmsTemplateLocationContactMutation, AddSmsTemplateLocationContactMutationVariables> {
    document = AddSmsTemplateLocationContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkCrewMessagesReadDocument = gql`
    mutation markCrewMessagesRead($crewIds: [ID!]!) {
  markCrewMessagesRead(crewIds: $crewIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkCrewMessagesReadGQL extends Apollo.Mutation<MarkCrewMessagesReadMutation, MarkCrewMessagesReadMutationVariables> {
    document = MarkCrewMessagesReadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveSmsTemplateDocument = gql`
    mutation saveSmsTemplate($smsTemplateInput: SmsTemplateInput!, $smsTemplateId: ID) {
  saveSmsTemplate(
    smsTemplateInput: $smsTemplateInput
    smsTemplateId: $smsTemplateId
  ) {
    id
    template {
      en
      fr
      nl
      de
    }
    type
    label
    reasonCode
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveSmsTemplateGQL extends Apollo.Mutation<SaveSmsTemplateMutation, SaveSmsTemplateMutationVariables> {
    document = SaveSmsTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveSmsTemplateDocument = gql`
    mutation removeSmsTemplate($smsTemplateId: ID!) {
  removeSmsTemplate(smsTemplateId: $smsTemplateId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveSmsTemplateGQL extends Apollo.Mutation<RemoveSmsTemplateMutation, RemoveSmsTemplateMutationVariables> {
    document = RemoveSmsTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendBookingSmsDocument = gql`
    mutation sendBookingSms($bookingId: ID!, $smsInput: SmsInput!) {
  sendBookingSms(bookingId: $bookingId, smsInput: $smsInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendBookingSmsGQL extends Apollo.Mutation<SendBookingSmsMutation, SendBookingSmsMutationVariables> {
    document = SendBookingSmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendBookingMessageDocument = gql`
    mutation sendBookingMessage($bookingId: ID!, $messageInput: MessageInput!) {
  sendBookingMessage(bookingId: $bookingId, messageInput: $messageInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendBookingMessageGQL extends Apollo.Mutation<SendBookingMessageMutation, SendBookingMessageMutationVariables> {
    document = SendBookingMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendCrewMessageDocument = gql`
    mutation sendCrewMessage($crewId: ID!, $messageInput: MessageInput!) {
  sendCrewMessage(crewId: $crewId, messageInput: $messageInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendCrewMessageGQL extends Apollo.Mutation<SendCrewMessageMutation, SendCrewMessageMutationVariables> {
    document = SendCrewMessageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendLocationSmsDocument = gql`
    mutation sendLocationSms($locationId: ID!, $flightId: ID!, $smsInput: SmsInput!) {
  sendLocationSms(
    locationId: $locationId
    flightId: $flightId
    smsInput: $smsInput
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendLocationSmsGQL extends Apollo.Mutation<SendLocationSmsMutation, SendLocationSmsMutationVariables> {
    document = SendLocationSmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendCrewSmsDocument = gql`
    mutation sendCrewSms($crewId: ID!, $smsInput: SmsInput!) {
  sendCrewSms(crewId: $crewId, smsInput: $smsInput)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendCrewSmsGQL extends Apollo.Mutation<SendCrewSmsMutation, SendCrewSmsMutationVariables> {
    document = SendCrewSmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SunriseSunsetDocument = gql`
    query sunriseSunset($sunriseSunsetInput: SunriseSunsetInput!) {
  sunriseSunset(sunriseSunsetInput: $sunriseSunsetInput) {
    sunrise
    sunset
    morningFlight
    eveningFlight
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SunriseSunsetGQL extends Apollo.Query<SunriseSunsetQuery, SunriseSunsetQueryVariables> {
    document = SunriseSunsetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllTagsDocument = gql`
    query getAllTags {
  getAllTags {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      allowedFlightTags {
        id
        tag
        type
        backgroundColor
        fontColor
        type
        enabled
        locked
        dashboard
      }
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllTagsGQL extends Apollo.Query<GetAllTagsQuery, GetAllTagsQueryVariables> {
    document = GetAllTagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllTagsWithCountersDocument = gql`
    query getAllTagsWithCounters {
  getAllTags {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      upcoming
      history
      allowedFlightTags {
        id
        tag
        type
        backgroundColor
        fontColor
        type
        enabled
        locked
        dashboard
      }
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      upcoming
      history
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllTagsWithCountersGQL extends Apollo.Query<GetAllTagsWithCountersQuery, GetAllTagsWithCountersQueryVariables> {
    document = GetAllTagsWithCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagDocument = gql`
    query getTag($tagId: ID!) {
  getTag(tagId: $tagId) {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      allowedFlightTags {
        id
        tag
        type
        backgroundColor
        fontColor
        type
        enabled
        locked
        dashboard
      }
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagGQL extends Apollo.Query<GetTagQuery, GetTagQueryVariables> {
    document = GetTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagWithCountersDocument = gql`
    query getTagWithCounters($tagId: ID!) {
  getTag(tagId: $tagId) {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      upcoming
      history
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      upcoming
      history
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagWithCountersGQL extends Apollo.Query<GetTagWithCountersQuery, GetTagWithCountersQueryVariables> {
    document = GetTagWithCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagsOfTypeDocument = gql`
    query getTagsOfType($tagType: TagType!) {
  getTagsOfType(tagType: $tagType) {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagsOfTypeGQL extends Apollo.Query<GetTagsOfTypeQuery, GetTagsOfTypeQueryVariables> {
    document = GetTagsOfTypeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagsOfTypeWithCountersDocument = gql`
    query getTagsOfTypeWithCounters($tagType: TagType!) {
  getTagsOfType(tagType: $tagType) {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      upcoming
      history
      allowedFlightTags {
        id
        tag
        type
        backgroundColor
        fontColor
        type
        enabled
        locked
        dashboard
      }
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      upcoming
      history
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagsOfTypeWithCountersGQL extends Apollo.Query<GetTagsOfTypeWithCountersQuery, GetTagsOfTypeWithCountersQueryVariables> {
    document = GetTagsOfTypeWithCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagsOfTypeWithUpcomingCountersDocument = gql`
    query getTagsOfTypeWithUpcomingCounters($tagType: TagType!) {
  getTagsOfType(tagType: $tagType) {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      upcoming
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      upcoming
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagsOfTypeWithUpcomingCountersGQL extends Apollo.Query<GetTagsOfTypeWithUpcomingCountersQuery, GetTagsOfTypeWithUpcomingCountersQueryVariables> {
    document = GetTagsOfTypeWithUpcomingCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTagsOfTypeWithHistoryCountersDocument = gql`
    query getTagsOfTypeWithHistoryCounters($tagType: TagType!) {
  getTagsOfType(tagType: $tagType) {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      history
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      history
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTagsOfTypeWithHistoryCountersGQL extends Apollo.Query<GetTagsOfTypeWithHistoryCountersQuery, GetTagsOfTypeWithHistoryCountersQueryVariables> {
    document = GetTagsOfTypeWithHistoryCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveTagDocument = gql`
    mutation saveTag($tagInput: TagInput!, $tagId: ID) {
  saveTag(tagInput: $tagInput, tagId: $tagId) {
    ... on BookingTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      allowedFlightTags {
        id
        tag
        type
        backgroundColor
        fontColor
        type
        enabled
        locked
        dashboard
      }
    }
    ... on FlightTag {
      id
      tag
      type
      backgroundColor
      fontColor
      type
      enabled
      locked
      dashboard
      onlyAllowedFlightTags
      bookingTags {
        id
        tag
        backgroundColor
        fontColor
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveTagGQL extends Apollo.Mutation<SaveTagMutation, SaveTagMutationVariables> {
    document = SaveTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTagDocument = gql`
    mutation deleteTag($tagId: ID!) {
  deleteTag(tagId: $tagId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTagGQL extends Apollo.Mutation<DeleteTagMutation, DeleteTagMutationVariables> {
    document = DeleteTagDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TenantActionsDocument = gql`
    query tenantActions {
  tenantActions {
    type
    severity
    since
    deepLinkRoute
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TenantActionsGQL extends Apollo.Query<TenantActionsQuery, TenantActionsQueryVariables> {
    document = TenantActionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantSettingDocument = gql`
    query getTenantSetting {
  tenantSetting {
    id
    apiKey
    upEnabled
    icsId
    mailFrom {
      email
      name
    }
    mailReplyTo {
      email
      name
    }
    mailAccountant {
      email
      name
    }
    locationOptions {
      defaultLocation {
        id
      }
    }
    tenantId
    name
    operatorSettings {
      id
      currency
      backup {
        active
        email
      }
      bookings {
        childAge
        flightOptionsCount
        showPayments
        showHistoryCompletedBookings
        disabledPaymentTypes
        sources
      }
      crew {
        shareBookings
        allowFlightSelection
        shareEvents
        shareFlightTags
        crewReadyChannel
        crewReadyLanguage
        crewReadyInstructions
        crewReadyIncludePassengers
        crewReadyIncludeTrajectory
      }
      displayedColumns {
        flightsUpcoming {
          name
          active
          mobile
          disabled
        }
        flightsUpcomingDefault {
          name
          active
          mobile
          disabled
        }
        flightsBooking {
          name
          active
          mobile
          disabled
        }
        flightsBookingDefault {
          name
          active
          mobile
          disabled
        }
        flightsHistory {
          name
          active
          mobile
          disabled
        }
        flightsHistoryDefault {
          name
          active
          mobile
          disabled
        }
        bookingsOpen {
          name
          active
          mobile
          disabled
        }
        bookingsOpenDefault {
          name
          active
          mobile
          disabled
        }
        bookingsHistory {
          name
          active
          mobile
          disabled
        }
        bookingsHistoryDefault {
          name
          active
          mobile
          disabled
        }
        bookingsPayment {
          name
          active
          mobile
          disabled
        }
        bookingsPaymentDefault {
          name
          active
          mobile
          disabled
        }
        bookingsDashboard {
          name
          active
          mobile
          disabled
        }
        bookingsDashboardDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlight {
          name
          active
          mobile
          disabled
        }
        bookingsFlightDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlightEnd {
          name
          active
          mobile
          disabled
        }
        bookingsFlightEndDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlightCancelled {
          name
          active
          mobile
          disabled
        }
        bookingsFlightCancelledDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlightAll {
          name
          active
          mobile
          disabled
        }
        bookingsFlightAllDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlightPayment {
          name
          active
          mobile
          disabled
        }
        bookingsFlightPaymentDefault {
          name
          active
          mobile
          disabled
        }
      }
      notifications {
        calendar
        calendarClosing
        flightCrew
      }
      flights {
        sunriseOffset
        sunsetOffset
        meetingTimeOffset
        cancelReasons
        defaultPeriod
        flightDuplicateProtection
      }
      sms {
        footerEnabled
      }
      timezone
      manifest {
        footer
        pilotDeclaration
      }
      myflight {
        id
        autoConfirm
        autoConfirmAPI
        autoConfirmEmailTemplate
        flights
        endOfSeason
        checkinMode
        checkinDaysBefore
        checkinInstructions
      }
      trajectoryProfile {
        duration
        level
      }
      twoFAEnabled
      weatherSource {
        mode
        mapping {
          country
          source
        }
      }
    }
    dashboardOptions {
      preferredDateToday
      recent
      toConfirm
    }
    subscription {
      custom
      gracePeriodDays
      planState
      isBlocked
      plan {
        valid
        status
        validUntil
        invalidSince
        expiredSince
        suggestedUpgrade
        suggestedOrderLines {
          productCode
          description
          descriptionEn
          descriptionDe
          descriptionFr
          quantity
          unitPrice
          totalPrice
          plan
          maxSeats
          type
          periodStart
          periodEnd
        }
      }
      sms {
        available
        used
        usedSMS {
          year
          month
          used
          usedWA
          waUtility
          waService
          waMarketing
          waAuthentication
          waBillable
          waFree
          waEstimatedCost
        }
        pctUsed
        ignoreWarning
        status
        suggestedOrderLines {
          productCode
          description
          descriptionEn
          descriptionDe
          descriptionFr
          quantity
          unitPrice
          totalPrice
          sms
          periodStart
          periodEnd
        }
      }
    }
    whatsapp {
      enabled
      fallbackSms
      provider
    }
    messageRetention {
      closedBookingsYears
      crewYears
    }
    integrations {
      callbackUrl
      FlightApp {
        keys {
          key
          valid
          pilotIds {
            id
            pilotId
            pilot {
              pilot {
                name
                email
              }
              number_of_entries
              total_flight_time
              total_flight_time_in_hours
              license_number
            }
          }
          aircraftsIds {
            id
            balloonId
            aircraft {
              callsign
              serial_number
              weight_category
              total_flight_duration_human
              total_flight_duration
              aircraft_type {
                id
                name
                code
                description
                manufacturer
                weight_category
                aircraft_category
              }
            }
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantSettingGQL extends Apollo.Query<GetTenantSettingQuery, GetTenantSettingQueryVariables> {
    document = GetTenantSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetAllReleaseNotesDocument = gql`
    query getAllReleaseNotes {
  allReleaseNotes {
    id
    date
    description
    documentation
    oneliner
    video
    tenants
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetAllReleaseNotesGQL extends Apollo.Query<GetAllReleaseNotesQuery, GetAllReleaseNotesQueryVariables> {
    document = GetAllReleaseNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReleaseNotesDocument = gql`
    query getReleaseNotes {
  releaseNotes {
    id
    date
    description
    documentation
    oneliner
    video
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReleaseNotesGQL extends Apollo.Query<GetReleaseNotesQuery, GetReleaseNotesQueryVariables> {
    document = GetReleaseNotesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReleaseNoteDocument = gql`
    query getReleaseNote($releaseNoteId: ID!) {
  releaseNote(releaseNoteId: $releaseNoteId) {
    id
    date
    description
    documentation
    oneliner
    video
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReleaseNoteGQL extends Apollo.Query<GetReleaseNoteQuery, GetReleaseNoteQueryVariables> {
    document = GetReleaseNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReleaseNotesCountDocument = gql`
    query getReleaseNotesCount {
  releaseNotesCount
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReleaseNotesCountGQL extends Apollo.Query<GetReleaseNotesCountQuery, GetReleaseNotesCountQueryVariables> {
    document = GetReleaseNotesCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantSettingMyFlightDocument = gql`
    query getTenantSettingMyFlight {
  tenantSetting {
    id
    operatorSettings {
      id
      myflight {
        id
        autoConfirm
        autoConfirmAPI
        autoConfirmEmailTemplate
        flights
        endOfSeason
        colors
        logo
        checkinMode
        checkinDaysBefore
        checkinNotificationChannel
        checkinInstructions
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantSettingMyFlightGQL extends Apollo.Query<GetTenantSettingMyFlightQuery, GetTenantSettingMyFlightQueryVariables> {
    document = GetTenantSettingMyFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetSubscriptionDocument = gql`
    query getSubscription {
  tenantSetting {
    id
    subscription {
      factuursturenClient
      custom
      gracePeriodDays
      debtorValidation {
        valid
        issues
        checkedAt
      }
      sms {
        available
        used
        usedSMS {
          year
          month
          used
          usedWA
          waUtility
          waService
          waMarketing
          waAuthentication
          waBillable
          waFree
          waEstimatedCost
        }
        pctUsed
        ignoreWarning
        status
        suggestedOrderLines {
          productCode
          description
          descriptionEn
          descriptionDe
          descriptionFr
          quantity
          unitPrice
          sms
          periodStart
          periodEnd
        }
      }
      plan {
        name
        seats
        used
        pctUsed
        validUntil
        valid
        status
        invalidSince
        expiredSince
        suggestedUpgrade
        suggestedOrderLines {
          type
          productCode
          description
          descriptionEn
          descriptionDe
          descriptionFr
          quantity
          unitPrice
          totalPrice
          sms
          plan
          maxSeats
          periodStart
          periodEnd
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetSubscriptionGQL extends Apollo.Query<GetSubscriptionQuery, GetSubscriptionQueryVariables> {
    document = GetSubscriptionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetDefaultLocationDocument = gql`
    query getDefaultLocation {
  tenantSetting {
    id
    locationOptions {
      defaultLocation {
        id
        address
        city
        country
        default
        description
        height
        latitude
        longitude
        maximumHeight
        name
        postalCode
        forecasts {
          slot
          flyability {
            verdict
            parameters {
              key
              value
              band
            }
          }
          forecast {
            datepart {
              part
              text
            }
            daytime
            flytime
            lastUpdate
            latitude
            longitude
            lowCloudsData
            pictoCodeData
            precipitationData
            pressureData
            sunrise
            sunset
            temperatureData
            time
            utc_timeoffset
            visibilityData
            windDirectionData
            windDirectionData_1000
            windDirectionData_500
            windDirectionData_550
            windDirectionData_600
            windDirectionData_650
            windDirectionData_700
            windDirectionData_750
            windDirectionData_800
            windDirectionData_925
            windDirectionData_950
            windDirectionData_975
            windGustData
            windSpeedData
            windSpeedData_1000
            windSpeedData_500
            windSpeedData_550
            windSpeedData_600
            windSpeedData_650
            windSpeedData_700
            windSpeedData_750
            windSpeedData_800
            windSpeedData_925
            windSpeedData_950
            windSpeedData_975
          }
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetDefaultLocationGQL extends Apollo.Query<GetDefaultLocationQuery, GetDefaultLocationQueryVariables> {
    document = GetDefaultLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUpUrlDocument = gql`
    query getUpUrl($bookingId: ID!) {
  upUrl(bookingId: $bookingId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUpUrlGQL extends Apollo.Query<GetUpUrlQuery, GetUpUrlQueryVariables> {
    document = GetUpUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FlyabilityDefaultsDocument = gql`
    query flyabilityDefaults {
  flyabilityDefaults {
    parameter
    goodMax
    warnMax
    goodMin
    warnMin
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FlyabilityDefaultsGQL extends Apollo.Query<FlyabilityDefaultsQuery, FlyabilityDefaultsQueryVariables> {
    document = FlyabilityDefaultsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FlyabilityThresholdsDocument = gql`
    query flyabilityThresholds {
  tenantSetting {
    id
    flyabilityEnabled
    flyability {
      parameter
      goodMax
      warnMax
      goodMin
      warnMin
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class FlyabilityThresholdsGQL extends Apollo.Query<FlyabilityThresholdsQuery, FlyabilityThresholdsQueryVariables> {
    document = FlyabilityThresholdsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateFlyabilitySettingsDocument = gql`
    mutation updateFlyabilitySettings($thresholds: [FlyabilityThresholdInput!]!, $enabled: Boolean) {
  updateFlyabilitySettings(thresholds: $thresholds, enabled: $enabled) {
    id
    flyabilityEnabled
    flyability {
      parameter
      goodMax
      warnMax
      goodMin
      warnMin
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateFlyabilitySettingsGQL extends Apollo.Mutation<UpdateFlyabilitySettingsMutation, UpdateFlyabilitySettingsMutationVariables> {
    document = UpdateFlyabilitySettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantLocationOptionsDocument = gql`
    mutation updateTenantLocationOptions($options: InputLocationOptions!) {
  updateTenantLocationOptions(options: $options) {
    locationOptions {
      defaultLocation {
        id
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantLocationOptionsGQL extends Apollo.Mutation<UpdateTenantLocationOptionsMutation, UpdateTenantLocationOptionsMutationVariables> {
    document = UpdateTenantLocationOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsBackupDocument = gql`
    mutation updateTenantOperatorSettingsBackup($settings: InputOperatorSettingsBackup!) {
  updateTenantOperatorSettingsBackup(settings: $settings) {
    operatorSettings {
      id
      backup {
        active
        email
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsBackupGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsBackupMutation, UpdateTenantOperatorSettingsBackupMutationVariables> {
    document = UpdateTenantOperatorSettingsBackupDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsDisplayedColumnsDocument = gql`
    mutation updateTenantOperatorSettingsDisplayedColumns($displayedColumns: InputDisplayedColumns!) {
  updateTenantOperatorSettingsDisplayedColumns(
    displayedColumns: $displayedColumns
  ) {
    operatorSettings {
      id
      displayedColumns {
        flightsUpcoming {
          name
          active
          mobile
          disabled
        }
        flightsUpcomingDefault {
          name
          active
          mobile
          disabled
        }
        flightsBooking {
          name
          active
          mobile
          disabled
        }
        flightsBookingDefault {
          name
          active
          mobile
          disabled
        }
        flightsHistory {
          name
          active
          mobile
          disabled
        }
        flightsHistoryDefault {
          name
          active
          mobile
          disabled
        }
        bookingsOpen {
          name
          active
          mobile
          disabled
        }
        bookingsOpenDefault {
          name
          active
          mobile
          disabled
        }
        bookingsHistory {
          name
          active
          mobile
          disabled
        }
        bookingsHistoryDefault {
          name
          active
          mobile
          disabled
        }
        bookingsPayment {
          name
          active
          mobile
          disabled
        }
        bookingsPaymentDefault {
          name
          active
          mobile
          disabled
        }
        bookingsDashboard {
          name
          active
          mobile
          disabled
        }
        bookingsDashboardDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlight {
          name
          active
          mobile
          disabled
        }
        bookingsFlightDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlightEnd {
          name
          active
          mobile
          disabled
        }
        bookingsFlightEndDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlightCancelled {
          name
          active
          mobile
          disabled
        }
        bookingsFlightCancelledDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlightAll {
          name
          active
          mobile
          disabled
        }
        bookingsFlightAllDefault {
          name
          active
          mobile
          disabled
        }
        bookingsFlightPayment {
          name
          active
          mobile
          disabled
        }
        bookingsFlightPaymentDefault {
          name
          active
          mobile
          disabled
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsDisplayedColumnsGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsDisplayedColumnsMutation, UpdateTenantOperatorSettingsDisplayedColumnsMutationVariables> {
    document = UpdateTenantOperatorSettingsDisplayedColumnsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsCrewDocument = gql`
    mutation updateTenantOperatorSettingsCrew($settings: InputOperatorSettingsCrew!) {
  updateTenantOperatorSettingsCrew(settings: $settings) {
    operatorSettings {
      id
      crew {
        shareBookings
        allowFlightSelection
        shareEvents
        shareFlightTags
        crewReadyChannel
        crewReadyLanguage
        crewReadyInstructions
        crewReadyIncludePassengers
        crewReadyIncludeTrajectory
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsCrewGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsCrewMutation, UpdateTenantOperatorSettingsCrewMutationVariables> {
    document = UpdateTenantOperatorSettingsCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsNotificationsDocument = gql`
    mutation updateTenantOperatorSettingsNotifications($settings: InputOperatorSettingsNotifications!) {
  updateTenantOperatorSettingsNotifications(settings: $settings) {
    operatorSettings {
      id
      notifications {
        calendar
        calendarClosing
        flightCrew
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsNotificationsGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsNotificationsMutation, UpdateTenantOperatorSettingsNotificationsMutationVariables> {
    document = UpdateTenantOperatorSettingsNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsTrajectoryProfileDocument = gql`
    mutation updateTenantOperatorSettingsTrajectoryProfile($settings: [InputOperatorSettingsTrajectoryProfile]!) {
  updateTenantOperatorSettingsTrajectoryProfile(settings: $settings) {
    operatorSettings {
      id
      trajectoryProfile {
        duration
        level
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsTrajectoryProfileGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsTrajectoryProfileMutation, UpdateTenantOperatorSettingsTrajectoryProfileMutationVariables> {
    document = UpdateTenantOperatorSettingsTrajectoryProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsMyFlightDocument = gql`
    mutation updateTenantOperatorSettingsMyFlight($settings: InputOperatorSettingsMyFlight!) {
  updateTenantOperatorSettingsMyFlight(settings: $settings) {
    operatorSettings {
      id
      myflight {
        id
        autoConfirm
        autoConfirmAPI
        autoConfirmEmailTemplate
        flights
        endOfSeason
        colors
        logo
        checkinMode
        checkinDaysBefore
        checkinNotificationChannel
        checkinInstructions
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsMyFlightGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsMyFlightMutation, UpdateTenantOperatorSettingsMyFlightMutationVariables> {
    document = UpdateTenantOperatorSettingsMyFlightDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsFlightsDocument = gql`
    mutation updateTenantOperatorSettingsFlights($settings: InputOperatorSettingsFlights!, $updateHours: Boolean) {
  updateTenantOperatorSettingsFlights(
    settings: $settings
    updateHours: $updateHours
  ) {
    operatorSettings {
      id
      flights {
        sunriseOffset
        sunsetOffset
        meetingTimeOffset
        cancelReasons
        defaultPeriod
        flightDuplicateProtection
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsFlightsGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsFlightsMutation, UpdateTenantOperatorSettingsFlightsMutationVariables> {
    document = UpdateTenantOperatorSettingsFlightsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsFlightsCancelReasonsDocument = gql`
    mutation updateTenantOperatorSettingsFlightsCancelReasons($cancelReasons: [String]!) {
  updateTenantOperatorSettingsFlightsCancelReasons(cancelReasons: $cancelReasons) {
    operatorSettings {
      id
      flights {
        sunriseOffset
        sunsetOffset
        meetingTimeOffset
        cancelReasons
        defaultPeriod
        flightDuplicateProtection
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsFlightsCancelReasonsGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsFlightsCancelReasonsMutation, UpdateTenantOperatorSettingsFlightsCancelReasonsMutationVariables> {
    document = UpdateTenantOperatorSettingsFlightsCancelReasonsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsSmsDocument = gql`
    mutation updateTenantOperatorSettingsSms($settings: InputOperatorSettingsSms!) {
  updateTenantOperatorSettingsSms(settings: $settings) {
    operatorSettings {
      id
      sms {
        footerEnabled
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsSmsGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsSmsMutation, UpdateTenantOperatorSettingsSmsMutationVariables> {
    document = UpdateTenantOperatorSettingsSmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsBookingsChildAgeDocument = gql`
    mutation updateTenantOperatorSettingsBookingsChildAge($childAge: NonNegativeInt) {
  updateTenantOperatorSettingsBookingsChildAge(childAge: $childAge) {
    operatorSettings {
      id
      bookings {
        childAge
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsBookingsChildAgeGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsBookingsChildAgeMutation, UpdateTenantOperatorSettingsBookingsChildAgeMutationVariables> {
    document = UpdateTenantOperatorSettingsBookingsChildAgeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsBookingsFlightOptionsCountDocument = gql`
    mutation updateTenantOperatorSettingsBookingsFlightOptionsCount($flightOptionsCount: NonNegativeInt) {
  updateTenantOperatorSettingsBookingsFlightOptionsCount(
    flightOptionsCount: $flightOptionsCount
  ) {
    operatorSettings {
      id
      bookings {
        flightOptionsCount
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsBookingsFlightOptionsCountGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsBookingsFlightOptionsCountMutation, UpdateTenantOperatorSettingsBookingsFlightOptionsCountMutationVariables> {
    document = UpdateTenantOperatorSettingsBookingsFlightOptionsCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsBookingsSourcesDocument = gql`
    mutation updateTenantOperatorSettingsBookingsSources($sources: [String]) {
  updateTenantOperatorSettingsBookingsSources(sources: $sources) {
    operatorSettings {
      id
      bookings {
        sources
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsBookingsSourcesGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsBookingsSourcesMutation, UpdateTenantOperatorSettingsBookingsSourcesMutationVariables> {
    document = UpdateTenantOperatorSettingsBookingsSourcesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsDisabledPaymentTypesDocument = gql`
    mutation updateTenantOperatorSettingsDisabledPaymentTypes($disabledPaymentTypes: [String]!) {
  updateTenantOperatorSettingsDisabledPaymentTypes(
    disabledPaymentTypes: $disabledPaymentTypes
  ) {
    operatorSettings {
      id
      bookings {
        disabledPaymentTypes
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsDisabledPaymentTypesGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsDisabledPaymentTypesMutation, UpdateTenantOperatorSettingsDisabledPaymentTypesMutationVariables> {
    document = UpdateTenantOperatorSettingsDisabledPaymentTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleTenantOperatorSettingsBookingsShowPaymentsDocument = gql`
    mutation toggleTenantOperatorSettingsBookingsShowPayments {
  toggleTenantOperatorSettingsBookingsShowPayments {
    operatorSettings {
      id
      bookings {
        showPayments
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleTenantOperatorSettingsBookingsShowPaymentsGQL extends Apollo.Mutation<ToggleTenantOperatorSettingsBookingsShowPaymentsMutation, ToggleTenantOperatorSettingsBookingsShowPaymentsMutationVariables> {
    document = ToggleTenantOperatorSettingsBookingsShowPaymentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ToggleTenantWAfallbackSmsDocument = gql`
    mutation toggleTenantWAfallbackSMS {
  toggleTenantWAfallbackSMS {
    whatsapp {
      enabled
      fallbackSms
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ToggleTenantWAfallbackSmsGQL extends Apollo.Mutation<ToggleTenantWAfallbackSmsMutation, ToggleTenantWAfallbackSmsMutationVariables> {
    document = ToggleTenantWAfallbackSmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantMessageRetentionDocument = gql`
    mutation updateTenantMessageRetention($messageRetention: InputMessageRetention!) {
  updateTenantMessageRetention(messageRetention: $messageRetention) {
    tenantId
    messageRetention {
      closedBookingsYears
      crewYears
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantMessageRetentionGQL extends Apollo.Mutation<UpdateTenantMessageRetentionMutation, UpdateTenantMessageRetentionMutationVariables> {
    document = UpdateTenantMessageRetentionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MessageRetentionImpactDocument = gql`
    query messageRetentionImpact($closedBookingsYears: NonNegativeInt, $crewYears: NonNegativeInt) {
  messageRetentionImpact(
    closedBookingsYears: $closedBookingsYears
    crewYears: $crewYears
  ) {
    closedBookingMessages
    crewMessages
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MessageRetentionImpactGQL extends Apollo.Query<MessageRetentionImpactQuery, MessageRetentionImpactQueryVariables> {
    document = MessageRetentionImpactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubscriptionSmsIgnoreWarningDocument = gql`
    mutation subscriptionSmsIgnoreWarning($ignore: Boolean!) {
  subscriptionSmsIgnoreWarning(ignore: $ignore)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubscriptionSmsIgnoreWarningGQL extends Apollo.Mutation<SubscriptionSmsIgnoreWarningMutation, SubscriptionSmsIgnoreWarningMutationVariables> {
    document = SubscriptionSmsIgnoreWarningDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddReleaseNoteDocument = gql`
    mutation addReleaseNote($releaseNote: InputReleaseNote!) {
  addReleaseNote(releaseNote: $releaseNote) {
    id
    date
    description
    documentation
    oneliner
    video
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddReleaseNoteGQL extends Apollo.Mutation<AddReleaseNoteMutation, AddReleaseNoteMutationVariables> {
    document = AddReleaseNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateReleaseNoteDocument = gql`
    mutation updateReleaseNote($id: ID!, $releaseNote: InputReleaseNote!) {
  updateReleaseNote(id: $id, releaseNote: $releaseNote) {
    id
    date
    description
    documentation
    oneliner
    video
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateReleaseNoteGQL extends Apollo.Mutation<UpdateReleaseNoteMutation, UpdateReleaseNoteMutationVariables> {
    document = UpdateReleaseNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteReleaseNoteDocument = gql`
    mutation deleteReleaseNote($id: ID!) {
  deleteReleaseNote(id: $id)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteReleaseNoteGQL extends Apollo.Mutation<DeleteReleaseNoteMutation, DeleteReleaseNoteMutationVariables> {
    document = DeleteReleaseNoteDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MarkReleaseNoteAsReadDocument = gql`
    mutation markReleaseNoteAsRead($releaseNoteIds: [ID]!) {
  markReleaseNoteAsRead(releaseNoteIds: $releaseNoteIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MarkReleaseNoteAsReadGQL extends Apollo.Mutation<MarkReleaseNoteAsReadMutation, MarkReleaseNoteAsReadMutationVariables> {
    document = MarkReleaseNoteAsReadDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIcsIdDocument = gql`
    mutation createIcsId {
  createIcsId
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIcsIdGQL extends Apollo.Mutation<CreateIcsIdMutation, CreateIcsIdMutationVariables> {
    document = CreateIcsIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateApiKeyDocument = gql`
    mutation createApiKey {
  createApiKey
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateApiKeyGQL extends Apollo.Mutation<CreateApiKeyMutation, CreateApiKeyMutationVariables> {
    document = CreateApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantCallbackUrlDocument = gql`
    mutation updateTenantCallbackUrl($callbackUrl: String!) {
  updateTenantCallbackUrl(callbackUrl: $callbackUrl) {
    id
    integrations {
      callbackUrl
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantCallbackUrlGQL extends Apollo.Mutation<UpdateTenantCallbackUrlMutation, UpdateTenantCallbackUrlMutationVariables> {
    document = UpdateTenantCallbackUrlDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIcsIdUserDocument = gql`
    mutation createIcsIdUser($userId: String!) {
  createIcsIdUser(userId: $userId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIcsIdUserGQL extends Apollo.Mutation<CreateIcsIdUserMutation, CreateIcsIdUserMutationVariables> {
    document = CreateIcsIdUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddFlightAppApiKeyDocument = gql`
    mutation addFlightAppApiKey($key: String!) {
  addFlightAppApiKey(key: $key)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddFlightAppApiKeyGQL extends Apollo.Mutation<AddFlightAppApiKeyMutation, AddFlightAppApiKeyMutationVariables> {
    document = AddFlightAppApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteFlightAppApiKeyDocument = gql`
    mutation deleteFlightAppApiKey($key: String!) {
  deleteFlightAppApiKey(key: $key)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteFlightAppApiKeyGQL extends Apollo.Mutation<DeleteFlightAppApiKeyMutation, DeleteFlightAppApiKeyMutationVariables> {
    document = DeleteFlightAppApiKeyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RefreshTenantSubscriptionUsedSmsDocument = gql`
    mutation refreshTenantSubscriptionUsedSms {
  refreshTenantSubscriptionUsedSms
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RefreshTenantSubscriptionUsedSmsGQL extends Apollo.Mutation<RefreshTenantSubscriptionUsedSmsMutation, RefreshTenantSubscriptionUsedSmsMutationVariables> {
    document = RefreshTenantSubscriptionUsedSmsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantSettingDocument = gql`
    mutation updateTenantSetting($tenantId: ID!, $settings: InputTenantSetting!) {
  updateTenantSettingAdmin(tenantId: $tenantId, settings: $settings) {
    id
    apiCacheEnabled
    subscription {
      factuursturenClient
      custom
      gracePeriodDays
      plan {
        name
        seats
        used
        pctUsed
        validUntil
        valid
        status
        invalidSince
        expiredSince
        suggestedUpgrade
      }
      sms {
        available
        used
        usedSMS {
          year
          month
          used
          usedWA
          waUtility
          waService
          waMarketing
          waAuthentication
          waBillable
          waFree
          waEstimatedCost
        }
        pctUsed
        ignoreWarning
        status
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantSettingGQL extends Apollo.Mutation<UpdateTenantSettingMutation, UpdateTenantSettingMutationVariables> {
    document = UpdateTenantSettingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsTwoFaDocument = gql`
    mutation updateTenantOperatorSettingsTwoFA($twoFAEnabled: Boolean!) {
  updateTenantOperatorSettingsTwoFA(twoFAEnabled: $twoFAEnabled) {
    operatorSettings {
      id
      twoFAEnabled
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsTwoFaGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsTwoFaMutation, UpdateTenantOperatorSettingsTwoFaMutationVariables> {
    document = UpdateTenantOperatorSettingsTwoFaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WeatherSourceDefaultsDocument = gql`
    query weatherSourceDefaults {
  weatherSourceDefaults {
    country
    source
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WeatherSourceDefaultsGQL extends Apollo.Query<WeatherSourceDefaultsQuery, WeatherSourceDefaultsQueryVariables> {
    document = WeatherSourceDefaultsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTenantOperatorSettingsWeatherSourceDocument = gql`
    mutation updateTenantOperatorSettingsWeatherSource($settings: InputOperatorSettingsWeatherSource!) {
  updateTenantOperatorSettingsWeatherSource(settings: $settings) {
    operatorSettings {
      id
      weatherSource {
        mode
        mapping {
          country
          source
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTenantOperatorSettingsWeatherSourceGQL extends Apollo.Mutation<UpdateTenantOperatorSettingsWeatherSourceMutation, UpdateTenantOperatorSettingsWeatherSourceMutationVariables> {
    document = UpdateTenantOperatorSettingsWeatherSourceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MessageRetentionStatusDocument = gql`
    query messageRetentionStatus {
  messageRetentionStatus {
    flaggedMessages
    nextPurgeAt
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class MessageRetentionStatusGQL extends Apollo.Query<MessageRetentionStatusQuery, MessageRetentionStatusQueryVariables> {
    document = MessageRetentionStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantByDisplayNameDocument = gql`
    query getTenantByDisplayName($displayName: String!) {
  getTenantByDisplayName(displayName: $displayName) {
    tenantId
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantByDisplayNameGQL extends Apollo.Query<GetTenantByDisplayNameQuery, GetTenantByDisplayNameQueryVariables> {
    document = GetTenantByDisplayNameDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantDocument = gql`
    query getTenant($tenantId: String!) {
  getTenant(tenantId: $tenantId) {
    displayName
    tenantSetting {
      id
      apiCacheEnabled
      upEnabled
      mailFrom {
        email
        name
      }
      mailReplyTo {
        email
        name
      }
      mailAccountant {
        email
        name
      }
      locationOptions {
        defaultLocation {
          id
        }
      }
      tenantId
      operatorSettings {
        backup {
          active
          email
        }
        crew {
          shareBookings
          allowFlightSelection
        }
        sms {
          footerEnabled
        }
        timezone
        manifest {
          footer
          pilotDeclaration
        }
        myflight {
          autoConfirm
          autoConfirmAPI
          flights
          endOfSeason
        }
      }
      dashboardOptions {
        preferredDateToday
        recent
        toConfirm
      }
      subscription {
        factuursturenClient
        custom
        gracePeriodDays
        debtorValidation {
          valid
          issues
          checkedAt
        }
        plan {
          name
          seats
          status
          validUntil
        }
        sms {
          available
          status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantGQL extends Apollo.Query<GetTenantQuery, GetTenantQueryVariables> {
    document = GetTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetTenantsDocument = gql`
    query getTenants {
  getTenants {
    tenantId
    displayName
    tenantSetting {
      upEnabled
      mailFrom {
        email
        name
      }
      mailReplyTo {
        email
        name
      }
      mailAccountant {
        email
        name
      }
      locationOptions {
        defaultLocation {
          id
        }
      }
      tenantId
      operatorSettings {
        backup {
          active
          email
        }
        crew {
          shareBookings
          allowFlightSelection
        }
        sms {
          footerEnabled
        }
        timezone
        manifest {
          footer
          pilotDeclaration
        }
        myflight {
          autoConfirm
          autoConfirmAPI
          flights
          endOfSeason
        }
      }
      dashboardOptions {
        preferredDateToday
        recent
        toConfirm
      }
      subscription {
        factuursturenClient
        custom
        gracePeriodDays
        plan {
          name
          seats
          status
          validUntil
        }
        sms {
          available
          status
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetTenantsGQL extends Apollo.Query<GetTenantsQuery, GetTenantsQueryVariables> {
    document = GetTenantsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsersDocument = gql`
    query getUsers($tenantId: String!) {
  getUsers(tenantId: $tenantId) {
    uid
    email
    customClaims
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsersGQL extends Apollo.Query<GetUsersQuery, GetUsersQueryVariables> {
    document = GetUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUserDocument = gql`
    query getUser {
  getUser {
    uid
    email
    userData {
      id
      icsId
      crew {
        id
        email
        emailNotifications
      }
      email
      displayName
      language
      role
      viewState
      tenant
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUserGQL extends Apollo.Query<GetUserQuery, GetUserQueryVariables> {
    document = GetUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TenantDocument = gql`
    query tenant {
  tenant {
    name
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TenantGQL extends Apollo.Query<TenantQuery, TenantQueryVariables> {
    document = TenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTenantDocument = gql`
    mutation createTenant($displayName: String!) {
  createTenant(displayName: $displayName) {
    tenantId
    displayName
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTenantGQL extends Apollo.Mutation<CreateTenantMutation, CreateTenantMutationVariables> {
    document = CreateTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InitializeTenantDocument = gql`
    mutation initializeTenant($tenantId: ID!) {
  initializeTenant(tenantId: $tenantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class InitializeTenantGQL extends Apollo.Mutation<InitializeTenantMutation, InitializeTenantMutationVariables> {
    document = InitializeTenantDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation createUser($GcpipUserInput: GcpipUserInput!, $tenantId: ID) {
  createUser(GcpipUserInput: $GcpipUserInput, tenantId: $tenantId) {
    uid
    email
    customClaims
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUserDocument = gql`
    mutation deleteUser($uid: String!, $tenantId: ID) {
  deleteUser(uid: $uid, tenantId: $tenantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUserGQL extends Apollo.Mutation<DeleteUserMutation, DeleteUserMutationVariables> {
    document = DeleteUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendPasswordResetEmailDocument = gql`
    mutation sendPasswordResetEmail($email: ID!, $tenantId: ID) {
  sendPasswordResetEmail(email: $email, tenantId: $tenantId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendPasswordResetEmailGQL extends Apollo.Mutation<SendPasswordResetEmailMutation, SendPasswordResetEmailMutationVariables> {
    document = SendPasswordResetEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveUserViewStateDocument = gql`
    mutation saveUserViewState($viewState: JSONObject!) {
  saveUserViewState(viewState: $viewState) {
    displayName
    language
    viewState
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveUserViewStateGQL extends Apollo.Mutation<SaveUserViewStateMutation, SaveUserViewStateMutationVariables> {
    document = SaveUserViewStateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendTwoFaEmailDocument = gql`
    mutation sendTwoFAEmail($deviceId: String!) {
  sendTwoFAEmail(deviceId: $deviceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendTwoFaEmailGQL extends Apollo.Mutation<SendTwoFaEmailMutation, SendTwoFaEmailMutationVariables> {
    document = SendTwoFaEmailDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VerifyTwoFaCodeDocument = gql`
    mutation verifyTwoFACode($code: String!, $deviceId: String!) {
  verifyTwoFACode(code: $code, deviceId: $deviceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VerifyTwoFaCodeGQL extends Apollo.Mutation<VerifyTwoFaCodeMutation, VerifyTwoFaCodeMutationVariables> {
    document = VerifyTwoFaCodeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForgetTrustedDeviceDocument = gql`
    mutation forgetTrustedDevice($deviceId: String!) {
  forgetTrustedDevice(deviceId: $deviceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForgetTrustedDeviceGQL extends Apollo.Mutation<ForgetTrustedDeviceMutation, ForgetTrustedDeviceMutationVariables> {
    document = ForgetTrustedDeviceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetVoucherDocument = gql`
    query getVoucher($id: ID!) {
  voucher(id: $id) {
    id
    adults
    adultsUsed
    adultsAvailable
    children
    childrenUsed
    childrenAvailable
    contactName
    contactPhone
    external
    externalSource
    issueDate
    paymentAmount
    paymentDate
    paymentStatus
    paymentType
    voucherReference
    voucherType
    expiryDate
    status
    comments
    contactCity
    contactEmail
    contactLanguage
    recipientName
    recipientPhone
    recipientLanguage
    recipientEmail
    recipientAddress
    recipientPostalCode
    recipientCity
    recipientCountry
    source
    tickets {
      passenger {
        id
        name
        child
        disability
      }
      booking {
        removed
        id
        inviteCount
        status
        icon
        iconColor
        contactName
        contactEmail
        contactPhone
        comments
        startDate
        endDate
        city
      }
      flight {
        date
        period
        balloon {
          name
        }
        id
        location {
          name
        }
        icon {
          sign
          color
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetVoucherGQL extends Apollo.Query<GetVoucherQuery, GetVoucherQueryVariables> {
    document = GetVoucherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VouchersDocument = gql`
    query Vouchers {
  vouchers {
    id
    adults
    children
    contactName
    contactPhone
    external
    externalSource
    issueDate
    paymentAmount
    paymentDate
    paymentStatus
    paymentType
    voucherReference
    voucherType
    expiryDate
    status
    comments
    contactCity
    contactEmail
    contactLanguage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VouchersGQL extends Apollo.Query<VouchersQuery, VouchersQueryVariables> {
    document = VouchersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetOpenVouchersDocument = gql`
    query getOpenVouchers($orderBy: OrderByVoucher, $orderDirection: OrderDirection, $limit: NonNegativeInt, $filter: String, $cursor: String, $voucherType: String) {
  openVouchers(
    orderBy: $orderBy
    orderDirection: $orderDirection
    limit: $limit
    cursor: $cursor
    filter: $filter
    voucherType: $voucherType
  ) {
    id
    adults
    adultsUsed
    adultsAvailable
    children
    childrenUsed
    childrenAvailable
    contactName
    contactPhone
    external
    externalSource
    issueDate
    paymentAmount
    paymentDate
    paymentStatus
    paymentType
    voucherReference
    voucherType
    expiryDate
    status
    comments
    contactCity
    contactEmail
    contactLanguage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetOpenVouchersGQL extends Apollo.Query<GetOpenVouchersQuery, GetOpenVouchersQueryVariables> {
    document = GetOpenVouchersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetUsedVouchersDocument = gql`
    query getUsedVouchers($orderBy: OrderByVoucher, $orderDirection: OrderDirection, $limit: NonNegativeInt, $filter: String, $cursor: String, $voucherType: String) {
  usedVouchers(
    orderBy: $orderBy
    orderDirection: $orderDirection
    limit: $limit
    cursor: $cursor
    filter: $filter
    voucherType: $voucherType
  ) {
    id
    adults
    children
    contactName
    contactPhone
    external
    externalSource
    issueDate
    paymentAmount
    paymentDate
    paymentStatus
    paymentType
    voucherReference
    voucherType
    expiryDate
    status
    comments
    contactCity
    contactEmail
    contactLanguage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetUsedVouchersGQL extends Apollo.Query<GetUsedVouchersQuery, GetUsedVouchersQueryVariables> {
    document = GetUsedVouchersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetExpiredVouchersDocument = gql`
    query getExpiredVouchers($orderBy: OrderByVoucher, $orderDirection: OrderDirection, $limit: NonNegativeInt, $filter: String, $cursor: String, $voucherType: String) {
  expiredVouchers(
    orderBy: $orderBy
    orderDirection: $orderDirection
    limit: $limit
    cursor: $cursor
    filter: $filter
    voucherType: $voucherType
  ) {
    id
    adults
    children
    contactName
    contactPhone
    external
    externalSource
    issueDate
    paymentAmount
    paymentDate
    paymentStatus
    paymentType
    voucherReference
    voucherType
    expiryDate
    status
    comments
    contactCity
    contactEmail
    contactLanguage
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetExpiredVouchersGQL extends Apollo.Query<GetExpiredVouchersQuery, GetExpiredVouchersQueryVariables> {
    document = GetExpiredVouchersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VoucherCountersDocument = gql`
    query voucherCounters {
  voucherCounters {
    statusCounters {
      AVAI
      USED
      EXPI
    }
    voucherTypes
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VoucherCountersGQL extends Apollo.Query<VoucherCountersQuery, VoucherCountersQueryVariables> {
    document = VoucherCountersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SaveVoucherDocument = gql`
    mutation saveVoucher($voucherInput: VoucherInput!, $voucherId: ID) {
  saveVoucher(voucherInput: $voucherInput, voucherId: $voucherId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SaveVoucherGQL extends Apollo.Mutation<SaveVoucherMutation, SaveVoucherMutationVariables> {
    document = SaveVoucherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteVoucherDocument = gql`
    mutation deleteVoucher($voucherId: ID!) {
  deleteVoucher(voucherId: $voucherId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteVoucherGQL extends Apollo.Mutation<DeleteVoucherMutation, DeleteVoucherMutationVariables> {
    document = DeleteVoucherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBookingFromVoucherDocument = gql`
    mutation createBookingFromVoucher($voucherId: ID!) {
  createBookingFromVoucher(voucherId: $voucherId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBookingFromVoucherGQL extends Apollo.Mutation<CreateBookingFromVoucherMutation, CreateBookingFromVoucherMutationVariables> {
    document = CreateBookingFromVoucherDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WeekPanelBookingDocument = gql`
    query weekPanelBooking($id: ID!) {
  booking(id: $id) {
    id
    contactName
    contactPhone
    contactEmail
    city
    status
    comments
    endDate
    bookingCode
    preferredDate
    preferredFlights {
      date
      period
    }
    region {
      id
      name
      color
    }
    passengerCounters {
      passengerCount
      totalWeight
      totalAmount
      paidAmount
      openAmount
    }
    passengers {
      name
      weight
    }
    flight {
      id
      date
      hour
      period
      balloon {
        id
        name
        capacity
      }
      location {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WeekPanelBookingGQL extends Apollo.Query<WeekPanelBookingQuery, WeekPanelBookingQueryVariables> {
    document = WeekPanelBookingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WeekPanelLocationDocument = gql`
    query weekPanelLocation($locationId: ID!) {
  location(locationId: $locationId) {
    id
    name
    city
    address
    description
    default
    latitude
    longitude
    meetingPointAddress
    contact {
      name
      phone
      email
      comment
    }
    region {
      id
      name
      color
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WeekPanelLocationGQL extends Apollo.Query<WeekPanelLocationQuery, WeekPanelLocationQueryVariables> {
    document = WeekPanelLocationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WeekPanelBalloonCrewDocument = gql`
    query weekPanelBalloonCrew($balloonId: ID!) {
  balloon(balloonId: $balloonId) {
    id
    preferredCrew {
      pilot {
        id
        name
      }
      driver {
        id
        name
      }
      crew {
        id
        name
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WeekPanelBalloonCrewGQL extends Apollo.Query<WeekPanelBalloonCrewQuery, WeekPanelBalloonCrewQueryVariables> {
    document = WeekPanelBalloonCrewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WeekPanelCrewOfDocument = gql`
    query weekPanelCrewOf($crewId: ID!) {
  crew(crewId: $crewId) {
    id
    preferredCrewOf {
      id
      name
      callSign
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WeekPanelCrewOfGQL extends Apollo.Query<WeekPanelCrewOfQuery, WeekPanelCrewOfQueryVariables> {
    document = WeekPanelCrewOfDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhatsappCloudStatusDocument = gql`
    query whatsappCloudStatus {
  tenantSetting {
    tenantId
    whatsapp {
      enabled
      fallbackSms
      cloudEnabled
      provider
      wabaId
      phoneNumberId
      phoneNumber
      messagingTier
      migrationStatus
      paymentConfirmedAt
      paymentError
      templates {
        key
        type
        label
        language
        approvalStatus
        rejectionReason
        validationIssues
        serving
        submittedAt
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhatsappCloudStatusGQL extends Apollo.Query<WhatsappCloudStatusQuery, WhatsappCloudStatusQueryVariables> {
    document = WhatsappCloudStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhatsappCloudOnboardDocument = gql`
    mutation whatsappCloudOnboard($code: String!) {
  whatsappCloudOnboard(code: $code) {
    success
    wabaId
    phoneNumberId
    displayPhoneNumber
    messagingTier
    templatesSubmitted
    error
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhatsappCloudOnboardGQL extends Apollo.Mutation<WhatsappCloudOnboardMutation, WhatsappCloudOnboardMutationVariables> {
    document = WhatsappCloudOnboardDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ActivateWhatsappCloudDocument = gql`
    mutation activateWhatsappCloud {
  activateWhatsappCloud {
    provider
    migrationStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ActivateWhatsappCloudGQL extends Apollo.Mutation<ActivateWhatsappCloudMutation, ActivateWhatsappCloudMutationVariables> {
    document = ActivateWhatsappCloudDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeactivateWhatsappCloudDocument = gql`
    mutation deactivateWhatsappCloud {
  deactivateWhatsappCloud {
    provider
    migrationStatus
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeactivateWhatsappCloudGQL extends Apollo.Mutation<DeactivateWhatsappCloudMutation, DeactivateWhatsappCloudMutationVariables> {
    document = DeactivateWhatsappCloudDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmWhatsappCloudPaymentDocument = gql`
    mutation confirmWhatsappCloudPayment {
  confirmWhatsappCloudPayment {
    paymentConfirmedAt
    paymentError
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmWhatsappCloudPaymentGQL extends Apollo.Mutation<ConfirmWhatsappCloudPaymentMutation, ConfirmWhatsappCloudPaymentMutationVariables> {
    document = ConfirmWhatsappCloudPaymentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhatsappCloudCostEstimateDocument = gql`
    query whatsappCloudCostEstimate {
  whatsappCloudCostEstimate {
    monthsSampled
    avgMonthlyMessages
    avgMonthlyBillable
    estimatedMonthlyCost
    ratePerMessage
    basedOnSmsHistory
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhatsappCloudCostEstimateGQL extends Apollo.Query<WhatsappCloudCostEstimateQuery, WhatsappCloudCostEstimateQueryVariables> {
    document = WhatsappCloudCostEstimateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const WhatsappWindowStatesDocument = gql`
    query whatsappWindowStates($phones: [String!]!) {
  whatsappWindowStates(phones: $phones) {
    phone
    open
    openUntil
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class WhatsappWindowStatesGQL extends Apollo.Query<WhatsappWindowStatesQuery, WhatsappWindowStatesQueryVariables> {
    document = WhatsappWindowStatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }